import React from 'react';
import clsx from 'clsx';
import { connect } from 'react-redux';
import Datetime from 'react-datetime';
import DatePicker from 'react-date-picker';

import compose from 'recompose/compose';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

import axios from 'axios';
import firebase, {
  db,
  storage,
  sendEmail,
  sendDynamicEmail,
  sendSMS,
} from 'firebase/fbConfig.js';
import moment from 'moment';
import { v1 as uuidv1 } from 'uuid';
import Geocode from 'react-geocode';
import _ from 'lodash';
import { jsPDF } from 'jspdf';

// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
import { makeStyles } from '@material-ui/core/styles';
import MaterialButton from '@material-ui/core/Button';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '@material-ui/core/Icon';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import VendorPicUpload from 'components/CustomUpload/vendorPicUpload.jsx';
import ButtonBase from '@material-ui/core/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import TextField from '@material-ui/core/TextField';
import Paper from '@material-ui/core/Paper';
import Divider from '@material-ui/core/Divider';
import Collapse from '@material-ui/core/Collapse';
import Grid from '@material-ui/core/Grid';

// @material-ui/icons
import Face from '@material-ui/icons/Face';
import Email from '@material-ui/icons/Email';
import Check from '@material-ui/icons/Check';
import Close from '@material-ui/icons/Close';
import SaveIcon from '@material-ui/icons/Save';
import EditIcon from '@material-ui/icons/Edit';
import CircularProgress from '@material-ui/core/CircularProgress';
import Switch from '@material-ui/core/Switch';

// @material-ui/lab
import Autocomplete, {
  createFilterOptions,
} from '@material-ui/lab/Autocomplete';
// import LockOutline from "@material-ui/icons/LockOutline";

// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import Button from 'components/CustomButtons/Button.jsx';
import Card from 'components/Card/Card.jsx';
import CardBody from 'components/Card/CardBody.jsx';
import CardHeader from 'components/Card/CardHeader.jsx';
import CardFooter from 'components/Card/CardFooter.jsx';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import styles from 'assets/jss/material-dashboard-pro-react/components/ActionSubmitFormStyle.jsx';
import ShipFullScreenMap from '../../views/Maps/ShipFullScreenMap';
import FormLabel from '@material-ui/core/FormLabel';
import FullScreenMap from '../../views/Maps/ShipFullScreenMap';
import FlightSearchForm from './FlightSearchFormNew';
import Chat from 'components/Chat';
import FlightCard from 'components/Card/FlightCard';
import UserConfirmModal from 'components/Modal/UserConfirm';
import PinUserForm from 'components/Forms/PinUserForm';

import DateTimePicker from 'react-datetime-picker';

import PrototypeExploreAssignUser from '../../views/Explore/PrototypeExploreAssignUser.jsx';
import PartyFreightSummary from './PartyFreightSummary.jsx';
import {
  isEmail,
  isPhoneNumber,
  itemErrorDetails,
  onlyNumbers,
  onlyLettersAndWhitespace,
} from '../../store/actions/formActions.jsx';

import { createBOL, uploadFile, createSignable } from 'store/actions/documentActions';
import DocumentUpload from "components/CustomUpload/DocumentUpload.jsx";

import DocUpload from 'components/CustomUpload/docUpload.jsx';

const useStyles = makeStyles((theme) => ({
  button: {
    maxWidth: '200px',
  },
  buttonProgress: {
    color: 'white',
    margin: '0 -16px 0 8px',
  },
  wrapper: {
    position: 'relative',
  },
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const Transition = (props) => {
  return <Slide direction="down" {...props} />;
};

const LoadButton = (props) => {
  const { children, isLoading, ...rest } = props;
  const classes = useStyles();
  return (
    <div className={classes.wrapper}>
      <Button
        className={classes.button}
        color="primary"
        disabled={isLoading}
        {...rest}
      >
        {children}
        {isLoading && (
          <CircularProgress
            size={17}
            className={classes.buttonProgress}
            disableShrink
          />
        )}
      </Button>
    </div>
  );
};

const filter = createFilterOptions();

class Form extends React.Component {
  constructor(props) {
    super(props);
    // we use this to make the card to appear after the page has been rendered
    this.state = {
      cardAnimaton: 'cardHidden',
      shippingMode: '',
      pickUpServices: '',
      dropOffServices: '',
      services: '',
      items: [],
      itemCount: 1,
      userSet: false,
      step5: true,
      item2: false,
      item3: false,
      transLoad: [],
      // flightNumber: this.state.orderData
      //   ? this.state.orderData.flight
      //     ? this.state.orderData.flight.number
      //       ? this.state.orderData.flight.number
      //       : null
      //     : null
      //   : null,
      matchingFlights: [],
      hideFlights: false,
      radius: 200,
      getAirportsLoaded: false,
      vendorsQualified: false,
      dropOffVendorsQualified: false,
      driverSelected: false,
      editOrder: false,
      documentsLoading: false,
      documentsLoaded: 0,
      legs: 0,
      // origin: (this.state.orderData && this.state.orderData.origin),
      // destination: (this.state.orderData && this.state.orderData.destination),
      originAirCarrier: {},
      destinationAirCarrier: {},
      dispatcherDataLoaded: false,
      qualifiedAirVendorsLoaded: false,
      openChats: [],
      isFlight: false,
      createModalOpen: false,
    };

    this.militaryTime = ['', '0000', '0030', '0100', '0130', '0200', '0230', '0300', '0330', '0400', '0430', '0500', '0530', '0600', '0630', '0700', '0730', '0800', '0830', '0900', '0930', '1000', '1030', '1100', '1130', '1200', '1230', '1300', '1330', '1400', '1430', '1500', '1530', '1600', '1630', '1700', '1730', '1800', '1830', '1900', '1930', '2000', '2030', '2100', '2130', '2200', '2230', '2300', '2330'];
    this.allMAString = 'All 48 States';
    this.handleNotificationsToggle = this.handleNotificationsToggle.bind(this);
    this.handleToggleServices = this.handleToggleServices.bind(this);
    this.handleToggleItemServices = this.handleToggleItemServices.bind(this);

    this.shipmentStatuses = [
      'Pending',
      'Quoted Needs Approval',
      'Booked',
      'Dispatched',
      'In Route to Shipper',
      'Arrived at Shipper',
      'Driver Departed Shipper',
      'Arrived at Airline',
      'Tendered to Airline Awaiting Departure',
      'Aircraft Departed',
      'Aircraft Arrived',
      'Aircraft Download',
      'In Route to Consignee',
      'Arrived at Consignee',
      'Docked',
      'Delivered',
    ];
    this.financialStatuses = [
      'Unquoted',
      'Quoted',
      'Quote Authorized',
      'Pricing Final',
      'Invoiced',
      'Paid',
      'Paid in Full',
      'Short Paid',
      'Over Paid',
      'Claim Pending'
    ];
    this.factoredFinancialStatuses = [
      'Unquoted',
      'Quoted',
      'Quote Authorized',
      'Pricing Final',
      'Submitted for Factor',
      'Factor Approved and Invoiced',
      'Factor Denied',
      'Paid',
      'Paid in Full',
      'Short Paid',
      'Over Paid',
      'Claim Pending'
    ];
    this.deliveryTypes = [
      { string: '', value: '' },
      { string: 'Next Flight Out', value: 'Air' },
      { string: 'Next Day Air', value: 'Scheduled Air' },
      { string: 'Dedicated Ground', value: 'Ground' },
      { string: 'LTL', value: 'LTL' },
      { string: 'Direct LTL', value: 'Additional Options' },
    ];
    this.billingParties = ['Shipper', 'Consignee', 'Third Party'];
  }
  componentDidMount() {
    // we add a hidden class to the card and after 700 ms we delete it and the transition appears
    this.timeOutFunction = setTimeout(
      function () {
        this.setState({ cardAnimaton: '' });
      }.bind(this),
      700
    );
  }
  componentWillUnmount() {
    clearTimeout(this.timeOutFunction);
    this.timeOutFunction = null;
  }
  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    //console.log(this.state)
  };

  handleFlightChange = (e) => {
    const flight = this.grabData('flight') ? this.grabData('flight') : {};
    flight[e.target.id] = e.target.value;
    console.log(flight);
    this.setState({ flight });
  };

  handleAdditionalLegsChange = (e, index) => {
    const additionalLegs = this.grabData('additionalLegs')
      ? this.grabData('additionalLegs')
      : [];
    additionalLegs[index][e.target.id ? e.target.id : e.target.name] =
      e.target.value;
    console.log(additionalLegs);
    this.setState({ additionalLegs: [...additionalLegs] });
  };

  handleArrChange = (e, arr) => {
    let array = this.state.orderData[arr];
    array[e.target.id] = e.target.value;
    this.setState({
      [arr]: array,
    });
  };

  handleItemChange = (e, i) => {
    var orderData = this.state.orderData;
    orderData.items[i][e.target.id || e.target.name] = e.target.value;
    console.log(orderData, e.target.id, e.target.value);
    this.setState({ orderData: orderData });
  };

  handleItemSelectChange = (e, i) => {
    const orderData = this.state.orderData;
    orderData.items[i][e.target.name] = e.target.value;

    this.setState({ orderData: orderData });
  };

  handleDateChange = (date, obj) => {
    if (date) {
      let bucket = this.state.orderData[obj];
      bucket['date'] = date;
      this.setState({
        [obj]: bucket,
      });
    }
  };

  handleDateTimeChange = (date, obj) => {
    let bucket = this.state.orderData[obj];
    bucket['deliverBy'] = date;
    this.setState({
      [obj]: bucket,
    });
  };

  handleFlightDateTimeChange = (date, type) => {
    const flight = this.grabData('flight') ? this.grabData('flight') : {};
    flight[type] = date;
    console.log(flight);
    this.setState({ flight });
  };

  handleAdditionalLegDateTimeChange = (date, type, index) => {
    const additionalLegs = this.grabData('additionalLegs')
      ? this.grabData('additionalLegs')
      : [];
    additionalLegs[index][type] = date;
    console.log(additionalLegs);
    this.setState({ additionalLegs: [...additionalLegs] });
  };

  handleQuoteDateTimeChange = (date, obj) => {
    let bucket = this.state[obj] ? this.state[obj] : {};
    bucket['quoteETA'] = date;
    this.setState({
      [obj]: bucket,
    });
  };

  handleQuoteWindowTimeChange = (e, obj, type) => {
    const bucket = this.grabData(obj) ? this.grabData(obj) : {};
    bucket[type] = e.target.value;
    this.setState({ 
      [obj]: bucket
    });
  }

  handleToggleItemServices(value, iterator) {
    var orderData = this.state.orderData;
    value = value.includes(' ') ? value.split(' ').join('') : value;
    orderData.items[iterator][`is${value}`] == true
      ? delete orderData.items[iterator][`is${value}`]
      : (orderData.items[iterator][`is${value}`] = true);
    this.setState({ orderData: orderData });
  }

  toggleFootage = (i) => {
    this.setState(
      (prevState) =>
      (prevState.orderData.items[i].isFootage = !Boolean(
        prevState.orderData.items[i].isFootage
      ))
    );
  };

  handlePickUpDateChange = (pickUpDate) => {
    //console.log(pickUpDate._d)
    if (pickUpDate) {
      this.setState(() => ({
        pickUpDate: pickUpDate,
        pickUpAPI: moment(pickUpDate).format('YYYY-MM-DD'),
      }));
    }
  };

  handleDropOffDateChange = (dropOffDate) => {
    //console.log(dropOffDate)
    if (dropOffDate) {
      this.setState(() => ({ dropOffDate: dropOffDate }));
    }
  };

  // only make future selectable
  valid = (current) => {
    return current.isAfter(Datetime.moment().subtract(1, 'day'));
  };
  handleFlightToggle = () => {
    this.setState({
      isFlight: !this.state.isFlight,
    });
    console.log('Pickle', this.state);
  };

  handleNotificationsToggle(value, obj) {
    var orderData = this.state.orderData;
    var notifications = !!orderData[obj]['notifications'];

    orderData[obj]['notifications'] = !notifications;

    this.setState({ orderData: orderData });
  }

  handleSelectChange = (e) => {
    console.log(e.target.value);
    this.setState({
      [e.target.name]: e.target.value,
      pickUpDriverContactLoaded: false,
    });
    // console.log(this.state)
  };

  handleSelectChangeObj = (e, obj) => {
    let bucket = this.state.orderData[obj];
    bucket[e.target.name] = e.target.value;
    this.setState({
      [obj]: bucket,
    });
  };

  handleSelectChangeStateObj = (e, obj) => {
    let orderData = this.state.orderData;
    orderData[obj][e.target.name] = e.target.value;
    this.setState({
      orderData: orderData,
    });
  };

  handleSelectDropOffVendorChange = (e) => {
    console.log(e.target.value);
    this.setState({
      [e.target.name]: e.target.value,
      dropOffDriver: { firstName: '', lastName: '', email: '' },
      dropOffDriverName: ' ',
      dropOffDriverSelected: false,
      driversDropOffDataLoaded: false,
    });
    // console.log(this.state)
  };

  handleSelectPickUpVendorChange = (e) => {
    console.log(e.target.value);
    console.log(e.target.name);
    this.setState({
      [e.target.name]: e.target.value,
      pickUpDriver: { firstName: '', lastName: '', email: '' },
      pickUpDriverName: ' ',
      driverSelected: false,
      driversPickUpDataLoaded: false,
    });
    // console.log(this.state)
  };

  handleTogglePickupServices(value) {
    const { pickUpServices } = this.state;
    const currentIndex = pickUpServices.indexOf(value);
    const newPickUpServices = [...pickUpServices];

    if (currentIndex === -1) {
      newPickUpServices.push(value);
    } else {
      newPickUpServices.splice(currentIndex, 1);
    }

    this.setState({
      pickUpServices: newPickUpServices,
    });
  }

  handleToggleFactored() {
    db.collection('haney-orders')
        .doc(this.state.orderData.id)
        .set(
          {
            isFactored: !this.state.orderData.isFactored
          },
          { merge: true }
        ).then(() => {
          window.location.reload();
        });
  }

  handleToggleChargeback() {
    db.collection('haney-orders')
        .doc(this.state.orderData.id)
        .set(
          {
            isChargeback: !this.state.orderData.isChargeback
          },
          { merge: true }
        ).then(() => {
          window.location.reload();
        });
  }
 

  handleToggleDropOffServices(value) {
    const { dropOffServices } = this.state;
    const currentIndex = dropOffServices.indexOf(value);
    const newDropOffServices = [...dropOffServices];

    if (currentIndex === -1) {
      newDropOffServices.push(value);
    } else {
      newDropOffServices.splice(currentIndex, 1);
    }

    this.setState({
      dropOffServices: newDropOffServices,
    });
  }

  handleToggleServices(value, obj) {
    var orderData = this.state.orderData;
    var services = orderData[obj]['services'];
    const index = services.indexOf(value);

    if (index !== -1) {
      services.splice(index, 1);
    } else {
      services.push(value);
    }

    orderData[obj]['services'] = services;

    this.setState({ orderData: orderData });
  }

  handleClickOpen = (modal) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
    });
  };
  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  };

  closeSnack = (snack) => {
    this.setState({
      [snack]: false,
    });
  };

  closeModal = (id) => {
    this.setState({ [id]: false });
  };

  updateQuote = async () => {

    let origin = this.grabData('origin') ? this.grabData('origin') : null;
    origin['deliverBy'] = null;

    let destination = this.grabData('destination') ? this.grabData('destination') : null;
    destination['deliverBy'] = null;

    // destination = {...destination, deliverBy: null}
    const quoteInfo = {
      air: this.grabData('air') ? this.grabData('air') : null,
      cargoAir: this.grabData('cargoAir') ? this.grabData('cargoAir') : null,
      ground: this.grabData('ground') ? this.grabData('ground') : null,
      autoLtl: this.grabData('autoLtl') ? this.grabData('autoLtl') : null,
      ltl: this.grabData('ltl') ? this.grabData('ltl') : null,
      airQuote: this.grabData('airQuote') ? this.grabData('airQuote') : null,
      cargoAirQuote: this.grabData('cargoAirQuote') ? this.grabData('cargoAirQuote') : null,
      groundQuote: this.grabData('groundQuote') ? this.grabData('groundQuote') : null,
      autoLtlQuote: this.grabData('autoLtlQuote') ? this.grabData('autoLtlQuote') : null,
      ltlQuote: this.grabData('ltlQuote') ? this.grabData('ltlQuote') : null,
      subDeliveryType: this.grabData('subDeliveryType') ? this.grabData('subDeliveryType') : 'Next Day Air',
      vendorPickUp: null,
      vendorDropOff: null,
      pickUpDriver: null,
      dropOffDriver: null,
      pickUpRate: null,
      dropOffRate: null,
      origin: origin,
      destination: destination,
      userQuoted: this.props.user,
    };

    console.log(quoteInfo);
    if (
      !quoteInfo.airQuote &&
      !quoteInfo.cargoAirQuote &&
      !quoteInfo.groundQuote &&
      !quoteInfo.ltlQuote &&
      !quoteInfo.autoLtlQuote
    ) {
      this.setState({
        errorMessage: `Please fill out a quote`,
        errorSnack: true,
      });
      return;
    }

    const associations = [
      { key: 'air', label: 'Air' },
      { key: 'cargoAir', label: 'Next Day Air' },
      { key: 'ground', label: 'Ground' },
      { key: 'ltl', label: 'Additional Options' },
      { key: 'autoLtl', label: 'LTL' },
    ];
    const errors = [];

    for (let i = 0; i < associations.length; i++) {
      const quoteObject = quoteInfo[associations[i].key];
      const quote = quoteInfo[`${associations[i].key}Quote`];
      if (quote && !(quoteObject && quoteObject.quoteETA)) {
        errors.push(`ETA for ${associations[i].label}`);
      }
    }

    if (errors.length) {
      this.setState({
        errorSnackMessage: `Please fill out the following: ${errors.join(
          ', '
        )}`,
        errorSnack: true,
      });
      return;
    }

    const orderRef = db.collection('haney-orders').doc(this.props.orderID);
    const registerRef = orderRef.collection('register');

    const registerSnapshot = await registerRef
      .where('type', '==', 'quote approved')
      .get();

    const ordersToDelete = registerSnapshot.docs.map((doc) =>
      registerRef.doc(doc.id).delete()
    );

    Promise.all([
      ...ordersToDelete,
      orderRef.set(
        {
          status: 'Quoted',
          ...quoteInfo,
        },
        { merge: true }
      ),
    ]).then((responses) => {
      console.log(responses);
      window.location.reload();
    });
  };

  uploadImage = (refString, pic) => {
    console.log('Uploading image');
    return new Promise((resolve, reject) => {
      // create storage ref
      var storageRef = storage.ref(refString);
      // upload pic
      var uploadTask = storageRef.put(pic);
      // update progress bar
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          // Observe state change events such as progress, pause, and
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          var Progress =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.setState({
            uploadProgress: 'Progress is ' + Progress + '% done',
          });

          switch (snapshot.state) {
            case firebase.storage.TaskState.PAUSED: // or 'paused'
              this.setState({ uploadProgress: ' Upload is paused' });
              break;
            case firebase.storage.TaskState.RUNNING: // or 'running'
              this.setState({ uploadProgress: 'Upload is running' });
              break;
          }
        },
        (error) => {
          // Handle unsuccessful uploads
          console.log(error);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
  };

  reassignPickUpDriver = () => {
    console.log('reassign driver');
    console.log(this.state.orderData.id);
    if (this.state.pickUpDriver) {
      console.log('If hit');
      db.collection('haney-orders')
        .doc(this.state.orderData.id)
        .set(
          {
            pickUpDriver: this.state.pickUpDriver,
            vendorPickUp: this.state.vendorPickUp,
            pickUpDriverAssignedAt: new Date(),
          },
          { merge: true }
        )
        .then(() => {
          window.location.reload();
        });
    }
  };

  reassignDropOffDriver = () => {
    console.log('reassign driver');
    console.log(this.state.orderData.id);
    if (this.state.dropOffDriver) {
      console.log('If hit');
      db.collection('haney-orders')
        .doc(this.state.orderData.id)
        .set(
          {
            dropOffDriver: this.state.dropOffDriver,
            vendorDropOff: this.state.vendorDropOff,
            dropOffDriverAssignedAt: new Date(),
          },
          { merge: true }
        )
        .then(() => {
          window.location.reload();
        });
    }
  };

  createCancelLog = () => {
    db.collection('haney-orders')
      .doc(this.state.orderData.id)
      .collection('statusLogs')
      .add({
        status: 'Canceled',
        type: 'status',
        updatedAt: new Date(),
        updatedBy: {
          name: this.props.user.firstName + ' ' + this.props.user.lastName,
          uid: this.props.authUser.uid,
        },
      })

      .then(() => {
        window.location.reload();
      });
  };

  cancelOrder = () => {
    // update firestore document with PENDING and comment
    db.collection('haney-orders')
      .doc(this.state.orderData.id)
      .set(
        {
          status: 'canceled',
          canceledAt: new Date(),
        },
        { merge: true }
      )

      .then(() => {
        db.collection('TEST-users')
          .doc(this.state.orderData.uid)
          .collection('orders')
          .doc(this.state.orderData.id)
          .set(
            {
              status: 'canceled',
              canceledAt: new Date(),
            },
            { merge: true }
          );
      })
      .then(() => this.createCancelLog());
  };

  assignPic = (files, itemIndex) => {
    const orderData = this.state.orderData;
    orderData.items[itemIndex].files = files;
    this.setState({ orderData: orderData });
  };

  removePicture = (i, j) => {
    this.setState((prevState) => {
      const { orderData } = prevState;
      orderData.items[i].files.splice(j, 1);
      return {
        orderData: orderData,
      };
    });
  };

  openChat = (c) => {
    const chatsOpen = this.state.openChats;
    const index = chatsOpen.indexOf(c);
    if (index > -1) {
      chatsOpen.splice(index, 1);
    } else {
      chatsOpen.splice(chatsOpen.length, 0, c);
    }
    this.setState({ openChats: chatsOpen });
  };

  submitDelivery = () => {
    const { actualDeliveredAt, nameOfSigner } = this.state.orderData;
    db.collection('haney-orders')
      .doc(this.props.orderID)
      .set(
        {
          actualDeliveredAt: actualDeliveredAt ? actualDeliveredAt : null,
          nameOfSigner: nameOfSigner ? nameOfSigner : null,
          status: 'Delivered',
        },
        { merge: true }
      )
      .then(() => window.location.reload())
      .catch((err) => console.log(err));
  };

  newBOL = (order) => new Promise((resolve, reject) => {
    createBOL(order, '', this.state.esignEnabled)
      .then(data => {
        console.log('evergrande completed', data);
        this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });

        if (!data.error) {
          console.log('evergrande successful');

          resolve({
            urls: {
              signingURLs: [
                this.state.esignEnabled ? data.signers[0].embedded_signing_url : "",
                this.state.esignEnabled ? data.signers[1].embedded_signing_url : "",
                this.state.esignEnabled ? data.signers[2].embedded_signing_url : "",
              ],
            },
            hashes: {
              bolHash: this.state.esignEnabled ? data.document_hash : "",
              bolHashURL: this.state.esignEnabled ? `https://api.eversign.com/api/download_current_document_status?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${data.document_hash}&audit_trail=1` : data.fileURL,
            },
            fileURL: data.fileURL,
            freightBillNumber: order.freightBillNumber,
          });
        } else {
          console.log('error w/ evergrande')
          this.setState({
            errorSnack: true,
            errorSnackMessage: data.error ?
              (data.error.info ? data.error.info : data.error.type)
              : 'Unknown error',
          });
          reject(data.error);
        }
      })
  });

  createWaybill = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      additionalLegs,
    } = order;
    console.log('generating waybill');
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
        data: {
          sandbox: 0,
          is_draft: 0,
          embedded: 1,
          title: `Haney Freightways Sample Universal Waybill #${freightBillNumber}`,
          message: 'This is my general document message.',
          use_signer_order: 0,
          reminders: 1,
          require_all_signers: 0,
          custom_requester_name: '',
          custom_requester_email: '',
          redirect: '',
          redirect_decline: '',
          client: '',
          expires: 1750513480,
          embedded_signing_enabled: 1,
          flexible_signing: 0,
          use_hidden_tags: 0,
          files: [
            {
              name: 'House Waybill',
              file_url:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FSample%20Universal%20Air%20Waybill%20Clean%206.22.2020.pdf?alt=media&token=827f1f4d-d012-4e52-9077-a8a2a9b89942'
                  : deliveryType == 'Ground' ||
                    deliveryType == 'Additional Options'
                    ? 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FCustomer%20Docs%2FHaney Freightways%20Bill%20of%20Lading%20Final%20No%20Auto%20Calc%20Weight%206.16.2020.pdf?alt=media&token=3f3404fa-a892-46ab-bc10-7ccaea831c4d'
                    : null,
              file_id: '',
              file_base64: '',
            },
          ],
          signers: [
            {
              id: 1,
              name: 'Shipper Signer',
              email: vendorPickUp.email
                ? vendorPickUp.email
                : 'vendoralerts@cargorx.com',
              order: 1,
              role: orderID,
              // "pin": "3874",
              message: 'This is my custom message to Shipper.',
              deliver_email: 0,
              language: 'en',
            },
          ],
          recipients: [
            {
              name: 'Vendor Alerts',
              email: 'vendoralerts@cargorx.com',
              // "email": "justin@pondata.com",
              language: 'en',
            },
          ],
          meta: {
            some_key: 'some_value',
            another_key: 'another_value',
          },
          fields: [
            [
              {
                type: 'signature',
                x: '520',
                y: '930',
                width: '120',
                height: '35',
                page: '1',
                signer: '1',
                name: '',
                identifier: 'unique_field_identifier_1',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '55',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '35'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '120'
                      : '',
                width: '300',
                height: '30',
                page: '1',
                signer: 'OWNER',
                name: 'Shipper Name',
                identifier: 'unique_field_identifier_2',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '#000000',
                text_font: '',
                text_style: '',
                value: 'Haney Freightways, LLC',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '55',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '48'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '235'
                      : '',
                width: '300',
                height: '30',
                page: '1',
                signer: 'OWNER',
                name: 'Shipper Address',
                identifier: 'unique_field_identifier_3',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '#000000',
                text_font: '',
                text_style: '',
                value: '16600 E 33rd Dr, Unit 10',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '55',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '70'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Shipper Phone Number',
                identifier: 'unique_field_identifier_4',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: 'Aurora, CO 80011 833-227-4679',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '54',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '108'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Co- Signee Name',
                identifier: 'unique_field_identifier_5',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  "'HOLD FOR PICK UP' - " +
                  (flight
                    ? flight.destinationAirport
                      ? flight.destinationAirport.substr(1)
                      : ' '
                    : ' '),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '54',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '120'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'CO-Signee Address',
                identifier: 'unique_field_identifier_6',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff ? vendorDropOff.name : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '54',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '135'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Origin Address',
                identifier: 'unique_field_identifier_7',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff ? vendorDropOff.mainPhone : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '54',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '150'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Origin Address',
                identifier: 'unique_field_identifier_117',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff ? vendorDropOff.physicalAddress : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '54',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '160'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Origin Address',
                identifier: 'unique_field_identifier_1117',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff
                  ? vendorDropOff.physicalCity +
                  ' ' +
                  vendorDropOff.physicalState +
                  ' ' +
                  vendorDropOff.physicalZip
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '315',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '180'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '302',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Vendor Name',
                identifier: 'unique_field_identifier_8',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                font_weight: '600',
                value: "'PREAPID BY SHIPPER'",
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '315',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '200'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Service Level',
                identifier: 'unique_field_identifier_9',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  'Service Level: ' +
                  (serviceLevel ? serviceLevel.toUpperCase() : ' '),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '85',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '255'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Airport departure',
                identifier: 'unique_field_identifier_1011',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: flight ? flight.originAirport : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '54',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '280'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Airport departure',
                identifier: 'unique_field_identifier_1022',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  additionalLegs && additionalLegs.length
                    ? flight
                      ? flight.destinationAirport
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '94',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '280'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Airport departure',
                identifier: 'unique_field_identifier_1033',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  additionalLegs && additionalLegs.length
                    ? flight
                      ? flight.airlineName
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '325',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '255'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'references Number',
                identifier: 'unique_field_identifier_11',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '#' + freightBillNumber,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '85',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '275'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Carrier Code ID',
                identifier: 'unique_field_identifier_12',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: flight
                  ? flight.number
                    ? flight.number.substring(0, flight.number.lastIndexOf(' '))
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '415',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '280'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Carrier Code',
                identifier: 'unique_field_identifier_13',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].declaredValue,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '95',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '300'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Airport Code',
                identifier: 'unique_field_identifier_14',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  additionalLegs && additionalLegs.length
                    ? additionalLegs[0].destinationAirport
                    : flight
                      ? flight.destinationAirport
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '305'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Flight/Date',
                identifier: 'unique_field_identifier_15',
                validation_type: '',
                text_size: '14px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: flight ? flight.number : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '250',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '320'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Flight/Date',
                identifier: 'unique_field_identifier_16',
                validation_type: '',
                text_size: '14px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: additionalLegs
                  ? moment(
                    additionalLegs[0].departureTime.seconds
                      ? additionalLegs[0].departureTime.toDate()
                      : additionalLegs[0].departureTime
                  ).format('MM-DD-YYYY HH:mm')
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '320',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '305'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'flight/Date',
                identifier: 'unique_field_identifier_17',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].declaredValue,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '250',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '305'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Flight/Date',
                identifier: 'unique_field_identifier_18',
                validation_type: '',
                text_size: '14px',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  additionalLegs && additionalLegs.length
                    ? additionalLegs[0].number
                    : flight
                      ? flight.number
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '165',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '320'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Flight/Date',
                identifier: 'unique_field_identifier_19',
                validation_type: '',
                text_size: '14px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: flight
                  ? flight.departureTime
                    ? moment(
                      flight.departureTime.seconds
                        ? flight.departureTime.toDate()
                        : flight.departureTime
                    ).format('MM-DD-YYYY HH:mm')
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '140',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '335'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '143'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Booking Number',
                identifier: 'unique_field_identifier_20',
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: 'Booking Number:' + ' ' + bookingNumber,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '450',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '60'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Frieght Company Name',
                identifier: 'unique_field_identifier_21',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: flight
                  ? flight.airlineName
                    ? flight.airlineName
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              // {
              //   "type": "text",
              //   "x": "430",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "405" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "items",
              //   "identifier": "unique_field_identifier_22",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "22px",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items,
              //   "options": [],
              //   "group": ""
              // },
              {
                type: 'text',
                x: '150',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '15'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Air Waybill Number',
                identifier: 'unique_field_identifier_23',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: airWaybillNumber ? airWaybillNumber : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '190',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '40'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'CargoRx Account Number',
                identifier: 'unique_field_identifier_24',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (originAirlineDetails[0] ? (originAirlineDetails[0].cargorxAccountNumber ? originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ",
                value:
                  deliveryType == 'Air'
                    ? originAirlineDetails
                      ? originAirlineDetails[0]
                        ? originAirlineDetails[0].cargorxAccountNumber
                          ? originAirlineDetails[0].cargorxAccountNumber
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.cargorxAccountNumber
                          ? originAirCarrier.cargorxAccountNumber
                          : ' '
                        : ' '
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '400'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_25',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].description,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '60',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '400'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_125',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].quantity,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '100',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '400'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_225',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].weight,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '420'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_26',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '60',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '420'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_126',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '100',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '420'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_226',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '440'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_27',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '60',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '440'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_327',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '100',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '440'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_227',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '460'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_427',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '60',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '460'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_527',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '100',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '460'
                    : deliveryType == 'Ground' ||
                      deliveryType == 'Additional Options'
                      ? '126'
                      : '',
                width: '300',
                height: '17',
                page: '1',
                signer: 'OWNER',
                name: 'Freight description',
                identifier: 'unique_field_identifier_627',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '22px',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].weight : ' ',
                options: [],
                group: '',
              },
              // {
              //   "type": "text",
              //   "x": "60",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "400" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Freight description",
              //   "identifier": "unique_field_identifier_28",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "22px",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (items[1] ? (items[2] ? (Number(items[0].quantity) + Number(items[1].quantity) + Number(items[2].quantity)) : (Number(items[0].quantity) + Number(items[1].quantity))) : items[0].quantity),
              //   "options": [],
              //   "group": ""
              // },
              // {
              //   "type": "text",
              //   "x": "100",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? "400" : ((deliveryType == "Ground" || deliveryType == "Additional Options") ? "126" : "")),
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Freight description",
              //   "identifier": "unique_field_identifier_29",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "22px",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (items[1] ? (items[2] ? (Number(items[0].weight) + Number(items[1].weight) + Number(items[2].weight)) : (Number(items[0].weight) + Number(items[1].weight))) : items[0].weight),
              //   "options": [],
              //   "group": ""
              // }
            ],
          ],
        },
        // "params": {
        //   "withFlightInfoOnly": "false"
        // }
      })
        .then((response) => {
          this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
          console.log(response);

          if (!response.data.error) {
            console.log('got waybill');
            const res = {
              urls: {
                signingSampleWayBill:
                  response.data.signers[0].embedded_signing_url,
              },
              hashes: {
                sampleWayBillHash: response.data.document_hash,
              },
            };
            resolve(res);
          } else {
            console.log(response.data);
            this.setState({
              errorSnack: true,
              errorSnackMessage: response.data.error
                ? response.data.error.info
                  ? response.data.error.info
                  : response.data.error.type
                : 'Unknown error',
            });
            reject(response);
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            errorSnack: true,
            errorSnackMessage: 'Unknown error',
          });
        });
    });
  };

  // CARRIER DROP OFF NOTIFICATION
  createDropOffNotification = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
    } = order;

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
        data: {
          sandbox: 0,
          is_draft: 0,
          embedded: 1,
          title: `Haney Freightways Drop Off Alert #${freightBillNumber}`,
          message: 'This is my general document message.',
          use_signer_order: 0,
          reminders: 1,
          require_all_signers: 0,
          custom_requester_name: '',
          custom_requester_email: '',
          redirect: '',
          redirect_decline: '',
          client: '',
          expires: 1750513480,
          embedded_signing_enabled: 1,
          flexible_signing: 0,
          use_hidden_tags: 0,
          files: [
            {
              name:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'Air Delivery Dispatch Alert'
                  : 'Ground Only Dispatch Alert',
              file_url:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FUNKNOWN%20Party%20Air%20Shipment%20Documents%2FDelivery%20Vendor%20Driver%20Docs%2FPick-Up%20Dispatch%20(Airline%20to%20Destination)%207.8.2020.pdf?alt=media&token=f6cd14ef-a71f-4d04-a136-b57b7ce1c0ae'
                  : 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FVendor%20Driver%20Docs%2FGround%20Only%20Dispatch%20(Origin%20to%20Destination)%20Final%203.20.2020.pdf?alt=media&token=2da3c1da-541e-471b-bd6b-bb3d5c91c8a6',
              file_id: '',
              file_base64: '',
            },
          ],
          signers: [
            {
              id: 1,
              name: 'Delivery Driver',
              email: vendorDropOff.email
                ? vendorDropOff.email
                : 'vendoralerts@cargorx.com',
              order: 1,
              role: orderID,
              // "pin": "3874",
              message: 'This is my custom message to Signer.',
              deliver_email: '',
              language: 'en',
            },
          ],
          recipients: [
            {
              name: 'Vendor Alerts',
              email: 'vendoralerts@cargorx.com',
              // "email": "justin@pondata.com",
              language: 'en',
            },
          ],
          meta: {
            some_key: 'some_value',
            another_key: 'another_value',
          },
          fields: [
            [
              {
                type: 'text',
                x: '120',
                y: '225',
                width: '100',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Name',
                identifier: 'unique_field_identifier_6',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '245',
                width: '100',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Phone',
                identifier: 'unique_field_identifier_7',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '(833) 227 4679',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '268',
                width: '150',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Email',
                identifier: 'unique_field_identifier_8',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: 'operations@cargorx.com',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '190',
                y: '297',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Ready Date/Time',
                identifier: 'unique_field_identifier_9',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.deliverBy
                  ? moment(destination.deliverBy).format('MM-DD-YYYY HH:mm')
                  : destination.endTimeWindow == null
                    ? String(
                      destination.date
                        ? moment(destination.date.toDate()).format(
                          'MM-DD-YYYY HH:mm'
                        )
                        : ' '
                    )
                    : destination.date
                      ? String(
                        moment(destination.date.toDate()).format('MM-DD-YYYY')
                      ) +
                      ' ' +
                      (destination.startTimeWindow &&
                        String(destination.startTimeWindow))
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '650',
                y: '225',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Waybill Number',
                identifier: 'unique_field_identifier_10',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: freightBillNumber,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '672',
                y: '295',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Delivery Date/Time',
                identifier: 'unique_field_identifier_11',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm'),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '555'
                    : '545',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Total Charges',
                identifier: 'unique_field_identifier_12',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '130',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '405'
                    : '395',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Name',
                identifier: 'unique_field_identifier_13',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff
                  ? vendorDropOff.name
                    ? vendorDropOff.name
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '115',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '450'
                    : '440',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'phone',
                identifier: 'unique_field_identifier_15',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff
                  ? vendorDropOff.phone
                    ? vendorDropOff.phone
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '115',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '470'
                    : '460',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Email',
                identifier: 'unique_field_identifier_16',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff
                  ? vendorDropOff.email
                    ? vendorDropOff.email
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '493'
                    : '483',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'DOT Number',
                identifier: 'unique_field_identifier_17',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff
                  ? vendorDropOff.dotNumber
                    ? vendorDropOff.dotNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '515'
                    : '505',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Name',
                identifier: 'unique_field_identifier_18',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '175',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '600'
                    : '590',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Print Name',
                identifier: 'unique_field_identifier_20',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '100',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '622'
                    : '612',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Date',
                identifier: 'unique_field_identifier_21',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": String(new Date()),
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '510',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '407'
                    : '397',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_22',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffDriver
                  ? dropOffDriver.firstName + ' ' + dropOffDriver.lastName
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '430'
                    : '420',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Phone',
                identifier: 'unique_field_identifier_23',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffDriver
                  ? dropOffDriver.cellPhone
                    ? dropOffDriver.cellPhone
                    : dropOffDriver.directPhone
                      ? dropOffDriver.directPhone
                      : dropOffDriver.cell
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '452'
                    : '442',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Email',
                identifier: 'unique_field_identifier_24',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffDriver ? dropOffDriver.email : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '632',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Company Name',
                identifier: 'unique_field_identifier_25',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": flight ? flight.movement.airport.icao : " ",
                value:
                  deliveryType == 'Air'
                    ? flight
                      ? flight.airlineName + ' ' + flight.destinationAirport
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.businessName +
                        ' ' +
                        destinationAirCarrier.airCode
                        : ' '
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '125',
                y: '653',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Address',
                identifier: 'unique_field_identifier_26',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalAddress : " ") : " ",
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalAddress
                          ? destinationAirlineDetails[0].physicalAddress
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.address
                        : ' '
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '110',
                y: '675',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'City',
                identifier: 'unique_field_identifier_27',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalCity
                          ? destinationAirlineDetails[0].physicalCity
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.city
                        : ' '
                      : ' ',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalCity : " ") : " ",
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '251',
                y: '675',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'State',
                identifier: 'unique_field_identifier_28',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalState : " ") : " ",
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalState
                          ? destinationAirlineDetails[0].physicalState
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.state
                        : ' '
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '360',
                y: '675',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Zip',
                identifier: 'unique_field_identifier_29',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalZip
                          ? destinationAirlineDetails[0].physicalZip
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.zip
                        : ' '
                      : ' ',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalZip : " ") : " ",
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '750',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact name / account #',
                identifier: 'unique_field_identifier_30',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '720',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Phone / flight #',
                identifier: 'unique_field_identifier_31',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' ? (flight ? flight.number : ' ') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '790',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Email',
                identifier: 'unique_field_identifier_32',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '235',
                y: '758',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name / airline waybill',
                identifier: 'unique_field_identifier_33',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? airWaybillNumber
                      ? airWaybillNumber
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '235',
                y: '780',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name / booking #',
                identifier: 'unique_field_identifier_34',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? bookingNumber
                      ? bookingNumber
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '245',
                y: '805',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name / origin airport',
                identifier: 'unique_field_identifier_35',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? (flight ? 'Origin Airport: ' + flight.airlineName : ' ') +
                    ' ' +
                    (flight ? flight.originAirport : ' ')
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.businessName +
                        ('Origin Airport: ' + originAirCarrier.airCode)
                        : ' '
                      : destination.businessName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '245',
                y: '880',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_36',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '605',
                y: '632',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_37',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.businessName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '652',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery Address',
                identifier: 'unique_field_identifier_38',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.address,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '510',
                y: '672',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery City',
                identifier: 'unique_field_identifier_39',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.city,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '760',
                y: '672',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery Zip',
                identifier: 'unique_field_identifier_40',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.zip,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '655',
                y: '672',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery State',
                identifier: 'unique_field_identifier_41',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.state,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '700',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Name',
                identifier: 'unique_field_identifier_42',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.firstName
                  ? destination.firstName + ' ' + destination.lastName
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '720',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Phone',
                identifier: 'unique_field_identifier_43',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.phone ? destination.phone : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '742',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Email',
                identifier: 'unique_field_identifier_44',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.email ? destination.email : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '815',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Secondary Contact Name',
                identifier: 'unique_field_identifier_45',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '835',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Secondary Contact Phone',
                identifier: 'unique_field_identifier_46',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '855',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Secondary Contact Email',
                identifier: 'unique_field_identifier_47',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '645',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '830'
                    : '877',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_48',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.referenceID ? destination.referenceID : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '505',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '895'
                    : '900',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_49',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.customExtraService
                  ? destination.customExtraService
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '575',
                y: '965',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_50',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '175',
                y: '900',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_51',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : origin.customExtraService
                      ? origin.customExtraService
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '205',
                y: '965',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_52',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_53',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].quantity,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '955',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_54',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_55',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_56',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_156',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_57',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].description,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_58',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_59',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_159',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_60',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].weight,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_61',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_62',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_162',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_63',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].length,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_64',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_65',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_165',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_66',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].width,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_67',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_68',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_168',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_69',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].height,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_70',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_71',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_171',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_72',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].unNumber ? items[0].unNumber : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_73',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1]
                  ? items[1].unNumber
                    ? items[1].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_74',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2]
                  ? items[2].unNumber
                    ? items[2].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_174',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3]
                  ? items[3].unNumber
                    ? items[3].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Hazmat',
                identifier: 'unique_field_identifier_75',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].isHazmat ? 'Yes' : 'No',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_76',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? (items[1].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_77',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? (items[2].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_177',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? (items[3].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '145',
                y: '600',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: ' ',
                identifier: 'unique_field_identifier_80',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (((this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0))),
                value: ' ',
                options: [],
                group: '',
              },
            ],
          ],
        },
        // "params": {
        //   "withFlightInfoOnly": "false"
        // }
      })
        .then((response) => {
          this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
          console.log(response);

          if (!response.data.error) {
            console.log('got dropoff notification');
            const res = {
              urls: {
                driverDropOffRateConURL:
                  response.data.signers[0].embedded_signing_url,
              },
              hashes: {
                driverDropOffRateHash: response.data.document_hash,
              },
            };
            resolve(res);
          } else {
            console.log(response.data);
            this.setState({
              errorSnack: true,
              errorSnackMessage: response.data.error
                ? response.data.error.info
                  ? response.data.error.info
                  : response.data.error.type
                : 'Unknown error',
            });
            reject(response);
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            errorSnack: true,
            errorSnackMessage: 'Unknown Error',
          });
          reject(err);
        });
    });
  };

  // CARRIER PICK UP NOTIFICATION
  createPickUpNotification = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      flightNumber,
    } = order;

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
        data: {
          sandbox: 0,
          is_draft: 0,
          embedded: 1,
          title: `Haney Freightways Alert #${freightBillNumber}`,
          message: 'This is my general document message.',
          use_signer_order: 0,
          reminders: 0,
          require_all_signers: 0,
          custom_requester_name: '',
          custom_requester_email: '',
          redirect: '',
          redirect_decline: '',
          client: '',
          expires: 1750513480,
          embedded_signing_enabled: 1,
          flexible_signing: 0,
          use_hidden_tags: 0,
          files: [
            {
              name:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'Air Pick Up Rate Confirmation'
                  : 'Ground Only Rate Confirmation',
              file_url:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? origin.ksms
                    ? 'https://firebasestorage.googleapis.com/v0/b/freightdragons.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Dispatcher%20Docs%2F3rd%20Page%20Haney Freightways%20IAC%20Known%20Shipper%20Cargo%20Certification%20Statement%20(3).pdf?alt=media&token=060f97a8-430b-4f76-9eec-eb184b86b880'
                    : 'https://firebasestorage.googleapis.com/v0/b/freightdragons.appspot.com/o/forms%2FUNKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Dispatcher%20Docs%2F3rd%20Page%20Haney Freightways%20Unknown%20Shipper%20Cargo%20Certification%20Statement%20(2).pdf?alt=media&token=32f92896-a48e-4ef0-9070-3a583fdbd537'
                  : 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FDedicated%20Ground%20Shipment%20Documents%2FVendor%20Driver%20Docs%2FGround%20Only%20Dispatch%20(Origin%20to%20Destination)%20Final%203.20.2020.pdf?alt=media&token=2da3c1da-541e-471b-bd6b-bb3d5c91c8a6',
              file_id: '',
              file_base64: '',
            },
          ],
          signers: [
            {
              id: 1,
              name: ' ',
              email: vendorPickUp.email
                ? vendorPickUp.email
                : 'vendoralerts@cargorx.com',
              order: 1,
              role: orderID,
              // "pin": "3874",
              message: 'This is my custom message to Signer.',
              deliver_email: '',
              language: 'en',
            },
          ],
          recipients: [
            {
              name: 'Vendor Alerts',
              email: 'vendoralerts@cargorx.com',
              // "email": "justin@pondata.com",
              language: 'en',
            },
          ],
          meta: {
            some_key: 'some_value',
            another_key: 'another_value',
          },
          fields: [
            [
              //   {
              //   "type": "text",
              //   "x": "120",
              //   "y": "225",
              //   "width": "100",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Haney Freightways Contact Name",
              //   "identifier": "unique_field_identifier_6",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "120",
              //   "y": "245",
              //   "width": "100",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Haney Freightways Contact Phone",
              //   "identifier": "unique_field_identifier_7",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": "(833) 227 4679",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "120",
              //   "y": "268",
              //   "width": "150",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Haney Freightways Contact Email",
              //   "identifier": "unique_field_identifier_8",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": "operations@cargorx.com",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "190",
              //   "y": "297",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Haney Freightways Contact Ready Date/Time",
              //   "identifier": "unique_field_identifier_9",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (origin.endTimeWindow == null) ? String(origin.date ? moment(origin.date.toDate()).format('MM-DD-YYYY HH:mm') : " ") : (origin.date ? String(moment(origin.date.toDate()).format('MM-DD-YYYY')) + " " + (origin.startTimeWindow && String(origin.startTimeWindow)) : " "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "650",
              //   "y": "225",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Haney Freightways Contact Waybill Number",
              //   "identifier": "unique_field_identifier_10",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": freightBillNumber ? freightBillNumber : ' ',
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "672",
              //   "y": "295",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Haney Freightways Contact Delivery Date/Time",
              //   "identifier": "unique_field_identifier_11",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? String(moment((origin.deliverBy.seconds ? origin.deliverBy.toDate() : origin.deliverBy)).format('MM-DD-YYYY HH:mm')) : moment(serviceETA.toDate()).format('MM-DD-YYYY HH:mm'),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "180",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "555" : "545",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Carrier Total Charges",
              //   "identifier": "unique_field_identifier_12",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "130",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "405" : "405",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Carrier Name",
              //   "identifier": "unique_field_identifier_13",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": vendorPickUp.name ? vendorPickUp.name : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "170",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "430" : "430",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Carrier Pro Number",
              //   "identifier": "unique_field_identifier_14",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "115",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "450" : "450",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "phone",
              //   "identifier": "unique_field_identifier_15",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": vendorPickUp.phone ? vendorPickUp.phone : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "115",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "470" : "470",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Email",
              //   "identifier": "unique_field_identifier_16",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": vendorPickUp.email ? vendorPickUp.email : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "180",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "493" : "493",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "DOT Number",
              //   "identifier": "unique_field_identifier_17",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": vendorPickUp.dotNumber ? vendorPickUp.dotNumber : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "180",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "515" : "515",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Contact Name",
              //   "identifier": "unique_field_identifier_18",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "225",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "537" : "537",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Pick-up Service Level",
              //   "identifier": "unique_field_identifier_19",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": "",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "510",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "407" : "407",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_22",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": pickUpDriver ? ((pickUpDriver.name == "undefined undefined") ? (pickUpDriver.firstName + " " + pickUpDriver.lastName) : pickUpDriver.name) : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "515",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "430" : "430",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Phone",
              //   "identifier": "unique_field_identifier_23",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": pickUpDriver ? (pickUpDriver.cellPhone ? pickUpDriver.cellPhone : (pickUpDriver.directPhone ? pickUpDriver.directPhone : pickUpDriver.cell )) : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "515",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "452" : "452",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Email",
              //   "identifier": "unique_field_identifier_24",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": pickUpDriver ? pickUpDriver.email : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "555" : "525",
              //   "y": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? "474" : "474",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Email",
              //   "identifier": "unique_field_identifier_78",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": pickUpDriver ? (pickUpDriver.sta && (pickUpDriver.sta)) : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "185",
              //   "y": "672",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Company Name",
              //   "identifier": "unique_field_identifier_25",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.businessName,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "125",
              //   "y": "695",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Address",
              //   "identifier": "unique_field_identifier_26",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.address,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "110",
              //   "y": "718",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "City",
              //   "identifier": "unique_field_identifier_27",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.city,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "251",
              //   "y": "718",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "State",
              //   "identifier": "unique_field_identifier_28",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.state,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "360",
              //   "y": "718",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Zip",
              //   "identifier": "unique_field_identifier_29",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.zip,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "185",
              //   "y": "740",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Contact name",
              //   "identifier": "unique_field_identifier_30",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (origin.firstName ? origin.firstName : " ") + " " + (origin.lastName ? origin.lastName : " "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "185",
              //   "y": "760",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Contact Phone",
              //   "identifier": "unique_field_identifier_31",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.phone ? origin.phone : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "185",
              //   "y": "780",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Contact Email",
              //   "identifier": "unique_field_identifier_32",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.email ? origin.email : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "255",
              //   "y": "802",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_33",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "255",
              //   "y": "826",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_34",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "255",
              //   "y": "845",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_35",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "245",
              //   "y": "870",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_36",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.referenceID ? origin.referenceID : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "605",
              //   "y": "870",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_81",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : (destination.referenceID ? destination.referenceID : " "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "605",
              //   "y": "672",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_37",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": ((deliveryType == "Air") ? ((flight ? (flight.airlineName ? flight.airlineName : " ") : " ") + " " + (flight ? flight.originAirport : " ")) : (deliveryType == "Scheduled Air" ? (originAirCarrier ? (originAirCarrier.businessName + " " + originAirCarrier.airCode) : " ") : destination.businessName)),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "585",
              //   "y": "692",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Delivery Address",
              //   "identifier": "unique_field_identifier_38",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].physicalAddress ? originAirlineDetails[0].physicalAddress : " ") : " ") : " ") : ((deliveryType == "Scheduled Air") ? (originAirCarrier ? originAirCarrier.address : " ") : destination.address),
              //   // "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].cargorxAccountNumber ? originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? originAirCarrier.cargorxAccountNumber : " "),
              //   // "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.address) : originAirlineDetails[0].physicalAddress) : destination.address),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "510",
              //   "y": "715",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Delivery City",
              //   "identifier": "unique_field_identifier_39",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].physicalCity ? originAirlineDetails[0].physicalCity : " ") : " ") : " ") : ((deliveryType == "Scheduled Air") ? (originAirCarrier ? originAirCarrier.city : " ") : destination.city),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "760",
              //   "y": "715",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Delivery Zip",
              //   "identifier": "unique_field_identifier_40",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].physicalZip ? originAirlineDetails[0].physicalZip : " ") : " ") : " ") : ((deliveryType == "Scheduled Air") ? (originAirCarrier ? originAirCarrier.zip : " ") : destination.zip),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "655",
              //   "y": "715",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Delivery State",
              //   "identifier": "unique_field_identifier_41",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].physicalState ? originAirlineDetails[0].physicalState : " ") : " ") : " ") : ((deliveryType == "Scheduled Air") ? (originAirCarrier ? originAirCarrier.state : " ") : destination.state),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "585",
              //   "y": "740",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Destination Contact Name",
              //   "identifier": "unique_field_identifier_42",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : (destination.firstName ? (destination.firstName + " " + destination.lastName) : " ")),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "585",
              //   "y": "762",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Destination Contact Phone",
              //   "identifier": "unique_field_identifier_43",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : (destination.phone ? destination.phone : " ")),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "585",
              //   "y": "782",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Destination Contact Email / Account number",
              //   "identifier": "unique_field_identifier_44",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? (originAirCarrier.cargorxAccountNumber ? originAirCarrier.cargorxAccountNumber : " ") : (destination.email ? destination.email : " ")),
              //   "value": (deliveryType == "Air") ? (originAirlineDetails ? (originAirlineDetails[0] ? (originAirlineDetails[0].cargorxAccountNumber ? originAirlineDetails[0].cargorxAccountNumber : " ") : " ") : " ") : (deliveryType == "Scheduled Air" ? (originAirCarrier ? (originAirCarrier.cargorxAccountNumber ? originAirCarrier.cargorxAccountNumber : " ") : " ") : " "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "660",
              //   "y": "805",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Booking",
              //   "identifier": "unique_field_identifier_45",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (bookingNumber ? bookingNumber : " ") : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "660",
              //   "y": "825",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Airline Waybill Number",
              //   "identifier": "unique_field_identifier_46",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (airWaybillNumber ? airWaybillNumber : " ") : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "660",
              //   "y": "845",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Flight Number",
              //   "identifier": "unique_field_identifier_47",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": deliveryType == "Air" ? flight ? flight.number : flightNumber : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "645",
              //   "y": "867",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Destination airport",
              //   "identifier": "unique_field_identifier_48",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": deliveryType == "Air" ? (flight ? flight.destinationAirport : ' ') : (deliveryType == "Scheduled Air" ? (destinationAirCarrier ? destinationAirCarrier.airCode : " ") : " "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "490",
              //   "y": "930",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_49",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? ("MUST MARK AIR WAYBILL AS: " + serviceLevel) : (destination.customExtraService ? destination.customExtraService : " "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "575",
              //   "y": "955",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_50",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "100",
              //   "y": "930",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_51",
              //   "required": 0,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": origin.customExtraService ? origin.customExtraService : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "205",
              //   "y": "955",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_52",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "70",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Item quantity 1",
              //   "identifier": "unique_field_identifier_53",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[0].quantity,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "185",
              //   "y": "955",
              //   "width": "300",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_54",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "70",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_55",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? items[1].quantity : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "70",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_56",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? items[2].quantity : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "70",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_156",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? items[3].quantity : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "100",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_57",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[0].description,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "100",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_58",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? items[1].description : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "100",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_59",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? items[2].description : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "100",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_159",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? items[3].description : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "355",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_60",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[0].weight,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "355",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_61",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? items[1].weight : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "355",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_62",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? items[2].weight : " ",
              //   "options": [],
              //   "group": ""
              // },{
              //   "type": "text",
              //   "x": "355",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_162",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? items[3].weight : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "430",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_63",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[0].length,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "430",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_64",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? items[1].length : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "430",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_65",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? items[2].length : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "430",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_165",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? items[3].length : " ",
              //   "options": [],
              //   "group": ""
              // },{
              //   "type": "text",
              //   "x": "515",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_66",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[0].width,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "515",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_67",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? items[1].width : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "515",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_68",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? items[2].width : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "515",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_168",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? items[3].width : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "590",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_69",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[0].height,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "590",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_70",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? items[1].height : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "590",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_71",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? items[2].height : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "590",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_171",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? items[3].height : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "680",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_72",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (items[0].unNumber ? items[0].unNumber : " "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "680",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_73",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? (items[1].unNumber ? items[1].unNumber : " ") : (" "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "680",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_74",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? (items[2].unNumber ? items[2].unNumber : " ") : (" "),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "680",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_174",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? (items[3].unNumber ? items[3].unNumber : " ") : (" "),
              //   "options": [],
              //   "group": ""
              // },{
              //   "type": "text",
              //   "x": "770",
              //   "y": "236",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Hazmat",
              //   "identifier": "unique_field_identifier_75",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": (items[0].isHazmat ? "Yes" : "No"),
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "770",
              //   "y": "256",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_76",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[1] ? (items[1].isHazmat ? "Yes" : "No") : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "770",
              //   "y": "276",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_77",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[2] ? (items[2].isHazmat ? "Yes" : "No") : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "770",
              //   "y": "296",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "Driver name",
              //   "identifier": "unique_field_identifier_177",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   "value": items[3] ? (items[3].isHazmat ? "Yes" : "No") : " ",
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "text",
              //   "x": "145",
              //   "y": "600",
              //   "width": "300",
              //   "height": "17",
              //   "page": "2",
              //   "signer": "1",
              //   "name": "total declared value",
              //   "identifier": "unique_field_identifier_80",
              //   "required": 1,
              //   "readonly": 1,
              //   "validation_type": "",
              //   "text_size": "",
              //   "text_color": "",
              //   "text_font": "",
              //   "text_style": "",
              //   // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
              //   "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? " " : (items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0),
              //   "options": [],
              //   "group": ""
              // },
              {
                type: 'text',
                x: '94',
                y: origin.ksms ? '300' : '270',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: 'Date',
                identifier: 'unique_field_identifier_100',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? String(new Date())
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '210',
                y: origin.ksms ? '330' : '300',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: 'Date',
                identifier: 'unique_field_identifier_101',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? airWaybillNumber
                      ? airWaybillNumber
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '280',
                y: origin.ksms ? '360' : '330',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: 'Date',
                identifier: 'unique_field_identifier_102',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '150',
                y: origin.ksms ? '417' : '387',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: 'Date',
                identifier: 'unique_field_identifier_104',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? vendorPickUp
                      ? vendorPickUp.name
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '160',
                y: origin.ksms ? '448' : '418',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: 'Company AddresS',
                identifier: 'unique_field_identifier_105',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? vendorPickUp
                      ? (vendorPickUp.physicalAddress
                        ? vendorPickUp.physicalAddress
                        : ' ') +
                      ' ' +
                      (vendorPickUp.physicalCity
                        ? vendorPickUp.physicalCity
                        : ' ') +
                      ' ' +
                      (vendorPickUp.physicalZip
                        ? vendorPickUp.physicalZip
                        : ' ')
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '105',
                y: origin.ksms ? '478' : '446',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: 'Company Phone',
                identifier: 'unique_field_identifier_106',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? vendorPickUp
                      ? vendorPickUp.mainPhone
                        ? vendorPickUp.mainPhone
                        : ' '
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: origin.ksms ? '505' : '475',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: 'driver print name',
                identifier: 'unique_field_identifier_107',
                required: 1,
                readonly:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? 0
                    : 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'signature',
                x: '155',
                y: origin.ksms ? '530' : '500',
                width: '120',
                height: '35',
                page: 1,
                signer: '1',
                name: '',
                identifier: 'unique_field_identifier_108',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '250',
                y: origin.ksms ? '565' : '535',
                width: '300',
                height: '17',
                page: 1,
                signer: '1',
                name: ' ',
                identifier: 'unique_field_identifier_109',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? pickUpDriver
                      ? pickUpDriver.sta && pickUpDriver.sta
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
            ],
          ],
        },
        // "params": {
        //   "withFlightInfoOnly": "false"
        // }
      })
        .then((response) => {
          this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
          console.log(response);

          if (!response.data.error) {
            console.log('got pick up notification');
            const res = {
              urls: {
                driverPickUpRateConURL:
                  response.data.signers[0].embedded_signing_url,
              },
              hashes: {
                driverPickUpRateConHash: response.data.document_hash,
              },
            };
            resolve(res);
          } else {
            console.log(response.data);
            this.setState({
              errorSnack: true,
              errorSnackMessage: response.data.error
                ? response.data.error.info
                  ? response.data.error.info
                  : response.data.error.type
                : 'Unknown error',
            });
            reject(response);
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            errorSnack: true,
            errorSnackMessage: 'Unknown error',
          });
          reject(err);
        });
    });
  };

  //AIR PICK UP ivf
  createPickUpIVF = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
    } = order;

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
        data: {
          sandbox: 0,
          is_draft: 0,
          embedded: 1,
          title: `Haney Freightways Alert #${freightBillNumber}`,
          message: 'This is my general document message.',
          use_signer_order: 0,
          reminders: 0,
          require_all_signers: 0,
          custom_requester_name: '',
          custom_requester_email: '',
          redirect: '',
          redirect_decline: '',
          client: '',
          expires: 1750513480,
          embedded_signing_enabled: 1,
          flexible_signing: 0,
          use_hidden_tags: 0,
          files: [
            {
              name:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'Air Pick Up Rate Confirmation'
                  : 'Ground Only Rate Confirmation',
              file_url:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Dispatcher%20Docs%2FIdentification%20Validation%20Form%206.20.2020.pdf?alt=media&token=2df8fdad-fa0c-4215-9f28-d615e782aa3e'
                  : 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Dispatcher%20Docs%2FIdentification%20Validation%20Form%206.20.2020.pdf?alt=media&token=2df8fdad-fa0c-4215-9f28-d615e782aa3e',
              file_id: '',
              file_base64: '',
            },
          ],
          signers: [
            {
              id: 1,
              name: 'Pick Up Driver',
              email: vendorPickUp.email
                ? vendorPickUp.email
                : 'vendoralerts@cargorx.com',
              order: 1,
              role: orderID,
              // "pin": "3874",
              message: 'This is my custom message to Signer.',
              deliver_email: '',
              language: 'en',
            },
          ],
          recipients: [
            {
              name: 'Vendor Alerts',
              email: 'vendoralerts@cargorx.com',
              // "email": "justin@pondata.com",
              language: 'en',
            },
          ],
          meta: {
            some_key: 'some_value',
            another_key: 'another_value',
          },
          fields: [
            [
              //   {
              //   "type": "dropdown",
              //   "x": "500",
              //   "y": "225",
              //   "width": "55",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "ID TYPE",
              //   "identifier": "unique_field_identifier_1",
              //   "required": 1,
              //   "readonly": 0,
              //   "text_size": 16,
              //   "text_color": "#FF0000",
              //   "text_font": "arial",
              //   "text_style": "BUI",
              //   "validation_type": "",
              //   "value": " ",
              //   "options": [
              //     "Government Issued",
              //     "Company Issued"
              //   ]
              // },
              {
                type: 'text',
                x: '500',
                y: '225',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'ID TYPE',
                identifier: 'unique_field_identifier_1',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              // {
              //   "type": "dropdown",
              //   "x": "540",
              //   "y": "273",
              //   "width": "55",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Matching Photo on ID?",
              //   "identifier": "unique_field_identifier_2",
              //   "required": 1,
              //   "readonly": 0,
              //   "text_size": 16,
              //   "text_color": "#FF0000",
              //   "text_font": "arial",
              //   "text_style": "BUI",
              //   "validation_type": "",
              //   "value": " ",
              //   "options": [
              //     "Yes",
              //     "No"
              //   ]
              // },
              {
                type: 'text',
                x: '500',
                y: '273',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Matching Photo on ID?',
                identifier: 'unique_field_identifier_2',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              // {
              //   "type": "dropdown",
              //   "x": "540",
              //   "y": "357",
              //   "width": "55",
              //   "height": "17",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Matching Photo on ID?",
              //   "identifier": "unique_field_identifier_3",
              //   "required": 1,
              //   "readonly": 0,
              //   "text_size": 16,
              //   "text_color": "#FF0000",
              //   "text_font": "arial",
              //   "text_style": "BUI",
              //   "validation_type": "",
              //   "value": " ",
              //   "options": [
              //     "Yes",
              //     "No"
              //   ]
              // },
              {
                type: 'text',
                x: '500',
                y: '357',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Matching Photo on ID?',
                identifier: 'unique_field_identifier_3',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              // {
              //   "type": "checkbox",
              //   "x": "562",
              //   "y": "273",
              //   "width": "14",
              //   "height": "14",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Matching Photo on ID?",
              //   "identifier": "unique_field_identifier_37",
              //   "required": 1,
              //   "readonly": 0,
              //   "validation_type": "",
              //   "value": 0,
              //   "options": [],
              //   "group": ""
              // },
              // {
              //   "type": "checkbox",
              //   "x": "640",
              //   "y": "265",
              //   "width": "14",
              //   "height": "14",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Freight Charge Terms Prepaid",
              //   "identifier": "unique_field_identifier_38",
              //   "required": 1,
              //   "readonly": 0,
              //   "validation_type": "",
              //   "value": 0,
              //   "options": [],
              //   "group": ""
              // },
              {
                type: 'text',
                x: '500',
                y: '310',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'type of id reviewed',
                identifier: 'unique_field_identifier_4',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              // {
              //   "type": "checkbox",
              //   "x": "560",
              //   "y": "355",
              //   "width": "14",
              //   "height": "14",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Freight Charge Terms Prepaid",
              //   "identifier": "unique_field_identifier_5",
              //   "required": 1,
              //   "readonly": 0,
              //   "validation_type": "",
              //   "value": 0,
              //   "options": [],
              //   "group": ""
              // }, {
              //   "type": "checkbox",
              //   "x": "6000",
              //   "y": "355",
              //   "width": "14",
              //   "height": "14",
              //   "page": "1",
              //   "signer": "OWNER",
              //   "name": "Freight Charge Terms Prepaid",
              //   "identifier": "unique_field_identifier_6",
              //   "required": 1,
              //   "readonly": 0,
              //   "validation_type": "",
              //   "value": 0,
              //   "options": [],
              //   "group": ""
              // },
              {
                type: 'text',
                x: '500',
                y: '410',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'printed name',
                identifier: 'unique_field_identifier_9',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '500',
                y: '460',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'shipper company name',
                identifier: 'unique_field_identifier_8',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '500',
                y: '510',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'name of the iac employee',
                identifier: 'unique_field_identifier_10',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
            ],
          ],
        },
        // "params": {
        //   "withFlightInfoOnly": "false"
        // }
      })
        .then((response) => {
          this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
          console.log(response);

          if (!response.data.error) {
            console.log('got pick up ivf');
            const res = {
              urls: {
                driverIVFURL: response.data.signers[0].embedded_signing_url,
              },
              hashes: {
                driverIVF: response.data.document_hash,
              },
            };
            resolve(res);
          } else {
            console.log(response.data);
            this.setState({
              errorSnack: true,
              errorSnackMessage: response.data.error
                ? response.data.error.info
                  ? response.data.error.info
                  : response.data.error.type
                : 'Unknown error',
            });
            reject(response);
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            errorSnack: true,
            errorSnackMessage: 'Unknown error',
          });
          reject(err);
        });
    });
  };

  // Request Pick Up Sig
  createPickUpSig = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
    } = order;

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
        data: {
          sandbox: 0,
          is_draft: 0,
          embedded: 1,
          title: `Haney Freightways Document #${freightBillNumber}`,
          message: 'This is my general document message.',
          use_signer_order: 1,
          reminders: 0,
          require_all_signers: 1,
          custom_requester_name: '',
          custom_requester_email: '',
          redirect: `https://haney-freightways-vendor.web.app/order/${orderID}?pickUpConfirmed=Y`,
          redirect_decline: 'https://haney-freightways-vendor.web.app/declined',
          client: '',
          expires: 1750513480,
          embedded_signing_enabled: 1,
          flexible_signing: 0,
          use_hidden_tags: 0,
          files: [
            {
              name:
                deliveryType == 'Air'
                  ? 'Air Pick Up Rate Confirmation'
                  : 'Ground Only Rate Confirmation',
              file_url:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Dispatcher%20Docs%2FPick-Up%20Dispatch%20_%20Rate%20Confirmation%20(Origin%20to%20Airline)%20Final%203.20.2020.pdf?alt=media&token=dbdd4445-fdaa-4a60-93ef-b7c9c99ecd9f'
                  : 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FGround%20Only%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=f95662dd-c5ad-405f-a70a-0c8479a1faa9',
              file_id: '',
              file_base64: '',
            },
          ],
          signers: [
            {
              id: 1,
              name: ' ',
              email: vendorPickUp.email
                ? vendorPickUp.email
                : 'vendoralerts@cargorx.com',
              order: 1,
              role: orderID,
              // "pin": "3874",
              message: 'This is my custom message to Signer.',
              deliver_email: 0,
              language: 'en',
            },
          ],
          recipients: [
            {
              name: 'Vendor Alerts',
              email: 'vendoralerts@cargorx.com',
            },
          ],
          meta: {
            some_key: 'some_value',
            another_key: 'another_value',
          },
          fields: [
            [
              {
                type: 'signature',
                x: '250',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '570'
                    : '560',
                width: '120',
                height: '35',
                page: '1',
                signer: '1',
                name: '',
                identifier: 'unique_field_identifier_1',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '225',
                width: '100',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Name',
                identifier: 'unique_field_identifier_6',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '245',
                width: '100',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Phone',
                identifier: 'unique_field_identifier_7',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '(833) 227 4679',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '268',
                width: '150',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Email',
                identifier: 'unique_field_identifier_8',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: 'operations@cargorx.com',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '190',
                y: '297',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Ready Date/Time',
                identifier: 'unique_field_identifier_9',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  origin.endTimeWindow == null
                    ? String(
                      origin.date
                        ? moment(origin.date.toDate()).format(
                          'MM-DD-YYYY HH:mm'
                        )
                        : ' '
                    )
                    : origin.date
                      ? String(
                        moment(origin.date.toDate()).format('MM-DD-YYYY')
                      ) +
                      ' ' +
                      (origin.startTimeWindow && String(origin.startTimeWindow))
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '650',
                y: '225',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Waybill Number',
                identifier: 'unique_field_identifier_10',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: freightBillNumber ? freightBillNumber : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '672',
                y: '295',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Delivery Date/Time',
                identifier: 'unique_field_identifier_11',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? String(
                      moment(
                        origin.deliverBy.seconds
                          ? origin.deliverBy.toDate()
                          : origin.deliverBy
                      ).format('MM-DD-YYYY HH:mm')
                    )
                    : moment(serviceETA.toDate()).format('MM-DD-YYYY HH:mm'),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '555'
                    : '545',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Total Charges',
                identifier: 'unique_field_identifier_12',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: pickUpRate,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '130',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '405'
                    : '395',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Name',
                identifier: 'unique_field_identifier_13',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorPickUp.name,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '170',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '430'
                    : '420',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Pro Number',
                identifier: 'unique_field_identifier_14',
                required: 0,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '115',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '450'
                    : '440',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'phone',
                identifier: 'unique_field_identifier_15',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorPickUp.phone,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '115',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '470'
                    : '460',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Email',
                identifier: 'unique_field_identifier_16',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorPickUp.email,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '493'
                    : '483',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'DOT Number',
                identifier: 'unique_field_identifier_17',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorPickUp.dotNumber,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '515'
                    : '505',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Name',
                identifier: 'unique_field_identifier_18',
                required: 0,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '225',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '537'
                    : '527',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Pick-up Service Level',
                identifier: 'unique_field_identifier_19',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '175',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '600'
                    : '590',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Print Name',
                identifier: 'unique_field_identifier_20',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '100',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '622'
                    : '612',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Date',
                identifier: 'unique_field_identifier_21',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: String(new Date()),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '510',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '407'
                    : '397',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_22',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: pickUpDriver
                  ? pickUpDriver.firstName + ' ' + pickUpDriver.lastName
                  : pickUpDriver
                    ? pickUpDriver.firstName + ' ' + pickUpDriver.lastName
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '430'
                    : '420',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Phone',
                identifier: 'unique_field_identifier_23',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: pickUpDriver
                  ? pickUpDriver.cellPhone
                    ? pickUpDriver.cellPhone
                    : pickUpDriver.directPhone
                      ? pickUpDriver.directPhone
                      : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '452'
                    : '442',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Email',
                identifier: 'unique_field_identifier_24',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: pickUpDriver
                  ? pickUpDriver.email
                    ? pickUpDriver.email
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '505'
                    : '505',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '474'
                    : '464',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'STA',
                identifier: 'unique_field_identifier_78',
                required: 0,
                readonly:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? 0
                    : 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: pickUpDriver
                  ? pickUpDriver.sta
                    ? 'STA: ' + pickUpDriver.sta
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '682',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Company Name',
                identifier: 'unique_field_identifier_25',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.businessName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '125',
                y: '705',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Address',
                identifier: 'unique_field_identifier_26',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.address,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '110',
                y: '728',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'City',
                identifier: 'unique_field_identifier_27',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.city,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '251',
                y: '728',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'State',
                identifier: 'unique_field_identifier_28',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.state,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '360',
                y: '728',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Zip',
                identifier: 'unique_field_identifier_29',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.zip,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '750',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact name',
                identifier: 'unique_field_identifier_30',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  (origin.firstName ? origin.firstName : ' ') +
                  ' ' +
                  (origin.lastName ? origin.lastName : ' '),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '770',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Phone',
                identifier: 'unique_field_identifier_31',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.phone ? origin.phone : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '790',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Email',
                identifier: 'unique_field_identifier_32',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.email ? origin.email : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '255',
                y: '812',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_33',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '255',
                y: '836',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_34',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '255',
                y: '855',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_35',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '245',
                y: '880',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_36',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.referenceID ? origin.referenceID : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '605',
                y: '682',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_37',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? (flight
                      ? flight.airlineName
                        ? flight.airlineName
                        : ' '
                      : ' ') +
                    ' ' +
                    flight.originAirport
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.businessName + originAirCarrier.airCode
                        : ' '
                      : destination.businessName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '702',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery Address',
                identifier: 'unique_field_identifier_38',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? originAirlineDetails && originAirlineDetails[0]
                      ? originAirlineDetails[0].physicalAddress
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.address
                          ? originAirCarrier.address
                          : ' '
                        : ' '
                      : destination.address,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '510',
                y: '725',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery City',
                identifier: 'unique_field_identifier_39',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? originAirlineDetails && originAirlineDetails[0]
                      ? originAirlineDetails[0].physicalCity
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.city
                          ? originAirCarrier.city
                          : ' '
                        : ' '
                      : destination.city,
                // "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.city) : destination.city) : destination.city),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '760',
                y: '725',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery Zip',
                identifier: 'unique_field_identifier_40',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? originAirlineDetails && originAirlineDetails[0]
                      ? originAirlineDetails[0].physicalZip
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.zip
                          ? originAirCarrier.zip
                          : ' '
                        : ' '
                      : destination.zip,
                // "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.zip) : destination.zip) : destination.zip),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '655',
                y: '725',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery State',
                identifier: 'unique_field_identifier_41',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? originAirlineDetails && originAirlineDetails[0]
                      ? originAirlineDetails[0].physicalState
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.state
                          ? originAirCarrier.state
                          : ' '
                        : ' '
                      : destination.state,
                // "value": ((deliveryType == "Air") ? (deliveryType == "Scheduled Air" ? (originAirCarrier.state) : destination.state) : destination.state),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '750',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Name',
                identifier: 'unique_field_identifier_42',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : destination.firstName + ' ' + destination.firstName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '772',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Phone',
                identifier: 'unique_field_identifier_43',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : destination.phone,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '790',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Email / Account number',
                identifier: 'unique_field_identifier_44',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? (originAirCarrier.cargorxAccountNumber ? originAirCarrier.cargorxAccountNumber : " ") : (destination.email ? destination.email : " ")),
                value:
                  deliveryType == 'Air'
                    ? originAirlineDetails
                      ? originAirlineDetails[0]
                        ? originAirlineDetails[0].cargorxAccountNumber
                          ? originAirlineDetails[0].cargorxAccountNumber
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.cargorxAccountNumber
                          ? originAirCarrier.cargorxAccountNumber
                          : ' '
                        : ' '
                      : destination.email
                        ? destination.email
                        : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '810',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Booking',
                identifier: 'unique_field_identifier_45',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? bookingNumber
                      ? bookingNumber
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '830',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Airline Waybill Number',
                identifier: 'unique_field_identifier_46',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? airWaybillNumber
                      ? airWaybillNumber
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '855',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Secondary Contact Email',
                identifier: 'unique_field_identifier_47',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? origin.deliverBy
                      ? moment(
                        origin.deliverBy.seconds
                          ? origin.deliverBy.toDate()
                          : origin.deliverBy
                      ).format('MM/DD/YYYY HH:mm')
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '645',
                y: '877',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_48',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : destination.referenceID
                      ? destination.referenceID
                      : ' ',
                // "value": destination.referenceID ? destination.referenceID : " ",
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '575',
                y: '940',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_49',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : destination.customExtraService
                      ? destination.customExtraService
                      : ' ',
                // "value": destination.customExtraService ? destination.customExtraService : " ",
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '575',
                y: '965',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_50',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '205',
                y: '940',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_51',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: origin.customExtraService
                  ? origin.customExtraService
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '205',
                y: '965',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_52',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_53',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].quantity,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '955',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_54',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_55',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_56',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_156',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_57',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].description,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_58',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_59',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_159',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_60',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].weight,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_61',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_62',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_162',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_63',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].length,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_64',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_65',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_165',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_66',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].width,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_67',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_68',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_168',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_69',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].height,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_70',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_71',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_171',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_72',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].unNumber ? items[0].unNumber : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_73',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1]
                  ? items[1].unNumber
                    ? items[1].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_74',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2]
                  ? items[2].unNumber
                    ? items[2].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_174',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3]
                  ? items[3].unNumber
                    ? items[3].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Hazmat',
                identifier: 'unique_field_identifier_75',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].isHazmat ? 'Yes' : 'No',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_76',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? (items[1].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_77',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? (items[2].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_177',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? (items[3].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '145',
                y: '600',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: ' ',
                identifier: 'unique_field_identifier_80',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (((this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0))),
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '155',
                y: '605',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Destination Contact Phone',
                identifier: 'unique_field_identifier_82',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '145',
                y: '600',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'total declared value',
                identifier: 'unique_field_identifier_85',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : (items[0] ? Number(items[0].declaredValue) : 0) +
                    (items[1] ? Number(items[1].declaredValue) : 0) +
                    (items[2] ? Number(items[2].declaredValue) : 0) +
                    (items[3] ? Number(items[3].declaredValue) : 0),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '105',
                y: '620',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Destination Contact Phone',
                identifier: 'unique_field_identifier_83',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                      ? String(new Date())
                      : ' ',
                options: [],
                group: '',
              },
            ],
          ],
        },
        // "params": {
        //   "withFlightInfoOnly": "false"
        // }
      })
        .then((response) => {
          this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
          console.log(response);

          if (!response.data.error) {
            console.log('got pick up sig');
            const res = {
              urls: {
                pickUpRateConURL: response.data.signers[0].embedded_signing_url,
              },
              hashes: {
                pickUpRateConHash: response.data.document_hash,
              },
            };
            resolve(res);
          } else {
            console.log(response.data);
            this.setState({
              errorSnack: true,
              errorSnackMessage: response.data.error
                ? response.data.error.info
                  ? response.data.error.info
                  : response.data.error.type
                : 'Unknown error',
            });
            reject(response);
          }
        })
        .catch((err) => {
          console.log(err);
          this.setState({
            errorSnack: true,
            errorSnackMessage: 'Unknown error',
          });
          reject(err);
        });
    });
  };

  // Request Drop Off Sig
  createDropOffSig = (order) => {
    const { orderID } = this.props;
    const {
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      dropOffRate,
    } = order;

    let pickUpBy;

    if (destination.deliverBy) {
      if ('seconds' in this.state.destination.deliverBy) {
        pickUpBy = moment(destination.deliverBy.toDate()).format(
          'MM-DD-YYYY HH:mm'
        );
      } else {
        pickUpBy = moment(destination.deliverBy).format('MM-DD-YYYY HH:mm');
      }
    }
    // const pickUpBy = moment(destination.deliverBy.toDate()).format('MM-DD-YYYY HH:mm');
    const dropOffBy = moment(serviceETA.toDate()).format('MM-DD-YYYY HH:mm');

    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url: `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
        data: {
          sandbox: 0,
          is_draft: 0,
          embedded: 1,
          title: `Haney Freightways Document #${freightBillNumber}`,
          message: 'This is my general document message.',
          use_signer_order: 1,
          reminders: 0,
          require_all_signers: 1,
          custom_requester_name: '',
          custom_requester_email: '',
          redirect: `https://haney-freightways-vendor.web.app/order/${orderID}?pickUpConfirmed=Y`,
          redirect_decline: 'https://haney-freightways-vendor.web.app/declined',
          client: '',
          expires: 1750513480,
          embedded_signing_enabled: 1,
          flexible_signing: 0,
          use_hidden_tags: 0,
          files: [
            {
              name:
                deliveryType == 'Air'
                  ? 'Air Pick Up Rate Confirmation'
                  : 'Ground Only Rate Confirmation',
              file_url:
                deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                  ? 'https://firebasestorage.googleapis.com/v0/b/freightdragons.appspot.com/o/forms%2FUNKNOWN%20Party%20Air%20Shipment%20Documents%2FDelivery%20Vendor%20Dispatcher%20Docs%2FPick-Up%20Dispatch%20_%20Rate%20Confirmation%20(Airline%20to%20Destination)%20Final%203.20.2020%20(1).pdf?alt=media&token=43a2d88a-078e-4155-b342-e5d3c0051d31'
                  : 'https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FGround%20Only%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=f95662dd-c5ad-405f-a70a-0c8479a1faa9',
              file_id: '',
              file_base64: '',
            },
          ],
          signers: [
            {
              id: 1,
              name: ' ',
              email: vendorDropOff.email
                ? vendorDropOff.email
                : 'vendoralerts@cargorx.com',
              order: 1,
              role: orderID,
              // "pin": "3874",
              message: 'This is my custom message to Signer.',
              deliver_email: 0,
              language: 'en',
            },
          ],
          recipients: [
            {
              name: 'Vendor Alerts',
              email: 'vendoralerts@cargorx.com',
            },
          ],
          meta: {
            some_key: 'some_value',
            another_key: 'another_value',
          },
          fields: [
            [
              {
                type: 'signature',
                x: '250',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '570'
                    : '560',
                width: '120',
                height: '35',
                page: '1',
                signer: '1',
                name: '',
                identifier: 'unique_field_identifier_1',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '225',
                width: '100',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Name',
                identifier: 'unique_field_identifier_6',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '245',
                width: '100',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Phone',
                identifier: 'unique_field_identifier_7',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: '(833) 227 4679',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '120',
                y: '268',
                width: '150',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Email',
                identifier: 'unique_field_identifier_8',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: 'operations@cargorx.com',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '190',
                y: '297',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Ready Date/Time',
                identifier: 'unique_field_identifier_9',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: pickUpBy, // destination.deliveryBy ? moment(destination.deliveryBy.toDate()).format('MM-DD-YYYY HH:mm') : (destination.endTimeWindow == null ? String(destination.deliveryBy ? moment(destination.deliveryBy.toDate()).format('MM-DD-YYYY HH:mm') : " ") : (destination.deliverBy ? String(moment(destination.deliverBy.toDate()).format('MM-DD-YYYY')) + " " + (destination.startTimeWindow && String(destination.startTimeWindow)) : " ")),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '650',
                y: '225',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Waybill Number',
                identifier: 'unique_field_identifier_10',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: freightBillNumber ? freightBillNumber : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '672',
                y: '295',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Haney Freightways Contact Delivery Date/Time',
                identifier: 'unique_field_identifier_11',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffBy, // ((deliveryType == "Air" || deliveryType == "Scheduled Air")) ? String(moment(destination.date.toDate()).format('MM-DD-YYYY HH:mm')) : moment(serviceETA.toDate()).format('MM-DD-YYYY HH:mm'),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '555'
                    : '545',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Total Charges',
                identifier: 'unique_field_identifier_12',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffRate,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '130',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '405'
                    : '395',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Name',
                identifier: 'unique_field_identifier_13',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff.name,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '170',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '430'
                    : '420',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Carrier Pro Number',
                identifier: 'unique_field_identifier_14',
                required: 0,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '115',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '450'
                    : '440',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'phone',
                identifier: 'unique_field_identifier_15',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff.mainPhone,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '115',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '470'
                    : '460',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Email',
                identifier: 'unique_field_identifier_16',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff.email,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '493'
                    : '483',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'DOT Number',
                identifier: 'unique_field_identifier_17',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: vendorDropOff.dotNumber,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '180',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '515'
                    : '505',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Name',
                identifier: 'unique_field_identifier_18',
                required: 0,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '225',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '537'
                    : '527',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Pick-up Service Level',
                identifier: 'unique_field_identifier_19',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '175',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '600'
                    : '590',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Print Name',
                identifier: 'unique_field_identifier_20',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '100',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '622'
                    : '612',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Date',
                identifier: 'unique_field_identifier_21',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: String(new Date()),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '510',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '407'
                    : '397',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_22',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffDriver
                  ? dropOffDriver.firstName + ' ' + dropOffDriver.lastName
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '430'
                    : '420',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Phone',
                identifier: 'unique_field_identifier_23',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffDriver
                  ? dropOffDriver.cellPhone
                    ? dropOffDriver.cellPhone
                    : dropOffDriver.directPhone
                      ? dropOffDriver.directPhone
                      : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '452'
                    : '442',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Email',
                identifier: 'unique_field_identifier_24',
                required: 1,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffDriver
                  ? dropOffDriver.email
                    ? dropOffDriver.email
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '505'
                    : '505',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '474'
                    : '464',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'STA',
                identifier: 'unique_field_identifier_78',
                required: 0,
                readonly: 0,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: dropOffDriver
                  ? dropOffDriver.sta
                    ? 'STA: ' + dropOffDriver.sta
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '682',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Company Name',
                identifier: 'unique_field_identifier_25',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": flight ? flight.movement.airport.icao : " ",
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].name
                          ? destinationAirlineDetails[0].name +
                          ' ' +
                          destinationAirlineDetails[0].airCodes[0]
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.businessName +
                        destinationAirCarrier.airCode
                        : ' '
                      : destination.businessName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '125',
                y: '703',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Address',
                identifier: 'unique_field_identifier_26',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalAddress : " ") : " ",
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalAddress
                          ? destinationAirlineDetails[0].physicalAddress
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.address
                        : ' '
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '110',
                y: '725',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'City',
                identifier: 'unique_field_identifier_27',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalCity
                          ? destinationAirlineDetails[0].physicalCity
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.city
                        : ' '
                      : ' ',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalCity : " ") : " ",
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '251',
                y: '725',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'State',
                identifier: 'unique_field_identifier_28',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalState : " ") : " ",
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalState
                          ? destinationAirlineDetails[0].physicalState
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.state
                        : ' '
                      : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '360',
                y: '725',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Zip',
                identifier: 'unique_field_identifier_29',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? destinationAirlineDetails
                      ? destinationAirlineDetails[0]
                        ? destinationAirlineDetails[0].physicalZip
                          ? destinationAirlineDetails[0].physicalZip
                          : ' '
                        : ' '
                      : ' '
                    : deliveryType == 'Scheduled Air'
                      ? destinationAirCarrier
                        ? destinationAirCarrier.zip
                        : ' '
                      : ' ',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (destinationAirlineDetails[0] ? destinationAirlineDetails[0].physicalZip : " ") : " ",
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '800',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact name / account #',
                identifier: 'unique_field_identifier_30',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '770',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Phone / flight #',
                identifier: 'unique_field_identifier_31',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? flight
                      ? flight.number
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '840',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Contact Email',
                identifier: 'unique_field_identifier_32',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '255',
                y: '810',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name / airline waybill',
                identifier: 'unique_field_identifier_33',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? airWaybillNumber
                      ? airWaybillNumber
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '235',
                y: '830',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name / booking #',
                identifier: 'unique_field_identifier_34',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? bookingNumber
                      ? bookingNumber
                      : ' '
                    : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '245',
                y: '855',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name / origin airport',
                identifier: 'unique_field_identifier_35',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air'
                    ? (flight ? 'Origin Airport: ' + flight.airlineName : ' ') +
                    ' ' +
                    (flight ? flight.originAirport : ' ')
                    : deliveryType == 'Scheduled Air'
                      ? originAirCarrier
                        ? originAirCarrier.businessName
                        : ' '
                      : destination.businessName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '245',
                y: '930',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_36',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '605',
                y: '682',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_37',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.businessName,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '702',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery Address',
                identifier: 'unique_field_identifier_38',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.address,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '510',
                y: '722',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery City',
                identifier: 'unique_field_identifier_39',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.city,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '760',
                y: '722',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery Zip',
                identifier: 'unique_field_identifier_40',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.zip,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '655',
                y: '722',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Delivery State',
                identifier: 'unique_field_identifier_41',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.state,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '750',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Name',
                identifier: 'unique_field_identifier_42',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.firstName
                  ? destination.firstName + ' ' + destination.lastName
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '770',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Phone',
                identifier: 'unique_field_identifier_43',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.phone ? destination.phone : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '585',
                y: '792',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Destination Contact Email',
                identifier: 'unique_field_identifier_44',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.email ? destination.email : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '865',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Secondary Contact Name',
                identifier: 'unique_field_identifier_45',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '885',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Secondary Contact Phone',
                identifier: 'unique_field_identifier_46',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '660',
                y: '905',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Secondary Contact Email',
                identifier: 'unique_field_identifier_47',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '645',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '880'
                    : '877',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_48',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.referenceID ? destination.referenceID : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '505',
                y:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? '945'
                    : '900',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_49',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: destination.customExtraService
                  ? destination.customExtraService
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '575',
                y: '965',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_50',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '205',
                y: '940',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_51',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '205',
                y: '965',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_52',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_53',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].quantity,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '185',
                y: '955',
                width: '300',
                height: '17',
                page: '1',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_54',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_55',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_56',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '70',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_156',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].quantity : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_57',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].description,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_58',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_59',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '200',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_159',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].description : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_60',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].weight,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_61',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_62',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '355',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_162',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].weight : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_63',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].length,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_64',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_65',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '430',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_165',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].length : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_66',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].width,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_67',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_68',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '515',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_168',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].width : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_69',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].height,
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_70',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? items[1].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_71',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? items[2].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '590',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_171',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? items[3].height : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_72',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].unNumber ? items[0].unNumber : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_73',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1]
                  ? items[1].unNumber
                    ? items[1].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_74',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2]
                  ? items[2].unNumber
                    ? items[2].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '680',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_174',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3]
                  ? items[3].unNumber
                    ? items[3].unNumber
                    : ' '
                  : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '236',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Hazmat',
                identifier: 'unique_field_identifier_75',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[0].isHazmat ? 'Yes' : 'No',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '256',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_76',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[1] ? (items[1].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '276',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_77',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[2] ? (items[2].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '770',
                y: '296',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Driver name',
                identifier: 'unique_field_identifier_177',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value: items[3] ? (items[3].isHazmat ? 'Yes' : 'No') : ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '145',
                y: '600',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: ' ',
                identifier: 'unique_field_identifier_80',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (((this.state.orderData.items[0] ? Number(this.state.orderData.items[0].declaredValue) : 0) + (this.state.orderData.items[1] ? Number(this.state.orderData.items[1].declaredValue) : 0) + (this.state.orderData.items[2] ? Number(this.state.orderData.items[2].declaredValue) : 0) + (this.state.orderData.items[3] ? Number(this.state.orderData.items[3].declaredValue) : 0))),
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '155',
                y: '605',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Destination Contact Phone',
                identifier: 'unique_field_identifier_82',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": (deliveryType == "Air" || deliveryType == "Scheduled Air") ? (pickUpDriver ? pickUpDriver.name : " ") : " ",
                value: ' ',
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '145',
                y: '600',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'total declared value',
                identifier: 'unique_field_identifier_85',
                required: 0,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                // "value": ((deliveryType == "Air" || deliveryType == "Scheduled Air") ? " " : ((items[0] ? Number(items[0].declaredValue) : 0) + (items[1] ? Number(items[1].declaredValue) : 0) + (items[2] ? Number(items[2].declaredValue) : 0) + (items[3] ? Number(items[3].declaredValue) : 0))),
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : (items[0] ? Number(items[0].declaredValue) : 0) +
                    (items[1] ? Number(items[1].declaredValue) : 0) +
                    (items[2] ? Number(items[2].declaredValue) : 0) +
                    (items[3] ? Number(items[3].declaredValue) : 0),
                options: [],
                group: '',
              },
              {
                type: 'text',
                x: '105',
                y: '620',
                width: '300',
                height: '17',
                page: '2',
                signer: '1',
                name: 'Destination Contact Phone',
                identifier: 'unique_field_identifier_83',
                required: 1,
                readonly: 1,
                validation_type: '',
                text_size: '',
                text_color: '',
                text_font: '',
                text_style: '',
                value:
                  deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                    ? ' '
                    : deliveryType == 'Air' || deliveryType == 'Scheduled Air'
                      ? String(new Date())
                      : ' ',
                options: [],
                group: '',
              },
            ],
          ],
        },
        // "params": {
        //   "withFlightInfoOnly": "false"
        // }
      })
        .then((response) => {
          this.setState({ documentsLoaded: this.state.documentsLoaded + 1 });
          console.log(response);

          if (!response.data.error) {
            console.log('got drop off sig');
            const res = {
              urls: {
                dropOffRateConURL:
                  response.data.signers[0].embedded_signing_url,
              },
              hashes: {
                dropOffRateConHash: response.data.document_hash,
              },
            };
            resolve(res);
          } else {
            console.log(response.data);
            this.setState({
              errorSnack: true,
              errorSnackMessage: response.data.error
                ? response.data.error.info
                  ? response.data.error.info
                  : response.data.error.type
                : 'Unknown error',
            });
            reject(response);
          }
        })
        .catch((err) => {
          console.error(err);
          this.setState({
            errorSnack: true,
            errorSnackMessage: 'Unknown error',
          });
          reject(err);
        });
    });
  };

  // Invoice Email
  emailInvoice = async (order, links) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      docs,
    } = order;

    const getBillingPartyEmail = async () => {
      const billingToParty = {
        "Shipper": origin,
        "Consignee": destination,
        "Third Party": thirdParty,
      }

      console.log('cheese', billingParty);

      const { entityID, email } = billingToParty[billingParty];

      if (entityID) {
        const shipperSnap = await db
          .collection('haney-shippers')
          .doc(entityID)
          .get();

        if (shipperSnap.exists) {
          const docData = {
            ...shipperSnap.data(),
            id: shipperSnap.id,
          };

          const bpEmail = docData.accountingEmail
            ? docData.accountingEmail
            : docData.email
              ? docData.email
              : null;
          const list = bpEmail.split(', ');

          console.log(list);
          if (list.length) return list.map(e => e.trim());
        }
      }

      return [email];
    };

    // console.log("thirdParty")
    // console.log(Object.keys(thirdParty).length)
    // console.log(Object.keys(origin).length)
    // console.log("items")
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log(items);
    console.log('item1');
    console.log(item1);
    console.log(item2);
    console.log(item3);
    console.log(item4);
    console.log(item5);
    console.log(items.length);
    let conditionalItems = [];
    if (items.length > 1) {
      console.log('items are longer than 1');
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }
    console.log('conditionalItems');
    console.log(conditionalItems);
    // console.log(thirdParty)

    // let thirdParty = ((Object.keys(order.thirdParty).length !== 0) ? order.thirdParty : null)
    // console.log("thirdParty")

    // console.log(thirdParty)

    console.log('object keys');

    // let party_name = thirdParty.businessName
    // let party_address = thirdParty.address + " " + order.thirdParty.city + " " + order.thirdParty.zip
    // let party_contact = thirdParty.contact
    // let party_phone = thirdParty.phone
    // let party_email = thirdParty.email
    // let party_ksms = thirdParty.ksms

    let party_address = thirdParty
      ? (thirdParty.address ? thirdParty.address : ' ') +
      ' ' +
      (thirdParty ? thirdParty.city : ' ') +
      ' ' +
      (thirdParty ? thirdParty.zip : ' ')
      : undefined;
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }

    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      accufrate: deliveryType == 'LTL' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: true,
      consignee: false,
      thirdParty: false,
      pickUpVendor: false,
      pickUpDriver: false,
      party: 'Shipper',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      link: links.length > 1 ? null : links[0],
      links: links.length > 1 ? links : null,
      ...links[0],
      loginLink: 'https://haney-freightways-customer.web.app/pages/login-page',
      bolLink: docs && docs.alternateBOL ? docs.alternateBOL.fileURL : null,
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };

    // console.log('data');
    // console.log('Potato', data);

    return new Promise(async (resolve, reject) => {
      let subject = `CargoRx - Invoice for #${freightBillNumber}`;
      let html = `<p>Thank you very much for shipping with CargoRx! Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`;
      html += `<p><b>Using CargoRx Customer App</b></p>`;
      html += `<p>The button below will take you to the CargoRx Customer Application.  If you don't have a login yet, simply request one via shipping@cargorx.com.  We'll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`;
      html += `<p>- All CargoRx orders involving your company will be visible by clicking "Orders" on the menu bar</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="150">`;
      html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`;
      html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version if you'll be signing as the shipper contact.  If you aren't signing as the shipper contact, the driver will have an e-signature version of the shipping document on his or her phone for the shipping contact to sign.</p>`;
      html += `<p>- You can also use the Customer App to track your shipments - certain shipment types allow you to see the driver's location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`;
      html += `<p>- <b>New Transactions:</b> If you don't have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>- you'll be asked to complete certain missing fields later when you select the right shipping option and book your shipment.</p>`;
      html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing - you won't be asked for any missing information later when you select and book a shipping option.</p>`;
      html += `<a href="https://cargo-rx.web.app"><button>Customer App</button></a>`;
      html += `<p><b>E-Document and e-Signature Link</b></p>`;
      html += `<p>If you aren't able to access the customer application but did receive this message, you can access your electronic document using the link below.<p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? 'House Waybill'
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Bill of Lading'
          : ''
        }</b> requires your signature.  If you'd like a contact-free way to sign as the shipper, click the link below.</p>`;
      html += `<p>- To sign as the <b>Shipper</b>, please <a href="${links.find(
        (obj) => obj.name === 'Invoice'
      )}">click here</a></p>`;
      html += `<p>Thanks for the opportunity to serve your company!</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`;
      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
      const emails = await getBillingPartyEmail();
      console.log('Billing Email:', emails);
      emails.push('receivables@haneyfreightways.com');
      emails.push('justin@pondata.com');
      // const emails = [origin.email, "customeralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
      // const emails = [origin.email, "justin@pondata.com"];
      const invoicePDF = await fetch(
        `${links.find((obj) => obj.name === 'Invoice')}`
      );
      const attachment = invoicePDF.toString('base64');
      console.log('attachment', attachment);

      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      console.log('Invoice email: ', emails, subject);

      Promise.all([
        db
          .collection('haney-orders')
          .doc(orderID)
          .set(
            {
              previouslySentDocuments: links,
            },
            { merge: true }
          ),
        sendDynamicEmail({
          emails,
          subject,
          template: 'd-eea89a2b386d49adb9a5a79d04f07100',
          data,
          html,
          attachment,
        }),
        this.setState({
          invoiceSending: false,
          infoSnack: true,
          infoSnackMessage: 'Invoice email was successfully sent',
        })
      ])
        .then(res => {
          console.log("Everything went fine!!!", res);
          resolve(res);
        })
        .catch(err => {
          console.error("Look here!!!", err);
          reject(new Error(err));
        })
    });
  };

  // Shipper Email
  firstEmail = (order, bol = null) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      docs,
    } = order;

    // console.log("thirdParty")
    // console.log(Object.keys(thirdParty).length)
    // console.log(Object.keys(origin).length)
    // console.log("items")
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log('item1');
    console.log(item1);
    console.log(item2);
    console.log(item3);
    console.log(item4);
    console.log(item5);
    console.log(items.length);
    let conditionalItems = [];
    if (items.length > 1) {
      console.log('items are longer than 1');
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }
    console.log('conditionalItems');
    console.log(conditionalItems);
    // console.log(thirdParty)

    // let thirdParty = ((Object.keys(order.thirdParty).length !== 0) ? order.thirdParty : null)
    // console.log("thirdParty")

    // console.log(thirdParty)

    console.log('object keys');

    // let party_name = thirdParty.businessName
    // let party_address = thirdParty.address + " " + order.thirdParty.city + " " + order.thirdParty.zip
    // let party_contact = thirdParty.contact
    // let party_phone = thirdParty.phone
    // let party_email = thirdParty.email
    // let party_ksms = thirdParty.ksms

    let party_address

    if (thirdParty) {
      party_address = thirdParty
        ? (thirdParty.address ? thirdParty.address : ' ') +
        ' ' +
        (thirdParty ? thirdParty.city : ' ') +
        ' ' +
        (thirdParty ? thirdParty.zip : ' ')
        : undefined;
    }
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }

    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      accufrate: deliveryType == 'LTL' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: true,
      consignee: false,
      thirdParty: false,
      pickUpVendor: false,
      pickUpDriver: false,
      party: 'Shipper',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      link: bol ? bol : signingURLs[0],
      loginLink: 'https://haney-freightways-customer.web.app/pages/login-page',
      bolLink: docs && docs.alternateBOL ? docs.alternateBOL.fileURL : null,
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };

    console.log('data');
    console.log(data);

    return new Promise(async (resolve, reject) => {
      let subject = `CargoRx #${freightBillNumber} Shipping Documents - Your Signature May be Required!`;
      let html = `<p>Thank you very much for shipping with CargoRx! Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`;
      html += `<p><b>Using CargoRx Customer App</b></p>`;
      html += `<p>The button below will take you to the CargoRx Customer Application.  If you don't have a login yet, simply request one via shipping@cargorx.com.  We'll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`;
      html += `<p>- All CargoRx orders involving your company will be visible by clicking "Orders" on the menu bar</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="150">`;
      html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`;
      html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version if you'll be signing as the shipper contact.  If you aren't signing as the shipper contact, the driver will have an e-signature version of the shipping document on his or her phone for the shipping contact to sign.</p>`;
      html += `<p>- You can also use the Customer App to track your shipments - certain shipment types allow you to see the driver's location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`;
      html += `<p>- <b>New Transactions:</b> If you don't have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>- you'll be asked to complete certain missing fields later when you select the right shipping option and book your shipment.</p>`;
      html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing - you won't be asked for any missing information later when you select and book a shipping option.</p>`;
      html += `<a href="https://cargo-rx.web.app"><button>Customer App</button></a>`;
      html += `<p><b>E-Document and e-Signature Link</b></p>`;
      html += `<p>If you aren't able to access the customer application but did receive this message, you can access your electronic document using the link below.<p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? 'House Waybill'
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Bill of Lading'
          : ''
        }</b> requires your signature.  If you'd like a contact-free way to sign as the shipper, click the link below.</p>`;
      html += `<p>- To sign as the <b>Shipper</b>, please <a href="${bol ? bol : signingURLs[0]
        }">click here</a></p>`;
      html += `<p>Thanks for the opportunity to serve your company!</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`;
      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
      const emails = [
        origin.email ? origin.email : 'justin@ltl.ai',
        'customeralerts@haneyfreightways.com',
        'justin@pondata.com',
      ];
      // const emails = [origin.email, "customeralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
      // const emails = [origin.email, "justin@pondata.com"];
      const attachment = true;
      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      console.log('First email: ', emails, subject);
      const emailReturn = await sendDynamicEmail({
        emails,
        subject,
        template:
          deliveryType == 'Air' || deliveryType == 'Scheduled Air'
            ? 'd-66ebd124ba204f58a33f2d965eeaedae'
            : 'd-be3ca4a997054d0aa2746d3a3f9874b3',
        data,
        html,
        // attachment
      });

      resolve(emailReturn);
    });
  };

  secondEmail = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      bolHash,
      hashes,
      urls,
      pickUpRateConURL,
      driverPickUpRateConURL,
      docs,
      driverIVFURL,
      signingSampleWayBill,
    } = order;

    console.log(items);
    console.log('items');
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log(item1);
    console.log(!!item4);
    let conditionalItems = [];
    if (items.length > 1) {
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }
    console.log('conditionalItems');
    console.log(conditionalItems);

    // let party_name = thirdParty.businessName
    // let party_address = thirdParty.address + " " + order.thirdParty.city + " " + order.thirdParty.zip
    // let party_contact = thirdParty.contact
    // let party_phone = thirdParty.phone
    // let party_email = thirdParty.email
    // let party_ksms = thirdParty.ksms

    let OAC = originAirCarrier
      ? order.originAirCarrier
      : {
        businessName: ' ',
        address: ' ',
        city: ' ',
        zip: ' ',
        dropoff: ' ',
        customExtraService: ' ',
      };

    let carrier_name = OAC.businessName;
    let carrier_address;
    if (deliveryType == 'Air') {
      if (originAirlineDetails[0]) {
        carrier_address =
          originAirlineDetails[0].physicalAddress +
          ' ' +
          originAirlineDetails[0].physicalCity +
          ' ' +
          originAirlineDetails[0].physicalZip;
      }
    } else if (deliveryType == 'Scheduled Air') {
      carrier_address =
        originAirCarrier.address +
        ' ' +
        originAirCarrier.city +
        ' ' +
        originAirCarrier.zip;
    }
    let carrier_dropoff = OAC.dropoff;
    let carrier_service = OAC.customExtraService;
    let party_address = thirdParty
      ? (thirdParty.address ? thirdParty.address : ' ') +
      ' ' +
      (thirdParty ? thirdParty.city : ' ') +
      ' ' +
      (thirdParty ? thirdParty.zip : ' ')
      : undefined;

    console.log('object keys');
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }

    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: false,
      consignee: false,
      thirdParty: false,
      pickUpVendor: true,
      pickUpDriver: false,
      pickup: true,
      party: 'Pick Up Vendor',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      carrier_name:
        deliveryType == 'Air'
          ? originAirlineDetails
            ? originAirlineDetails[0]
              ? originAirlineDetails[0].name
                ? originAirlineDetails[0].name +
                ' ' +
                originAirlineDetails[0].airCodes[0]
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? originAirCarrier
              ? originAirCarrier.businessName
                ? originAirCarrier.businessName
                : ' '
              : ' '
            : null,
      carrier_address: carrier_address,
      carrier_dropoff: origin.deliverBy
        ? moment(
          origin.deliverBy.seconds
            ? origin.deliverBy.toDate()
            : origin.deliverBy
        ).format('MM/DD/YYYY HH:mm')
        : ' ',
      // carrier_service: originAirCarrier ? originAirCarrier.customExtraService : " ",
      carrier_service:
        deliveryType == 'Air'
          ? originAirlineDetails
            ? originAirlineDetails[0]
              ? originAirlineDetails[0].customExtraService
                ? originAirlineDetails[0].customExtraService
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? originAirCarrier
              ? originAirCarrier.customExtraService
                ? originAirCarrier.customExtraService
                : ' '
              : ' '
            : null,
      carrier_phone:
        deliveryType == 'Air'
          ? originAirlineDetails
            ? originAirlineDetails[0]
              ? originAirlineDetails[0].mainPhone
                ? originAirlineDetails[0].mainPhone
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? originAirCarrier
              ? originAirCarrier.mainPhone
                ? originAirCarrier.mainPhone
                : ' '
              : ' '
            : null,
      // carrier_phone: originAirCarrier ? originAirCarrier.mainPhone : " ",
      flight_number: flight ? flight.number : ' ',
      carrier_booking: bookingNumber ? bookingNumber : ' ',
      carrier_awb: airWaybillNumber ? airWaybillNumber : ' ',
      carrier_sl: serviceLevel ? serviceLevel : ' ',
      link: signingURLs[0],
      rateLink: pickUpRateConURL,
      bolLink: `https://api.eversign.com/api/download_current_document_status?access_key=${this.state.dispatchedBeforeEversign ? 'a74f3d4d2ca030cf60500f7814618064&business_id=141252' : '751efbc709ec4ace1d6ff70a062b7243&business_id=246480'}&document_hash=${bolHash}&audit_trail=1`,
      loginLink: 'https://haney-freightways-vendor.web.app/pages/login-page',
      pickUpStatementLink: driverPickUpRateConURL,
      sampleLink: docs
        ? docs.alternateAirWaybill
          ? docs.alternateAirWaybill.fileURL
          : signingSampleWayBill
        : signingSampleWayBill,
      // sampleLink: signingSampleWayBill,
      labelLink: docs ? (docs.airLabel ? docs.airLabel.fileURL : null) : null,
      airlineWaybillLink: docs
        ? docs.alternateAirWaybill
          ? docs.alternateAirWaybill.fileURL
          : null
        : null,
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };

    return new Promise(async (resolve, reject) => {
      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`;
      let html = `<p>Thank you very much for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`;
      html += `<p style="color: red"><b>Using Vendor Dispatch App</b></p>`;
      html += `<p>The button below will take you to the Haney Freightways Vendor Dispatcher Application. If you don't have a login yet, simply request one via your Haney Freightways representative or be emailing shipping@cargorx.com. We'll send a link via email and text, which will allow you to log right in. If you have a profile click the button below, log in, and access the following:</p>`;
      html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="150">`;
      html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`;
      html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents including the completed e-sign docs once all parties have signed – our preference is for the driver to obtain e-signatures, but we understand that paper might be necessary.</p>`;
      if (deliveryType == 'Scheduled Air') {
        html += `<p>- <b>The airline labels will have to be printed and affixed to the shipment prior to tendering to the airline!</b></p>`;
      }
      html += `<p>- The driver is able to upload pictures of paper documents through the driver application.  We send the driver a link to this app via text and email if you provide the driver’s information at the time of dispatch. Once uploaded, you will also have access via the shipment summary page within the vendor application.</p>`;
      html += `<p>- Within the shipment summary page, you will see a button the says “Confirm Rate” – if the Status above the button says “unconfirmed” in red text, please click on the button and e-sign the confirmation – if the status says “confirmed” in green text above the button, someone has already confirmed the rate. <b>The document takes a few seconds to generate so click the button once and wait patiently please.</b></p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.40.04%20PM.png?alt=media&token=9fc33ea6-f2f4-4d8b-9d17-8e573f943592" height="100">`;
      html += `<p><b>- Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`;
      html += `<a href="https://haney-freightways-vendor.web.app"><button>Vendor App</button></a>`;
      html += `<p><b>E-Document and e-Signature Links</b></p>`;
      html += `<p>If a driver wasn’t assigned at the time of dispatch, the assigned driver didn't receive our dispatch alert, or a new driver was assigned, they can access the electronic documents and e-signatures by using the links below.  You simply need to forward the applicable link(s) below to the appropriate driver.</p>`;
      // html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. As the driver, you must <a href=${urls.driverPickUpRateConURL}>click here</a> to view and complete the applicable TSA verification.</p>`
      // html += `<p>The <b>Dispatch Alert</b> is similar to the Bill of Lading but is only used for informational purposes (it will not be signed).  To view the dispatch alert, <a href=${urls.driverPickUpRateConURL}>click here</a></p>`
      html += `<p>Please click <a href=${pickUpRateConURL}>here</a> to e-sign the <b>Rate Confirmation</b>. </p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? `UNKNOWN or KNOWN Air Pick Up Alert will give you critical information about the pick-up and delivery locations, freight info, and flight information. The driver must <a href=${driverPickUpRateConURL}>click here</a> to view and complete the KNOWN or UNKNOWN Air Shipment Certification Statement on page two of this alert.`
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? `Dispatch Alert is similar to the Bill of Lading but is only used for informational purposes (it will not be signed). To view the dispatch alert, <a href=${driverPickUpRateConURL}>click here</a>`
          : ''
        }</b> </p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? "House Waybill requires the pick-up driver’s signature, and the shipper's signature. At the time of pick-up, we’ll need the driver and the shipper to sign."
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Bill of Lading requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature which also counts as the proof of delivery (POD). Since your driver is making the pick-up, we’ll need them and the shipper to sign.  If your driver is also delivering the freight, we’ll need them to collect the consignee’s signature as well.  All three signatures links are included below:'
          : ''
        }</b></p>`;
      html += `<p>- To sign as the <b>pick-up driver</b>, please <a href="${signingURLs[1]}">click here</a></p>`;
      html += `<p>- To sign as the <b>shipper</b>, please <a href="${signingURLs[0]}">click here</a></p>`;
      if (deliveryType == 'Ground' || deliveryType == 'Additional Options') {
        html += `<p>- To sign as the <b>consignee</b>, please <a href="${signingURLs[2]}">click here</a></p>`;
      }
      if (deliveryType == 'Air' || deliveryType == 'Scheduled Air') {
        if (deliveryType == 'Scheduled Air') {
          html += `<p>The <b>Labels</b> are a critical component of this shipment <b>and must be printed and securely fastened to the freight prior to tendering to DHL. It is a good idea to print and tape two labels to each piece of cargo being tendered.</b>. Please <a href="${docs ? (docs.airLabel ? docs.airLabel.fileURL : null) : null
            }">view here</a> and print the labels</p>`;
        }
        // html += `<p>You may also need a prefilled air waybill to tender along with the freight. This doesn't happen every time and we'll let you know if you need it. If we've asked you to use one, please The <b>Sample Airline Waybill</b> has been prefilled with all the necessary information to allow for a successful tender.  You can use this sample to fill out the actual waybill, or print and use for tender with the airline.  Please <a href="${urls.signingSampleWayBill}">view here</a></p>`
        if (deliveryType == 'Scheduled Air') {
          html += `<p>You may also need a prefilled air waybill to tender along with the freight. This doesn't happen every time and we'll let you know if you need it. If we've asked you to use one, please <a href="${docs
            ? docs.alternateAirWaybill
              ? docs.alternateAirWaybill.fileURL
              : null
            : null
            }">click here</a> to view and print.</p>`;
        }
        if (deliveryType == 'Air') {
          html += `<p>The <b>Sample Airline Waybill</b> has been prefilled with all the necessary information to allow for a successful tender.  You can use this sample to fill out the actual waybill, or print and use for tender with the airline. Please <a href="${signingSampleWayBill}">view here</a>.</p>`;
        }
        html += `<p>The <b>IAC Certificate</b> must be printed and tendered to the airline along with the waybill and freight. Please <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIAC%20Certificate%2011.8.2019%20(1).pdf?alt=media&token=4cc64b5d-d5cf-4627-b223-d099d8b6edab">view here</a> and print.</p>`;
      }
      // if ((deliveryType == "Ground" || deliveryType == "Additional Options")) {
      //   html += `<p>Please click the following link to have the consignee sign the <b>Bill of Lading</b> once they have agreed to take delivery: <a href="${urls.signingURLs[2]}">Sign Here</a></p>`
      //   html += `<p>If the consignee has already signed, you will be notified as such when you click the consignee signature link.<p>`
      // }
      if (!origin.ksms && deliveryType == 'Air') {
        html += `<p>If you’ve received the <b>Identification Validation Form</b>, it’s because the shipper is unknown to TSA and this form must be completed. Please <a href="${driverIVFURL}">click here</a> and complete the form.</p>`;
      }
      html += `<p>Thanks, and be safe out there!<p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`;
      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
      const emails = [
        vendorPickUp.email && vendorPickUp.email,
        'vendoralerts@cargorx.com',
        'justin@pondata.com',
      ];
      // const emails = [vendorPickUp.email, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
      // const emails = [vendorPickUp.email, "justin@pondata.com"];
      const attachment = true;
      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      const emailReturn = await sendDynamicEmail({
        emails,
        subject,
        template:
          deliveryType == 'Air' || deliveryType == 'Scheduled Air'
            ? 'd-43aa3970af84414d98b40af62e0c4131'
            : 'd-3a941603428b45609d337a94ee25e0f1',
        data,
        html,
        // attachment
      });
      resolve(emailReturn);
    });
  };

  thirdEmail = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      signingSampleWayBill,
      driverPickUpRateConURL,
      docs,
      driverIVFURL,
    } = order;

    console.log(items);
    console.log('items');
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log(item1);
    console.log(!!item4);
    let conditionalItems = [];
    if (items.length > 1) {
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }
    console.log(conditionalItems);
    // let thirdParty = ((Object.keys(order.thirdParty).length !== 0) ? order.thirdParty : null)
    let OAC = originAirCarrier
      ? order.originAirCarrier
      : {
        businessName: ' ',
        address: ' ',
        city: ' ',
        zip: ' ',
        dropoff: ' ',
        customExtraService: ' ',
      };
    let carrier_address;
    if (deliveryType == 'Air') {
      if (originAirlineDetails[0]) {
        carrier_address =
          originAirlineDetails[0].physicalAddress +
          ' ' +
          originAirlineDetails[0].physicalCity +
          ' ' +
          originAirlineDetails[0].physicalZip;
      }
    } else if (deliveryType == 'Scheduled Air') {
      carrier_address =
        originAirCarrier.address +
        ' ' +
        originAirCarrier.city +
        ' ' +
        originAirCarrier.zip;
    }

    // let carrier_name = OAC.businessName
    // let carrier_address = OAC.address + " " + OAC.city + " " + OAC.zip
    // let carrier_dropoff = OAC.dropoff
    // let carrier_service = OAC.customExtraService

    let party_address = thirdParty
      ? (thirdParty.address ? thirdParty.address : ' ') +
      ' ' +
      (thirdParty ? thirdParty.city : ' ') +
      ' ' +
      (thirdParty ? thirdParty.zip : ' ')
      : undefined;
    // console.log(party_address)
    // console.log(((thirdParty) ? thirdParty.businessName : " "))
    // console.log("party_address")
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }
    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: false,
      consignee: false,
      thirdParty: false,
      pickUpVendor: false,
      pickUpDriver: true,
      pickup: true,
      party: 'Pick Up Driver',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      carrier_name:
        deliveryType == 'Air'
          ? originAirlineDetails
            ? originAirlineDetails[0]
              ? originAirlineDetails[0].name
                ? originAirlineDetails[0].name +
                ' ' +
                originAirlineDetails[0].airCodes[0]
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? originAirCarrier
              ? originAirCarrier.businessName
                ? originAirCarrier.businessName
                : ' '
              : ' '
            : null,
      carrier_address: carrier_address,
      carrier_dropoff: origin.deliverBy
        ? moment(
          origin.deliverBy.seconds
            ? origin.deliverBy.toDate()
            : origin.deliverBy
        ).format('MM/DD/YYYY HH:mm')
        : ' ',
      // carrier_service: originAirCarrier ? originAirCarrier.customExtraService : " ",
      carrier_service:
        deliveryType == 'Air'
          ? originAirlineDetails
            ? originAirlineDetails[0]
              ? originAirlineDetails[0].customExtraService
                ? originAirlineDetails[0].customExtraService
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? originAirCarrier
              ? originAirCarrier.customExtraService
                ? originAirCarrier.customExtraService
                : ' '
              : ' '
            : null,
      carrier_phone:
        deliveryType == 'Air'
          ? originAirlineDetails
            ? originAirlineDetails[0]
              ? originAirlineDetails[0].mainPhone
                ? originAirlineDetails[0].mainPhone
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? originAirCarrier
              ? originAirCarrier.mainPhone
                ? originAirCarrier.mainPhone
                : ' '
              : ' '
            : null,
      // carrier_phone: originAirCarrier ? originAirCarrier.mainPhone : " ",
      flight_number: flight ? flight.number : ' ',
      carrier_booking: bookingNumber ? bookingNumber : ' ',
      carrier_awb: airWaybillNumber ? airWaybillNumber : ' ',
      carrier_sl: serviceLevel ? serviceLevel : ' ',
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      link: signingURLs[0],
      shipperLink: signingURLs[0],
      driverLink: signingURLs[1],
      consigneeLink: signingURLs[2],
      driverAppLink: `https://haney-freightways-driver.web.app/pages/upload/${orderID}/pickup`,
      loginLink: 'https://haney-freightways-vendor.web.app/pages/login-page',
      pickUpStatementLink: driverPickUpRateConURL,
      sampleLink: docs
        ? docs.alternateAirWaybill
          ? docs.alternateAirWaybill.fileURL
          : signingSampleWayBill
        : signingSampleWayBill,
      labelLink: docs ? (docs.airLabel ? docs.airLabel.fileURL : null) : null,
      airlineWaybillLink: docs
        ? docs.alternateAirWaybill
          ? docs.alternateAirWaybill.fileURL
          : null
        : null,
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };

    return new Promise(async (resolve, reject) => {
      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`;
      let html = `<p>Thank you very much for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures and perform key driver functions.</p>`;
      html += `<p><b>Using the Driver App</b></p>`;
      html += `<p>The button below will take you to the Haney Freightways Driver Application.  You won’t need to log in and you won’t need to download anything to your phone! You should also have received a link via text if we were given your cell number at the time of dispatch.</p>`;
      html += `<p><b>Once you’re in, you’ll have access to the e-signatures and image captures we need for this order.</b></p>`;
      html += `<p>- <b>Click “allow location services”</b> – our application uses geo-fencing to automatically update the status of this shipment.  Please do not close the browser window being used to access the driver application until your entire job has been completed.</p>`;
      html += `<p>- <b>Pick-Up Alert</b> - complete the fields under KNOWN or UNKNOWN Air Shipment Certification Statement on page two of this alert.</p>`;
      html += `<p>- <b>Driver BOL</b> - compare the Cargorx house waybill to the freight being offered, and e-sign when you're confident you have the right shipment.</p>`;
      html += `<p>- <b>Shipper BOL</b> - have the shipper e-sign on your phone or type the shipper's name in for them using the e-signature tool - if the shipper has already signed, the link will tell you so.</p>`;
      html += `<p>- <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? 'Paper BOL/Waybill'
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Paper/Hardcopy BOL'
          : ''
        }</b> - sometimes physical paperwork is all you have - please use the appropriate photo upload to capture the signed hardcopies right in the app.</p>`;
      html += `<p>- <b>Pre-departure Freight Pics</b> - we like to document the condition of freight at multiple stages - please use the applicable photo upload to snap a pic of the freight prior to departing shipper.</p>`;
      if (deliveryType == 'Ground' || deliveryType == 'Additional Options') {
        html += `<p>- <b>Consignee BOL</b> - have the consignee e-sign on your phone or type their name in for them using the e-signature tool - if the consignee has already signed, the link will tell you so.</p>`;
      }
      if (deliveryType == 'Ground' || deliveryType == 'Additional Options') {
        html += `<p>- <b>Paper/Hardcopy POD</b> - sometimes physical paperwork is all you have – please use the appropriate photo upload button to capture the signed hardcopies within the app.</p>`;
      }
      if (deliveryType == 'Ground' || deliveryType == 'Additional Options') {
        html += `<p>- <b>Post Delivery Freight Pics</b> - we like to document the condition of freight atmultiple stages – please use the applicable photo upload to snap a pic of the freight once the consignee has signed for delivery.</p>`;
      }
      if (deliveryType == 'Air' || deliveryType == 'Scheduled Air') {
        html += `<p>- <b>IAC Certificate</b> - a copy will need to be tendered to the airline with the freight - view and print form the app</p>`;
      }
      if (deliveryType == 'Air') {
        html += `<p>- <b>ID Validation</b> - in certain scenarios you may be required by the TSA to complete this form as well.  PLEASE DON’T SKIP OVER THIS IMPORTANT STEP! If you don’t see the button, we don’t need the form for your shipment.</p>`;
      }
      if (deliveryType == 'Scheduled Air') {
        html += `<p>- <b>Airline Labels</b> - THESE MUST BE PRINTED AND ATTACHED TO THE FREIGHT PRIOR TO TENDERING TO THE AIRLINE!!</p>`;
      }
      if (deliveryType == 'Scheduled Air') {
        html += `<p>- <b>Airline Waybill</b> - if required for oyur shipment, we've provided a copy of the waybill you'll need to print and use for tender to the airline. If you don't see one, you don't need it.</p>`;
      }
      if (deliveryType == 'Air') {
        html += `<p>- <b>Sample Airline Waybill </b> - we’ve prefilled a sample with all the necessary information you’ll need to fill out the actual waybill or print and use for tender to the airline.</p>`;
      }
      if (deliveryType == 'Air' || deliveryType == 'Scheduled Air') {
        html += `<p>- <b>Hard Copy Airline Waybill and UNKNOWN/KNOWN Air Forms</b> - PLEASE USE THE APPROPORATE PHOTO UPLOAD FIELD SO WE HAVVE RECORD OF ANY OTHER HARD COPY DOCS YOU USED! If you went all electronic, good job and thank you!</p>`;
      }
      // html += `<p>- Click the <b>“Driver’s Signature”</b> button, compare the Haney Freightways bill to the freight being offered, and e-sign when you’re confident you have the right shipment.</p>`
      // html += `<p>- Click on the <b>“Shipper’s Signature”<b> button and either have them signon your phone, or type the shipper’s name in for them using the e-signature tool – if the shipper has already signed, the link will tell you so.</p>`
      // html += `<p>- Depending on the type of job you’re doing, other paperwork like TSA forms, air waybills, or labels may be available to you – if you see them, you need them.</p>`
      html += `<p>- <b>Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`;
      html += `<a href="https://haney-freightways-driver.web.app/pages/upload/${orderID}/pickup"><button>Driver App</button></a>`;
      html += `<p><b>E-Document and E-Signature Links</b></p>`;
      html += `<p>If you aren’t able to access the driver application but did receive this message, you can access your electronic documents using the links below.</p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? `UNKNOWN or KNOWN Air Pick Up Alert will give you critical information about the pick-up and delivery locations, freight info, and flight information. The driver must <a href=${driverPickUpRateConURL}>click here</a> to view and complete the KNOWN or UNKNOWN Air Shipment Certification Statement on page two of this alert.`
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? `Dispatch Alert is similar to the Bill of Lading but is only used for informational purposes (it will not be signed). To view the dispatch alert, <a href=${driverPickUpRateConURL}>click here</a>`
          : ''
        }</b> </p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? "House Waybill requires the pick-up driver’s signature, and the shipper's signature. At the time of pick-up, we’ll need the driver and the shipper to sign."
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Bill of Lading requires the pick-up driver’s signature, the shipper’s signature, and the consignee’s signature which also counts as the proof of delivery (POD). Since your driver is making the pick-up, we’ll need them and the shipper to sign.  If your driver is also delivering the freight, we’ll need them to collect the consignee’s signature as well.  All three signatures links are included below:'
          : ''
        }</b></p>`;
      html += `<p>- To sign as the <b>pick-up driver</b>, please <a href="${signingURLs[1]}">click here</a></p>`;
      html += `<p>- To sign as the <b>shipper</b>, please <a href="${signingURLs[0]}">click here</a></p>`;
      if (deliveryType == 'Ground' || deliveryType == 'Additional Options') {
        html += `<p>- To sign as the <b>consignee</b>, please <a href="${signingURLs[2]}">click here</a></p>`;
      }
      if (deliveryType == 'Air' || deliveryType == 'Scheduled Air') {
        if (deliveryType == 'Scheduled Air') {
          html += `<p>The <b>Labels</b> are a critical component of this shipment <b>and must be printed and securely fastened to the freight prior to tendering to DHL. It is a good idea to print and tape two labels to each piece of cargo being tendered.</b>. Please <a href="${docs ? (docs.airLabel ? docs.airLabel.fileURL : null) : null
            }">view here</a> and print the labels</p>`;
        }
        // html += `<p>You may also need a prefilled air waybill to tender along with the freight. This doesn't happen every time and we'll let you know if you need it. If we've asked you to use one, please The <b>Sample Airline Waybill</b> has been prefilled with all the necessary information to allow for a successful tender.  You can use this sample to fill out the actual waybill, or print and use for tender with the airline.  Please <a href="${urls.signingSampleWayBill}">view here</a></p>`
        if (deliveryType == 'Scheduled Air') {
          html += `<p><b>Sample Airline Waybill</b>– we’ve prefilled a sample with all the necessary information you’ll need to fill out the actual waybill or print and use for tender to the airline. <a href="${signingSampleWayBill}">click here</a> to view and print.</p>`;
        }
        if (deliveryType == 'Air') {
          html += `<p>You may also need a prefilled air waybill to tender along with the freight. This doesn't happen every time and we'll let you know if you need it. If we've asked you to use one, please <a href="${signingSampleWayBill}">click here</a> to view and print.</p>`;
        }
        html += `<p>The <b>IAC Certificate</b> must be printed and tendered to the airline along with the waybill and freight. Please <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Party%20Air%20Shipment%20Documents%2FPick%20Up%20Vendor%20Driver%20Docs%2FIAC%20Certificate%2011.8.2019%20(1).pdf?alt=media&token=4cc64b5d-d5cf-4627-b223-d099d8b6edab">view here</a> and print.</p>`;
      }
      // if ((deliveryType == "Ground" || deliveryType == "Additional Options")) {
      //   html += `<p>Please click the following link to have the consignee sign the <b>Bill of Lading</b> once they have agreed to take delivery: <a href="${urls.signingURLs[2]}">Sign Here</a></p>`
      //   html += `<p>If the consignee has already signed, you will be notified as such when you click the consignee signature link.<p>`
      // }
      if (!origin.ksms && deliveryType == 'Air') {
        html += `<p>If you’ve received the <b>Identification Validation Form</b> it’s because the shipper is unknown to TSA and this form must be completed. Please <a href="${driverIVFURL}">click here</a> and complete the form.</p>`;
      }
      html += `<p>Thanks, and be safe out there!<p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`;
      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
      const emails = [
        pickUpDriver ? pickUpDriver.email && pickUpDriver.email : null,
        'vendoralerts@cargorx.com',
        'justin@pondata.com',
      ];
      // const emails = [driverPickUpEmail, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
      // const emails = [driverPickUpEmail, "justin@pondata.com"];
      const attachment = true;
      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      const emailReturn = await sendDynamicEmail({
        emails,
        subject,
        template:
          deliveryType == 'Air' || deliveryType == 'Scheduled Air'
            ? 'd-2a099851de754a5b8e65c488a039f7ef'
            : 'd-dc06f07f268946b7bafd5475436d2db6',
        data,
        html,
        // attachment
      });
      resolve(emailReturn);
    });
  };

  sendDE = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      items,
      billingParty,
      deliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      dropOffRateConURL,
      driverDropOffRateConURL,
    } = order;
    return new Promise(async (resolve, reject) => {
      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`;
      const data = {
        // name: data.name,
        // confirm_account_url: data.confirm_account__url, not sure what values to use
        // reset_password_url: data.reset_password_url, not sure what values to use
        // Shipper Data
        shipper_name: origin.name,
        shipper_address: origin.address,
        shipper_pickup: origin.pickup,
        shipper_service: origin.customExtraService,
        // Consignee Data
        consignee_name: destination.name,
        consignee_address: destination.address,
        consignee_dropoff: serviceETA
          ? moment(serviceETA.toDate()).format('YYYY-MM-DD HH:mm')
          : ' ',
        consignee_service: destination.customExtraService,
        // 3rd Party Data
        // party_name: ((Object.keys(thirdParty).length !== 0) ? thirdParty.businessName : " "),
        // party_address: ((Object.keys(thirdParty).length !== 0) ? thirdParty.address : " "),
        // party_contact: ((Object.keys(thirdParty).length !== 0) ? thirdParty.contact : " "),
        // party_phone: ((Object.keys(thirdParty).length !== 0) ? thirdParty.phone : " "),
        // party_email: ((Object.keys(thirdParty).length !== 0) ? thirdParty.email : " "),
        // party_ksms: ((Object.keys(thirdParty).length !== 0) ? thirdParty.ksms : " "),
        // Item Data
        item_number: items[0].number,
        item_packaging: items[0].packaging,
        item_quantity: items[0].quantity,
        item_weight: items[0].weight,
        // item_total: items[0].total,
        item_length: items[0].length,
        item_width: items[0].width,
        item_height: items[0].height,
        item_value: items[0].value,
        // item_upload: items[0].upload, not sure what values to use
        // Description Data
        // one_description: data.one_description,
        // item_description: data.item_description,
        // Carrier Data
        // carrier_name: data.carrier_name,
        // carrier_address: data.carrier_address,
        // carrier_phone: data.carrier_phone,
        // carrier_pickup: data.carrier_pickup,
        // carrier_awb: data.carrier_awb,
        // carrier_booking: data.carrier_booking,
        // carrier_flight: data.carrier_flight,
        // carrier_origin: data.carrier_origin,
        // carrier_destination: data.carrier_destination,
        // carrier_service: data.carrier_service,
        // carrier_dropoff: data.carrier_dropoff,
        // carrier_level: data.carrier_level,
        // carrier_dropoff: data.carrier_level,
      };
      let html = `<p>Thank you for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`;
      const emails = ['justin@pondata.com'];
      console.log(data);
      console.log(sendDynamicEmail);

      const attachment = true;
      const emailReturn = await sendDynamicEmail({
        emails,
        subject,
        template:
          deliveryType == 'Air' || deliveryType == 'Scheduled Air'
            ? 'd-2a099851de754a5b8e65c488a039f7ef'
            : 'd-dc06f07f268946b7bafd5475436d2db6',
        data,
        html,
        // attachment
      });
      console.log('hello');
      console.log(emailReturn);

      resolve(emailReturn);
    });
  };

  fifthEmail = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      serviceLevel,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      bolHash,
      dropOffRateConURL,
      driverDropOffRateConURL,
    } = order;

    console.log(items);
    console.log('items');
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log(item1);
    console.log(!!item4);
    let conditionalItems = [];
    if (items.length > 1) {
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }

    let carrier_address;
    if (deliveryType == 'Air') {
      if (destinationAirlineDetails[0]) {
        carrier_address =
          destinationAirlineDetails[0].physicalAddress +
          ' ' +
          destinationAirlineDetails[0].physicalCity +
          ' ' +
          destinationAirlineDetails[0].physicalZip;
      }
    } else if (deliveryType == 'Scheduled Air') {
      carrier_address =
        destinationAirCarrier.address +
        ' ' +
        destinationAirCarrier.city +
        ' ' +
        destinationAirCarrier.zip;
    }

    console.log(conditionalItems);
    // let thirdParty = ((Object.keys(order.thirdParty).length !== 0) ? order.thirdParty : null)
    let party_address = thirdParty.address
      ? (thirdParty.address ? thirdParty.address : ' ') +
      ' ' +
      (thirdParty.city ? thirdParty.city : ' ') +
      ' ' +
      (thirdParty.zip ? thirdParty.zip : ' ')
      : undefined;
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }
    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: false,
      consignee: false,
      thirdParty: false,
      pickUpVendor: true,
      pickUpDriver: false,
      dropoff: true,
      party: 'Drop Off Vendor',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      carrier_name:
        deliveryType == 'Air'
          ? destinationAirlineDetails
            ? destinationAirlineDetails[0]
              ? destinationAirlineDetails[0].name
                ? destinationAirlineDetails[0].name +
                ' ' +
                destinationAirlineDetails[0].airCodes[0]
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? destinationAirCarrier
              ? destinationAirCarrier.businessName
                ? destinationAirCarrier.businessName
                : ' '
              : ' '
            : null,
      carrier_address: carrier_address,
      carrier_pickup: destination.deliverBy
        ? moment(
          destination.deliverBy.seconds
            ? destination.deliverBy.toDate()
            : destination.deliverBy
        ).format('MM/DD/YYYY HH:mm')
        : ' ',
      // carrier_service: originAirCarrier ? originAirCarrier.customExtraService : " ",
      carrier_service:
        deliveryType == 'Air'
          ? destinationAirlineDetails
            ? destinationAirlineDetails[0]
              ? destinationAirlineDetails[0].customExtraService
                ? destinationAirlineDetails[0].customExtraService
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? destinationAirCarrier
              ? destinationAirCarrier.customExtraService
                ? destinationAirCarrier.customExtraService
                : ' '
              : ' '
            : null,
      carrier_phone:
        deliveryType == 'Air'
          ? destinationAirlineDetails
            ? destinationAirlineDetails[0]
              ? destinationAirlineDetails[0].mainPhone
                ? destinationAirlineDetails[0].mainPhone
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? destinationAirCarrier
              ? destinationAirCarrier.mainPhone
                ? destinationAirCarrier.mainPhone
                : ' '
              : ' '
            : null,
      // carrier_phone: originAirCarrier ? originAirCarrier.mainPhone : " ",
      carrier_awb: airWaybillNumber ? airWaybillNumber : ' ',
      carrier_sl: serviceLevel ? serviceLevel : ' ',
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      rateLink: dropOffRateConURL,
      bolLink: `https://api.eversign.com/api/download_current_document_status?access_key=${this.state.dispatchedBeforeEversign ? 'a74f3d4d2ca030cf60500f7814618064&business_id=141252' : '751efbc709ec4ace1d6ff70a062b7243&business_id=246480'}&document_hash=${bolHash}&audit_trail=1`,
      link: signingURLs[0],
      shipperLink: signingURLs[0],
      driverLink: signingURLs[1],
      consigneeLink: signingURLs[2],
      driverAppLink: `https://haney-freightways-driver.web.app/pages/upload/${orderID}/pickup`,
      loginLink: 'https://haney-freightways-vendor.web.app/pages/login-page',
      pickUpStatementLink: driverDropOffRateConURL,
      // sampleLink: signingSampleWayBill,
      // labelLink: docs ? (docs.airLabel ? docs.airLabel.fileURL : null) : null,
      // airlineWaybillLink: docs ? (docs.alternateAirWaybill ? docs.alternateAirWaybill.fileURL : null) : null,
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };
    console.log('vendordropoff email');

    return new Promise(async (resolve, reject) => {
      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`;
      let html = `<p>Thank you for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures.</p>`;
      html += `<p><b>Using Vendor Dispatch App</b></p>`;
      html += `<p>The button below will take you to the Haney Freightways Vendor Dispatcher Application. If you don't have a login yet, simply request one via your Haney Freightways representative or be emailing shipping@cargorx.com. We'll send a link via email and text, which will allow you to log right in. If you have a profile click the button below, log in, and access the following:</p>`;
      html += `<p>- All Haney Freightways orders involving your company will be visible by clicking "Orders" on the menu bar</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.34.08%20PM.png?alt=media&token=8ea25f35-9ea0-4612-b5b6-62e5046d2de0" height="100">`;
      html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="100">`;
      html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents including the completed e-sign docs once all parties have signed – our preference is for the driver to obtain e-signatures, but we understand that paper might be necessary.</p>`;
      html += `<p>- The driver is able to upload pictures of paper documents through the driver application and we send the driver a link to this app if we have the driver’s information when we dispatch the shipment.</p>`;
      html += `<p>- Within the shipment summary page, you will see a button the says “Confirm Rate” – if the Status above the button says “unconfirmed” in red text, please click on the button and e-sign the confirmation – if the status says “confirmed” in green text above the button, someone has already confirmed the rate. <b>The document takes a few seconds to generate so click the button once and wait patiently please.</b></p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.40.04%20PM.png?alt=media&token=9fc33ea6-f2f4-4d8b-9d17-8e573f943592" height="100">`;
      html += `<p><b>Call 833-227-4679 for answers to any questions you have – we’re here for you!</b></p>`;
      html += `<a href="https://haney-freightways-vendor.web.app"><button>Vendor App</button></a>`;
      html += `<p><b>E-Document and e-Signature Links</b></p>`;
      html += `<p>If a driver wasn’t assigned at the time of dispatch, the assigned driver didn't receive our dispatch alert, or a new driver was assigned, they can access the electronic documents and e-signatures by using the links below.  You simply need to forward the applicable link(s) below to the appropriate driver.</p>`;
      html += `<p>Please click <a href=${dropOffRateConURL}>here</a> to e-sign the <b>Rate Confirmation</b>. </p>`;
      html += `<p>The <b>Dispatch Alert</b> will give you critical information about the pick-up and deliverylocations, freight info, and flight information. Please <a href=${driverDropOffRateConURL}>view here</a>.</p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? 'House Waybill'
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Bill of Lading'
          : ''
        } requires the consignee’s signature.  Since you’re making the delivery, we need the consignee to sign which becomes the Proof of Delivery.</p>`;
      html += `<p>- To have the <b>consignee</b> sign, please <a href="${signingURLs[2]}">click here</a></p>`;
      html += `<p>The <b>Destination Airline Air Waybill or Recovery Receipt</b> is a critical piece of information.  Please take a picture of the actual airline airwaybill or recovery receipt within the driver application – if you are unable to access the driver application, please obtain a hard copy and send back to Haney Freightways via email or snail mail.</p>`;
      html += `<p>Thanks, and be safe out there!<p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`;
      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
      html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`;
      const emails = [
        vendorDropOff.email && vendorDropOff.email,
        'vendoralerts@cargorx.com',
        'justin@pondata.com',
      ];
      // const emails = [vendorDropOff.email, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
      // const emails = [vendorDropOff.email, "justin@pondata.com"];
      const attachment = true;
      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      const emailReturn = await sendDynamicEmail({
        emails,
        subject,
        template:
          deliveryType == 'Air' || deliveryType == 'Scheduled Air'
            ? 'd-43aa3970af84414d98b40af62e0c4131'
            : 'd-3a941603428b45609d337a94ee25e0f1',
        data,
        html,
        // attachment
      });
      resolve(emailReturn);
    });
  };

  sixthEmail = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      driverDropOffRateConURL,
    } = order;

    console.log(items);
    console.log('items');
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log(item1);
    console.log(!!item4);
    let conditionalItems = [];
    if (items.length > 1) {
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }
    console.log(conditionalItems);

    let carrier_address;
    if (deliveryType == 'Air') {
      if (destinationAirlineDetails[0]) {
        carrier_address =
          destinationAirlineDetails[0].physicalAddress +
          ' ' +
          destinationAirlineDetails[0].physicalCity +
          ' ' +
          destinationAirlineDetails[0].physicalZip;
      }
    } else if (deliveryType == 'Scheduled Air') {
      carrier_address =
        destinationAirCarrier.address +
        ' ' +
        destinationAirCarrier.city +
        ' ' +
        destinationAirCarrier.zip;
    }

    // let thirdParty = ((Object.keys(order.thirdParty).length !== 0) ? order.thirdParty : null)
    let party_address = thirdParty.address
      ? (thirdParty.address ? thirdParty.address : ' ') +
      ' ' +
      (thirdParty.city ? thirdParty.city : ' ') +
      ' ' +
      (thirdParty.zip ? thirdParty.zip : ' ')
      : undefined;
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }
    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: false,
      consignee: false,
      thirdParty: false,
      pickUpVendor: false,
      pickUpDriver: true,
      dropoff: true,
      party: 'Drop Off Driver',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      carrier_name:
        deliveryType == 'Air'
          ? destinationAirlineDetails
            ? destinationAirlineDetails[0]
              ? destinationAirlineDetails[0].name
                ? destinationAirlineDetails[0].name +
                ' ' +
                destinationAirlineDetails[0].airCodes[0]
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? destinationAirCarrier
              ? destinationAirCarrier.businessName
                ? destinationAirCarrier.businessName
                : ' '
              : ' '
            : null,
      carrier_address: carrier_address,
      carrier_pickup: destination.deliverBy
        ? moment(
          destination.deliverBy.seconds
            ? destination.deliverBy.toDate()
            : destination.deliverBy
        ).format('MM/DD/YYYY HH:mm')
        : ' ',
      // carrier_service: originAirCarrier ? originAirCarrier.customExtraService : " ",
      carrier_service:
        deliveryType == 'Air'
          ? destinationAirlineDetails
            ? destinationAirlineDetails[0]
              ? destinationAirlineDetails[0].customExtraService
                ? destinationAirlineDetails[0].customExtraService
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? destinationAirCarrier
              ? destinationAirCarrier.customExtraService
                ? destinationAirCarrier.customExtraService
                : ' '
              : ' '
            : null,
      carrier_phone:
        deliveryType == 'Air'
          ? destinationAirlineDetails
            ? destinationAirlineDetails[0]
              ? destinationAirlineDetails[0].mainPhone
                ? destinationAirlineDetails[0].mainPhone
                : ' '
              : ' '
            : ' '
          : deliveryType == 'Scheduled Air'
            ? destinationAirCarrier
              ? destinationAirCarrier.mainPhone
                ? destinationAirCarrier.mainPhone
                : ' '
              : ' '
            : null,
      // carrier_phone: originAirCarrier ? originAirCarrier.mainPhone : " ",
      carrier_awb: airWaybillNumber ? airWaybillNumber : ' ',
      carrier_sl: serviceLevel ? serviceLevel : ' ',
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      link: signingURLs[0],
      shipperLink: signingURLs[0],
      driverLink: signingURLs[1],
      consigneeLink: signingURLs[2],
      driverAppLink: `https://haney-freightways-driver.web.app/pages/upload/${orderID}/dropoff`,
      loginLink: 'https://haney-freightways-vendor.web.app/pages/login-page',
      pickUpStatementLink: driverDropOffRateConURL,
      // sampleLink: signingSampleWayBill,
      // labelLink: docs ? (docs.airLabel ? docs.airLabel.fileURL : null) : null,
      // airlineWaybillLink: docs ? (docs.alternateAirWaybill ? docs.alternateAirWaybill.fileURL : null) : null,
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };

    console.log('pickupdropoff email');

    return new Promise(async (resolve, reject) => {
      let subject = `Haney Freightways #${freightBillNumber} Shipping Documents - Please Get Signatures!`;
      let html = `<p>Thank you very much for partnering with Haney Freightways!  Please use the instructions below to help us obtain the necessary electronic signatures and perform key driver functions.</p>`;
      html += `<p><b>Using the Driver App</b></p>`;
      html += `<p>The button below will take you to the Haney Freightways Driver Application.  You won’t need to log in and you won’t need to download anything to your phone! You should also have received a link via text if we were given your cell number at the time of dispatch.</p>`;
      html += `<p><b>Once you’re in, you’ll have access to the e-signatures and image captures we need for this order.</b></p>`;
      html += `<p>- <b>Click “allow location services”</b> – our application uses geo-fencing to automatically update the status of this shipment.  Please do not close the browser window being used to access the driver application until your entire job has been completed.</p>`;
      html += `<p>- <b>Delivery Alert</b> - contains critical information about the pick-up location, airline information, shipment information, and delivery information.</p>`;
      html += `<p>- <b>Destination Air Waybill</b> - it contains important information so please use the appropriate photo upload button to capture a picture for us.</p>`;
      // html += `<p>- <b>Driver BOL</b> - compare the Cargorx house waybill to the freight being offered, and e-sign when you're confident you have the right shipment.</p>`
      // html += `<p>- <b>Shipper BOL</b> - have the shipper e-sign on your phone or type the shipper's name in for them using the e-signature tool - if the shipper has already signed, the link will tell you so.</p>`
      // html += `<p>- <b>Paper BOL/Waybill</b> - sometimes physical paperwork is all you have - please use the appropriate photo upload to capture the signed hardcopies right in the app.</p>`
      html += `<p>- <b>Post Flight Freight Pics</b> - we like to document the condition of freight at multiple stages - please use the applicable photo upload to snap a pic of the freight prior to prior to being loaded by the airline.</p>`;
      html += `<p>- <b>Consignee BOL</b> - have the consignee e-sign on your phone or type their name in for them using the e-signature tool - if the consignee has already signed, the link will tell you so.</p>`;
      html += `<p>- <b>Post Delivery Freight Pics</b> - we like to document the condition of freight at multiple stages - please use the applicable photo upload to snap a pic of the freight once the consignee has signed for delivery.</p>`;
      // html += `<p>- <b>IAC Certificate</b> - a copy will need to be tendered to the airline with the freight - view and print form the app</p>`
      // html += `<p>- <b>Airline Labels</b> - THESE MUST BE PRINTED AND ATTACHED TO THE FREIGHT PRIOR TO TENDERING TO THE AIRLINE!!</p>`
      // html += `<p>- <b>Airline Waybill</b> - if required for oyur shipment, we've provided a copy of the waybill you'll need to print and use for tender to the airline. If you don't see one, you don't need it.</p>`
      html += `<p>- <b>Hard Copy Documentation</b> - PLEASE USE THE APPROPORATE PHOTO UPLOAD FIELD SO WE HAVVE RECORD OF ANY OTHER HARD COPY DOCS YOU USED! If you went all electronic, good job and thank you!</p>`;
      html += `<p><b>E-Document and e-Signature Links</b></p>`;
      html += `<p>If you aren’t able to access the driver application but did receive this message, you can access your electronic documents using the links below.</p>`;
      html += `<p>The <b>Delivery Alert</b> will give you critical information about the pick-up, airline information, shipment information, and delivery information. <a href=${driverDropOffRateConURL}>click here</a></p>`;
      html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? 'House Waybill'
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Bill of Lading'
          : ''
        } requires consignee’s signature.  Since you’re making the delivery, we need the consignee to sign which becomes the Proof of Delivery.</p>`;
      html += `<p>- To have the <b>consignee</b> sign, please <a href="${signingURLs[2]}">click here</a></p>`;
      html += `<p>The <b>Destination Airline Air Waybill or Recovery Receipt</b> is a critical piece of information.  Please take a picture of the actual airline airwaybill or recovery receipt within the driver application – if you are unable to access the driver application, please obtain a hard copy and send back to Haney Freightways via email or snail mail.</p>`;
      html += `<a href="https://haney-freightways-driver.web.app/pages/upload/${orderID}/dropoff"><button>Driver App</button></a>`;
      html += `<p>Thanks, and be safe out there!<p>`;
      html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="200">`;
      html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
      // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
      const emails = [
        dropOffDriver ? dropOffDriver.email : null,
        'vendoralerts@cargorx.com',
        'justin@pondata.com',
      ];
      // const emails = [driverDropOffEmail, "vendoralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
      // const emails = [driverDropOffEmail, "justin@pondata.com"];
      const attachment = true;
      const emailReturn = await sendDynamicEmail({
        emails,
        subject,
        template:
          deliveryType == 'Air' || deliveryType == 'Scheduled Air'
            ? 'd-2a099851de754a5b8e65c488a039f7ef'
            : 'd-dc06f07f268946b7bafd5475436d2db6',
        data,
        html,
        // attachment
      });
      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      resolve(emailReturn);
    });
  };

  seventhEmail = (order, bol = null) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
      signingURLs,
      docs,
    } = order;

    console.log(items);
    console.log('items');
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log(item1);
    console.log(!!item4);
    let conditionalItems = [];
    if (items.length > 1) {
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }
    console.log(conditionalItems);
    // let thirdParty = ((Object.keys(order.thirdParty).length !== 0) ? order.thirdParty : null)

    let party_address

    party_address = thirdParty
      ? (thirdParty.address ? thirdParty.address : ' ') +
      ' ' +
      (thirdParty.city ? thirdParty.city : ' ') +
      ' ' +
      (thirdParty.zip ? thirdParty.zip : ' ')
      : undefined;
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }

    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' ||
          deliveryType == 'Additional Options' ||
          deliveryType == 'LTL'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      accufrate: deliveryType == 'LTL' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: false,
      consignee: true,
      thirdParty: false,
      pickUpVendor: false,
      pickUpDriver: false,
      party: 'Consignee',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      link: bol ? bol : signingURLs[2],
      loginLink: 'https://haney-freightways-customer.web.app/pages/login-page',
      bolLink: docs && docs.alternateBOL ? docs.alternateBOL.fileURL : null,
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };

    let subject = `Haney Freightways ${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
      ? 'House Waybill'
      : deliveryType == 'Ground' || deliveryType == 'Additional Options'
        ? 'Bill of Lading'
        : ''
      } #${freightBillNumber}, Shipping Documents – Your Signature May be Required!`;
    let html = `<p>Thank you very much for shipping with Haney Freightways!  Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`;
    html += `<p><b>Using Haney Freightways Customer App</b></p>`;
    html += `<p>The "Customer App" button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`;
    html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`;
    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%202.07.50%20PM.png?alt=media&token=e7a63ce9-9179-4ac8-850f-cf6c14423ada" height="150">`;
    html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`;
    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`;
    html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents and access the e-sign version.  If you won’t be the person signing for the delivery of this shipment, the driver will have an e-signature version of the shipping document on his or her phone for the for the person taking delivery.</p>`;
    html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`;
    html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select the right shipping option and book your shipment.</p>`;
    html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`;
    html += `<p>Please click the link below to verify shipment details. The link includes an e-signature, which we realize you won’t complete until your freight has been received.<p>`;
    html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`;
    html += `<p><b>E-Document and e-Signature Links</b></p>`;
    html += `<p>If you aren’t able to access the customer application but did receive this message, you can access your electronic document using the link below.<p>`;
    html += `<p>The <b>${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
      ? 'House Waybill'
      : deliveryType == 'Ground' || deliveryType == 'Additional Options'
        ? 'Bill of Lading'
        : ''
      }</b> requires a signature from the consignee at the time of delivery. Once that happens, the ${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
        ? 'House Waybill'
        : deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? 'Bill of Lading'
          : ''
      } also becomes the <b>Proof of Deliver</b> If you’d like a contact-free way to sign at delivery, click the link below.</p>`;
    html += `<p>- To sign as the <b>Consignee</b> at the time of delivery, please <a href="${bol ? bol : signingURLs[2]
      }">click here</a></p>`;
    html += `<p>Thanks for the opportunity to serve your company!</p>`;
    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`;
    html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
    // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
    const emails = [
      destination.email ? destination.email : 'justin@ltl.ai',
      'customeralerts@haneyfreightways.com',
      'justin@pondata.com',
    ];
    // const emails = [destination.email, "customeralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
    // const emails = [destination.email, "justin@pondata.com"];
    const attachment = true;
    return new Promise(async (resolve, reject) => {
      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      console.log('Seventh email: ', emails, subject);
      const emailReturn = await sendDynamicEmail({
        emails,
        subject,
        template:
          deliveryType == 'Air' || deliveryType == 'Scheduled Air'
            ? 'd-66ebd124ba204f58a33f2d965eeaedae'
            : 'd-be3ca4a997054d0aa2746d3a3f9874b3',
        data,
        html,
        // attachment
      });
      resolve(emailReturn);
    });
  };

  eigthEmail = (order) => {
    const { orderID } = this.props;
    const {
      origin,
      destination,
      thirdParty,
      items,
      billingParty,
      deliveryType,
      subDeliveryType,
      air,
      freightBillNumber,
      cargoAir,
      ground,
      ltl,
      airWaybillNumber,
      flight,
      driverPickUpEmail,
      vendorDropOff,
      serviceLevel,
      bookingNumber,
      originAirlineDetails,
      originAirCarrier,
      destinationAirCarrier,
      destinationAirlineDetails,
      serviceETA,
      driverDropOff,
      vendorPickUp,
      pickUpDriver,
      pickUpRate,
      pickUpDriverCell,
      dropOffDriver,
      driverDropOffEmail,
      status,
    } = order;

    console.log(items);
    console.log('items');
    const item1 = items[0];
    const item2 = items[1];
    const item3 = items[2];
    const item4 = items[3];
    const item5 = items[4];
    console.log(item1);
    console.log(!!item4);
    let conditionalItems = [];
    if (items.length > 1) {
      conditionalItems = !!item4
        ? [
          {
            item_number: item1.id + 1,
            item_packaging: item1.packaging,
            item_quantity: item1.quantity,
            item_weight: item1.weight,
            // item_total: items[0].total,
            item_length: item1.length,
            item_width: item1.width,
            item_height: item1.height,
            item_value: item1.declaredValue,
            item_description: item1.description,
          },
          {
            item_number: item2.id + 1,
            item_packaging: item2.packaging,
            item_quantity: item2.quantity,
            item_weight: item2.weight,
            // item_total: items[0].total,
            item_length: item2.length,
            item_width: item2.width,
            item_height: item2.height,
            item_value: item2.declaredValue,
            item_description: item2.description,
          },
          {
            item_number: item3.id + 1,
            item_packaging: item3.packaging,
            item_quantity: item3.quantity,
            item_weight: item3.weight,
            // item_total: items[0].total,
            item_length: item3.length,
            item_width: item3.width,
            item_height: item3.height,
            item_value: item3.declaredValue,
            item_description: item3.description,
          },
          {
            item_number: item4.id + 1,
            item_packaging: item4.packaging,
            item_quantity: item4.quantity,
            item_weight: item4.weight,
            // item_total: items[0].total,
            item_length: item4.length,
            item_width: item4.width,
            item_height: item4.height,
            item_value: item4.declaredValue,
            item_description: item4.description,
          },
        ]
        : !!item3
          ? [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
            {
              item_number: item3.id + 1,
              item_packaging: item3.packaging,
              item_quantity: item3.quantity,
              item_weight: item3.weight,
              // item_total: items[0].total,
              item_length: item3.length,
              item_width: item3.width,
              item_height: item3.height,
              item_value: item3.declaredValue,
              item_description: item3.description,
            },
          ]
          : [
            {
              item_number: item1.id + 1,
              item_packaging: item1.packaging,
              item_quantity: item1.quantity,
              item_weight: item1.weight,
              // item_total: items[0].total,
              item_length: item1.length,
              item_width: item1.width,
              item_height: item1.height,
              item_value: item1.declaredValue,
              item_description: item1.description,
            },
            {
              item_number: item2.id + 1,
              item_packaging: item2.packaging,
              item_quantity: item2.quantity,
              item_weight: item2.weight,
              // item_total: items[0].total,
              item_length: item2.length,
              item_width: item2.width,
              item_height: item2.height,
              item_value: item2.declaredValue,
              item_description: item2.description,
            },
          ];
    } else {
      conditionalItems = null;
    }
    console.log(conditionalItems);
    // let thirdParty = ((Object.keys(order.thirdParty).length !== 0) ? order.thirdParty : null)
    let party_address = thirdParty
      ? (thirdParty.address ? thirdParty.address : ' ') +
      ' ' +
      (thirdParty.city ? thirdParty.city : ' ') +
      ' ' +
      (thirdParty.zip ? thirdParty.zip : ' ')
      : undefined;
    let weight = 0;
    for (let i = 0; i < items.length; i++) {
      const wpp = parseInt(items[i].weight ? items[i].weight : 0);
      const qty = parseInt(items[i].quantity ? items[i].quantity : 0);
      weight += wpp * qty;
    }
    const data = {
      // name: data.name,
      // confirm_account_url: data.confirm_account__url, not sure what values to use
      // reset_password_url: data.reset_password_url, not sure what values to use
      // Shipper Data
      freightBillNumber: freightBillNumber,
      air:
        deliveryType == 'Air' || deliveryType == 'Scheduled Air' ? true : false,
      ground:
        deliveryType == 'Ground' || deliveryType == 'Additional Options'
          ? true
          : false,
      nfo: deliveryType == 'Air' ? true : false,
      nda: deliveryType == 'Scheduled Air' ? true : false,
      airTruck: subDeliveryType == 'Air Truck' ? true : false,
      shipper: false,
      consignee: false,
      thirdParty: true,
      pickUpVendor: false,
      pickUpDriver: false,
      party: 'Third Party',
      shipper_name: origin.businessName,
      shipper_address: origin.address + ' ' + origin.city + ' ' + origin.zip,
      shipper_contact: origin.firstName + ' ' + origin.lastName,
      shipper_phone: origin.phone,
      shipper_pickup:
        moment(origin.date.toDate()).format('MM/DD/YYYY') +
        ' ' +
        (origin.startTimeWindow ? origin.startTimeWindow : ' ') +
        ' - ' +
        (origin.endTimeWindow ? origin.endTimeWindow : ' '),
      shipper_service: origin.customExtraService,
      shipper_rn: origin.referenceID,
      consignee_rn: destination.referenceID,
      // Consignee Data
      consignee_name: destination.businessName,
      consignee_address:
        destination.address + ' ' + destination.city + ' ' + destination.zip,
      consignee_contact: destination.firstName + ' ' + destination.lastName,
      consignee_phone: destination.phone,
      consignee_dropoff: serviceETA
        ? moment(serviceETA.toDate()).format('MM/DD/YYYY HH:mm')
        : ' ',
      consignee_service: destination.customExtraService,
      // 3rd Party Data
      party_name: thirdParty ? thirdParty.businessName : ' ',
      party_address: thirdParty ? party_address : ' ',
      party_contact: thirdParty ? thirdParty.contact : ' ',
      party_phone: thirdParty ? thirdParty.phone : ' ',
      party_email: thirdParty ? thirdParty.email : ' ',
      party_ksms: thirdParty ? thirdParty.ksms : ' ',
      link: false,
      loginLink: 'https://haney-freightways-customer.web.app/pages/login-page',
      // Item Data
      weight: weight,
      items: conditionalItems,
      item_number: items[0].number,
      item_packaging: items[0].packaging,
      item_quantity: items[0].quantity,
      item_weight: items[0].weight,
      // item_total: items[0].total,
      item_length: items[0].length,
      item_width: items[0].width,
      item_height: items[0].height,
      item_value: items[0].declaredValue,
      item_description: items[0].description,
      // item_number_2: items[1].number,
      // item_packaging_2: items[1].packaging,
      // item_quantity_2: items[1].quantity,
      // item_weight_2: items[1].weight,
      //  item_total: items[0].total,
      // item_length_2: items[1].length,
      // item_width_2: items[1].width,
      // item_height_2: items[1].height,
      // item_value_2: items[1].value,
      // item_upload: items[0].upload, not sure what values to use
      // Description Data
      // one_description: data.one_description,
      // item_description: data.item_description,
      // Carrier Data
      // carrier_name: data.carrier_name,
      // carrier_address: data.carrier_address,
      // carrier_phone: data.carrier_phone,
      // carrier_pickup: data.carrier_pickup,
      // carrier_awb: data.carrier_awb,
      // carrier_booking: data.carrier_booking,
      // carrier_flight: data.carrier_flight,
      // carrier_origin: data.carrier_origin,
      // carrier_destination: data.carrier_destination,
      // carrier_service: data.carrier_service,
      // carrier_dropoff: data.carrier_dropoff,
      // carrier_level: data.carrier_level,
      // carrier_dropoff: data.carrier_level,
    };

    let subject = `Haney Freightways ${deliveryType == 'Air' || deliveryType == 'Scheduled Air'
      ? 'House Waybill'
      : deliveryType == 'Ground' || deliveryType == 'Additional Options'
        ? 'Bill of Lading'
        : ''
      } #${freightBillNumber} - Shipping Documents!`;
    let html = `<p>Thank you very much for shipping with Haney Freightways!  Please use the instructions below to access your shipping documents, sign your documents electronically, and track your shipment.</p>`;
    html += `<p><b>Using Haney Freightways Customer App</b></p>`;
    html += `<p>The "Customer App" button below will take you to the Haney Freightways Customer Application.  If you don’t have a login yet, simply request one via shipping@cargorx.com.  We’ll send a link via email and text, which will allow you to log right in.  If you have a profile, click the button below, log in, and access the following:<p>`;
    html += `<p>- All Haney Freightways orders involving your company will be visible by click "Orders" on the menu bar</p>`;
    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%202.07.50%20PM.png?alt=media&token=e7a63ce9-9179-4ac8-850f-cf6c14423ada" height="150">`;
    html += `<p>- Clicking the “Details” button on any shipment will take you to the shipment summary page</p>`;
    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/Images%2FScreen%20Shot%202020-07-22%20at%2012.35.30%20PM.png?alt=media&token=bb34dc97-3e36-4c1f-9fc9-5db0575c9ce1" height="50">`;
    html += `<p>- On the shipment summary page, you can download and print hard copies of the shipping documents.</p>`;
    html += `<p>- You can also use the Customer App to track your shipments – certain shipment types allow you to see the driver’s location on the map!  Click on “Orders” within the menu bar, then on the “Details” button of your shipment.</p>`;
    html += `<p>- <b>New Transactions:</b> If you don’t have complete shipping information but need an idea of what options are available, use the <b>“Quote” menu bar option </b>– you’ll be asked to complete certain missing fields later when you select the right shipping option and book your shipment.</p>`;
    html += `<p>- <b>New Transactions:</b> If you have complete shipping information, use the <b>“Ship” menu bar</b> option to obtain shipping options and pricing – you won’t be asked for any missing information later when you select and book a shipping option.</p>`;
    html += `<a href="https://haney-freightways-customer.web.app"><button>Customer App</button></a>`;
    html += `<p>Thanks for the opportunity to serve your company!</p>`;
    html += `<img src="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/logos%2FbURGCR.png?alt=media&token=5cc65bda-942f-439a-9eef-bb74918e3753" width="100">`;
    html += `<p>If you have any questions or concerns, please call <a href="tel:+8332274679">833-227-4679</a>.</p>`;
    // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
    const emails = [
      (thirdParty ? thirdParty.email : 'justin@ltl.ai'),
      'customeralerts@haneyfreightways.com',
      'justin@pondata.com',
    ];
    // const emails = [(thirdParty ? thirdParty.email : ""), "customeralerts@cargorx.com", "chris502castro@gmail.com", "justin@pondata.com"];
    // const emails = [(thirdParty ? thirdParty.email : ""), "justin@pondata.com"];
    const attachment = true;
    return new Promise(async (resolve, reject) => {
      // const emailReturn = await sendEmail({
      //   emails,
      //   subject,
      //   html,
      //   attachment
      // })
      let emailReturn;

      if (thirdParty) {
        emailReturn = await sendDynamicEmail({
          emails,
          subject,
          template:
            deliveryType == 'Air' || deliveryType == 'Scheduled Air'
              ? 'd-66ebd124ba204f58a33f2d965eeaedae'
              : 'd-be3ca4a997054d0aa2746d3a3f9874b3',
          data,
          html,
          // attachment
        });
      } else {
        emailReturn = true;
      }

      resolve(emailReturn);
    });
  };

  grabData = (key) => {
    const checkObj = () => {
      const checkArray = () => {
        if (
          (Array.isArray(this.state[key]) && this.state[key].length) ||
          !this.state.orderData[key] ||
          (this.state[key] &&
            this.state[key].length &&
            this.state.orderData[key] &&
            !this.state.orderData[key].length)
        ) {
          return this.state[key];
        } else {
          return this.state.orderData[key];
        }
      };

      if (
        Array.isArray(this.state[key]) ||
        Array.isArray(this.state.orderData[key])
      ) {
        return checkArray();
      }

      if (
        typeof this.state[key] === 'object' &&
        this.state[key] !== null &&
        Object.keys(this.state[key]).length
      ) {
        return this.state[key];
      } else if (
        this.state.orderData[key] &&
        typeof this.state.orderData[key] === 'object' &&
        Object.keys(this.state.orderData[key]).length
      ) {
        return this.state.orderData[key];
      } else {
        return null;
      }
    };

    const checkOther = () => {
      if (key in this.state) {
        return this.state[key];
      } else if (this.state.orderData[key]) {
        return this.state.orderData[key];
      } else {
        return null;
      }
    };

    if (
      (typeof this.state[key] === 'object' && this.state[key] !== null) ||
      (typeof this.state.orderData[key] === 'object' &&
        this.state.orderData[key] !== null)
    ) {
      return checkObj();
    } else {
      return checkOther();
    }
  };

  redispatchPickUpVendor = async () => {
    const dispatchData = {
      originAirCarrier: this.grabData('originAirCarrier'),
      destinationAirCarrier: this.grabData('destinationAirCarrier'),
      originAirlineDetails: this.grabData('originAirlineDetails'),
      destinationAirlineDetails: this.grabData('destinationAirlineDetails'),
      flight: this.grabData('flight'),
      additionalLegs: this.grabData('additionalLegs'),
      flightNumber: this.grabData('flightNumber'),
      pickUpDriver: this.grabData('pickUpDriver'),
      vendorPickUp: this.grabData('vendorPickUp'),
      vendorDropOff: this.grabData('vendorDropOff'),
      airCarrierExpense: this.grabData('airCarrierExpense'),
      pickUpRate: this.grabData('pickUpRate'),
      bookingNumber: this.grabData('bookingNumber'),
      airWaybillNumber: this.grabData('airWaybillNumber'),
      serviceLevel: this.grabData('serviceLevel'),
      vendorRate: this.grabData('vendorRate'),
      accufrateBOL: this.grabData('accufrateBOL'),
      brokerName: this.grabData('brokerName'),
      brokerPRO: this.grabData('brokerPRO'),
      brokerRate: this.grabData('brokerRate'),
      carrierName: this.grabData('carrierName'),
      carrierPRO: this.grabData('carrierPRO'),
      insuranceCost: this.grabData('insuranceCost'),
      carrierRate: this.grabData('carrierRate'),
    };

    const reqFields = [];
    const reqFieldsNames = [];

    switch (this.state.orderData.deliveryType) {
      case 'Air':
        reqFields.push(
          dispatchData.flight.number,
          dispatchData.vendorPickUp,
          this.state.origin.deliverBy,
          dispatchData.pickUpRate
        );
        reqFieldsNames.push(
          'Flight Number',
          'Pick Up Vendor',
          'Pick Up By',
          'Pick Up Rate'
        );
        break;

      case 'Scheduled Air':
        reqFields.push(
          dispatchData.vendorPickUp,
          this.state.origin.deliverBy,
          dispatchData.originAirCarrier,
          dispatchData.pickUpRate
        );
        reqFieldsNames.push(
          'Pick Up Vendor',
          'Pick Up By',
          'Origin Air Carrier',
          'Pick Up Rate'
        );
        break;

      case 'Ground':
        reqFields.push(
          dispatchData.vendorPickUp,
          this.state.origin.deliverBy,
          dispatchData.pickUpRate
        );
        reqFieldsNames.push('Pick Up Vendor', 'Pick Up By', 'Pick Up Rate');
        break;

      case 'Additional Options':
        reqFields.push(
          dispatchData.vendorPickUp,
          this.state.origin.deliverBy,
          dispatchData.pickUpRate
        );
        reqFieldsNames.push('Pick Up Vendor', 'Pick Up By', 'Pick Up Rate');
        break;

      default:
        break;
    }

    const falsyValues = [undefined, null, ''];

    if (reqFields.some((field) => falsyValues.includes(field))) {
      let errorString = 'Please fill out the following: ';
      for (let i = 0; i < reqFields.length; i++) {
        if (falsyValues.includes(reqFields[i]) && i < reqFields.length - 1) {
          errorString += `${reqFieldsNames[i]}, `;
        } else if (falsyValues.includes(reqFields[i])) {
          errorString += `${reqFieldsNames[i]}`;
        }
      }
      this.setState({ errorSnack: true, errorSnackMessage: errorString });
      return;
    }

    this.setState({
      redispatchPickUpVendorUI: true,
      documentsLoading: 0,
      documentsLoaded: 0,
    });

    const docData = {
      ...this.state.orderData,
      // originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
      originAirport: this.state.originAirport ? this.state.originAirport : null,
      // destinationAirlineDetails: this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0] : null) : null,
      destinationAirport: this.state.destinationAirport
        ? this.state.destinationAirport
        : null,
      currentDriver: dispatchData.pickUpDriver,
      driverPickUp: this.state.driverPickUp ? this.state.driverPickUp : null,
      driverPickUpName: dispatchData.pickUpDriver
        ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}`
        : null,
      driverPickUpEmail: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver.email
        : null,
      driverPickUpID: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver.id
          ? dispatchData.pickUpDriver.id
          : null
        : null,
      vendorPickUpName: dispatchData.vendorPickUp
        ? dispatchData.vendorPickUp.name
        : null,
      vendorPickUpID: dispatchData.vendorPickUp
        ? dispatchData.vendorPickUp.id
        : null,
      driverDropOff: dispatchData.dropOffDriver
        ? dispatchData.dropOffDriver
        : null,
      driverDropOffName: dispatchData.dropOffDriver
        ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}`
        : null,
      driverDropOffID: dispatchData.dropOffDriver
        ? dispatchData.dropOffDriver.id
          ? dispatchData.dropOffDriver.id
          : null
        : null,
      vendorDropOffName: dispatchData.vendorDropOff
        ? dispatchData.vendorDropOff.name
        : null,
      vendorDropOffID: dispatchData.vendorDropOff
        ? dispatchData.vendorDropOff.id
        : null,
      pickUpRateConIsSigned: false,
      dropOffRateConIsSigned: false,
      status: 'Dispatched',
      dispatcherID: this.props.authUser.uid,
      dispatcherEmail: this.props.user.email,
      dispatcherAssigned: new Date(),
      dispatchedAt: new Date(),
      origin: this.state.origin,
      destination: this.state.destination,
      ...dispatchData,
    };

    const documentRef = db.collection('haney-orders').doc(this.props.orderID);

    // await documentRef.set({
    //   ...dispatchData,
    //   driverPickUpName: dispatchData.pickUpDriver ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}` : null,
    //   driverPickUpID: dispatchData.pickUpDriver ? (dispatchData.pickUpDriver.id ? dispatchData.pickUpDriver.id : null) : null,
    //   vendorPickUpName: dispatchData.vendorPickUp ? dispatchData.vendorPickUp.name : null,
    //   vendorPickUpID: dispatchData.vendorPickUp ? dispatchData.vendorPickUp.id : null,
    //   dispatcherID: this.props.authUser.uid,
    //   dispatcherEmail: this.props.user.email,
    //   dispatcherAssigned: new Date(),
    //   dispatchedAt: new Date(),
    //   pickUpRateConIsSigned: false
    // }, { merge: true });

    // console.log('document set');

    // documentRef.get()
    //   .then(document => {
    //     const docData = {
    //       ...document.data(),
    //       id: document.id
    //     }

    console.log('document gotten', docData);
    const docPromises = [
      this.createWaybill(docData),
      this.createPickUpIVF(docData),
      this.createPickUpNotification(docData),
      this.createPickUpSig(docData),
    ];
    this.setState({ documentsLoading: docPromises.length });

    Promise.all(docPromises).then((responses) => {
      let allURLs = {};
      let allHashes = {};
      console.log(responses);

      for (let i = 0; i < responses.length; i++) {
        const { urls, hashes } = responses[i];
        allURLs = { ...allURLs, ...urls };
        allHashes = { ...allHashes, ...hashes };
      }

      const newHashes = Object.values(allHashes);

      const hashesArray = docData.hashesArray;
      for (let i = 0; i < newHashes.length; i++) {
        hashesArray.push(newHashes[i]);
      }

      console.log(allURLs, allHashes);
      console.log(hashesArray);

      const newDoc = {
        ...docData,
        ...allURLs,
        ...allHashes,
        hashesArray: hashesArray,
      };

      const emailPromises = [this.secondEmail(newDoc), this.thirdEmail(newDoc)];

      Promise.all([
        ...emailPromises,
        documentRef.set(newDoc, { merge: true }),
        this.setExpenses(),
      ]).then((results) => {
        console.log(results);

        for (let i = 0; i < emailPromises.length; i++) {
          const r = results[i].data;
          console.log(r);
          if (typeof r !== 'boolean') {
            console.log('r is not a boolean');
            this.setState({
              errorSnack: true,
              errorSnackMessage: r.response.body.errors[0].message,
            });
          }
        }

        if (!this.state.errorSnack) {
          window.location.reload();
        }
      });
    });

    // })
  };

  redispatchDropOffVendor = async () => {
    const dispatchData = {
      originAirCarrier: this.grabData('originAirCarrier'),
      destinationAirCarrier: this.grabData('destinationAirCarrier'),
      originAirlineDetails: this.grabData('originAirlineDetails'),
      destinationAirlineDetails: this.grabData('destinationAirlineDetails'),
      flight: this.grabData('flight'),
      additionalLegs: this.grabData('additionalLegs'),
      flightNumber: this.grabData('flightNumber'),
      dropOffDriver: this.grabData('dropOffDriver'),
      vendorDropOff: this.grabData('vendorDropOff'),
      vendorPickUp: this.grabData('vendorPickUp'),
      airCarrierExpense: this.grabData('airCarrierExpense'),
      dropOffRate: this.grabData('dropOffRate'),
      bookingNumber: this.grabData('bookingNumber'),
      airWaybillNumber: this.grabData('airWaybillNumber'),
      serviceLevel: this.grabData('serviceLevel'),
      vendorRate: this.grabData('vendorRate'),
      accufrateBOL: this.grabData('accufrateBOL'),
      brokerName: this.grabData('brokerName'),
      brokerPRO: this.grabData('brokerPRO'),
      brokerRate: this.grabData('brokerRate'),
      carrierName: this.grabData('carrierName'),
      carrierPRO: this.grabData('carrierPRO'),
      insuranceCost: this.grabData('insuranceCost'),
      carrierRate: this.grabData('carrierRate'),
    };

    const reqFields = [];
    const reqFieldsNames = [];

    switch (this.state.orderData.deliveryType) {
      case 'Air':
        reqFields.push(
          dispatchData.flight.number,
          dispatchData.vendorDropOff,
          this.state.destination.deliverBy,
          dispatchData.dropOffRate
        );
        reqFieldsNames.push(
          'Flight Number',
          'Drop Off Vendor',
          'Deliver By',
          'Drop Off Rate'
        );
        break;

      case 'Scheduled Air':
        reqFields.push(
          dispatchData.vendorDropOff,
          this.state.destination.deliverBy,
          dispatchData.destinationAirCarrier,
          dispatchData.dropOffRate
        );
        reqFieldsNames.push(
          'Drop Off Vendor',
          'Deliver By',
          'Destination Air Carrier',
          'Drop Off Rate'
        );
        break;

      default:
        break;
    }

    const falsyValues = [undefined, null, ''];

    if (reqFields.some((field) => falsyValues.includes(field))) {
      let errorString = 'Please fill out the following: ';
      for (let i = 0; i < reqFields.length; i++) {
        if (falsyValues.includes(reqFields[i]) && i < reqFields.length - 1) {
          errorString += `${reqFieldsNames[i]}, `;
        } else if (falsyValues.includes(reqFields[i])) {
          errorString += `${reqFieldsNames[i]}`;
        }
      }
      this.setState({ errorSnack: true, errorSnackMessage: errorString });
      return;
    }

    this.setState({
      redispatchDropOffVendorUI: true,
      documentsLoading: 0,
      documentsLoaded: 0,
    });

    const docData = {
      ...this.state.orderData,
      // originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
      originAirport: this.state.originAirport ? this.state.originAirport : null,
      // destinationAirlineDetails: this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0] : null) : null,
      destinationAirport: this.state.destinationAirport
        ? this.state.destinationAirport
        : null,
      currentDriver: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver
        : null,
      driverPickUp: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver
        : null,
      driverPickUpName: dispatchData.pickUpDriver
        ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}`
        : null,
      driverPickUpEmail: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver.email
        : null,
      driverPickUpID: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver.id
          ? dispatchData.pickUpDriver.id
          : null
        : null,
      vendorPickUpName: dispatchData.vendorPickUp
        ? dispatchData.vendorPickUp.name
        : null,
      vendorPickUpID: dispatchData.vendorPickUp
        ? dispatchData.vendorPickUp.id
        : null,
      driverDropOff: dispatchData.dropOffDriver
        ? dispatchData.dropOffDriver
        : null,
      driverDropOffName: dispatchData.dropOffDriver
        ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}`
        : null,
      driverDropOffID: dispatchData.dropOffDriver
        ? dispatchData.dropOffDriver.id
          ? dispatchData.dropOffDriver.id
          : null
        : null,
      vendorDropOffName: dispatchData.vendorDropOff
        ? dispatchData.vendorDropOff.name
        : null,
      vendorDropOffID: dispatchData.vendorDropOff
        ? dispatchData.vendorDropOff.id
        : null,
      pickUpRateConIsSigned: false,
      dropOffRateConIsSigned: false,
      status: 'Dispatched',
      dispatcherID: this.props.authUser.uid,
      dispatcherEmail: this.props.user.email,
      dispatcherAssigned: new Date(),
      dispatchedAt: new Date(),
      origin: this.state.origin,
      destination: this.state.destination,
      ...dispatchData,
    };

    const documentRef = db.collection('haney-orders').doc(this.props.orderID);

    // await documentRef.set({
    //   ...dispatchData,
    //   driverDropOffName: dispatchData.dropOffDriver ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}` : null,
    //   driverDropOffID: dispatchData.dropOffDriver ? (dispatchData.dropOffDriver.id ? dispatchData.dropOffDriver.id : null) : null,
    //   vendorDropOffName: dispatchData.vendorDropOff ? dispatchData.vendorDropOff.name : null,
    //   vendorDropOffID: dispatchData.vendorDropOff ? dispatchData.vendorDropOff.id : null,
    //   dispatcherID: this.props.authUser.uid,
    //   dispatcherEmail: this.props.user.email,
    //   dispatcherAssigned: new Date(),
    //   dispatchedAt: new Date(),
    //   dropOffRateConIsSigned: false
    // }, { merge: true });

    // console.log('doc set')

    // documentRef.get()
    //   .then(document => {
    //     const docData = {
    //       ...document.data(),
    //       id: document.id
    //     }

    console.log('doc got', docData);
    const docPromises = [
      this.createDropOffNotification(docData),
      this.createDropOffSig(docData),
    ];
    this.setState({ documentsLoading: docPromises.length });

    Promise.all(docPromises).then((responses) => {
      let allURLs = {};
      let allHashes = {};
      console.log(responses);

      for (let i = 0; i < responses.length; i++) {
        const { urls, hashes } = responses[i];
        allURLs = { ...allURLs, ...urls };
        allHashes = { ...allHashes, ...hashes };
      }

      console.log(allURLs, allHashes);
      const newHashes = Object.values(allHashes);

      const hashesArray = docData.hashesArray;
      for (let i = 0; i < newHashes.length; i++) {
        hashesArray.push(newHashes[i]);
      }
      console.log(hashesArray);

      const newDoc = {
        ...docData,
        ...allURLs,
        ...allHashes,
        hashesArray: hashesArray,
      };

      const emailPromises = [this.fifthEmail(newDoc), this.sixthEmail(newDoc)];

      console.log(newDoc);

      Promise.all([
        ...emailPromises,
        documentRef.set(newDoc, { merge: true }),
        this.setExpenses(),
      ]).then((results) => {
        console.log(results);
        for (let i = 0; i < emailPromises.length; i++) {
          const r = results[i].data;
          console.log(r);
          if (typeof r !== 'boolean') {
            console.log('r is not a boolean');
            this.setState({
              errorSnack: true,
              errorSnackMessage: r.response.body.errors[0].message,
            });
          }
        }

        if (!this.state.errorSnack) {
          window.location.reload();
        }
      });
    });

    // })
  };

  redispatchAllVendors = async () => {
    const dispatchData = {
      originAirCarrier: this.grabData('originAirCarrier'),
      destinationAirCarrier: this.grabData('destinationAirCarrier'),
      originAirlineDetails: this.grabData('originAirlineDetails'),
      destinationAirlineDetails: this.grabData('destinationAirlineDetails'),
      flight: this.grabData('flight'),
      additionalLegs: this.grabData('additionalLegs'),
      flightNumber: this.grabData('flightNumber'),
      dropOffDriver: this.grabData('dropOffDriver'),
      vendorDropOff: this.grabData('vendorDropOff'),
      pickUpDriver: this.grabData('pickUpDriver'),
      vendorPickUp: this.grabData('vendorPickUp'),
      airCarrierExpense: this.grabData('airCarrierExpense'),
      dropOffRate: this.grabData('dropOffRate'),
      pickUpRate: this.grabData('pickUpRate'),
      bookingNumber: this.grabData('bookingNumber'),
      airWaybillNumber: this.grabData('airWaybillNumber'),
      serviceLevel: this.grabData('serviceLevel'),
      vendorRate: this.grabData('vendorRate'),
      accufrateBOL: this.grabData('accufrateBOL'),
      brokerName: this.grabData('brokerName'),
      brokerPRO: this.grabData('brokerPRO'),
      brokerRate: this.grabData('brokerRate'),
      carrierName: this.grabData('carrierName'),
      carrierPRO: this.grabData('carrierPRO'),
      insuranceCost: this.grabData('insuranceCost'),
      carrierRate: this.grabData('carrierRate'),
    };

    const reqFields = [];
    const reqFieldsNames = [];

    switch (this.state.orderData.deliveryType) {
      case 'Air':
        reqFields.push(
          dispatchData.flight.number,
          dispatchData.vendorPickUp,
          dispatchData.vendorDropOff,
          this.state.origin.deliverBy,
          this.state.destination.deliverBy,
          dispatchData.pickUpRate,
          dispatchData.dropOffRate
        );
        reqFieldsNames.push(
          'Flight Number',
          'Pick Up Vendor',
          'Drop Off Vendor',
          'Pick Up By',
          'Deliver By',
          'Pick Up Rate',
          'Drop Off Rate'
        );
        break;

      case 'Scheduled Air':
        reqFields.push(
          dispatchData.vendorPickUp,
          dispatchData.vendorDropOff,
          this.state.origin.deliverBy,
          this.state.destination.deliverBy,
          dispatchData.originAirCarrier,
          dispatchData.destinationAirCarrier,
          dispatchData.pickUpRate,
          dispatchData.dropOffRate
        );
        reqFieldsNames.push(
          'Pick Up Vendor',
          'Drop Off Vendor',
          'Pick Up By',
          'Deliver By',
          'Origin Air Carrier',
          'Destination Air Carrier',
          'Pick Up Rate',
          'Drop Off Rate'
        );
        break;

      default:
        break;
    }

    const falsyValues = [undefined, null, ''];

    if (reqFields.some((field) => falsyValues.includes(field))) {
      let errorString = 'Please fill out the following: ';
      for (let i = 0; i < reqFields.length; i++) {
        if (falsyValues.includes(reqFields[i]) && i < reqFields.length - 1) {
          errorString += `${reqFieldsNames[i]}, `;
        } else if (falsyValues.includes(reqFields[i])) {
          errorString += `${reqFieldsNames[i]}`;
        }
      }
      this.setState({ errorSnack: true, errorSnackMessage: errorString });
      return;
    }

    this.setState({
      redispatchAllVendorsUI: true,
      documentsLoading: 0,
      documentsLoaded: 0,
    });

    const documentRef = db.collection('haney-orders').doc(this.props.orderID);

    const docData = {
      ...this.state.orderData,
      // originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
      originAirport: this.state.originAirport ? this.state.originAirport : null,
      // destinationAirlineDetails: this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0] : null) : null,
      destinationAirport: this.state.destinationAirport
        ? this.state.destinationAirport
        : null,
      currentDriver: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver
        : null,
      driverPickUp: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver
        : null,
      driverPickUpName: dispatchData.pickUpDriver
        ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}`
        : null,
      driverPickUpEmail: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver.email
        : null,
      driverPickUpID: dispatchData.pickUpDriver
        ? dispatchData.pickUpDriver.id
          ? dispatchData.pickUpDriver.id
          : null
        : null,
      vendorPickUpName: dispatchData.vendorPickUp
        ? dispatchData.vendorPickUp.name
        : null,
      vendorPickUpID: dispatchData.vendorPickUp
        ? dispatchData.vendorPickUp.id
        : null,
      driverDropOff: dispatchData.dropOffDriver
        ? dispatchData.dropOffDriver
        : null,
      driverDropOffName: dispatchData.dropOffDriver
        ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}`
        : null,
      driverDropOffID: dispatchData.dropOffDriver
        ? dispatchData.dropOffDriver.id
          ? dispatchData.dropOffDriver.id
          : null
        : null,
      vendorDropOffName: dispatchData.vendorDropOff
        ? dispatchData.vendorDropOff.name
        : null,
      vendorDropOffID: dispatchData.vendorDropOff
        ? dispatchData.vendorDropOff.id
        : null,
      pickUpRateConIsSigned: false,
      dropOffRateConIsSigned: false,
      status: 'Dispatched',
      dispatcherID: this.props.authUser.uid,
      dispatcherEmail: this.props.user.email,
      dispatcherAssigned: new Date(),
      dispatchedAt: new Date(),
      origin: this.state.origin,
      destination: this.state.destination,
      ...dispatchData,
    };

    // await documentRef.set({
    //   ...dispatchData,
    //   driverDropOffName: dispatchData.dropOffDriver ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}` : null,
    //   driverDropOffID: dispatchData.dropOffDriver ? (dispatchData.dropOffDriver.id ? dispatchData.dropOffDriver.id : null) : null,
    //   vendorDropOffName: dispatchData.vendorDropOff ? dispatchData.vendorDropOff.name : null,
    //   vendorDropOffID: dispatchData.vendorDropOff ? dispatchData.vendorDropOff.id : null,
    //   driverPickUpName: dispatchData.pickUpDriver ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}` : null,
    //   driverPickUpID: dispatchData.pickUpDriver ? (dispatchData.pickUpDriver.id ? dispatchData.pickUpDriver.id : null) : null,
    //   vendorPickUpName: dispatchData.vendorPickUp ? dispatchData.vendorPickUp.name : null,
    //   vendorPickUpID: dispatchData.vendorPickUp ? dispatchData.vendorPickUp.id : null,
    //   dispatcherID: this.props.authUser.uid,
    //   dispatcherEmail: this.props.user.email,
    //   dispatcherAssigned: new Date(),
    //   dispatchedAt: new Date(),
    //   dropOffRateConIsSigned: false,
    //   pickUpRateConIsSigned: false
    // }, { merge: true });

    // console.log('doc set')

    // documentRef.get()
    //   .then(document => {
    //     const docData = {
    //       ...document.data(),
    //       id: document.id
    //     }

    console.log('doc got', docData);
    const docPromises = [
      this.createDropOffNotification(docData),
      this.createDropOffSig(docData),
      this.createPickUpIVF(docData),
      this.createPickUpNotification(docData),
      this.createPickUpSig(docData),
    ];
    this.setState({ documentsLoading: docPromises.length });

    Promise.all(docPromises).then((responses) => {
      let allURLs = {};
      let allHashes = {};
      console.log(responses);

      for (let i = 0; i < responses.length; i++) {
        const { urls, hashes } = responses[i];
        allURLs = { ...allURLs, ...urls };
        allHashes = { ...allHashes, ...hashes };
      }

      console.log(allURLs, allHashes);
      const newHashes = Object.values(allHashes);

      const hashesArray = docData.hashesArray;
      for (let i = 0; i < newHashes.length; i++) {
        hashesArray.push(newHashes[i]);
      }
      console.log(hashesArray);

      const newDoc = {
        ...docData,
        ...allURLs,
        ...allHashes,
        hashesArray: hashesArray,
      };

      const emailPromises = [
        this.secondEmail(newDoc),
        this.thirdEmail(newDoc),
        this.fifthEmail(newDoc),
        this.sixthEmail(newDoc),
      ];

      console.log(newDoc);

      Promise.all([
        ...emailPromises,
        documentRef.set(newDoc, { merge: true }),
        this.setExpenses(),
      ]).then((results) => {
        console.log(results);
        for (let i = 0; i < emailPromises.length; i++) {
          const r = results[i].data;
          console.log(r);
          if (typeof r !== 'boolean') {
            console.log('r is not a boolean');
            this.setState({
              errorSnack: true,
              errorSnackMessage: r.response.body.errors[0].message,
            });
          }
        }

        if (!this.state.errorSnack) {
          window.location.reload();
        }
      });
    });

    // })
  };

  regenerateBOL = () => {
    this.setState({ documentsLoading: 0, documentsLoaded: 0 });

    const main = async () => {
      const dispatchData = Object.fromEntries(Object.entries(this.state.orderData).map(([key, value]) => [key, this.grabData(key)]));

      const reqFields = [];
      const reqFieldsNames = [];

      switch (this.state.orderData.deliveryType) {
        case 'Air':
          reqFields.push(
            dispatchData.flight.number,
            dispatchData.vendorPickUp,
            dispatchData.vendorDropOff,
            this.state.origin.deliverBy,
            this.state.destination.deliverBy,
            dispatchData.pickUpRate,
            dispatchData.dropOffRate
          );
          reqFieldsNames.push(
            'Flight Number',
            'Pick Up Vendor',
            'Drop Off Vendor',
            'Pick Up By',
            'Deliver By',
            'Pick Up Rate',
            'Drop Off Rate'
          );
          break;

        case 'Scheduled Air':
          reqFields.push(
            dispatchData.vendorPickUp,
            dispatchData.vendorDropOff,
            this.state.origin.deliverBy,
            this.state.destination.deliverBy,
            dispatchData.originAirCarrier,
            dispatchData.destinationAirCarrier,
            dispatchData.pickUpRate,
            dispatchData.dropOffRate
          );
          reqFieldsNames.push(
            'Pick Up Vendor',
            'Drop Off Vendor',
            'Pick Up By',
            'Deliver By',
            'Origin Air Carrier',
            'Destination Air Carrier',
            'Pick Up Rate',
            'Drop Off Rate'
          );
          break;

        case 'Ground':
          // reqFields.push(
          //   dispatchData.vendorPickUp,
          //   this.state.origin.deliverBy,
          //   dispatchData.pickUpRate
          // );
          // reqFieldsNames.push('Pick Up Vendor', 'Pick Up By', 'Pick Up Rate');
          break;

        case 'Additional Options':
          // reqFields.push(
          //   dispatchData.vendorPickUp,
          //   this.state.origin.deliverBy,
          //   dispatchData.pickUpRate
          // );
          // reqFieldsNames.push('Pick Up Vendor', 'Pick Up By', 'Pick Up Rate');
          break;

        default:
          break;
      }

      console.log(reqFields, reqFieldsNames);

      const falsyValues = [undefined, null, ''];

      if (reqFields.some((field) => falsyValues.includes(field))) {
        let errorString = 'Please fill out the following: ';
        for (let i = 0; i < reqFields.length; i++) {
          if (falsyValues.includes(reqFields[i]) && i < reqFields.length - 1) {
            errorString += `${reqFieldsNames[i]}, `;
          } else if (falsyValues.includes(reqFields[i])) {
            errorString += `${reqFieldsNames[i]}`;
          }
        }
        this.setState({ errorSnack: true, errorSnackMessage: errorString });
        return;
      }

      this.setState({ documentsLoading: true });

      const docData = {
        ...dispatchData,
        // originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
        originAirport: this.state.originAirport
          ? this.state.originAirport
          : null,
        // destinationAirlineDetails: this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0] : null) : null,
        destinationAirport: this.state.destinationAirport
          ? this.state.destinationAirport
          : null,
        currentDriver: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver
          : null,
        driverPickUp: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver
          : null,
        driverPickUpName: dispatchData.pickUpDriver
          ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}`
          : null,
        driverPickUpEmail: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver.email
          : null,
        driverPickUpID: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver.id
            ? dispatchData.pickUpDriver.id
            : null
          : null,
        vendorPickUpName: dispatchData.vendorPickUp
          ? dispatchData.vendorPickUp.name
          : null,
        vendorPickUpID: dispatchData.vendorPickUp
          ? dispatchData.vendorPickUp.id
          : null,
        driverDropOff: dispatchData.dropOffDriver
          ? dispatchData.dropOffDriver
          : null,
        driverDropOffName: dispatchData.dropOffDriver
          ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}`
          : null,
        driverDropOffID: dispatchData.dropOffDriver
          ? dispatchData.dropOffDriver.id
            ? dispatchData.dropOffDriver.id
            : null
          : null,
        vendorDropOffName: dispatchData.vendorDropOff
          ? dispatchData.vendorDropOff.name
          : null,
        vendorDropOffID: dispatchData.vendorDropOff
          ? dispatchData.vendorDropOff.id
          : null,
        shipperBOLIsSigned: false,
        consigneeBOLIsSigned: false,
        driverBOLIsSigned: false,
        bolIsCompleted: false,
        // pickUpRateConIsSigned: false,
        // dropOffRateConIsSigned: false,
        dispatcherID: this.props.authUser.uid,
        dispatcherEmail: this.props.user.email,
        dispatcherAssigned: new Date(),
        dispatchedAt: new Date(),
      };

      const documentRef = db.collection('haney-orders').doc(this.props.orderID);
      if (docData.deliveryType === 'LTL') {
        const r = await this.setExpenses();
        console.log(r);
        window.location.reload();
      }

      const statusCollectionRef = db.collection('haney-orders').doc(this.props.orderID).collection('statusLogs');


      this.setState({ documentsLoading: 1 });

      this.newBOL(docData)
        .then(response => {

          const hashesArray = Object.values(response.hashes);
          console.log(hashesArray);

          const newDoc = {
            ...docData,
            ...response.urls,
            ...response.hashes,
            hashesArray: hashesArray,
          };

          console.log(newDoc);

          const emailPromises = [
            this.firstEmail(newDoc),
            this.seventhEmail(newDoc),
            this.eigthEmail(newDoc),
          ];

          Promise.all([
            ...emailPromises,
            documentRef.set(newDoc, { merge: true }),
            statusCollectionRef.add({
              status: "Dispatched",
              type: "status",
              updatedAt: new Date(),
              updatedBy: {
                name: this.props.user.firstName + ' ' + this.props.user.lastName,
                uid: this.props.authUser.uid,
              },
            }),
            this.setExpenses(),
          ]).then((results) => {
            console.log(results);
            let hasErrors = false;
            if (!results.slice(0, emailPromises.length).every(r => r === true || r.data === true)) {
              hasErrors = true;
              this.setState({
                errorSnack: true,
                errorSnackMessage: results.find(r => r !== true && r.data !== true).response.body.errors[0].message,
              });
            } else if (results[emailPromises.length] !== undefined) {
              hasErrors = true;
              this.setState({
                errorSnack: true,
                errorSnackMessage: 'Could not set document'
              })
            } else if (results[results.length - 1] !== true) {
              hasErrors = true;
              this.setState({
                errorSnack: true,
                errorSnackMessage: 'Could not set expenses'
              })
            } else {
              window.location.reload();
            }
          });
        });
      // })
      // .catch(err => {
      //   console.log(err);
      // })
    };
    main();
  };

  handleSubmit = (reassign) => {
    console.log(reassign);
    this.setState({ documentsLoading: 0, documentsLoaded: 0 });
    const axios = require('axios');

    const main = async () => {
      const dispatchData = {
        originAirCarrier: this.grabData('originAirCarrier'),
        destinationAirCarrier: this.grabData('destinationAirCarrier'),
        originAirlineDetails: this.grabData('originAirlineDetails'),
        destinationAirlineDetails: this.grabData('destinationAirlineDetails'),
        flight: this.grabData('flight'),
        additionalLegs: this.grabData('additionalLegs'),
        flightNumber: this.grabData('flightNumber'),
        dropOffDriver: this.grabData('dropOffDriver'),
        pickUpDriver: this.grabData('pickUpDriver'),
        vendorPickUp: this.grabData('vendorPickUp'),
        vendorDropOff: this.grabData('vendorDropOff'),
        airCarrierExpense: this.grabData('airCarrierExpense'),
        pickUpRate: this.grabData('pickUpRate'),
        dropOffRate: this.grabData('dropOffRate'),
        bookingNumber: this.grabData('bookingNumber'),
        airWaybillNumber: this.grabData('airWaybillNumber'),
        serviceLevel: this.grabData('serviceLevel'),
        vendorRate: this.grabData('vendorRate'),
        accufrateBOL: this.grabData('accufrateBOL'),
        brokerName: this.grabData('brokerName'),
        brokerPRO: this.grabData('brokerPRO'),
        brokerRate: this.grabData('brokerRate'),
        carrierName: this.grabData('carrierName'),
        carrierPRO: this.grabData('carrierPRO'),
        insuranceCost: this.grabData('insuranceCost'),
        carrierRate: this.grabData('carrierRate'),
        origin: this.grabData('origin'),
        destination: this.grabData('destination'),
      };

      console.log(dispatchData);

      const reqFields = [];
      const reqFieldsNames = [];

      switch (this.state.orderData.deliveryType) {
        case 'Air':
          reqFields.push(
            dispatchData.flight ? dispatchData.flight.number : null,
            dispatchData.vendorPickUp,
            dispatchData.vendorDropOff,
            dispatchData.origin.deliverBy,
            dispatchData.destination.deliverBy,
            dispatchData.pickUpRate,
            dispatchData.dropOffRate,
            dispatchData.serviceLevel
          );
          reqFieldsNames.push(
            'Flight Number',
            'Pick Up Vendor',
            'Drop Off Vendor',
            'Deliver By Date',
            'Pick Up Date',
            'Pick Up Rate',
            'Drop Off Rate',
            'Service Level'
          );
          break;

        case 'Scheduled Air':
          reqFields.push(
            dispatchData.vendorPickUp,
            dispatchData.vendorDropOff,
            dispatchData.origin.deliverBy,
            dispatchData.destination.deliverBy,
            dispatchData.originAirCarrier,
            dispatchData.destinationAirCarrier,
            dispatchData.pickUpRate,
            dispatchData.dropOffRate
          );
          reqFieldsNames.push(
            'Pick Up Vendor',
            'Drop Off Vendor',
            'Deliver By Date',
            'Pick Up Date',
            'Origin Air Carrier',
            'Destination Air Carrier',
            'Pick Up Rate',
            'Drop Off Rate'
          );
          break;

        case 'Ground':
          reqFields.push(
            dispatchData.vendorPickUp,
            dispatchData.origin.deliverBy,
            dispatchData.pickUpRate
          );
          reqFieldsNames.push(
            'Pick Up Vendor',
            'Deliver By Date',
            'Pick Up Rate'
          );
          break;

        case 'Additional Options':
          reqFields.push(
            dispatchData.vendorPickUp,
            dispatchData.origin.deliverBy,
            dispatchData.pickUpRate
          );
          reqFieldsNames.push(
            'Pick Up Vendor',
            'Deliver By Date',
            'Pick Up Rate'
          );
          break;

        case 'LTL':
          reqFields.push(
            dispatchData.accufrateBOL,
            dispatchData.vendorRate,
            dispatchData.brokerName,
            dispatchData.brokerPRO,
            dispatchData.brokerRate,
            dispatchData.carrierName,
            dispatchData.origin.deliverBy
          );
          reqFieldsNames.push(
            'Accufrate BOL #',
            'Accufrate Rate',
            'Broker Name',
            'Broker PRO #',
            'Broker Rate',
            'Carrier Name',
            'Deliver By Date'
          );

        default:
          break;
      }

      console.log(reqFields, reqFieldsNames);

      const falsyValues = [undefined, null, ''];

      if (reqFields.some((field) => falsyValues.includes(field))) {
        let errorString = 'Please fill out the following: ';
        for (let i = 0; i < reqFields.length; i++) {
          if (falsyValues.includes(reqFields[i]) && i < reqFields.length - 1) {
            errorString += `${reqFieldsNames[i]}, `;
          } else if (falsyValues.includes(reqFields[i])) {
            errorString += `${reqFieldsNames[i]}`;
          }
        }
        this.setState({ errorSnack: true, errorSnackMessage: errorString });
        return;
      }

      console.log('All fields satisfied');
      this.setState({ documentsLoading: true, reassignBool: reassign });

      const docData = {
        ...this.state.orderData,
        // originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
        originAirport: this.state.originAirport
          ? this.state.originAirport
          : null,
        // destinationAirlineDetails: this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0] : null) : null,
        destinationAirport: this.state.destinationAirport
          ? this.state.destinationAirport
          : null,
        currentDriver: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver
          : null,
        driverPickUp: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver
          : null,
        driverPickUpName: dispatchData.pickUpDriver
          ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}`
          : null,
        driverPickUpEmail: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver.email
          : null,
        driverPickUpID: dispatchData.pickUpDriver
          ? dispatchData.pickUpDriver.id
            ? dispatchData.pickUpDriver.id
            : null
          : null,
        vendorPickUpName: dispatchData.vendorPickUp
          ? dispatchData.vendorPickUp.name
          : null,
        vendorPickUpID: dispatchData.vendorPickUp
          ? dispatchData.vendorPickUp.id
          : null,
        driverDropOff: dispatchData.dropOffDriver
          ? dispatchData.dropOffDriver
          : null,
        driverDropOffName: dispatchData.dropOffDriver
          ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}`
          : null,
        driverDropOffID: dispatchData.dropOffDriver
          ? dispatchData.dropOffDriver.id
            ? dispatchData.dropOffDriver.id
            : null
          : null,
        vendorDropOffName: dispatchData.vendorDropOff
          ? dispatchData.vendorDropOff.name
          : null,
        vendorDropOffID: dispatchData.vendorDropOff
          ? dispatchData.vendorDropOff.id
          : null,
        pickUpRateConIsSigned: false,
        dropOffRateConIsSigned: false,
        shipperBOLIsSigned: false,
        consigneeBOLIsSigned: false,
        driverBOLIsSigned: false,
        bolIsCompleted: false,
        status: 'Dispatched',
        dispatcherID: this.props.authUser.uid,
        dispatcherEmail: this.props.user.email,
        dispatcherAssigned: new Date(),
        dispatchedAt: new Date(),
        origin: this.state.origin,
        destination: this.state.destination,
        // thirdParty: this.state.thirdParty ? this.state.thirdParty : {},
        ...dispatchData,
      };

      // const otherObj = Object.assign(this.state.orderData, dispatchData);
      // console.log(docData);
      // console.log(otherObj);
      // console.log("otherObj");
      const documentRef = db.collection('haney-orders').doc(this.props.orderID);
      // await documentRef.set({
      //   // originAirlineDetails: this.state.originAirlineDetails ? this.state.originAirlineDetails : null,
      //   originAirport: this.state.originAirport ? this.state.originAirport : null,
      //   // destinationAirlineDetails: this.state.destinationAirlineDetails ? (this.state.destinationAirlineDetails[0] ? this.state.destinationAirlineDetails[0] : null) : null,
      //   destinationAirport: this.state.destinationAirport ? this.state.destinationAirport : null,
      //   currentDriver: dispatchData.pickUpDriver,
      //   driverPickUp: this.state.driverPickUp ? this.state.driverPickUp : null,
      //   driverPickUpName: dispatchData.pickUpDriver ? `${dispatchData.pickUpDriver.firstName} ${dispatchData.pickUpDriver.lastName}` : null,
      //   driverPickUpEmail: dispatchData.pickUpDriver ? dispatchData.pickUpDriver.email : null,
      //   driverPickUpID: dispatchData.pickUpDriver ? (dispatchData.pickUpDriver.id ? dispatchData.pickUpDriver.id : null) : null,
      //   vendorPickUpName: dispatchData.vendorPickUp ? dispatchData.vendorPickUp.name : null,
      //   vendorPickUpID: dispatchData.vendorPickUp ? dispatchData.vendorPickUp.id : null,
      //   driverDropOff: dispatchData.dropOffDriver,
      //   driverDropOffName: dispatchData.dropOffDriver ? `${dispatchData.dropOffDriver.firstName} ${dispatchData.dropOffDriver.lastName}` : null,
      //   driverDropOffID: dispatchData.dropOffDriver ? (dispatchData.dropOffDriver.id ? dispatchData.dropOffDriver.id : null) : null,
      //   vendorDropOffName: dispatchData.vendorDropOff ? dispatchData.vendorDropOff.name : null,
      //   vendorDropOffID: dispatchData.vendorDropOff ? dispatchData.vendorDropOff.id : null,
      //   pickUpRateConIsSigned: false,
      //   dropOffRateConIsSigned: false,
      //   status: "Dispatched",
      //   dispatcherID: this.props.authUser.uid,
      //   dispatcherEmail: this.props.user.email,
      //   dispatcherAssigned: new Date(),
      //   dispatchedAt: new Date(),
      //   origin: this.state.origin,
      //   destination: this.state.destination,
      //   ...dispatchData
      // }, { merge: true })
      //   .then(async () => {

      //     const document = (await documentRef.get());

      //     const docData = {
      //       ...document.data(),
      //       id: document.id
      //     };

      if (docData.deliveryType === 'LTL') {
        const docs = this.grabData('docs');
        const thirdParty = this.grabData('thirdParty');
        const promises = [];
        const bolLink =
          docs && docs.alternateBOL ? docs.alternateBOL.fileURL : null;

        if (bolLink) {
          promises.push(
            documentRef.set(docData, { merge: true }),
            this.firstEmail(docData, bolLink),
            this.seventhEmail(docData, bolLink)
          );
          if (thirdParty)
            promises.push(
              this.eigthEmail({ ...docData, thirdParty: thirdParty })
            );
        } else {
          this.setState({
            errorSnack: true,
            errorSnackMessage:
              'LTL orders must have an Accufrate BOL to be dispatched',
            documentsLoaded: null,
            documentsLoading: null,
          });
          return;
        }

        const promisesReturn = await Promise.all(promises);
        console.log(promisesReturn);
        return window.location.reload();
      }

      console.log(docData);

      const docPromises =
        docData.deliveryType === 'Air' ||
          docData.deliveryType === 'Scheduled Air'
          ? [
            this.createBOL(docData),
            this.createWaybill(docData),
            this.createPickUpIVF(docData),
            this.createDropOffNotification(docData),
            this.createDropOffSig(docData),
            this.createPickUpNotification(docData),
            this.createPickUpSig(docData),
          ]
          : [
            this.createBOL(docData),
            this.createPickUpNotification(docData),
            this.createPickUpSig(docData),
          ];
      this.setState({ documentsLoading: docPromises.length });

      Promise.all(docPromises).then((responses) => {
        let allURLs = {};
        let allHashes = {};
        console.log(responses);

        for (let i = 0; i < responses.length; i++) {
          const { urls, hashes } = responses[i];
          allURLs = { ...allURLs, ...urls };
          allHashes = { ...allHashes, ...hashes };
        }

        console.log(allURLs, allHashes);
        const hashesArray = Object.values(allHashes);
        console.log(hashesArray);

        const newDoc = {
          ...docData,
          ...allURLs,
          ...allHashes,
          hashesArray: hashesArray,
        };

        console.log(newDoc);

        const emailPromises =
          docData.deliveryType === 'Air' ||
            docData.deliveryType === 'Scheduled Air'
            ? [
              this.firstEmail(newDoc),
              this.secondEmail(newDoc),
              this.thirdEmail(newDoc),
              this.fifthEmail(newDoc),
              this.sixthEmail(newDoc),
              this.seventhEmail(newDoc),
              this.eigthEmail(newDoc),
            ]
            : [
              this.firstEmail(newDoc),
              this.secondEmail(newDoc),
              this.thirdEmail(newDoc),
              this.seventhEmail(newDoc),
              this.eigthEmail(newDoc),
            ];
        if (docData.thirdParty) emailPromises.push(this.eigthEmail(newDoc));
        console.log(emailPromises);
        Promise.all([
          ...emailPromises,
          documentRef.set(newDoc, { merge: true }),
          this.setExpenses(),
        ]).then((results) => {
          console.log('emails done');
          for (let i = 0; i < emailPromises.length; i++) {
            const r = results[i].data;
            console.log(r);
            if (typeof r !== 'boolean') {
              console.log('r is not a boolean');
              this.setState({
                errorSnack: true,
                errorSnackMessage: r.response.body.errors[0].message,
              });
            }
          }

          if (!this.state.errorSnack) {
            window.location.reload();
          }
        });
      });

      // })
      // .catch(err => {
      //   console.log(err);
      // })
    };

    main();
  };

  handleSwitchChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });

    // console.log('jelly', this.state);
  };


  buildErrorMessage = (errorDetails) => {
    let errorMessage = errorDetails.length
      ? 'Please fill the following fields: '
      : '';

    for (let i = 0; i < errorDetails.length; i++) {
      errorMessage = errorMessage + errorDetails[i];
      console.log(errorMessage);

      if (errorDetails.length > 1 && i < errorDetails.length - 1) {
        errorMessage = errorMessage + ', ';
      }
    }

    return errorMessage;
  };

  saveLTLData = () => {
    const ltlData = {
      vendorRate: this.grabData('vendorRate'),
      accufrateBOL: this.grabData('accufrateBOL'),
      brokerName: this.grabData('brokerName'),
      brokerPRO: this.grabData('brokerPRO'),
      brokerRate: this.grabData('brokerRate'),
      carrierName: this.grabData('carrierName'),
      carrierPRO: this.grabData('carrierPRO'),
      insuranceCost: this.grabData('insuranceCost'),
      carrierRate: this.grabData('carrierRate'),
      origin: this.grabData('origin'),
    };

    Promise.all([
      db
        .collection('haney-orders')
        .doc(this.props.orderID)
        .set(
          {
            ...ltlData,
          },
          { merge: true }
        ),
      this.setExpenses(),
    ]).then((responses) => {
      console.log(responses);
      window.location.reload();
    });
  };

  setExpenses = () => {
    return new Promise(async (resolve, reject) => {
      const registerRef = db
        .collection('haney-orders')
        .doc(this.state.orderData.id)
        .collection('register');

      const initialExpensesSnapshot = await registerRef
        .where('type', 'in', [
          'air carrier expense',
          'pick up rate',
          'drop off rate',
          'accufrate rate',
          'broker rate',
          'insurance cost',
        ])
        .get();

      const initialExpenses = [];
      for (let i = 0; i < initialExpensesSnapshot.docs.length; i++) {
        const docData = {
          ...initialExpensesSnapshot.docs[i].data(),
          id: initialExpensesSnapshot.docs[i].id,
        };

        initialExpenses.push(docData);
      }

      console.log(initialExpenses);

      const expensesData = {
        airCarrierExpense: {
          data: this.grabData('airCarrierExpense'),
          type: 'air carrier expense',
          business: this.grabData('originAirlineDetails')
            ? this.grabData('originAirlineDetails').length
              ? this.grabData('originAirlineDetails')[0]
              : null
            : null,
        },
        pickUpRate: {
          data: this.grabData('pickUpRate'),
          type: 'pick up rate',
          business: this.grabData('vendorPickUp'),
        },
        dropOffRate: {
          data: this.grabData('dropOffRate'),
          type: 'drop off rate',
          business: this.grabData('vendorDropOff'),
        },
        vendorRate: {
          data: this.grabData('vendorRate'),
          type: 'accufrate rate',
          business: {
            businessName: 'Accufrate',
            id: '86AEyQZ7ODbjgSt3PMW0',
          },
        },
        brokerRate: {
          data: this.grabData('brokerRate'),
          type: 'broker rate',
          business: {
            businessName: 'Accufrate',
            id: '86AEyQZ7ODbjgSt3PMW0',
          },
        },
        insuranceCost: {
          data: this.grabData('insuranceCost'),
          type: 'insurance cost',
          business: {
            businessName: 'Accufrate',
            id: '86AEyQZ7ODbjgSt3PMW0',
          },
        },
      };

      const promises = [];
      for (let key in expensesData) {
        if (expensesData[key].data) {
          console.log(expensesData[key].type);
          const expenseBefore = initialExpenses.find((obj) => {
            console.log(obj);
            return obj.type === expensesData[key].type;
          });
          console.log(key);
          console.log(expenseBefore);
          const businessName = expensesData[key].business
            ? expensesData[key].business.businessName
              ? expensesData[key].business.businessName
              : expensesData[key].business.name
                ? expensesData[key].business.name
                : null
            : null;
          const businessID = expensesData[key].business
            ? expensesData[key].business.id
              ? expensesData[key].business.id
              : null
            : null;

          if (expenseBefore) {
            promises.push(
              registerRef.doc(expenseBefore.id).set(
                {
                  dollarAmount: parseFloat(expensesData[key].data),
                  business: {
                    businessName,
                    id: businessID,
                  },
                },
                { merge: true }
              )
            );
          } else {
            promises.push(
              registerRef.add({
                dollarAmount: parseFloat(expensesData[key].data),
                type: expensesData[key].type,
                category: 'expense',
                description: 'Routing expense',
                business: {
                  businessName,
                  id: businessID,
                },
              })
            );
          }
        }
      }

      Promise.all(promises).then((responses) => {
        console.log(responses);
        resolve(true);
      });
    });
  };

  pingDriver = (driver, type) => {
    const { freightBillNumber, origin, destination, id } = this.state.orderData;
    console.log(driver, freightBillNumber, origin, destination, id);
    let body = `Thank you for partnering with Haney Freightways on shipment number ${freightBillNumber} from ${origin.businessName} in ${origin.city} ${origin.state} to ${destination.businessName} in ${destination.city} ${destination.state}`;
    body += `\nTo ensure we all get paid on time, we use the Haney Freightways LiveLync which gives you access to the electronic documents for this shipment and several upload fields.`;
    body += `\nPlease visit the LiveLync, click "Allow" when asked about location services, and read the simple instructions.`;
    let from = '+17205139929';
    let to = '+1' + (driver.cellPhone ? driver.cellPhone : driver.directPhone); // driver.phone

    const detailsReturn = sendSMS({
      body,
      from,
      to,
    });

    body = `LiveLync: https://cargo-rx-driver.web.app/pages/upload/${id}/${type}`;

    const linkReturn = sendSMS({
      body,
      from,
      to,
    });
  };

  createInvoice = async () => {
    this.setState({ invoiceSending: true });

    const orderData = {
      origin: this.grabData('origin'),
      destination: this.grabData('destination'),
      thirdParty: this.grabData('thirdParty'),
      items: this.grabData('items'),
      freightBillNumber: this.grabData('freightBillNumber'),
      billingParty: this.state.orderData.billingParty,
      subDeliveryType: this.state.orderData.subDeliveryType,
      deliveryType: this.state.orderData.deliveryType,
      docs: this.grabData('docs') ? this.grabData('docs') : {},
    };
    const parties = {
      Shipper: 'origin',
      Consignee: 'destination',
      'Third Party': 'thirdParty',
    };
    const deliveryTypeToQuote = {
      Air: 'airQuote',
      'Scheduled Air': 'cargoAirQuote',
      Ground: 'groundQuote',
      LTL: 'autoLtlQuote',
      'Additional Options': 'ltlQuote',
    };

    const fDate = (date) => moment(date).format('MM/DD/YYYY');

    const billingPartyObjString = parties[orderData.billingParty];
    const billingPartyObj = orderData[billingPartyObjString];
    let billingParty;
    let creditTerms = '30';
    console.log(billingPartyObjString, billingPartyObj);
    if (billingPartyObj.entityID) {
      console.log('Entity exists');
      const docSnap = await db
        .collection('haney-shippers')
        .doc(billingPartyObj.entityID)
        .get();
      console.log(billingPartyObj.entityID, docSnap);
      if (docSnap.exists) {
        console.log('Found entity');
        const docData = {
          ...docSnap.data(),
          id: docSnap.id,
        };

        docData.creditTerms = docData.creditTerms
          ? docData.creditTerms.replace(/\D/g, '')
          : null;

        if (docData.creditTerms) creditTerms = docData.creditTerms;

        billingParty = {
          address: docData.physicalAddress
            ? docData.physicalAddress
            : billingPartyObj.address,
          city: docData.physicalCity
            ? docData.physicalCity
            : billingPartyObj.city,
          state: docData.physicalState
            ? docData.physicalState
            : billingPartyObj.state,
          zip: docData.physicalZip ? docData.physicalZip : billingPartyObj.zip,
          businessName: docData.name
            ? docData.name
            : billingPartyObj.businessName,
          quickbooksID: docData.quickbooksID
            ? docData.quickbooksID
            : billingPartyObj.quickbooksID
              ? billingPartyObj.quickbooksID
              : ' ',
        };
      }
    }
    if (!billingParty) {
      console.log('Billing party is falsy');
      billingParty = billingPartyObj;
    }

    const billingAmount = this.grabData(
      deliveryTypeToQuote[orderData.deliveryType]
    );

    const shipDate =
      orderData.origin.date instanceof Date
        ? orderData.origin.date
        : orderData.origin.date.toDate();
    const dueDate = new Date(shipDate).setDate(shipDate.getDate() + 30);

    console.log(
      'Dynamic data:',
      billingParty,
      billingAmount,
      creditTerms,
      moment(shipDate).format('YYYY-MM-DD hh:MM'),
      moment(dueDate).format('YYYY-MM-DD hh:MM')
    );

    const doc = new jsPDF();
    doc.setDrawColor(77, 171, 41);
    doc.setFontSize(12);
    doc.text('CargoRx, Ltd.:', 10, 16);
    doc.setFontSize(9);
    doc.text('6880 E 56th Ave', 10, 20);
    doc.text('Commerce City, CO 80022', 10, 24);
    doc.text('(833) 227 - 4679', 10, 28);
    doc.text('receivables@haneyfreightways.com', 10, 32);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(10);
    doc.text(`INVOICE # ${orderData.freightBillNumber}`, 130, 46);
    doc.setFontSize(10);
    doc.text(`SHIP DATE ${fDate(shipDate)}`, 130, 51);
    doc.text(`DUE DATE ${fDate(dueDate)}`, 130, 56);
    doc.text(`TERMS  NET ${creditTerms}`, 130, 61);
    doc.text(
      `ORIGIN REF # ${orderData.origin.referenceID ? orderData.origin.referenceID : ' '
      }`,
      130,
      75
    );
    doc.setFontSize(10);
    doc.text(
      `DESTINATION REF # ${orderData.destination.referenceID
        ? orderData.destination.referenceID
        : ' '
      }`,
      130,
      80
    );
    doc.setFontSize(10);

    const ColoredLine = ({ color }) => (
      <hr
        style={{
          color: '#EF5350',
          backgroundColor: '#EF5350',
          // height: 5,
        }}
      />
    );
    doc.setFontSize(18);
    doc.setTextColor(0, 0, 0);
    doc.text('INVOICE', 10, 42);
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(12);
    doc.text('Bill To', 10, 50);
    doc.setFontSize(10);
    doc.text(billingParty.businessName, 10, 54);
    doc.text(`${billingParty.address}`, 10, 58);
    doc.text(
      `${billingParty.city}, ${billingParty.state} ${billingParty.zip}`,
      10,
      62
    );
    doc.setDrawColor(0);
    // Shippment Description
    doc.setFillColor(160, 160, 160);
    // doc.rect(20, 60, 170, 1, 'F')
    // Shipper Information
    console.log("shipper")
    doc.setFontSize(12);
    doc.text('Shipper:', 10, 72);
    doc.setFontSize(10);
    doc.text(`${orderData.origin.businessName}`, 10, 76);
    doc.text(`${orderData.origin.address}`, 10, 80);
    doc.text(
      `${orderData.origin.city}, ${orderData.origin.state} ${orderData.origin.zip}`,
      10,
      84
    );

    doc.setFontSize(10);
    doc.text(fDate(shipDate), 25, 122);
    doc.setFontSize(12);
    doc.text(`$${Math.round(Number(this.props.totalRevenue) * 100) / 100}`, 150, 122);
    doc.setFontSize(20);
    doc.text(
      `$${Math.round(Number(this.props.totalRevenue) * 100) / 100}`,
      150,
      195 + 10 * (orderData.items.length - 1)
    );
    doc.setFontSize(12);
    doc.text('Balance Due:', 115, 195 + 10 * (orderData.items.length - 1));
    // doc.rect(225, 140, 69, 30)
    doc.setFontSize(12);
    // doc.text("Key Resources:", 240, 144);
    doc.setFontSize(10);
    // doc.text(this.props.keyResources.values.filter((item) => item.text !== "").map((item) => { return " " + item.text }), 226, 152);
    // doc.rect(225, 175, 69, 30)
    doc.setFontSize(12);
    // doc.text("Key Partnerships: ", 240, 179 + (10 * (orderData.items.length - 1)));
    doc.setFontSize(10);
    // doc.text(this.props.keyPartnerships.values.filter((item) => item.text !== "").map((item) => { return " " + item.text }), 226, 188);
    doc.setFontSize(8);
    doc.text(
      'Please note we have moved to a new office location at the address ',
      10,
      195 + 10 * (orderData.items.length - 1)
    );
    doc.text(
      'listed above. Please remit payment to the Commerce City address',
      10,
      199 + 10 * (orderData.items.length - 1)
    );
    doc.text(
      'only or electronically as outlined below',
      10,
      203 + 10 * (orderData.items.length - 1)
    );
    doc.setFontSize(10);
    doc.text(
      'Thank You For Your Business',
      10,
      225 + 10 * (orderData.items.length - 1)
    );
    doc.setFontSize(8);
    doc.text(
      'Payment can be remitted via ACH',
      10,
      215 + 10 * (orderData.items.length - 1)
    );
    // doc.text("Routing number: 102001017", 10, 220 + (10 * (orderData.items.length - 1)));
    // doc.text("Account number: 587128593", 10, 225 + (10 * (orderData.items.length - 1)));
    doc.setDrawColor(0);
    // Shippment Description
    doc.setFillColor(160, 160, 160);
    doc.rect(20, 110, 170, 7, 'F');
    doc.setTextColor(0, 0, 0);
    doc.setFontSize(10);
    doc.text('SHIP DATE', 25, 115);
    doc.setFontSize(10);
    doc.text('DESCRIPTION ', 76, 115);
    doc.setFontSize(10);
    doc.text('AMOUNT' + '', 150, 115);

    // Cosignee Information
    doc.setFontSize(12);
    doc.text('Consignee:', 10, 91);
    doc.setFontSize(10);
    doc.text(`${orderData.destination.businessName}`, 10, 95);
    doc.text(`${orderData.destination.address}`, 10, 99);
    doc.text(
      `${orderData.destination.city}, ${orderData.destination.state} ${orderData.destination.zip}`,
      10,
      103
    );
    doc.setFontSize(12);
    // doc.text(orderData.thirdParty ? "Third Party:" : " ", 76, 159);
    // doc.setFontSize(10);
    // doc.text(orderData.thirdParty ? `${orderData.thirdParty.businessName}` : " ", 76, 165);
    // doc.text(orderData.thirdParty ? `${orderData.thirdParty.address}` : " ", 76, 170);
    // doc.text(orderData.thirdParty ? `${orderData.thirdParty.city}, ${orderData.thirdParty.state} ${orderData.thirdParty.zip}` : " ", 76, 175);
    doc.setFontSize(10);
    orderData.items.map((item, i) => {
      var itemDimensions = doc.splitTextToSize(
        `${item.description} - ${item.length}*${item.width}*${item.height}`.substring(
          0,
          83
        ),
        70
      );
      doc.text(76, 122 + 15 * i, itemDimensions);
      var itemWeight = doc.splitTextToSize(
        `Weight ${parseFloat(item.weight) *
          parseFloat(item.quantity)} lbs.`.substring(0, 83),
        70
      );
      doc.text(76, 130 + 15 * i, itemWeight);
    });

    const blobPDF = new Blob([doc.output('blob')], { type: 'application/pdf' });
    const blobURL = window.URL.createObjectURL(blobPDF);
    const fileID = uuidv1();
    console.log(blobURL);

    const fileURL = await this.uploadImage(
      `orders/${this.props.orderID}/${fileID}`,
      blobPDF
    );

    console.log(orderData);
    console.log(orderData.subDeliveryType);
    console.log(
      orderData.subDeliveryType
        ? orderData.subDeliveryType
        : orderData.deliveryType
    );

    let qbItemRef = '401 Sales - Haney Freightways';

    // if (orderData.deliveryType == "Scheduled Air") {
    //   qbItemRef = orderData.subDeliveryType
    // } else {
    //   switch (orderData.deliveryType) {
    //     case 'Air':
    //       qbItemRef = "401 Sales - Haney Freightways"
    //       break;

    //     case 'Ground':
    //       qbItemRef = "401 Sales - Haney Freightways"
    //       break;

    //       case 'LTL':
    //         qbItemRef = "401 Sales - Haney Freightways"
    //         break;

    //     case 'Additional Options':
    //       qbItemRef = "401 Sales - Haney Freightways"
    //       break;

    //     default:
    //       break;
    //   }
    // }

    orderData.docs.invoice = {
      createdAt: new Date(),
      fileURL,
      id: fileID,
      qbItemRef: qbItemRef,
      name: 'Invoice',
      amount: this.props.totalRevenue,
      quickbooksID: billingParty.quickbooksID ? billingParty.quickbooksID : '',
    };

    let invoiceData = orderData.docs.invoice;

    db.collection('haney-orders')
      .doc(this.props.orderID)
      .set(
        {
          docs: orderData.docs,
        },
        { merge: true }
      )
      .then(() => {
        db.collection('haney-orders')
          .doc(this.props.orderID)
          .collection('invoices')
          .doc(fileID)
          .set({
            invoiceData,
            freightBillNumber: orderData.freightBillNumber,
          })
          .then(() => {
            this.setState({
              orderData: {
                ...this.state.orderData,
                docs: orderData.docs,
              },
              invoiceSending: false,
              infoSnack: true,
              infoSnackMessage: 'Invoice successfully created',
            });
            window.location.reload();
          });
      });
  };

  sendInvoice = async () => {
    const { orderData, additionalDocuments } = this.state;
    this.setState({ invoiceSending: true });


  console.log("sending")

    const links =
      additionalDocuments && additionalDocuments.length
        ? additionalDocuments
        : orderData.previouslySentDocuments
          ? orderData.previouslySentDocuments
          : [orderData.docs.invoice];

    if (!links.find((obj) => obj.name === 'Invoice'))
      links.push(orderData.docs.invoice);

    this.emailInvoice(orderData, links).then(() => {
      db.collection('haney-orders')
        .doc(this.props.orderID)
        .set(
          {
            financialStatus: this.state.orderData.isFactored ? 'Factor Approved and Invoiced' : 'Invoiced',
          },
          { merge: true }
        )
        .then(() => {
          this.setState({
            infoSnackMessage: 'Invoice successfully sent',
          });
        })
        .catch((err) => {
          this.setState({
            infoSnackMessage: err,
          });
        });
    });
  };

  saveAsQuote = () => {
    // update firestore document with PENDING and comment
    console.log('saving quote');
    db.collection('TEST-quotes')
      .add({
        uid: this.state.uid ? this.state.uid : null,
        role: this.state.role ? this.state.role : null,
        status: 'pending',
        originBusinessName: this.state.originBusinessName
          ? this.state.originBusinessName
          : null,
        originContactName: this.state.originContactName
          ? this.state.originContactName
          : null,
        originContactEmail: this.state.originContactEmail
          ? this.state.originContactEmail
          : null,
        originContactPhone: this.state.originContactPhone
          ? this.state.originContactPhone
          : null,
        originOpenTime: this.state.originOpenTime
          ? this.state.originOpenTime
          : null,
        originCloseTime: this.state.originCloseTime
          ? this.state.originCloseTime
          : null,
        originStartTimeWindow: this.state.originStartTimeWindow
          ? this.state.originStartTimeWindow
          : null,
        originEndTimeWindow: this.state.originEndTimeWindow
          ? this.state.originEndTimeWindow
          : null,
        originAddress: this.state.originAddress
          ? this.state.originAddress
          : null,
        originCity: this.state.originCity ? this.state.originCity : null,
        originState: this.state.originState ? this.state.originState : null,
        originZip: this.state.originZip ? this.state.originZip : null,
        originType: this.state.originType ? this.state.originType : null,
        pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
        pickUpServices: this.state.pickUpServices
          ? this.state.pickUpServices
          : null,
        destinationBusinessName: this.state.destinationBusinessName
          ? this.state.destinationBusinessName
          : null,
        destinationContactName: this.state.destinationContactName
          ? this.state.destinationContactName
          : null,
        destinationContactEmail: this.state.destinationContactEmail
          ? this.state.destinationContactEmail
          : null,
        destinationContactPhone: this.state.destinationContactPhone
          ? this.state.destinationContactPhone
          : null,
        destinationOpenTime: this.state.destinationOpenTime
          ? this.state.destinationOpenTime
          : null,
        destinationCloseTime: this.state.destinationCloseTime
          ? this.state.destinationCloseTime
          : null,
        destinationStartTimeWindow: this.state.destinationStartTimeWindow
          ? this.state.destinationStartTimeWindow
          : null,
        destinationEndTimeWindow: this.state.destinationEndTimeWindow
          ? this.state.destinationEndTimeWindow
          : null,
        destinationAddress: this.state.destinationAddress
          ? this.state.destinationAddress
          : null,
        destinationCity: this.state.destinationCity
          ? this.state.destinationCity
          : null,
        destinationState: this.state.destinationState
          ? this.state.destinationState
          : null,
        destinationZip: this.state.destinationZip
          ? this.state.destinationZip
          : null,
        destinationType: this.state.destinationType
          ? this.state.destinationType
          : null,
        dropOffDate: this.state.dropOffDate ? this.state.dropOffDate : null,
        dropOffServices: this.state.dropOffServices
          ? this.state.dropOffServices
          : null,
        services: this.state.services ? this.state.services : null,
        unNumber: this.state.unNumber ? this.state.unNumber : null,
        properShippingName: this.state.properShippingName
          ? this.state.properShippingName
          : null,
        packaging: this.state.packaging ? this.state.packaging : null,
        quantity: this.state.quantity ? this.state.quantity : null,
        weight: this.state.weight ? this.state.weight : null,
        height: this.state.height ? this.state.height : null,
        width: this.state.width ? this.state.width : null,
        depth: this.state.depth ? this.state.depth : null,
        class: this.state.class ? this.state.class : null,
        deliveryType: this.state.deliveryType ? this.state.deliveryType : null,
        flightNumber: this.state.flightNumber ? this.state.flightNumber : null,
        page: window.location.pathname,
        updatedAt: new Date(),
      })
      .then((docRef) => {
        db.collection('TEST-users')
          .doc(this.state.uid)
          .collection('quotes')
          .doc(docRef.id)
          .set(
            {
              uid: this.state.uid ? this.state.uid : null,
              role: this.state.role ? this.state.role : null,
              status: 'pending',
              originBusinessName: this.state.originBusinessName
                ? this.state.originBusinessName
                : null,
              originContactName: this.state.originContactName
                ? this.state.originContactName
                : null,
              originContactEmail: this.state.originContactEmail
                ? this.state.originContactEmail
                : null,
              originContactPhone: this.state.originContactPhone
                ? this.state.originContactPhone
                : null,
              originOpenTime: this.state.originOpenTime
                ? this.state.originOpenTime
                : null,
              originCloseTime: this.state.originCloseTime
                ? this.state.originCloseTime
                : null,
              originStartTimeWindow: this.state.originStartTimeWindow
                ? this.state.originStartTimeWindow
                : null,
              originEndTimeWindow: this.state.originEndTimeWindow
                ? this.state.originEndTimeWindow
                : null,
              originAddress: this.state.originAddress
                ? this.state.originAddress
                : null,
              originCity: this.state.originCity ? this.state.originCity : null,
              originState: this.state.originState
                ? this.state.originState
                : null,
              originZip: this.state.originZip ? this.state.originZip : null,
              originType: this.state.originType ? this.state.originType : null,
              pickUpDate: this.state.pickUpDate ? this.state.pickUpDate : null,
              pickUpServices: this.state.pickUpServices
                ? this.state.pickUpServices
                : null,
              destinationBusinessName: this.state.destinationBusinessName
                ? this.state.destinationBusinessName
                : null,
              destinationContactName: this.state.destinationContactName
                ? this.state.destinationContactName
                : null,
              destinationContactEmail: this.state.destinationContactEmail
                ? this.state.destinationContactEmail
                : null,
              destinationContactPhone: this.state.destinationContactPhone
                ? this.state.destinationContactPhone
                : null,
              destinationOpenTime: this.state.destinationOpenTime
                ? this.state.destinationOpenTime
                : null,
              destinationCloseTime: this.state.destinationCloseTime
                ? this.state.destinationCloseTime
                : null,
              destinationStartTimeWindow: this.state.destinationStartTimeWindow
                ? this.state.destinationStartTimeWindow
                : null,
              destinationEndTimeWindow: this.state.destinationEndTimeWindow
                ? this.state.destinationEndTimeWindow
                : null,
              destinationAddress: this.state.destinationAddress
                ? this.state.destinationAddress
                : null,
              destinationCity: this.state.destinationCity
                ? this.state.destinationCity
                : null,
              destinationState: this.state.destinationState
                ? this.state.destinationState
                : null,
              destinationZip: this.state.destinationZip
                ? this.state.destinationZip
                : null,
              destinationType: this.state.destinationType
                ? this.state.destinationType
                : null,
              dropOffDate: this.state.dropOffDate
                ? this.state.dropOffDate
                : null,
              dropOffServices: this.state.dropOffServices
                ? this.state.dropOffServices
                : null,
              services: this.state.services ? this.state.services : null,
              unNumber: this.state.unNumber ? this.state.unNumber : null,
              properShippingName: this.state.properShippingName
                ? this.state.properShippingName
                : null,
              packaging: this.state.packaging ? this.state.packaging : null,
              quantity: this.state.quantity ? this.state.quantity : null,
              weight: this.state.weight ? this.state.weight : null,
              height: this.state.height ? this.state.height : null,
              width: this.state.width ? this.state.width : null,
              depth: this.state.depth ? this.state.depth : null,
              class: this.state.class ? this.state.class : null,
              deliveryType: this.state.deliveryType
                ? this.state.deliveryType
                : null,
              flightNumber: this.state.flightNumber
                ? this.state.flightNumber
                : null,
              page: window.location.pathname,
              updatedAt: new Date(),
            },
            { merge: true }
          )
          .then(() => {
            this.props.history.push('/quotes');
          })
          .then(() => {
            window.location.reload();
          })
          .catch((err) => {
            console.log(`${err}`);
          });
      })
      .catch((err) => {
        console.log(`${err}`);
      });
  };

  resetRequest = () => {
    window.location.reload();
  };

  setUser = (user) => {
    this.setState({
      uid: user,
      userSet: true,
    });
    console.log(this.state);
  };

  handleGeoChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
    //console.log(this.state)
  };

  getAirports = (order) => {
    const axios = require('axios');
    console.log(order);
    console.log(this.state.orderData);
    this.setState({
      getAirportsLoaded: true,
    });
    axios({
      method: 'GET',
      url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.orderData.originLat
        }/${this.state.orderData.originLng}/km/${this.state.originRadius ? this.state.originRadius : '200'
        }/32`,
      headers: {
        'content-type': 'application/octet-stream',
        'x-rapidapi-host': 'aerodatabox.p.rapidapi.com',
        'x-rapidapi-key': '6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e',
      },
      params: {
        withFlightInfoOnly: 'false',
      },
    })
      .then((response) => {
        this.setState({
          originAirports: response.data,
          // getAirportsLoaded: true
        });

        axios({
          method: 'GET',
          url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.orderData.destinationLat}/${this.state.orderData.destinationLng}/km/80/16`,
          headers: {
            'content-type': 'application/octet-stream',
            'x-rapidapi-host': 'aerodatabox.p.rapidapi.com',
            'x-rapidapi-key':
              '6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e',
          },
          params: {
            withFlightInfoOnly: 'false',
          },
        })
          .then((response) => {
            this.setState({
              destinationAirports: response.data,
              // getAirportsLoaded: true
            });
          })
          .catch((error) => {
            console.log(error);
          });
        // console.log(response)
      })
      .catch((error) => {
        console.log(error);
      });
  };

  getFlights = () => {
    const axios = require('axios');

    this.setState({
      matchingFlights: [],
    });

    Geocode.setApiKey('AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM');

    let origin = this.state.originCity + ' ' + this.state.originState;
    // console.log(origin)
    // this.setState({
    //   mapDataSaved: false
    // })
    let originCoords = Geocode.fromAddress(origin).then((response) => {
      // console.log(response.results[0].geometry.location);
      this.setState({
        originCoords: response.results[0].geometry.location,
      });
      let destination =
        this.state.destinationCity + ' ' + this.state.destinationState;
      // console.log(destination)
      let destinationCoords = Geocode.fromAddress(destination)
        .then((response) => {
          // console.log(response.results[0].geometry.location);
          this.setState({
            destinationCoords: response.results[0].geometry.location,
          });
          console.log(this.state);
        })
        .then((response) => {
          // console.log(this.state)
          axios({
            method: 'GET',
            url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.originCoords.lat}/${this.state.originCoords.lng}/km/${this.state.radius}/16`,
            headers: {
              'content-type': 'application/octet-stream',
              'x-rapidapi-host': 'aerodatabox.p.rapidapi.com',
              'x-rapidapi-key':
                '6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e',
            },
            params: {
              withFlightInfoOnly: 'false',
            },
          })
            .then((response) => {
              this.setState({
                originAirports: response.data,
              });
              axios({
                method: 'GET',
                url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/airports/search/location/${this.state.destinationCoords.lat}/${this.state.destinationCoords.lng}/km/${this.state.radius}/16`,
                headers: {
                  'content-type': 'application/octet-stream',
                  'x-rapidapi-host': 'aerodatabox.p.rapidapi.com',
                  'x-rapidapi-key':
                    '6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e',
                },
                params: {
                  withFlightInfoOnly: 'false',
                },
              })
                .then((response) => {
                  this.setState({
                    destinationAirports: response.data,
                  });
                  // console.log(this.state.originAirports.items[0].icao)

                  this.state.originAirports.items.forEach((originAirport) => {
                    // console.log(originAirport.icao)
                    let originAirportID = originAirport.icao;
                    axios({
                      method: 'GET',
                      url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao
                        }/${moment(this.state.pickUpDate).format(
                          'YYYY-MM-DD'
                        )}T00:00/${moment(this.state.pickUpDate).format(
                          'YYYY-MM-DD'
                        )}T11:59`,
                      headers: {
                        'content-type': 'application/octet-stream',
                        'x-rapidapi-host': 'aerodatabox.p.rapidapi.com',
                        'x-rapidapi-key':
                          '6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e',
                      },
                      params: {
                        withLeg: 'false',
                        direction: 'Departure',
                      },
                    })
                      .then((response) => {
                        this.setState({
                          departingFlights: response.data,
                        });
                        console.log(response.data.departures);
                        // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                        // console.log(departingFlightsMatch)
                        let filteredDepartingFlights = this.state
                          .matchingFlights;
                        // Parse data into array like in firebase.js
                        this.state.destinationAirports.items.forEach(
                          (destinationAirport) => {
                            let departingFlights = response.data.departures.filter(
                              (flight) =>
                                flight.destinationAirport ===
                                destinationAirport.icao
                            );
                            // console.log(destinationAirport)
                            // console.log(departingFlights)
                            if (departingFlights.length > 0) {
                              departingFlights.forEach((flight) => {
                                let docData = flight;
                                let docObj = {
                                  ...docData,
                                  originAirport: originAirport.icao,
                                };
                                filteredDepartingFlights.push(docObj);
                              });
                            }
                          }
                        );
                        // console.log(originAirport)
                        this.setState({
                          matchingFlights: filteredDepartingFlights,
                        });
                        this.state.originAirports.items.forEach(
                          (originAirport) => {
                            // console.log(originAirport.icao)
                            let originAirportID = originAirport.icao;
                            axios({
                              method: 'GET',
                              url: `https://arcane-lowlands-31408.herokuapp.com/https://aerodatabox.p.rapidapi.com/flights/airports/icao/${originAirport.icao
                                }/${moment(this.state.pickUpDate).format(
                                  'YYYY-MM-DD'
                                )}T12:00/${moment(this.state.pickUpDate).format(
                                  'YYYY-MM-DD'
                                )}T23:59`,
                              headers: {
                                'content-type': 'application/octet-stream',
                                'x-rapidapi-host': 'aerodatabox.p.rapidapi.com',
                                'x-rapidapi-key':
                                  '6e8eead6f7mshdf336167267cb29p1122aejsnb8fac950984e',
                              },
                              params: {
                                withLeg: 'false',
                                direction: 'Departure',
                              },
                            })
                              .then((response) => {
                                this.setState({
                                  departingFlights: response.data,
                                });
                                // console.log(response.data.departures)
                                // let departingFlightsMatch = response.data.departures.filter(flight => (flight.movement.airport.icao === "KDEN"));
                                // console.log(departingFlightsMatch)
                                let filteredDepartingFlights = this.state
                                  .matchingFlights;
                                // Parse data into array like in firebase.js
                                this.state.destinationAirports.items.forEach(
                                  (destinationAirport) => {
                                    let departingFlights = response.data.departures.filter(
                                      (flight) =>
                                        flight.destinationAirport ===
                                        destinationAirport.icao
                                    );
                                    // console.log(destinationAirport)
                                    // console.log(departingFlights)
                                    if (departingFlights.length > 0) {
                                      departingFlights.forEach((flight) => {
                                        let docData = flight;
                                        let docObj = {
                                          ...docData,
                                          originAirport: originAirport.icao,
                                        };
                                        filteredDepartingFlights.push(docObj);
                                      });
                                    }
                                  }
                                );
                                // console.log(originAirport)
                                this.setState({
                                  matchingFlights: filteredDepartingFlights,
                                });
                                // console.log(this.state)
                              })
                              .catch((error) => {
                                console.log(error);
                              });
                          }
                        );
                      })
                      .catch((error) => {
                        console.log(error);
                      });
                  });
                })
                .catch((error) => {
                  console.log(error);
                });
              // console.log(response)
            })
            .catch((error) => {
              console.log(error);
            });
        });
    });
  };

  saveInfo = (arr) => {
    let orderData = this.state.orderData;
    orderData[arr]['firstName'] = orderData[arr]['firstName']
      ? onlyLettersAndWhitespace(orderData[arr]['firstName']).trim()
      : null;
    orderData[arr]['lastName'] = orderData[arr]['lastName']
      ? onlyLettersAndWhitespace(orderData[arr]['lastName']).trim()
      : null;
    orderData[arr]['phone'] = orderData[arr]['phone']
      ? onlyNumbers(orderData[arr]['phone'])
      : null;
    orderData[arr]['email'] = orderData[arr]['email']
      ? orderData[arr]['email'].trim()
      : null;

    this.setState({
      errorMessage: '',
      orderData: orderData,
    });

    const reqFields = [
      'firstName',
      'lastName',
      'email',
      'phone',
      'businessName',
      'address',
      'city',
      'state',
      'zip',
    ];
    const arrToBP = {
      origin: 'Shipper',
      destination: 'Consignee',
      thirdParty: 'Third Party',
    };

    if (arrToBP[arr] !== this.state.orderData.billingParty) {
      reqFields.splice(0, 4);
    }

    let errorDetails = itemErrorDetails(orderData[arr], reqFields);

    let errorMessage = '';

    for (var i = 0; i < errorDetails.length; i++) {
      if (i === errorDetails.length - 1) {
        errorMessage =
          errorDetails.length > 1
            ? `${errorMessage} and ${errorDetails[i]} are not filled`
            : `${errorDetails[i]} is not filled`;
      } else {
        errorMessage = errorMessage + errorDetails[i] + ', ';
      }
    }

    if (!errorMessage) {
      Geocode.setApiKey('AIzaSyDKrlqKEz5EdVwdJQA5tasUAIurZ_jsYNM');

      this.setState({ orderData: orderData });
      let cityState =
        this.state.orderData[arr]['city'] +
        ' ' +
        this.state.orderData[arr]['state'];
      this.setState({
        mapDataSaved: false,
      });
      let originCoords = Geocode.fromAddress(cityState).then((response) => {
        // console.log(response.results[0].geometry.location);

        let orderData = this.state.orderData;
        orderData['originCoords'] = response.results[0].geometry.location;

        this.setState({
          orderData: orderData,
          mapDataSaved: true,
        });
        db.collection('haney-orders')
          .doc(this.state.orderData.id)
          .set(
            {
              [arr]: this.state.orderData[arr],
              [`${arr}Lat`]: this.state.orderData.originCoords
                ? this.state.orderData.originCoords.lat
                : null,
              [`${arr}Lng`]: this.state.orderData.originCoords
                ? this.state.orderData.originCoords.lng
                : null,
              page: window.location.pathname,
              updatedAt: new Date(),
            },
            { merge: true }
          )
          .then((docRef) => {
            db.collection('TEST-users')
              .doc(this.state.orderData.uid)
              .collection('orders')
              .doc(this.state.orderData.id)
              .set(
                {
                  [arr]: this.state.orderData[arr],
                  [`${arr}Lat`]: this.state.orderData.originCoords
                    ? this.state.orderData.originCoords.lat
                    : null,
                  [`${arr}Lng`]: this.state.orderData.originCoords
                    ? this.state.orderData.originCoords.lng
                    : null,
                  page: window.location.pathname,
                  updatedAt: new Date(),
                },
                { merge: true }
              )
              .then(() => {
                console.log('User order has been updated');
                const modalString =
                  arr === 'origin'
                    ? 'updateOrigin'
                    : arr === 'destination'
                      ? 'updateDestination'
                      : 'updateThirdParty';
                this.handleClose(modalString);
              })
              .catch((err) => console.log('Error updating user order', err));
          })
          .catch((err) => console.log('Could not update haney-orders', err));
      });
    } else {
      this.setState({
        errorMessage: errorMessage,
      });
    }
  };

  renewItems = async (id, items) => {
    return new Promise((resolve, reject) => {
      db.collection('haney-orders')
        .doc(id)
        .set(
          {
            items: items,
          },
          { merge: true }
        )
        .then(() => {
          resolve(true);
        });
    });
  };

  saveFreight = () => {
    console.log('save freight func hit');
    const orderID = this.state.orderData.id;
    const items = this.state.orderData.items;


    const errors = [];

    items.map((item, i) => {
      const reqFields = [
        'packaging',
        'quantity',
        'weight',
        'length',
        'description',
      ];
      if (!item.isFootage) {
        reqFields.push('height', 'width');
      }

      if (item.isHazmat) {
        reqFields.push('unNumber', 'properShippingName');
      }

      reqFields.map((req) =>
        item[req] ? null : errors.push({ index: i, error: req })
      );
    });

    // for (let i = 0; i < items.length; i++) {
    //   if (items[i].isHazmat) {
    //     reqFields.push("unNumber", "properShippingName")
    //   }
    //   reqFields.map(req => items[i][req] ? null : errors.push({index: i, erreq}));
    //   if (items[i].isHazmat) {
    //     reqFields.splice(reqFields.length - 3, 2);
    //   }
    // }

    // for (var i = 0; i < errorDetails.length; i++) {
    //   if (i === errorDetails.length - 1 && errorDetails.length > 1) {
    //     errorMessage = errorDetails.length > 1 ? `${errorMessage} and ${errorDetails[i]} are not filled` : `${errorDetails[i]} is not filled`;
    //   } else {
    //     errorMessage = errorMessage + errorDetails[i] + ", ";
    //   }
    // }

    if (!errors.length) {
      const itemsNoFiles = [];
      const allFiles = [];

      for (let i = 0; i < items.length; i++) {
        const { files, ...noFiles } = items[i];
        itemsNoFiles.push(noFiles);
        allFiles.push(files);
      }

      db.collection('haney-orders')
        .doc(orderID)
        .set(
          {
            items: itemsNoFiles,
            page: window.location.pathname,
            updatedAt: new Date(),
          },
          { merge: true }
        )
        .then((docRef) => {
          const newFilesReference = [];
          const uploadPromises = [];
          for (let i = 0; i < allFiles.length; i++) {
            const item = items[i];

            const oldFiles = [];
            const newFiles = [];

            allFiles[i] &&
              allFiles[i].map((file) => {
                if ('file' in file) {
                  const id = uuidv1();
                  newFiles.push({ ...file, id: id });
                } else {
                  oldFiles.push(file);
                }
              });

            console.log(newFiles);

            oldFiles.map((file, index) => {
              if ('files' in itemsNoFiles[i]) {
                itemsNoFiles[i].files.push(file);
              } else {
                itemsNoFiles[i].files = [file];
              }
            });

            const fileIDs = [];

            newFiles.map((fileObj) => {
              const { file, id } = fileObj;
              fileIDs.push({ picID: id, itemID: i });
              // newFilesReference.push({ picID: id });
              uploadPromises.push(
                this.uploadImage(`orders/${orderID}/${i}/${id}`, file)
              );
            });

            newFilesReference.push(fileIDs);
          }

          Promise.all(uploadPromises).then((downloadURLs) => {
            let count = 0;

            for (let i = 0; i < newFilesReference.length; i++) {
              const itemFiles = newFilesReference[i];
              for (let j = 0; j < itemFiles.length; j++) {
                const fileObj = {
                  ...itemFiles[j],
                  picURL: downloadURLs[count],
                };
                count++;
                if ('files' in itemsNoFiles[i]) {
                  itemsNoFiles[i].files.push(fileObj);
                } else {
                  itemsNoFiles[i].files = [fileObj];
                }
              }
            }

            if (count !== downloadURLs.length - 1)
              console.log('File saving did not go as planned');

            const newDocData = {
              items: itemsNoFiles,
              page: window.location.pathname,
              updatedAt: new Date(),
            };

            Promise.all([
              db
                .collection('haney-orders')
                .doc(orderID)
                .set(newDocData, { merge: true }),
              db
                .collection('TEST-users')
                .doc(this.state.orderData.uid)
                .collection('orders')
                .doc(orderID)
                .set(newDocData, { merge: true }),
            ]).then((responses) => {
              console.log(responses);
              this.handleClose('updateFreight');
            });
          });
        })
        .catch((err) => console.log('Could not update haney-orders', err));
    } else {
      const statements = items
        .map((item, i) => {
          const itemErrors = errors.filter((err) => err.index === i);
          if (itemErrors.length) {
            return `Please fill out the following for item #${i +
              1}: ${itemErrors.map((err) => err.error).join(', ')}\n`;
          } else {
            return null;
          }
        })
        .filter(Boolean);

      console.log(statements);

      this.setState({
        errorSnackMessage: statements.join(''),
        errorSnack: true,
      });
    }
  };

  step2Back = () => {
    this.setState({
      step1: true,
      step2: false,
    });
  };

  step3Back = () => {
    this.setState({
      step2: true,
      step3: false,
    });
  };

  getQuote = () => {
    this.setState({
      step4: false,
      step5: true,
    });
  };
  saveAsQuote = () => {
    this.setState({
      quote: true,
    });
  };

  step4Back = () => {
    this.setState({
      step3: true,
      step4: false,
    });
  };

  step5Back = () => {
    this.setState({
      step4: true,
      step5: false,
    });
  };

  addItem = () => {
    var orderData = this.state.orderData;
    orderData.items.push({ id: this.state.itemCount });
    this.setState({
      orderData: orderData,
      itemCount: this.state.itemCount + 1,
    });
  };

  removeItem = () => {
    var orderData = this.state.orderData;
    orderData.items.pop();
    this.setState({
      orderData: orderData,
      itemCount: this.state.itemCount - 1,
    });
  };

  addItem2 = () => {
    this.setState({
      item3: false,
    });
  };

  viewFreight = () => {
    this.setState({
      viewFreight: true,
    });
  };

  assignFlightNumber = (flightNumber, originAirport, destinationAirport) => {
    this.setState({
      flightNumber: flightNumber,
      originAirport: originAirport,
      destinationAirport: destinationAirport,
    });
  };

  assignUser = (doc, arr, query) => {
    // console.log(doc);
    var orderData = this.state.orderData;
    orderData[arr]['phone'] = doc.cellPhone
      ? doc.cellPhone
      : doc.directPhone
        ? doc.directPhone
        : '';
    orderData[arr]['firstName'] = doc.firstName;
    orderData[arr]['lastName'] = doc.lastName;
    orderData[arr]['email'] = doc.email;

    this.setState({
      orderData: orderData,
      [query]: '',
    });
  };

  assignBusiness = (doc, arr, query) => {
    // console.log(doc);
    var orderData = this.state.orderData;
    orderData[arr]['businessName'] = doc.name ? doc.name : null;
    orderData[arr]['address'] = doc.physicalAddress
      ? doc.physicalAddress
      : null;
    orderData[arr]['city'] = doc.physicalCity ? doc.physicalCity : null;
    orderData[arr]['state'] = doc.physicalState ? doc.physicalState : null;
    orderData[arr]['zip'] = doc.physicalZip ? doc.physicalZip : null;
    orderData[arr]['entityID'] = doc.id ? doc.id : null;
    this.setState({
      orderData: orderData,
      [query]: '',
    });
  };

  assignOriginAirCarrier = (doc, arr, query) => {
    // console.log(doc, arr, query);
    let originAirCarrier = this.state.originAirCarrier;
    originAirCarrier['businessName'] = doc.name ? doc.name : null;
    originAirCarrier['airCode'] = doc.airCodes[0] ? doc.airCodes[0] : null;
    originAirCarrier['address'] = doc.physicalAddress
      ? doc.physicalAddress
      : null;
    originAirCarrier['city'] = doc.physicalCity ? doc.physicalCity : null;
    originAirCarrier['state'] = doc.physicalState ? doc.physicalState : null;
    originAirCarrier['zip'] = doc.physicalZip ? doc.physicalZip : null;
    originAirCarrier['mainPhone'] = doc.mainPhone ? doc.mainPhone : null;
    originAirCarrier['cargorxAccountNumber'] = doc.cargorxAccountNumber
      ? doc.cargorxAccountNumber
      : false;
    this.setState({
      originAirCarrier: originAirCarrier,
      [query]: '',
    });
    this.qualifyAirPickUpVendors();
  };

  assignDestinationAirCarrier = (doc, arr, query) => {
    // console.log(doc, arr, query);
    let destinationAirCarrier = this.state.destinationAirCarrier;
    destinationAirCarrier['businessName'] = doc.name ? doc.name : null;
    destinationAirCarrier['airCode'] = doc.airCodes[0] ? doc.airCodes[0] : null;
    destinationAirCarrier['address'] = doc.physicalAddress
      ? doc.physicalAddress
      : null;
    destinationAirCarrier['city'] = doc.physicalCity ? doc.physicalCity : null;
    destinationAirCarrier['state'] = doc.physicalState
      ? doc.physicalState
      : null;
    destinationAirCarrier['zip'] = doc.physicalZip ? doc.physicalZip : null;
    destinationAirCarrier['mainPhone'] = doc.mainPhone ? doc.mainPhone : null;
    destinationAirCarrier['cargorxAccountNumber'] = doc.cargorxAccountNumber
      ? doc.cargorxAccountNumber
      : false;
    this.setState({
      destinationAirCarrier: destinationAirCarrier,
      [query]: '',
    });
    this.qualifyAirPickUpVendors();
  };

  deliveryType = (type) => {
    this.setState({
      deliveryType: type,
    });
  };

  hideFlights = () => {
    this.setState({
      hideFlights: !this.state.hideFlights,
    });
  };

  setLegFlight = (flight, index) => {
    console.log(flight, index);
  };

  findFlightInfo = () => {
    console.log(this.grabData('flight'));
    const flight = this.grabData('flight')
      ? this.grabData('flight')
      : {
        number: this.grabData('flightNumber'),
      };
    console.log(flight);
    const acToFullName = {
      SWA: 'Southwest Airlines',
      UAL: 'United Airlines',
    };
    const airline = acToFullName[flight.number.replace(/[^a-zA-Z]+/g, '')];

    axios({
      method: 'GET',
      url: `https://arcane-lowlands-31408.herokuapp.com/http://flightxml.flightaware.com/json/FlightXML2/FlightInfo?ident=${flight.number}`,
      auth: {
        username: 'JustinOberg',
        password: '4c5c82ba4823f6ea450f4e37750b932455ae4e56',
      },
    }).then(async (response) => {
      // const flights = [];
      console.log(response);
      if (response.data.error) {
        console.log(response.data);
        return;
      }
      const flights = [];

      const seconds_with_leading_zeros = (dt) => {
        return /\((.*)\)/.exec(dt.toString())[1];
      };

      response.data.FlightInfoResult.flights.forEach(async (flight) => {
        console.log(flight);
        console.log(flight.ident.replace(/[^a-zA-Z]+/g, ''));
        const f = {};
        f.aircraftType = flight.aircrafttype;
        f.originAirport = flight.origin;
        f.destinationAirport = flight.destination;
        f.departureTime = new Date(flight.filed_departuretime * 1000);
        f.arrivalTime = new Date(flight.estimatedarrivaltime * 1000);
        console.log(f.departureTime);
        f.timezone = seconds_with_leading_zeros(f.departureTime);
        f.number = flight.ident;
        f.airlineName = airline;
        flights.push(f);
      });

      console.log(flights);

      const departureTime =
        flight.departureTime instanceof Date
          ? flight.departureTime
          : flight.departureTime
            ? flight.departureTime.toDate()
            : null;
      const filteredFlights = flights.filter(
        (f) =>
          f.departureTime > new Date() &&
          (departureTime
            ? departureTime.getMonth() === f.departureTime.getMonth() &&
            departureTime.getDate() === f.departureTime.getDate()
            : true)
      );

      filteredFlights.sort((a, b) => a.departureTime - b.departureTime);

      this.setState({
        flightFlights: filteredFlights.length
          ? filteredFlights
          : [{ error: 'No flights found' }],
      });
    });
  };

  findAdditionalLegInfo = (index) => {
    const additionalLegs = this.grabData('additionalLegs');
    console.log(
      'Find flight information for:',
      this.grabData('additionalLegs')[index].number
    );
    const acToFullName = {
      SWA: 'Southwest Airlines',
      UAL: 'United Airlines',
    };
    const airline =
      acToFullName[additionalLegs[index].number.replace(/[^a-zA-Z]+/g, '')];

    axios({
      method: 'GET',
      url: `https://arcane-lowlands-31408.herokuapp.com/http://flightxml.flightaware.com/json/FlightXML2/FlightInfo?ident=${additionalLegs[index].number}`,
      auth: {
        username: 'JustinOberg',
        password: '4c5c82ba4823f6ea450f4e37750b932455ae4e56',
      },
    }).then(async (response) => {
      // const flights = [];
      console.log(response);
      if (response.data.error) {
        console.log(response.data);
        return;
      }
      const flights = [];

      const seconds_with_leading_zeros = (dt) => {
        return /\((.*)\)/.exec(dt.toString())[1];
      };

      response.data.FlightInfoResult.flights.forEach(async (flight) => {
        console.log(flight);
        console.log(flight.ident.replace(/[^a-zA-Z]+/g, ''));
        const f = {};
        f.aircraftType = flight.aircrafttype;
        f.originAirport = flight.origin;
        f.destinationAirport = flight.destination;
        f.departureTime = new Date(flight.filed_departuretime * 1000);
        f.arrivalTime = new Date(flight.estimatedarrivaltime * 1000);
        console.log(f.departureTime);
        f.timezone = seconds_with_leading_zeros(f.departureTime);
        f.number = flight.ident;
        f.airlineName = airline;
        flights.push(f);
      });

      console.log(flights);

      const departureTime =
        additionalLegs[index].departureTime instanceof Date
          ? additionalLegs[index].departureTime
          : additionalLegs[index].departureTime
            ? additionalLegs[index].departureTime.toDate()
            : null;
      const filteredFlights = flights.filter(
        (f) =>
          f.departureTime > new Date() &&
          (departureTime
            ? departureTime.getMonth() === f.departureTime.getMonth() &&
            departureTime.getDate() === f.departureTime.getDate()
            : true)
      );

      filteredFlights.sort((a, b) => a.departureTime - b.departureTime);

      this.setState({
        additionalLegs: additionalLegs,
        [`leg${index}Flights`]: filteredFlights.length
          ? filteredFlights
          : [{ error: 'No flights found' }],
      });

      // this.qualifyAirPickUpVendors()
    });
  };

  addFlight = async (flight) => {
    const newFlightsFound = [];

    if (flight.airlineName && flight.originAirport) {
      console.log('Flight has airlineName and origin');

      const vendorSnapshot = await db
        .collection('haney-vendors')
        .where('name', '==', flight.airlineName)
        .where('airCodes', 'array-contains', flight.originAirport)
        .get();
      console.log(vendorSnapshot);
      if (vendorSnapshot.docs.length) {
        console.log('Found vendor w/ similarities');

        flight.vendor = {
          ...vendorSnapshot.docs[0].data(),
          id: vendorSnapshot.docs[0].id,
        };
      }
    }
    this.setState({ flight: flight, flightFlights: [...newFlightsFound] });
  };

  addAdditionalLeg = async (flight, index) => {
    const additionalLegs = this.grabData('additionalLegs');

    console.log(flight);
    if (flight.airlineName && flight.originAirport) {
      console.log('Flight has airlineName and origin');

      const vendorSnapshot = await db
        .collection('haney-vendors')
        .where('name', '==', flight.airlineName)
        .where('airCodes', 'array-contains', flight.originAirport)
        .get();
      console.log(vendorSnapshot);
      if (vendorSnapshot.docs.length) {
        console.log('Found vendor w/ similarities');

        flight.vendor = {
          ...vendorSnapshot.docs[0].data(),
          id: vendorSnapshot.docs[0].id,
        };
      }
    }
    additionalLegs[index] = flight;
    console.log(additionalLegs);
    this.setState({ additionalLegs: [...additionalLegs] });
  };

  addLeg = () => {
    const legs = this.state.legs + 1;
    const additionalLegs = [
      ...(this.grabData('additionalLegs')
        ? this.grabData('additionalLegs')
        : []),
      {},
    ];

    // for (let i = 0; i < legs; i++) {

    //   if (this.state.additionalLegs && this.state.additionalLegs[i]) {
    //     additionalLegs.push(this.state.additionalLegs[i])
    //   } else {
    //     additionalLegs.push({})
    //   }

    // }

    this.setState({
      legs: legs,
      additionalLegs: additionalLegs,
    });
  };

  removeLeg = () => {
    const additionalLegs = this.grabData('additionalLegs');
    additionalLegs.pop();
    this.setState({
      additionalLegs: additionalLegs,
      legs: this.state.legs - 1,
    });
  };

  clearFlight = () => {
    const orderData = this.state.orderData;
    orderData.flight = null;
    this.setState({ flight: null, orderData: orderData });
  };

  clearAdditionalLeg = (index) => {
    const additionalLegs = this.grabData('additionalLegs');
    additionalLegs.splice(index, 1);
    this.setState({ additionalLegs: [...additionalLegs] });
  };

  changeLegs = (e, i) => {
    const { additionalLegs } = this.state;
    additionalLegs[i][e.target.id ? e.target.id : e.target.name] =
      e.target.value;

    this.setState({
      additionalLegs: additionalLegs,
    });
  };

  changeLegsDate = (date, i, key) => {
    const { additionalLegs } = this.state;
    additionalLegs[i][key] = date;
    this.setState({
      additionalLegs: additionalLegs,
    });
  };

  addLeg2 = () => {
    this.setState({
      leg2: true,
    });
  };

  removeLeg2 = () => {
    this.setState({
      leg1: false,
    });
  };

  addLeg3 = () => {
    this.setState({
      leg3: true,
    });
  };

  loadVendorsSTAData = (id) => {
    console.log('load vendors sta data');
    let data = db
      .collection('haney-vendors')
      .where('sta', '==', true)
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();

            console.log(docData);
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        data;
        console.log('loading vendors completed');
        this.setState({
          vendorsSTAData: data,
          vendorsDataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadVendorsData = (id) => {
    console.log('Loading vendors');
    let data = db
      .collection('haney-vendors')
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          vendorsData: data,
          vendorsDataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadDriversPickUpData = (id) => {
    let data = db
      .collection('haney-vendors')
      .doc(id)
      .collection('users')
      .where('role', '==', 'Driver')
      .get()
      .then(
        (snapshot) => {
          // console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        console.log(data)
        this.setState({
          driversPickUpData: data,
          driversPickUpDataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadDriversDropOffData = (id) => {
    let data = db
      .collection('haney-vendors')
      .doc(id)
      .collection('users')
      .where('role', '==', 'Driver')
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          driversDropOffData: data,
          driversDropOffDataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadDriversPickUpSTAData = (id) => {
    let data = db
      .collection('TEST-users')
      .where('vendorID', '==', id)
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            console.log(docObj);
            if (!!docObj.sta) {
              data.push(docObj);
            }
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        //console.log(data)
        this.setState({
          driversPickUpSTAData: data,
          driversPickUpSTADataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadDriversDropOffSTAData = (id) => {
    let data = db
      .collection('haney-vendors')
      .doc(id)
      .collection('users')
      .where('userType', '==', 'Driver')
      .where('sta', '==', true)
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          driversDropOffSTAData: data,
          driversDropOffSTADataLoaded: true,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadInvoiceData = () => {
    let invoiceData = db
      .collection('haney-orders')
      .doc(this.state.orderData.id)
      .collection('invoices')
      .doc(this.state.orderData.docs.invoice.id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            // docData.origin.date = moment.unix(docData.origin.date.seconds, moment.defaultFormat).toDate();
            // docData.destination.date = moment.unix(docData.destination.date.seconds, moment.defaultFormat).toDate();
            var docObj = {
              id: snapshot.id,
              ...docData,
            };
            console.log(docObj);
            this.setState({
              invoiceData: docObj,
              invoiceDataLoaded: true,
            });
          } else {
            return { firstName: 'Unknown', lastName: 'Invoice' };
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      );
  };

  loadOrdersData = (id) => {
    console.log('loading order data');
    this.setState({
      orderDataLoaded: true,
    });
    let data = db
      .collection('haney-orders')
      .doc(id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            // docData.origin.date = moment.unix(docData.origin.date.seconds, moment.defaultFormat).toDate();
            // docData.destination.date = moment.unix(docData.destination.date.seconds, moment.defaultFormat).toDate();
            var docObj = {
              id: snapshot.id,
              ...docData,
            };
            console.log(docObj);
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        docObj['thirdParty'] = docObj['thirdParty'] ? docObj['thirdParty'] : {}
        this.setState({
          origin: docObj.origin,
          destination: docObj.destination,
          orderData: docObj,
          deliveryType: docObj.deliveryType,
          originDeliverBy: docObj.origin.deliverBy,
          destinationPickUpBy: docObj.destination.deliverBy,
        });

        if (docObj.dispatcherID) {
          // docObj.origin.date = docObj.origin.date.seconds.toDate();
          let dispatcherNameData = db
            .collection('TEST-users')
            .doc(docObj.dispatcherID)
            .get()
            .then(
              (snapshot) => {
                var docData = snapshot.data();
                if (docData) {
                  // docData.origin.date = moment.unix(docData.origin.date.seconds, moment.defaultFormat).toDate();
                  // docData.destination.date = moment.unix(docData.destination.date.seconds, moment.defaultFormat).toDate();
                  var docObj = {
                    id: snapshot.id,
                    ...docData,
                  };
                  console.log(docObj);
                  return docObj;
                } else {
                  return { firstName: 'Unknown', lastName: 'Dispatcher' };
                }
              },
              (error) => {
                console.log('error fetching data: ', error);
              }
            )
            .then((docObj) => {
              // docObj.origin.date = docObj.origin.date.seconds.toDate();

              this.setState({
                dispatcherName: docObj.firstName + ' ' + docObj.lastName,
              });
            });
        }
      });

    let dataNormal = db
      .collection('haney-orders')
      .doc(id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              id: snapshot.id,
              ...docData,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        this.setState({
          orderDataNormal: docObj,
        });
      });

    let crxDataNormal = db
      .collection('TEST-orders')
      .doc(id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              id: snapshot.id,
              ...docData,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        this.setState({
          crxOrderData: docObj,
        });
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  loadStatusData = (id) => {
    let data = db
      .collection('haney-orders')
      .doc(id)
      .collection('statusLogs')
      .where('status', '==', 'Dispatched')
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            console.log("StatusData: " + docObj.updatedAt.toDate())

            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        data;

        let dispatchedBeforeEversign

        if (this.state.statusLogsData) {
          console.log("statusA: " + JSON.stringify(this.state.statusLogsData))
          let statusLogsSorted = data.sort(function(a, b) {
            var keyA = new Date(a.updatedAt.seconds),
              keyB = new Date(b.updatedAt.seconds);
            // Compare the 2 dates
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
          });
    
          console.log(statusLogsSorted[0].updatedAt.toDate() < new Date('08/23/2022 12:00'))
    
          dispatchedBeforeEversign = statusLogsSorted[0].updatedAt.toDate() < new Date('08/23/2022 12:00')
  
          this.setState({
            statusLogsData: data,
            dispatchedBeforeEversign: dispatchedBeforeEversign,
            statusLogsDataLoaded: true,
          });
        }
        
        
      });

    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };


  loadPickUpDriverContact = (id) => {
    // console.log("loading order data")
    let data = db
      .collection('TEST-users')
      .doc(id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              ...docData,
              id: snapshot.id,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        this.setState({
          pickUpDriverContact: docObj,
          pickUpDriverContactLoaded: true,
        });
      });
    //console.log(this.state)
    //let relatedConceptsData = this.props.relatedConcepts.dataRows

    // this.setState({
    //   relatedConceptsData,
    //   dataLoaded: true
    // })
  };

  favOrder = () => {
    db.collection('haney-orders')
      .doc(this.props.orderID)
      .set(
        {
          dispatcherID:
            this.state.orderData.dispatcherID === this.props.authUser.uid
              ? ''
              : this.props.authUser.uid,
          dispatcherAssigned: new Date(),
        },
        { merge: true }
      )
      .then(() => {
        window.location.reload();
      });
  };

  testOrder = () => {
    db.collection('haney-orders')
      .doc()
      .set({
        ...this.state.orderData,
        test: true,
        updatedAt: new Date(),
      })
      .then((docObj) => {
        window.location.reload();
      });
  };

  deleteLocation = () => {
    db.collection('haney-orders')
      .doc(this.state.orderData.id)
      .set(
        {
          dropOffDriverLocation: null,
          updatedAt: new Date(),
        },
        { merge: true }
      )
      .then(() => {
        window.location.reload();
      });
  };

  saveBillingParty = (name, value) => {
    const { orderData } = this.state;
    orderData[name] = value;

    this.setState({ orderData: orderData });

    db.collection('haney-orders')
      .doc(orderData.id)
      .update({
        [name]: value,
        ['ChangeBillingPartyAt']: new Date(),
        ['ChangeBillingPartyBy']: this.props.authUser.uid,
      })
      .then((res) => console.log('Update succesful'))
      .catch((err) => console.log('Error in updating the db'));
  };

  saveShipmentStatus = (name, value) => {
    const { orderData } = this.state;
    orderData[name] = value;

    this.setState({ orderData: orderData });

    db.collection('haney-orders')
      .doc(orderData.id)
      .update({
        [name]: value,
        [value + 'At']: new Date(),
        [value + 'By']: this.props.authUser.uid,
      })
      .then((res) => {
        db.collection('haney-orders')
          .doc(orderData.id)
          .collection('statusLogs')
          .add({
            status: value,
            type: name,
            updatedAt: new Date(),
            updatedBy: {
              name: this.props.user.firstName + ' ' + this.props.user.lastName,
              uid: this.props.authUser.uid,
            },
          })
          .then((res) => console.log('Update succesful'))
          .catch((err) => console.log('Error in updating the db'));
      })
      .catch((err) => console.log('Error in updating the db'));
  };

  changeShipmentStatus = (e) => {
    const { value, name } = e.target;
    console.log(value, name);
    if (!this.state.orderData) return;

    let arrName;

    if (this.state.orderData.isFactored) {
      switch (name) {
        case 'status':
          arrName = 'shipmentStatuses';
          break;
  
        case 'financialStatus':
          arrName = 'factoredFinancialStatuses';
          break;
  
        default:
          return;
          break;
      }
    } else {
      switch (name) {
        case 'status':
          arrName = 'shipmentStatuses';
          break;
  
        case 'financialStatus':
          arrName = 'financialStatuses';
          break;
  
        default:
          return;
          break;
      }
    }

    console.log(this.state.orderData[name]);

    const prevIndex = this[arrName].findIndex(
      (status) => status === this.state.orderData[name]
    );
    const newIndex = this[arrName].findIndex((status) => status === value);

    console.log(prevIndex, newIndex);

    if (newIndex < prevIndex && this[arrName][prevIndex] !== 'Docked') {
      console.log('open modal');
      this.setState({ promptModal: true, temp: { name, value } });
    } else if (newIndex > prevIndex || this[arrName][prevIndex] === 'Docked') {
      this.saveShipmentStatus(name, value);
    }
  };

  qualifyAirPickUpVendors = () => {
    let qualifiedPickUpVendors = [];
    let qualifiedDropOffVendors = [];
    // this.state.originAirports.items.map((airport) => {
    //   console.log(airport.icao)

    const flight = this.grabData('flight');
    const additionalLegs = this.grabData('additionalLegs');

    //   var qualifiedPickUpVendorsList = this.state.vendorsSTAData.filter(function (vendor) {
    //     // console.log(vendor.airCodes.indexOf(airport.icao))
    //     return vendor.airCodes.indexOf(airport.icao) !== -1
    //   });
    //   console.log(qualifiedPickUpVendorsList)
    //   qualifiedPickUpVendors = qualifiedPickUpVendors.concat(qualifiedPickUpVendorsList)
    // })
    console.log('this.state.vendorsSTAData');
    console.log(this.state.vendorsSTAData);
    console.log(
      this.state.flight
        ? this.state.flight.originAirport
        : this.state.orderData.flight
          ? this.state.orderData.flight.originAirport
          : null
    );
    let airCode, destinationAirCode;
    if (this.state.orderData.deliveryType === 'Scheduled Air') {
      airCode =
        this.state.originAirCarrier &&
          Object.keys(this.state.originAirCarrier).length
          ? this.state.originAirCarrier.airCode
          : this.state.orderData.originAirCarrier &&
            Object.keys(this.state.orderData.originAirCarrier).length
            ? this.state.orderData.originAirCarrier.airCode
            : null;
      destinationAirCode =
        this.state.destinationAirCarrier &&
          Object.keys(this.state.destinationAirCarrier).length
          ? this.state.destinationAirCarrier.airCode
          : this.state.orderData.destinationAirCarrier &&
            Object.keys(this.state.orderData.destinationAirCarrier).length
            ? this.state.orderData.destinationAirCarrier.airCode
            : null;
    } else if (this.state.orderData.deliveryType === 'Air') {
      airCode = flight ? flight.originAirport : null; //this.state.flight ? (this.state.flight.originAirport) : (this.state.orderData.flight ? this.state.orderData.flight.originAirport : null);
      console.log('qualifying vendors for air');
      console.log(additionalLegs);
      destinationAirCode =
        additionalLegs && additionalLegs.length
          ? additionalLegs[0].destinationAirport
          : flight
            ? flight.destinationAirport
            : null; // (this.state.additionalLegs ? (this.state.additionalLegs[0].destinationAirport) : (this.state.flight ? (this.state.flight.destinationAirport) : (this.state.orderData.flight ? this.state.orderData.flight.destinationAirport : null));
    }
    // let airCode = this.state.flight ? (this.state.flight.originAirport) : (this.state.orderData.flight ? this.state.orderData.flight.originAirport : null)
    if (this.state.orderData.subDeliveryType !== 'Air Truck') {
      this.state.vendorsSTAData.map((vendor) => {
        if (vendor.airCodes && vendor.airCodes.indexOf(airCode) !== -1) {
          qualifiedPickUpVendors = qualifiedPickUpVendors.concat(vendor);
        }
      });
    } else {
      this.state.vendorsData.map((vendor) => {
        if (vendor.airCodes && vendor.airCodes.indexOf(airCode) !== -1) {
          qualifiedPickUpVendors = qualifiedPickUpVendors.concat(vendor);
        }
      });
    }

    // let destinationAirCode = this.state.flight ? (this.state.flight.destinationAirport) : (this.state.orderData.flight ? this.state.orderData.flight.destinationAirport : null)

    this.state.vendorsData.map((vendor) => {
      if (vendor.airCodes) {
        if (vendor.airCodes.indexOf(destinationAirCode) !== -1) {
          if (
            vendor.vendorType == 'Ground Carrier' ||
            vendor.vendorType == 'LTL Carrier'
          )
            qualifiedDropOffVendors = qualifiedDropOffVendors.concat(vendor);
        }
      } else {
        null;
      }
    });

    console.log('qualifiedPickUpVendorsList');

    console.log(qualifiedPickUpVendors);
    console.log(qualifiedDropOffVendors);
    // var qualifiedPickUpVendorsFinal = this.state.qualifiedPickUpVendors.filter(function (vendor) {
    //   // console.log(vendor.airCodes.indexOf(airport.icao))
    //   return !this[vendor.id] && (this[vendor.id] = true);
    // });
    this.setState({
      qualifiedPickUpVendors: qualifiedPickUpVendors,
      qualifiedDropOffVendors: qualifiedDropOffVendors,
      qualifiedAirVendorsLoaded: true,
    });
  };

  qualifyVendors = () => {
    var qualifiedPickUpVendors = [];
    this.state.originAirports.items.map((airport) => {
      console.log(airport.icao);

      var qualifiedPickUpVendorsList = this.state.vendorsSTAData.filter(
        function (vendor) {
          // console.log(vendor.airCodes.indexOf(airport.icao))
          return vendor.airCodes.indexOf(airport.icao) !== -1;
        }
      );
      console.log(qualifiedPickUpVendorsList);
      qualifiedPickUpVendors = qualifiedPickUpVendors.concat(
        qualifiedPickUpVendorsList
      );
    });
    console.log(qualifiedPickUpVendors);
    // var qualifiedPickUpVendorsFinal = this.state.qualifiedPickUpVendors.filter(function (vendor) {
    //   // console.log(vendor.airCodes.indexOf(airport.icao))
    //   return !this[vendor.id] && (this[vendor.id] = true);
    // });
    this.setState({
      qualifiedPickUpVendors: qualifiedPickUpVendors,
      vendorsQualified: true,
    });
  };

  qualifyDropOffVendors = () => {
    console.log('qualifying dropoff vendors');
    var qualifiedDropOffVendors = [];
    this.state.destinationAirports.items.map((airport) => {
      console.log(airport.icao);

      var qualifiedDropOffVendorsList = this.state.vendorsData.filter(function (
        vendor
      ) {
        console.log(vendor);
        // console.log(vendor.airCodes.indexOf(airport.icao))
        if (vendor.airCodes) {
          return (
            vendor.airCodes.indexOf(airport.icao) !== -1 &&
            (vendor.vendorType == 'Ground Carrier' ||
              vendor.vendorType == 'LTL Carrier')
          );
        }
      });
      qualifiedDropOffVendors = qualifiedDropOffVendors.concat(
        qualifiedDropOffVendorsList
      );
    });
    console.log(qualifiedDropOffVendors);
    this.setState({
      qualifiedDropOffVendors: qualifiedDropOffVendors,
      dropOffVendorsQualified: true,
    });
  };

  selectDriver = (driver) => {
    console.log(driver);
    let data = db
      .collection('TEST-users')
      .doc(driver.id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              ...docData,
              id: snapshot.id,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        console.log(docObj);
        this.setState({
          pickUpDriver: docObj,
          pickUpDriverName: docObj.firstName + ' ' + docObj.lastName,
          pickUpDriverContactLoaded: true,
          driverSelected: true,
        });
      });
    // this.setState({
    //   pickUpDriverID: driver.id,
    //   pickUpDriverName: driver.name,
    //   pickUpDriverEmail: driver.email,
    //   pickUpDriverCell: driver.cellPhone,
    //   pickUpDriver: driver,
    //   driverSelected: true
    // })
  };

  selectDropOffDriver = (driver) => {
    console.log(driver);
    let data = db
      .collection('TEST-users')
      .doc(driver.id)
      .get()
      .then(
        (snapshot) => {
          var docData = snapshot.data();
          if (docData) {
            var docObj = {
              ...docData,
              id: snapshot.id,
            };
            return docObj;
          } else {
            return null;
          }
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((docObj) => {
        console.log(docObj);
        this.setState({
          dropOffDriver: docObj,
          dropOffDriverName: docObj.firstName + ' ' + docObj.lastName,
          dropOffDriverContactLoaded: true,
          dropOffDriverSelected: true,
        });
      });

    // console.log(driver)
    // this.setState({
    //   dropOffDriverID: driver.id,
    //   dropOffDriverName: driver.name,
    //   dropOffDriverEmail: driver.email,
    //   dropOffDriver: driver,
    //   dropOffDriverSelected: true
    // })
  };

  selectFlight = (flight) => {
    console.log('selecting flight');
    console.log(flight);

    const { airlineName, originAirport, destinationAirport } = flight;
    console.log('airlineName');
    console.log(airlineName, originAirport, destinationAirport);
    if (!airlineName) {
      console.log('No airline name given');
      this.qualifyAirPickUpVendors();
      db.collection('haney-orders')
        .doc(this.props.orderID)
        .set(
          {
            flight: flight,
          },
          { merge: true }
        );
      return this.setState({ flight: flight, flightFlights: [] });
    }

    const airlineRef = db
      .collection('haney-vendors')
      .where('name', '==', airlineName);

    Promise.all([
      airlineRef.where('airCodes', 'array-contains', originAirport).get(),
      airlineRef.where('airCodes', 'array-contains', destinationAirport).get(),
    ]).then((responses) => {
      const [originAirlinesSnapshot, destinationAirlinesSnapshot] = responses;
      console.log(responses);
      const loopLen = Math.max(
        originAirlinesSnapshot.docs.length,
        destinationAirlinesSnapshot.docs.length
      );

      const [originAirlineDetails, destinationAirlineDetails] = [[], []];
      for (let i = 0; i < loopLen; i++) {
        if (originAirlinesSnapshot.docs.length > i) {
          const oAirline = {
            ...originAirlinesSnapshot.docs[i].data(),
            id: originAirlinesSnapshot.docs[i].id,
          };

          originAirlineDetails.push(oAirline);
        }
        if (destinationAirlinesSnapshot.docs.length > i) {
          const dAirline = {
            ...destinationAirlinesSnapshot.docs[i].data(),
            id: destinationAirlinesSnapshot.docs[i].id,
          };

          destinationAirlineDetails.push(dAirline);
        }
      }

      const addressedOriginVendor = originAirlineDetails.find(
        (obj) => obj.physicalAddress
      );
      const addressedDestinationVendor = destinationAirlineDetails.find(
        (obj) => obj.physicalAddress
      );

      if (addressedOriginVendor)
        flight.originAirlineAddress = addressedOriginVendor.physicalAddress;
      if (addressedDestinationVendor)
        flight.destinationAirlineAddress =
          addressedDestinationVendor.physicalAddress;

      this.setState({
        originAirlineDetails: originAirlineDetails,
        destinationAirlineDetails: this.state.additionalLegs
          ? this.state.additionalLegs[0].originAirport ==
            destinationAirlineDetails[0].airCodes
            ? this.state.destinationAirlineDetails
            : destinationAirlineDetails
          : destinationAirlineDetails,
        airportAddressUpdated: true,
        flight: flight,
        flightFlights: [],
      });

      db.collection('haney-orders')
        .doc(this.props.orderID)
        .set(
          {
            originAirlineDetails: originAirlineDetails,
            destinationAirlineDetails: this.state.additionalLegs
              ? this.state.additionalLegs[0].originAirport ==
                destinationAirlineDetails[0].airCodes
                ? this.state.destinationAirlineDetails
                : destinationAirlineDetails
              : destinationAirlineDetails,
            flight: flight,
          },
          { merge: true }
        );
      this.qualifyAirPickUpVendors();
    });
  };

  selectAdditionalLegs = (flight, i) => {
    console.log('selecting flight');
    console.log(flight);

    const { airlineName, originAirport, destinationAirport } = flight;
    console.log('airlineName');
    console.log(airlineName, originAirport, destinationAirport);
    if (!airlineName) {
      console.log('No airline name given');
      this.qualifyAirPickUpVendors();
      db.collection('haney-orders')
        .doc(this.props.orderID)
        .set(
          {
            additionalLegs: [flight],
          },
          { merge: true }
        );
      return this.setState({
        additionalLegs: [flight],
        [`leg${i}Flights`]: [],
      });
    }
    const airlineRef = db
      .collection('haney-vendors')
      .where('name', '==', airlineName);

    Promise.all([
      airlineRef.where('airCodes', 'array-contains', destinationAirport).get(),
    ]).then((responses) => {
      const [destinationAirlinesSnapshot] = responses;
      console.log(responses);
      const loopLen = Math.max(destinationAirlinesSnapshot.docs.length);

      const [destinationAirlineDetails] = [[], []];
      for (let i = 0; i < loopLen; i++) {
        if (destinationAirlinesSnapshot.docs.length > i) {
          const dAirline = {
            ...destinationAirlinesSnapshot.docs[i].data(),
            id: destinationAirlinesSnapshot.docs[i].id,
          };

          destinationAirlineDetails.push(dAirline);
        }
      }

      const addressedDestinationVendor = destinationAirlineDetails.find(
        (obj) => obj.physicalAddress
      );

      if (addressedDestinationVendor)
        flight.destinationAirlineAddress =
          addressedDestinationVendor.physicalAddress;

      this.setState({
        destinationAirlineDetails: destinationAirlineDetails,
        airportAddressUpdated: true,
        additionalLegs: [flight],
        [`leg${i}Flights`]: [],
      });
      db.collection('haney-orders')
        .doc(this.props.orderID)
        .set(
          {
            destinationAirlineDetails: destinationAirlineDetails,
            additionalLegs: [flight],
          },
          { merge: true }
        );
      this.qualifyAirPickUpVendors();
    });
    // this.setState({ additionalLegs: [flight], [`leg${i}Flights`]: [] }, () => this.qualifyAirPickUpVendors());
  };

  loadAirportAddress = (airline, origin, destination) => {
    console.log(airline, origin, destination);
    this.setState({ airportAddressUpdated: true });
    const airlineAppend = airline + ' Airlines';
    let data = db
      .collection('haney-vendors')
      .where('name', '==', airlineAppend)
      .where('airCodes', 'array-contains', origin)
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          originAirlineDetails: data,
          // airportAddressUpdated: true,
        });
      });

    let destinationData = db
      .collection('haney-vendors')
      .where('name', '==', airlineAppend)
      .where('airCodes', 'array-contains', destination)
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        data;
        this.setState({
          destinationAirlineDetails: data,
          // airportAddressUpdated: true,
        });
      });
  };

  loadMarketAreas = () => {
    // console.log()
    this.setState({
      marketAreasDataLoaded: true,
    });
    db.collection('marketareas')
      .get()
      .then(
        (snapshot) => {
          //console.log(snapshot)
          const data = [];
          // Parse data into array like in firebase.js
          snapshot.docs.forEach((doc) => {
            var docData = doc.data();
            var docObj = {
              id: doc.id,
              ...docData,
            };
            data.push(docObj);
          });
          return data;
        },
        (error) => {
          console.log('error fetching data: ', error);
        }
      )
      .then((data) => {
        console.log('last stage reached');
        this.setState({
          marketAreasData: data,
        });
      });
  };
  convertZipToMarketArea = (zip) => {
    console.log(
      'convertZipToMarketArea: ' + zip.replace(/\s/g, '').substring(0, 3)
    );
    // console.log(state.zip.length == 3 ? zip.substring(0, 3) : null)

    console.log(this.state.marketAreasData);
    if (zip.length >= 3) {
      var newArray = this.state.marketAreasData.filter(function (marketArea) {
        return marketArea.zips.includes(zip.replace(/\s/g, '').substring(0, 3));
      });
      console.log(newArray);
      this.setState({
        filteredMarketArea: newArray[0] ? newArray[0].city : true,
        filteredMarketAreaCity: newArray[0] ? newArray[0].city : true,
        filteredMarketAreaFullName: newArray[0] ? newArray[0].fullName : true,
        filteredMarketAreasVendorLoaded: true,
      });
    }
  };

  qualifyMarketAreaVendors = () => {
    console.log('qualifying ground vendors');
    console.log(this.state.filteredMarketArea);

    const maString = this.allMAString;
    var marketArea = this.state.filteredMarketArea;
    var marketAreaCity = this.state.filteredMarketAreaCity;
    var marketAreaFullName = this.state.filteredMarketAreaFullName;
    var qualifiedPickUpVendors = [];

    if (
      this.state.orderData.deliveryType == 'Additional Options' ||
      this.state.orderData.deliveryType == 'Ground'
    ) {
      var qualifiedPickUpVendorsList = this.state.vendorsData.filter(function (
        vendor
      ) {
        console.log(vendor);

        if (
          vendor.marketAreas &&
          (vendor.vendorType === 'Ground Carrier' ||
            vendor.vendorType === 'LTL Carrier')
        ) {
          return (
            vendor.marketAreas.find((area) => area === maString) ||
            vendor.marketAreas.indexOf(marketAreaCity) !== -1 ||
            vendor.marketAreas.indexOf(marketAreaFullName) !== -1
          );
        }
      });
    } else if (this.state.orderData.deliveryType === 'LTL') {
      var qualifiedPickUpVendorsList = this.state.vendorsData.filter(function (
        vendor
      ) {
        console.log(vendor);

        if (vendor.marketAreas && vendor.vendorType === 'LTL Carrier') {
          return (
            vendor.marketAreas.find((area) => area === maString) ||
            vendor.marketAreas.indexOf(marketAreaCity) !== -1 ||
            vendor.marketAreas.indexOf(marketAreaFullName) !== -1
          );
        }
      });
    }
    // } else {
    //   var qualifiedPickUpVendorsList = this.state.vendorsData.filter(function (vendor) {
    //     console.log(vendor)

    //     if (vendor.marketAreas) {
    //       return (((vendor.marketAreas.indexOf(marketAreaCity) !== -1) || (vendor.marketAreas.indexOf(marketAreaFullName) !== -1)) && (vendor.vendorType == "Ground Carrier" || vendor.vendorType == "LTL Carrier") && (vendor.hasDrivers))
    //     }
    //   });
    // }
    // var qualifiedPickUpVendorsList = this.state.vendorsData.filter(function (vendor) {
    //   console.log(vendor)

    //   if (vendor.marketAreas) {
    //     return (((vendor.marketAreas.indexOf(marketAreaCity) !== -1) || (vendor.marketAreas.indexOf(marketAreaFullName) !== -1)) && (vendor.vendorType == "Ground Carrier" || vendor.vendorType == "LTL Carrier") && (vendor.hasDrivers))
    //   }
    // });
    console.log(qualifiedPickUpVendorsList);
    qualifiedPickUpVendors = qualifiedPickUpVendors.concat(
      qualifiedPickUpVendorsList
    );
    console.log(qualifiedPickUpVendors);
    this.setState({
      qualifiedPickUpVendors: qualifiedPickUpVendors,
      qualifiedGroundPickUpVendors: qualifiedPickUpVendors,
      marketAreaFilteredVendorsLoaded: true,
    });
  };

  loadDispatch = () => {
    this.setState({
      // dispatcherData: docObj,
      dispatcherDataLoaded: true,
    });

    if (this.state.orderData.dispatcherID) {
      let dispatcherData = db
        .collection('TEST-users')
        .doc(this.state.orderData.dispatcherID)
        .get()
        .then(
          (snapshot) => {
            var docData = snapshot.data();
            if (docData) {
              var docObj = {
                id: snapshot.id,
                ...docData,
              };
              return docObj;
            } else {
              return null;
            }
          },
          (error) => {
            console.log('error fetching data: ', error);
          }
        )
        .then((docObj) => {
          this.setState({
            dispatcherData: docObj,
            // dispatcherDataLoaded: true
          });
        });
    }
  };

  assignPic2 = (files) => {
    console.log(files);
    const { orderData } = this.state;
    orderData.newDocs
      ? (orderData.newDocs = [...orderData.newDocs, ...files])
      : (orderData.newDocs = files);
    console.log(orderData.newDocs);
    this.setState({
      orderData: orderData,
    });
  };

  removeDoc = (i) => {
    this.setState((prevState) => {
      const { orderData } = prevState;
      orderData.newDocs.splice(i, 1);
      return {
        orderData: orderData,
      };
    });
  };

  saveDoc = async (document) => {
    const id = uuidv1();
    const docValToType = {
      airLabel: 'Carrier Labels',
      alternateBOL: 'Accufrate BOL',
      alternateAirWaybill: 'Carrier Air Waybill',
    };
    const oldDocs = this.state.orderData.docs ? this.state.orderData.docs : {};
    const newDocs = this.state.orderData.newDocs.filter(
      (doc) => doc !== document
    );
    const orderData = this.state.orderData;

    const fileURL = await this.uploadImage(
      `/orders/${this.props.orderID}/documents/${id}`,
      document.file
    );
    const docName = this.state.document
      ? docValToType[this.state.document]
      : document.name
        ? document.name
        : document.file.name;
    const docID = `${this.state.document
      ? this.state.document
      : document.name
        ? document.name
        : document.file.name
      }${this.state.document ? '' : `_${id}`}`;

    const changeDoc = {
      name: docName,
      fileURL,
      id,
      createdAt: new Date(),
    };

    console.log(changeDoc);

    oldDocs[docID] = changeDoc;
    orderData.newDocs = newDocs;
    orderData.docs = oldDocs;

    db.collection('haney-orders')
      .doc(this.props.orderID)
      .set(
        {
          docs: oldDocs,
        },
        { merge: true }
      )
      .then(() => {
        this.setState({ orderData: orderData });
      })
      .catch((err) => {
        console.log('Document link was not uploaded to firestore');
      });
  };

  deleteDocument = async (document, e) => {
    e.preventDefault();
    const { orderData, additionalDocuments } = this.state;
    const { docs, documents, previouslySentDocuments } = orderData;
    console.log(docs, documents, this.props.orderID);
    const orderRef = db.collection('haney-orders').doc(this.props.orderID);

    const docsEntries = Object.entries(docs);

    const documentsIndex = documents
      ? documents.findIndex((obj) => obj.id === document.id)
      : -1;
    const docsIndex = docsEntries.findIndex(
      (entry) => entry[1].id === document.id
    );

    const psdIndex = previouslySentDocuments
      ? previouslySentDocuments.findIndex((obj) => obj.id === document.id)
      : -1;
    const addIndex = additionalDocuments
      ? additionalDocuments.findIndex((obj) => obj.id === document.id)
      : -1;

    console.log(documentsIndex, docsIndex);

    if (psdIndex > -1) {
      previouslySentDocuments.splice(psdIndex, 1);
    }

    if (addIndex > -1) {
      additionalDocuments.splice(addIndex, 1);
    }

    if (documentsIndex > -1) {
      documents.splice(documentsIndex, 1);
      console.log(documents);

      orderRef.set(
        {
          documents: documents,
          previouslySentDocuments: previouslySentDocuments
            ? previouslySentDocuments
            : null,
        },
        { merge: true }
      );

      orderData.documents = documents;
      orderData.previouslySentDocuments = previouslySentDocuments
        ? previouslySentDocuments
        : null;
      this.setState({
        orderData,
        additionalDocuments,
      });
    } else if (docsIndex > -1) {
      console.log(docsEntries);

      await orderRef.set(
        {
          docs: {
            [docsEntries[docsIndex][0]]: firebase.firestore.FieldValue.delete(),
          },
          previouslySentDocuments: previouslySentDocuments
            ? previouslySentDocuments
            : null,
        },
        { merge: true }
      );

      docsEntries.splice(docsIndex, 1);

      orderData.docs = Object.fromEntries(docsEntries);
      orderData.previouslySentDocuments = previouslySentDocuments
        ? previouslySentDocuments
        : null;
      this.setState({
        orderData,
        additionalDocuments: additionalDocuments,
      });
    } else {
      console.log("Can't find document anywhere");
    }
  };

  deleteDriverUploads = (document, e, i) => {
    e.preventDefault();
    const { orderData, additionalDocuments } = this.state;
    const { shipperBOL, consigneeBOL, previouslySentDocuments } = orderData;
    const uploads = {
      shipperBOL,
      consigneeBOL,
    };

    let key;
    let index = -1;

    for (key in uploads) {
      index = uploads[key]
        ? uploads[key].findIndex((obj) => obj.id === document.id)
        : -1;
      if (index > -1) break;
    }

    const psdIndex = previouslySentDocuments
      ? previouslySentDocuments.findIndex((obj) => obj.id === document.id)
      : -1;
    const addIndex = additionalDocuments
      ? additionalDocuments.findIndex((obj) => obj.id === document.id)
      : -1;

    console.log(index);

    if (index > -1) {
      console.log(
        key,
        index,
        uploads[key][index],
        previouslySentDocuments,
        additionalDocuments
      );

      uploads[key].splice(index, 1);
      // orderData[key].splice(index, 1);

      if (psdIndex > -1) previouslySentDocuments.splice(psdIndex, 1);
      if (addIndex > -1) additionalDocuments.splice(addIndex, 1);

      console.log(
        'Updated array of files:',
        uploads[key],
        previouslySentDocuments,
        additionalDocuments
      );

      orderData.previouslySentDocuments = previouslySentDocuments;

      db.collection('haney-orders')
        .doc(this.props.orderID)
        .set(
          {
            [key]: uploads[key],
            previouslySentDocuments: previouslySentDocuments
              ? previouslySentDocuments
              : null,
          },
          { merge: true }
        );

      this.setState({
        orderData,
        additionalDocuments: additionalDocuments ? additionalDocuments : null,
      });

      console.log('Setting all new data');
    } else {
      console.log('Could not find document attempting to be deleted');
    }
  };

  selectAttachments = (e, newValues) => {
    this.setState({ additionalDocuments: newValues });
  };

  textDriver = (e) => {
    e.persist();
    console.log(e.target);
    const orderData = this.state.orderData;
    orderData.sendDriverReminders = e.target.checked;

    this.setState({ orderData: orderData });
    db.collection('haney-orders')
      .doc(orderData.id)
      .set(
        {
          sendDriverReminders: e.target.checked,
        },
        { merge: true }
      )
      .then(() => console.log('Driver to be texted:', e.target.checked))
      .catch((err) => console.log(err));
  };

  addTotalBytes = (value, ref, index) => {
    console.log(value, ref, index);
    const arr = this.state[ref];
    arr[index].totalBytes = value;
    this.setState({
      [ref]: arr,
    });
  };

  addUploadedBytes = (value, ref, index) => {
    console.log(value, ref, index);
    const arr = this.state[ref];
    arr[index].uploadedBytes = value;
    this.setState({
      [ref]: arr,
    });
  };

  uploadImage2 = (refString, pic, ref, index) => {
    console.log("Uploading image");
    return new Promise((resolve, reject) => {
      // create storage ref
      var storageRef = storage.ref(refString);
      // upload pic
      var uploadTask = storageRef.put(pic);
      let updatedTotal = false;
      // update progress bar
      uploadTask.on(
        "state_changed",
        (snapshot) => {
          // Observe state change events such as progress, pause, and
          // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
          if (!updatedTotal) {
            this.addTotalBytes(snapshot.totalBytes, ref, index);
            updatedTotal = true;
          }

          this.addUploadedBytes(snapshot.bytesTransferred, ref, index);
        },
        (error) => {
          // Handle unsuccessful uploads
          console.log(error);
        },
        () => {
          // Handle successful uploads on complete
          // For instance, get the download URL: https://firebasestorage.googleapis.com/...
          uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
            resolve(downloadURL);
          });
        }
      );
    });
  };

  assignDoc = (files, ref) => {
    console.log(files, ref);
    const uploadString = `${ref}Upload`;
    const allFiles = this.state.orderData.transLoad ? this.state.orderData.transLoad : this.state[ref];

    this.setState(
      {
        [uploadString]: Array(files.length)
          .fill()
          .map((_, i) => ({ uploadedBytes: 0, totalBytes: 1 })),
      },
      async () => {
        const uploadPromises = [];
        const newFiles = [];

        for (let i = 0; i < files.length; i++) {
          const file = files[i];
          const id = uuidv1();

          newFiles.push({
            name: file.file.name,
            id,
          });
          uploadPromises.push(
            this.uploadImage2(
              `/orders/${this.state.orderData.id}/documents/${id}`,
              file.file,
              uploadString,
              i
            )
          );
        }

        const uploadURLs = await Promise.all(uploadPromises);

        for (let i = 0; i < files.length; i++) {
          allFiles.push({
            ...newFiles[i],
            fileURL: uploadURLs[i],
            createdAt: new Date(),
          });
        }

        db.collection("haney-orders")
          .doc(this.state.orderData.id)
          .set(
            {
              [ref]: allFiles,
            },
            { merge: true }
          ).then(() => {
            if (!this.state.orderData.transLoad) {
              window.location.reload();
            }
          });
        this.setState({
          [ref]: allFiles,
        });

        
      }
    );
  };


  render() {
    const { classes, modalClose, authUser, orderID, user } = this.props;
    function StyledRadio(props) {
      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          }
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }
    // Inspired by blueprintjs
    function StyledRadio(props) {
      return (
        <Radio
          className={classes.root}
          disableRipple
          color="default"
          checkedIcon={
            <span className={clsx(classes.icon, classes.checkedIcon)} />
          }
          icon={<span className={classes.icon} />}
          {...props}
        />
      );
    }
    radiusOptions;
    const shippingModes = ['', 'LTL', 'TL'];
    const role = ['', 'Shipper', 'Consignee', 'Third Party'];
    const locationTypes = [
      '',
      'Business',
      'Construction Site',
      'Convention Center or Tradeshow',
      'Freight Carrier Terminal',
      'Home Based Business',
      'Mlitary Base',
      'Mini-Storage / Self Storage Facility',
      'Religious Institution',
      'Residential / Home',
    ];
    const packagingTypes = [
      '',
      'Pallets: Standard (40" x 48")',
      'Pallets (48" x 48")',
      'Pallets (60" x 48")',
      'Pallets (enter dimensions)',
      'Boxed',
      'Crated',
      'Drums or Barrels',
    ];
    const freightClass = [
      '',
      'I dont know',
      '50',
      '55',
      '60',
      '65',
      '70',
      '77.5',
      '85',
      '92.5',
      '100',
      '110',
      '125',
      '150',
      '175',
      '200',
      '250',
      '300',
      '400',
      '500',
    ];
    const radiusOptions = ['', '50', '100', '150', '200', '250', '300'];
    const documentOptions = [
      { string: '', value: '' },
      { string: 'Carrier Labels', value: 'airLabel' },
      { string: 'Accufrate BOL', value: 'alternateBOL' },
      { string: 'Carrier Air Waybill', value: 'alternateAirWaybill' },
    ];

    if (authUser && !this.state.userSet) {
      this.setUser(authUser.uid);
    }
    //console.log(authUser)
    // reset modal when closed
    // if (this.state.messageSent) { this.resetRequest() }

    let pathname = window.location.pathname;

    if (this.state.pickUpDriverContact) {
      console.log("pick up driver " + this.state.pickUpDriverContact.truckNumber)
    }

    // try {
    //   if (this.state.orderData) {
    //     if (this.state.orderData.pickUpDriver && !this.state.pickUpDriverContactLoaded) {
    //       // console.log("next3")
  
    //       this.loadPickUpDriverContact(this.state.orderData.pickUpDriver.id);
  
    //       console.log('loading driver pickup contact data');
    //     }
    //   }
    // } catch (err) {
    //   console.log(err);
    // }

    try {
      if (
        user.dataLoaded &&
        !this.state.orderDataLoaded &&
        !this.state.vendorsDataLoaded && !this.state.statusLogsDataLoaded &&
        orderID &&
        orderID
      ) {
        this.loadOrdersData(this.props.orderID);
        this.loadStatusData(this.props.orderID);
        this.loadVendorsData();
        this.loadVendorsSTAData();
        console.log('loading order data');
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (this.state.vendorPickUp && !this.state.driversPickUpDataLoaded) {
        // console.log("next1")
        this.loadDriversPickUpData(this.state.vendorPickUp.id);
        this.loadDriversPickUpSTAData(this.state.vendorPickUp.id);
        console.log('loading driver pickup data');
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (this.state.vendorDropOff && !this.state.driversDropOffDataLoaded) {
        // console.log("next2")

        this.loadDriversDropOffData(this.state.vendorDropOff.id);
        this.loadDriversDropOffSTAData(this.state.vendorDropOff.id);

        console.log('loading driver drpooff data');
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (this.state.driverPickUp && !this.state.pickUpDriverContactLoaded) {
        // console.log("next3")

        this.loadPickUpDriverContact(this.state.driverPickUp.id);

        console.log('loading driver pickup contact data');
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (!this.state.getAirportsLoaded && this.state.orderDataLoaded) {
        // console.log("next4")

        // console.log(this.state.orderData)
        // console.log(this.state.orderDataLoaded)
        // if (!this.state.orderData.deliveryType == "LTL") {
        this.getAirports(this.state.orderData);

        console.log('loading airport data');

        // }
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (
        !this.state.invoiceDataLoaded &&
        this.state.orderData.docs.invoice.id
      ) {
        console.log('getting invoice');
        console.log(this.state.orderData.docs.invoice);
        this.loadInvoiceData();
      }
    } catch (err) {
      console.log(err);
    }
    // try {
    //   if (this.state.getAirportsLoaded) {
    //     // console.log(this.state.vendorsData)
    //     // console.log(this.state.destinationAirports.items)
    //   }
    // } catch (err) {
    //   console.log(err)
    // }

    // try {
    //   if (this.state.vendorsSTAData && this.state.originAirports && this.state.destinationAirports && this.state.getAirportsLoaded && !this.state.vendorsQualified) {
    //     // console.log("next5")

    //     this.qualifyVendors()
    //     this.qualifyDropOffVendors()

    //     console.log("loading vendor data")

    //   }
    // } catch (err) {
    //   console.log(err)
    // }

    try {
      if (
        this.state.orderData &&
        this.state.orderData.flight &&
        !this.state.airportAddressUpdated
      ) {
        console.log('loading airport address data');

        if (this.state.orderData.flight) {
          this.loadAirportAddress(
            this.state.orderData.flight.airlineName,
            this.state.orderData.flight.originAirport,
            this.state.orderData.flight.destinationAirport
          );
        }
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (user.dataLoaded && !this.state.marketAreasDataLoaded) {
        // console.log("next7")

        this.loadMarketAreas();

        console.log('loading markt area data');
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (
        this.state.orderData &&
        this.state.marketAreasData &&
        !this.state.filteredMarketAreasVendorLoaded
      ) {
        // console.log("next8")

        this.convertZipToMarketArea(this.state.orderData.origin.zip);

        console.log('loading zip data');
      }
    } catch (err) {
      console.log(err);
    }

    if (this.state.orderData) {
      try {
        console.log(this.state.orderData);
        console.log('load ground vendors');
        if (
          this.state.orderData.deliveryType == 'Ground' ||
          this.state.orderData.deliveryType == 'LTL' ||
          this.state.orderData.deliveryType == 'Additional Options'
        ) {
          console.log(this.state.filteredMarketArea);
          if (
            this.state.filteredMarketArea &&
            this.state.vendorsData &&
            !this.state.marketAreaFilteredVendorsLoaded
          ) {
            console.log('load ground vendors');
            this.qualifyMarketAreaVendors();

            console.log('loading marketarea vendor data');
          }
        } else {
          console.log('this is an air shipment');
        }
      } catch (err) {
        console.log(err);
      }
    }
    try {
      if (this.state.orderData) {
        console.log('qualify air 1');

        if (
          this.state.orderData.deliveryType == 'Air' ||
          this.state.orderData.deliveryType == 'Scheduled Air'
        ) {
          console.log('qualify air2 ');

          if (
            this.state.vendorsSTAData &&
            this.state.vendorsData &&
            !this.state.qualifiedAirVendorsLoaded
          ) {
            console.log('qualify air 3');
            this.qualifyAirPickUpVendors();
            // this.qualifyAirDropOffVendors()
          }
        }
      }
    } catch (err) {
      console.log(err);
    }
    try {
      if (
        !this.state.dispatcherDataLoaded &&
        this.state.orderData.dispatcherID
      ) {
        // console.log("next9")

        this.loadDispatch();

        console.log('loading dispatch data');
      }
    } catch (err) {
      console.log(err);
    }

    try {
      if (this.state.orderData) {
        console.log('loading deliverby data');

        // console.log(this.state.orderData.origin);
        if (this.state.orderData.origin.deliverBy) {
          if ('seconds' in this.state.orderData.origin.deliverBy) {
            var deliverBy = this.state.orderData.origin.deliverBy.toDate();
          } else {
            var deliverBy = this.state.orderData.origin.deliverBy;
          }
        }
        // console.log(this.state.orderData.destination);
        if (this.state.orderData.destination.deliverBy) {
          if ('seconds' in this.state.destination.deliverBy) {
            var pickUpBy = this.state.orderData.destination.deliverBy.toDate();
          } else {
            var pickUpBy = this.state.orderData.destination.deliverBy;
          }
        }
      }
    } catch (err) {
      console.log(err);
    }

    const uploadedDocuments = [];
    this.state.orderData &&
      this.state.orderData.documents &&
      this.state.orderData.documents.map((doc) => uploadedDocuments.push(doc));
    if (this.state.orderData && this.state.orderData.docs) {
      console.log('loading docs data');

      const docs = this.state.orderData.docs;
      for (let key in docs) {
        if ('createdAt' in docs[key]) {
          uploadedDocuments.push(docs[key]);
        }
      }
    }

    const invoiceDocuments = [...uploadedDocuments];

    if (
      this.state.orderData &&
      this.state.orderData.shipperBOL &&
      this.state.orderData.shipperBOL.length
    ) {
      invoiceDocuments.push({
        ...this.state.orderData.shipperBOL[0],
        name: 'BOL',
      });
    }
    if (
      this.state.orderData &&
      this.state.orderData.consigneeBOL &&
      this.state.orderData.consigneeBOL.length
    ) {
      invoiceDocuments.push({
        ...this.state.orderData.consigneeBOL[0],
        name: 'POD',
      });
    }

    const quoteETAs = {};


    if (this.state.orderData) {
      quoteETAs.air = this.grabData('air') ? this.grabData('air') : null;
      quoteETAs.scheduledAir = this.grabData('cargoAir') ? this.grabData('cargoAir') : null;
      quoteETAs.ground = this.grabData('ground') ? this.grabData('ground') : null;
      quoteETAs.ltl = this.grabData('autoLtl') ? this.grabData('autoLtl') : null;
      quoteETAs.additionalOptions = this.grabData('ltl') ? this.grabData('ltl') : null;

      for (let key in quoteETAs) {
        const quote = quoteETAs[key];
        if (quote && quote.quoteETA && quote.quoteETA.seconds) quoteETAs[key].quoteETA = quote.quoteETA.toDate();
      }
      console.log(quoteETAs);
    }

    let daysAged
    let agingStatus

    if (this.state.orderData) {
      if (this.state.orderData.docs) {
        if (this.state.orderData.docs["invoice"]) {
          if (this.state.orderData.financialStatus == "Paid" || this.state.orderData.financialStatus == "Paid in Full") {
            agingStatus = "Paid"
          } else {
            let timeAged = new Date().getTime() - new Date(this.state.orderData.docs["invoice"].createdAt.seconds * 1000).getTime()
            daysAged = Math.round(timeAged / (1000 * 3600 * 24))
            switch (true) {
              case (daysAged < 31):
                agingStatus = "Current";
                break;
              case (daysAged < 61):
                agingStatus = "Past Due 1 - 30 Days";
                break;
              case (daysAged < 91):
                agingStatus = "Past Due 31 - 60 Days";
                break;
              case (daysAged < 121):
                agingStatus = "Past Due 61 - 90 Days";
                break;
              case (daysAged >= 121):
                agingStatus = "Past Due > 90 Days";
            }
          }
        }
      }
    }

    

    return (
      <div>
        {this.state.messageSent ? (
          <GridContainer justify="center">
            <GridItem xs={11}>
              <h4 className={classes.textPrimary}>Order Submitted!</h4>
            </GridItem>
          </GridContainer>
        ) : (
          <GridContainer style={{ marginTop: '-30px' }} justify="center">
            {/* {
                this.state.mapDataSaved ?
                  <GridItem xs={12} md={8}>
                    <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                  </GridItem>
                  : null
              } */}
            <GridItem xs={12}>
              <div className={classes.formContainer}>
                <form onSubmit={this.handleSubmit}>
                  <GridContainer justify="center">
                    <GridItem xs={11}>
                      {this.state.messageError ? (
                        <h5 className={classes.bodyText}>
                          There Has Been An Error: {this.state.messageError}
                        </h5>
                      ) : null}
                      {this.state.step1 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 1 of 4</h3>
                          <p>
                            Tell us who you are and where you're coming from.
                          </p>
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="role"
                              className={classes.selectLabel}
                            >
                              YOUR ROLE:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.role}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'role',
                                name: 'role',
                              }}
                            >
                              {role.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {/*<FormControl
                          fullWidth
                          className={classes.selectFormControl}>
                          <InputLabel
                            htmlFor="shippingmode"
                            className={classes.selectLabel}>
                            SHIPPING MODE:
                  </InputLabel>
                          <Select
                            MenuProps={{
                              className: classes.selectMenu
                            }}
                            classes={{
                              select: classes.select
                            }}
                            value={this.state.shippingMode}
                            onChange={this.handleSelectChange}
                            inputProps={{
                              id: 'shippingMode',
                              name: 'shippingMode'
                            }}
                          >
                            {
                              shippingModes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem
                                  }}
                                  value={item}
                                  key={item}
                                >{item}</MenuItem>
                              ))
                            }
                          </Select>
                          </FormControl>*/}

                          <br />
                          <br />
                          <h4 className={classes.bodyText}>
                            <b>Origin Details </b>
                          </h4>

                          <CustomInput
                            labelText="Business Name"
                            id="originBusinessName"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: 'text',
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.originBusinessName
                                ? this.state.originBusinessName
                                : '',
                            }}
                          />

                          <CustomInput
                            labelText="Address"
                            id="originAddress"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: 'text',
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.originAddress
                                ? this.state.originAddress
                                : '',
                            }}
                          />
                          <GridContainer justify="center">
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="City"
                                id="originCity"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originCity
                                    ? this.state.originCity
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem
                              xs={3}
                              style={{
                                padding: '0px, 0px, 0px, 0px !important',
                              }}
                            >
                              <CustomInput
                                labelText="State"
                                id="originState"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originState
                                    ? this.state.originState
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3}>
                              <CustomInput
                                labelText="ZIP"
                                id="originZip"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originZip
                                    ? this.state.originZip
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={12}>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="originType"
                                  className={classes.selectLabel}
                                >
                                  LOCATION TYPE:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  value={this.state.originType}
                                  onChange={this.handleSelectChange}
                                  defaultValue={
                                    this.state.originZip
                                      ? this.state.originZip
                                      : ''
                                  }
                                  inputProps={{
                                    id: 'originType',
                                    name: 'originType',
                                  }}
                                >
                                  {locationTypes.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </GridItem>
                          </GridContainer>
                          <GridContainer style={{ marginTop: '10px' }}>
                            <GridItem xs={6}>
                              {/* <Datetime
                                  selected={this.state.orderData && this.state.orderData.origin.date}
                                  onChange={this.handlePickUpDateChange}
                                  defaultValue={this.state.orderData ? this.state.orderData.origin.date : ''}
                                  timeFormat={true}
                                  isValidDate={this.valid}
                                  renderInput={(dateInputProps, open, close) => (
                                    <CustomInput
                                      inputProps={{ ...dateInputProps, id: 'pickUpDate', name: 'pickUpDate', required: true, }}
                                      onBlur={close}
                                      onFocus={open}
                                      labelText="Pickup Date"
                                      formControlProps={{
                                        fullWidth: true
                                      }}
                                    />
                                  )}
                                />
 */}
                            </GridItem>
                            <GridItem xs={6}>
                              <h5 className={classes.bodyText}>
                                EXTRA SERVICES
                              </h5>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  ' ' +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleTogglePickupServices(
                                          'Lift Gate'
                                        )
                                      }
                                      checked={
                                        this.state.pickUpServices.indexOf(
                                          'Lift Gate'
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Lift Gate at Pickup Point"
                                />
                              </div>
                              <br />
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  ' ' +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleTogglePickupServices(
                                          'Limited Access'
                                        )
                                      }
                                      checked={
                                        this.state.pickUpServices.indexOf(
                                          'Limited Access'
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Limited Access Pick Up"
                                />
                              </div>
                            </GridItem>
                          </GridContainer>

                          <Button
                            style={{ float: 'right', marginTop: '20px' }}
                            color="primary"
                            onClick={() => this.saveOrigin()}
                          >
                            NEXT
                          </Button>
                        </div>
                      ) : null}

                      {/* 
                        <CustomInput
                          labelText="Notes"
                          id="description"
                          formControlProps={{
                            fullWidth: true
                          }}
                          inputProps={{
                            id: "pickUpNotes",
                            name: "pickUpNotes",
                            type: "text",
                            multiline: true,
                            rows: 5,
                            onChange: (event) => this.handleChange(event)
                          }}
                        /> */}

                      {this.state.step2 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 2 of 4</h3>
                          <p>Tell us where you're going.</p>

                          <h4 className={classes.bodyText}>
                            <b>Receiver Details</b>
                          </h4>

                          <CustomInput
                            labelText="Business Name"
                            id="destinationBusinessName"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: 'text',
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.destinationBusinessName
                                ? this.state.destinationBusinessName
                                : '',
                            }}
                          />

                          <CustomInput
                            labelText="Address"
                            id="destinationAddress"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: 'text',
                              onChange: (event) => this.handleChange(event),
                              defaultValue: this.state.destinationAddress
                                ? this.state.destinationAddress
                                : '',
                            }}
                          />
                          <GridContainer justify="center">
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="City"
                                id="destinationCity"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationCity
                                    ? this.state.destinationCity
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem
                              xs={3}
                              style={{
                                padding: '0px, 0px, 0px, 0px !important',
                              }}
                            >
                              <CustomInput
                                labelText="State"
                                id="destinationState"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationState
                                    ? this.state.destinationState
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={3}>
                              <CustomInput
                                labelText="ZIP"
                                id="destinationZip"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationZip
                                    ? this.state.destinationZip
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>

                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="destinationType"
                              className={classes.selectLabel}
                            >
                              LOCATION TYPE:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.destinationType}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'destinationType',
                                name: 'destinationType',
                              }}
                            >
                              {locationTypes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <GridContainer style={{ marginTop: '10px' }}>
                            <GridItem xs={6}>
                              <Datetime
                                selected={this.state.dropOffDate}
                                onChange={this.handleDropOffDateChange}
                                defaultValue={
                                  this.state.dropOffDate
                                    ? this.state.dropOffDate
                                    : ''
                                }
                                timeFormat={true}
                                isValidDate={this.valid}
                                renderInput={(dateInputProps, open, close) => (
                                  <CustomInput
                                    inputProps={{
                                      ...dateInputProps,
                                      id: 'dropOffDate',
                                      name: 'dropOffDate',
                                      required: true,
                                    }}
                                    onBlur={close}
                                    onFocus={open}
                                    labelText="Drop Off Date"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                  />
                                )}
                              />
                            </GridItem>
                            <GridItem xs={6}>
                              <h5 className={classes.bodyText}>
                                EXTRA SERVICES
                              </h5>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  ' ' +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleDropOffServices(
                                          'Lift Gate'
                                        )
                                      }
                                      checked={
                                        this.state.dropOffServices.indexOf(
                                          'Lift Gate'
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Lift Gate at Pickup Point"
                                />
                              </div>
                              <br />
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  ' ' +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleDropOffServices(
                                          'Limited Access'
                                        )
                                      }
                                      checked={
                                        this.state.dropOffServices.indexOf(
                                          'Limited Access'
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Limited Access Pick Up"
                                />
                              </div>
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ marginTop: '20px' }}
                                onClick={() => this.step2Back()}
                              >
                                BACK
                              </Button>
                            </GridItem>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ float: 'right', marginTop: '20px' }}
                                onClick={() => this.saveDestination()}
                              >
                                NEXT
                              </Button>
                            </GridItem>
                          </GridContainer>
                        </div>
                      ) : null}

                      {/* <CustomInput
                              labelText="Notes"
                              id="dropOffNotes"
                              formControlProps={{
                                fullWidth: true
                              }}
                              inputProps={{
                                type: "text",
                                multiline: true,
                                rows: 5,
                                onChange: (event) => this.handleChange(event)
                              }}
                            /> */}
                      {this.state.step3 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 3 of 4</h3>
                          <p>Tell us who we'll be dealing with and when.</p>
                          <p>
                            <b>Who can we contact at the origin address?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Name"
                                id="originContactName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactName
                                    ? this.state.originContactName
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Email"
                                id="originContactEmail"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactEmail
                                    ? this.state.originContactEmail
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Phone"
                                id="originContactPhone"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originContactPhone
                                    ? this.state.originContactPhone
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>What are their business hours?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Open"
                                id="originOpenTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originOpenTime
                                    ? this.state.originOpenTime
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={2}>
                              <p>to</p>
                            </GridItem>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Close"
                                id="originCloseTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originCloseTime
                                    ? this.state.originCloseTime
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>When should we pick up the freight?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={2}>
                              <p>Between</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="Start"
                                id="originStartTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originStartTimeWindow
                                    ? this.state.originStartTimeWindow
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={1}>
                              <p>and</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="End"
                                id="originEndTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.originEndTimeWindow
                                    ? this.state.originEndTimeWindow
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <br /> <br />
                          <p>
                            <b>
                              Who can we contact at the destination address?
                            </b>
                          </p>
                          <GridContainer>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Name"
                                id="destinationContactName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationContactName
                                    ? this.state.destinationContactName
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Email"
                                id="destinationContactEmail"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationContactEmail
                                    ? this.state.destinationContactEmail
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={12}>
                              <CustomInput
                                labelText="Contact Phone"
                                id="destinationContactPhone"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationContactPhone
                                    ? this.state.destinationContactPhone
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>What are their business hours?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Open"
                                id="destinationOpenTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationOpenTime
                                    ? this.state.destinationOpenTime
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={2}>
                              <p>to</p>
                            </GridItem>
                            <GridItem xs={5}>
                              <CustomInput
                                labelText="Close"
                                id="destinationCloseTime"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.destinationCloseTime
                                    ? this.state.destinationCloseTime
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <p>
                            <b>When should we drop off the freight?</b>
                          </p>
                          <GridContainer>
                            <GridItem xs={2}>
                              <p>Between</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="Start"
                                id="destinationStartTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationStartTimeWindow
                                    ? this.state.destinationStartTimeWindow
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={1}>
                              <p>and</p>
                            </GridItem>
                            <GridItem xs={4}>
                              <CustomInput
                                labelText="End"
                                id="destinationEndTimeWindow"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state
                                    .destinationEndTimeWindow
                                    ? this.state.destinationEndTimeWindow
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ marginTop: '20px' }}
                                onClick={() => this.step3Back()}
                              >
                                BACK
                              </Button>
                            </GridItem>
                            <GridItem xs={6}>
                              <Button
                                color="primary"
                                style={{ float: 'right', marginTop: '20px' }}
                                onClick={() => this.saveFreight()}
                              >
                                NEXT
                              </Button>
                            </GridItem>
                          </GridContainer>
                        </div>
                      ) : null}
                      {this.state.step4 ? (
                        <div>
                          <h3 className={classes.bodyText}>Step 4 of 4</h3>
                          <p>Tell us what you are shipping.</p>

                          <h3 className={classes.bodyText}>ITEM #1</h3>
                          <h5 className={classes.bodyText}>EXTRA SERVICES</h5>
                          <div
                            className={
                              classes.checkboxAndRadio +
                              ' ' +
                              classes.checkboxAndRadioHorizontal
                            }
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  tabIndex={-1}
                                  onClick={() =>
                                    this.handleToggleServices('Hazmat')
                                  }
                                  checked={
                                    this.state.services.indexOf('Hazmat') !== -1
                                      ? true
                                      : false
                                  }
                                  checkedIcon={
                                    <Check className={classes.checkedIcon} />
                                  }
                                  icon={
                                    <Check className={classes.uncheckedIcon} />
                                  }
                                  color="primary"
                                  classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                  }}
                                />
                              }
                              classes={{ label: classes.bodyText }}
                              label="Hazmat"
                            />
                          </div>
                          <div
                            className={
                              classes.checkboxAndRadio +
                              ' ' +
                              classes.checkboxAndRadioHorizontal
                            }
                          >
                            <FormControlLabel
                              control={
                                <Checkbox
                                  tabIndex={-1}
                                  onClick={() =>
                                    this.handleToggleServices('Over Length')
                                  }
                                  checked={
                                    this.state.services.indexOf(
                                      'Over Length'
                                    ) !== -1
                                      ? true
                                      : false
                                  }
                                  checkedIcon={
                                    <Check className={classes.checkedIcon} />
                                  }
                                  icon={
                                    <Check className={classes.uncheckedIcon} />
                                  }
                                  color="primary"
                                  classes={{
                                    checked: classes.checked,
                                    root: classes.checkRoot,
                                  }}
                                />
                              }
                              classes={{ label: classes.bodyText }}
                              label="Over Length"
                            />
                          </div>
                          <GridContainer>
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="UN Number"
                                id="unNumber"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.unNumber
                                    ? this.state.unNumber
                                    : '',
                                }}
                              />
                            </GridItem>
                            <GridItem xs={6}>
                              <CustomInput
                                labelText="Proper Shipping Name"
                                id="properShippingName"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'text',
                                  onChange: (event) => this.handleChange(event),
                                  defaultValue: this.state.properShippingName
                                    ? this.state.properShippingName
                                    : '',
                                }}
                              />
                            </GridItem>
                          </GridContainer>
                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="packaging"
                              className={classes.selectLabel}
                            >
                              PACKAGING:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.packaging}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'packaging',
                                name: 'packaging',
                              }}
                            >
                              {packagingTypes.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>

                          <CustomInput
                            labelText="Qty"
                            id="quantity"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: 'number',
                              min: '0',
                              step: '1',
                              onChange: (event) => this.handleChange(event),
                            }}
                          />
                          <CustomInput
                            labelText="Total Weight"
                            id="weight"
                            formControlProps={{
                              fullWidth: true,
                            }}
                            inputProps={{
                              required: true,
                              type: 'number',
                              min: '0',
                              step: '1',
                              onChange: (event) => this.handleChange(event),
                            }}
                          />
                          {this.state.packaging ==
                            'Pallets (enter dimensions)' ? (
                            <GridContainer>
                              <GridItem xs={3}>
                                <CustomInput
                                  labelText="Height"
                                  id="height"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    required: true,
                                    type: 'number',
                                    min: '0',
                                    step: '1',
                                    onChange: (event) =>
                                      this.handleChange(event),
                                    defaultValue: this.state.height
                                      ? this.state.height
                                      : '',
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={4}>
                                <CustomInput
                                  labelText="Width"
                                  id="width"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    required: true,
                                    type: 'number',
                                    min: '0',
                                    step: '1',
                                    onChange: (event) =>
                                      this.handleChange(event),
                                    defaultValue: this.state.width
                                      ? this.state.width
                                      : '',
                                  }}
                                />
                              </GridItem>
                              <GridItem xs={3}>
                                <CustomInput
                                  labelText="Depth"
                                  id="depth"
                                  formControlProps={{
                                    fullWidth: true,
                                  }}
                                  inputProps={{
                                    required: true,
                                    type: 'number',
                                    min: '0',
                                    step: '1',
                                    onChange: (event) =>
                                      this.handleChange(event),
                                    defaultValue: this.state.depth
                                      ? this.state.depth
                                      : '',
                                  }}
                                />
                              </GridItem>
                            </GridContainer>
                          ) : null}

                          <FormControl
                            fullWidth
                            className={classes.selectFormControl}
                          >
                            <InputLabel
                              htmlFor="class"
                              className={classes.selectLabel}
                            >
                              FREIGHT CLASS:
                            </InputLabel>
                            <Select
                              MenuProps={{
                                className: classes.selectMenu,
                              }}
                              classes={{
                                select: classes.select,
                              }}
                              value={this.state.class}
                              onChange={this.handleSelectChange}
                              inputProps={{
                                id: 'class',
                                name: 'class',
                              }}
                            >
                              {freightClass.map((item) => (
                                <MenuItem
                                  classes={{
                                    root: classes.selectMenuItem,
                                  }}
                                  value={item}
                                  key={item}
                                >
                                  {item}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          {!this.state.item2 ? (
                            <Button
                              color="primary"
                              onClick={() => this.addItem()}
                            >
                              ADD ITEM
                            </Button>
                          ) : null}
                          {this.state.item2 ? (
                            <div>
                              <h3 className={classes.bodyText}>ITEM #2</h3>
                              <h5 className={classes.bodyText}>
                                EXTRA SERVICES
                              </h5>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  ' ' +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleServices('Hazmat')
                                      }
                                      checked={
                                        this.state.services.indexOf(
                                          'Hazmat'
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Hazmat"
                                />
                              </div>
                              <div
                                className={
                                  classes.checkboxAndRadio +
                                  ' ' +
                                  classes.checkboxAndRadioHorizontal
                                }
                              >
                                <FormControlLabel
                                  control={
                                    <Checkbox
                                      tabIndex={-1}
                                      onClick={() =>
                                        this.handleToggleServices('Over Length')
                                      }
                                      checked={
                                        this.state.services.indexOf(
                                          'Over Length'
                                        ) !== -1
                                          ? true
                                          : false
                                      }
                                      checkedIcon={
                                        <Check
                                          className={classes.checkedIcon}
                                        />
                                      }
                                      icon={
                                        <Check
                                          className={classes.uncheckedIcon}
                                        />
                                      }
                                      color="primary"
                                      classes={{
                                        checked: classes.checked,
                                        root: classes.checkRoot,
                                      }}
                                    />
                                  }
                                  classes={{ label: classes.bodyText }}
                                  label="Over Length"
                                />
                              </div>
                              <GridContainer>
                                <GridItem xs={6}>
                                  <CustomInput
                                    labelText="UN Number"
                                    id="unNumber"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: 'number',
                                      min: '0',
                                      step: '1',
                                      onChange: (event) =>
                                        this.handleChange(event),
                                    }}
                                  />
                                </GridItem>
                                <GridItem xs={6}>
                                  <CustomInput
                                    labelText="Proper Shipping Name"
                                    id="propperShippingName"
                                    formControlProps={{
                                      fullWidth: true,
                                    }}
                                    inputProps={{
                                      required: true,
                                      type: 'text',
                                      onChange: (event) =>
                                        this.handleChange(event),
                                    }}
                                  />
                                </GridItem>
                              </GridContainer>
                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="packaging"
                                  className={classes.selectLabel}
                                >
                                  PACKAGING:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  value={this.state.packaging}
                                  onChange={this.handleSelectChange}
                                  inputProps={{
                                    id: 'packaging',
                                    name: 'packaging',
                                  }}
                                >
                                  {packagingTypes.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>

                              <CustomInput
                                labelText="Qty"
                                id="quantity"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'number',
                                  min: '0',
                                  step: '1',
                                  onChange: (event) => this.handleChange(event),
                                }}
                              />
                              <CustomInput
                                labelText="Total Weight"
                                id="weight"
                                formControlProps={{
                                  fullWidth: true,
                                }}
                                inputProps={{
                                  required: true,
                                  type: 'number',
                                  min: '0',
                                  step: '1',
                                  onChange: (event) => this.handleChange(event),
                                }}
                              />
                              {this.state.packaging ==
                                'Pallets (enter dimensions)' ? (
                                <GridContainer>
                                  <GridItem xs={3}>
                                    <CustomInput
                                      labelText="Height"
                                      id="height"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      inputProps={{
                                        required: true,
                                        type: 'number',
                                        min: '0',
                                        step: '1',
                                        onChange: (event) =>
                                          this.handleChange(event),
                                      }}
                                    />
                                  </GridItem>
                                  <GridItem xs={4}>
                                    <CustomInput
                                      labelText="Width"
                                      id="width"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      inputProps={{
                                        required: true,
                                        type: 'number',
                                        min: '0',
                                        step: '1',
                                        onChange: (event) =>
                                          this.handleChange(event),
                                      }}
                                    />
                                  </GridItem>
                                  <GridItem xs={3}>
                                    <CustomInput
                                      labelText="Depth"
                                      id="depth"
                                      formControlProps={{
                                        fullWidth: true,
                                      }}
                                      inputProps={{
                                        required: true,
                                        type: 'number',
                                        min: '0',
                                        step: '1',
                                        onChange: (event) =>
                                          this.handleChange(event),
                                      }}
                                    />
                                  </GridItem>
                                </GridContainer>
                              ) : null}

                              <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="class"
                                  className={classes.selectLabel}
                                >
                                  FREIGHT CLASS:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  value={this.state.class}
                                  onChange={this.handleSelectChange}
                                  inputProps={{
                                    id: 'class',
                                    name: 'class',
                                  }}
                                >
                                  {freightClass.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>
                                  ))}
                                </Select>
                              </FormControl>
                            </div>
                          ) : null}

                          {this.state.flights &&
                            this.state.flights.map((flight) => {
                              if (flight.Stops.length == 0) {
                                return (
                                  <div>
                                    <Card
                                      style={{
                                        backgroundColor: 'white',
                                        boxShadow: '0px 0px 5px 0px #888888',
                                      }}
                                    >
                                      {/* <CardHeader>
                          <h5 style={{ color: "black" }}> <i>Case #{flight.id}</i> <br /></h5>
                        </CardHeader> */}
                                      <CardBody>
                                        <p>
                                          <span style={{ color: 'black' }}>
                                            Carrier:
                                          </span>{' '}
                                          <span
                                            style={{
                                              fontWeight: '900',
                                              color: 'black',
                                            }}
                                          >
                                            {flight.Carriers}
                                          </span>{' '}
                                        </p>
                                        {/*<p><span style={{ color: "black" }}>Stops:</span> <span style={{ fontWeight: "900", color: "black" }}>{flight.Stops.length}</span> </p>
                          <p>Flights: {flight.FlightNumbers.map(flight => {
                            return (
                              <p>
                                {flight.FlightNumber} <br />{flight.CarrierId}
                              </p>
                            )
                          })}</p>*/}
                                        <GridContainer>
                                          <GridItem xs={6}>
                                            {String(flight.Departure)}
                                          </GridItem>
                                          <GridItem xs={6}>
                                            {String(flight.Arrival)}
                                          </GridItem>
                                        </GridContainer>
                                      </CardBody>
                                    </Card>
                                  </div>
                                );
                              } else {
                                null;
                              }
                            })}
                          {this.state.assigningAction ? (
                            <div>
                              <p className={classes.bodyText}>
                                {this.state.assigningAction}
                              </p>
                            </div>
                          ) : (
                            <div>
                              <GridContainer>
                                <GridItem xs={6}>
                                  <Button
                                    color="primary"
                                    style={{ marginTop: '20px' }}
                                    onClick={() => this.step4Back()}
                                  >
                                    BACK
                                  </Button>
                                </GridItem>
                                <GridItem xs={6}>
                                  <Button
                                    color="primary"
                                    style={{
                                      float: 'right',
                                      marginTop: '20px',
                                    }}
                                    onClick={() =>
                                      this.getFlights(
                                        this.state.originCoords,
                                        this.state.destinationCoords
                                      )
                                    }
                                  >
                                    NEXT
                                  </Button>
                                </GridItem>
                              </GridContainer>
                            </div>
                          )}
                        </div>
                      ) : null}
                      {this.state.step5 ? (
                        <div>
                          <br />
                          <GridContainer style={{ marginTop: '20px' }}>
                            <GridContainer
                              style={{
                                marginBottom: '20px',
                                padding: 'auto',
                                width: '100%',
                              }}
                            >
                              <GridItem
                                md={3}
                                sm={12}
                                style={{ marginRight: '10px' }}
                              >
                                <h4>
                                  <b>
                                    Order #{' '}
                                    {this.state.orderData
                                      ? this.state.orderData.freightBillNumber
                                      : null}
                                  </b>
                                </h4>
                                <p>
                                  <b>CRX:</b>{' '}
                                  {this.state.orderData
                                    ? this.state.crxOrderData
                                      ? this.state.crxOrderData
                                        .freightBillNumber
                                      : null
                                    : null}
                                </p>
                                <p>
                                  <b>Order ID: </b>
                                  <i>
                                    {this.state.orderData
                                      ? this.state.orderData.id
                                      : null}
                                  </i>
                                </p>
                                <p>
                                  <b>
                                    Location last updated:
                                    <br />{' '}
                                  </b>
                                  {this.state.orderData
                                    ? this.state.orderData.dropOffDriverLocation
                                      ? this.state.orderData
                                        .dropOffDriverLocation.updatedAt
                                        ? moment(
                                          this.state.orderData.dropOffDriverLocation.updatedAt.toDate()
                                        ).format('YYYY-MM-DD HH:mm')
                                        : 'No location stamped'
                                      : 'No driver location'
                                    : 'No order data'}
                                </p>
                                <Button
                                  color={'rose'}
                                  onClick={() => this.deleteLocation()}
                                  fullWidth
                                >
                                  DELETE LOCATION
                                </Button>
                              </GridItem>

                              <GridItem md={3} xs={12}>
                                <FormControl
                                  fullWidth
                                  className={classes.selectFormControl}
                                >
                                  <InputLabel
                                    htmlFor="status"
                                    className={classes.selectLabel}
                                  >
                                    Shipment Operational Status:
                                  </InputLabel>
                                  <Select
                                    MenuProps={{
                                      className: classes.selectMenu,
                                    }}
                                    classes={{
                                      select: classes.select,
                                    }}
                                    value={
                                      this.state.orderData &&
                                      this.state.orderData.status
                                    }
                                    onChange={(e) => {
                                      this.changeShipmentStatus(e);
                                    }}
                                    defaultValue={
                                      this.state.orderData &&
                                      this.state.orderData.status
                                    }
                                    inputProps={{
                                      id: 'status',
                                      name: 'status',
                                    }}
                                  >
                                    {this.shipmentStatuses.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem,
                                        }}
                                        value={item}
                                        key={item}
                                      >
                                        {item}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                {this.state.orderData &&
                                  this.state.orderData.status}
                                {this.state.orderData &&
                                <FormControl
                                fullWidth
                                className={classes.selectFormControl}
                              >
                                <InputLabel
                                  htmlFor="financialStatus"
                                  className={classes.selectLabel}
                                >
                                  Shipment Accounting Status:
                                </InputLabel>
                                <Select
                                  MenuProps={{
                                    className: classes.selectMenu,
                                  }}
                                  classes={{
                                    select: classes.select,
                                  }}
                                  value={
                                    this.state.orderData &&
                                    this.state.orderData.financialStatus
                                  }
                                  onChange={(e) => {
                                    this.changeShipmentStatus(e);
                                  }}
                                  defaultValue={
                                    this.state.orderData &&
                                    this.state.orderData.financialStatus
                                  }
                                  inputProps={{
                                    id: 'financialStatus',
                                    name: 'financialStatus',
                                  }}
                                >
                                  {this.state.orderData.isFactored ? this.factoredFinancialStatuses.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>
                                  )) : this.financialStatuses.map((item) => (
                                    <MenuItem
                                      classes={{
                                        root: classes.selectMenuItem,
                                      }}
                                      value={item}
                                      key={item}
                                    >
                                      {item}
                                    </MenuItem>))
                                  }
                                </Select>
                              </FormControl>
                                }
                                
                                {this.state.orderData &&
                                  this.state.orderData.financialStatus}
                                   <br/>
                                   {this.state.orderData && <FormControlLabel
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => this.handleToggleFactored()}
                            checked={this.state.orderData.isFactored}
                            checkedIcon={<Check className={classes.checkedIcon} />}
                            icon={<Check className={classes.uncheckedIcon} style={{ color: "black !imporant" }} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="Factored?"
                      />}
                      {this.state.orderData &&
                         <div>
                          <p>Days Aged: {daysAged}</p>
                          <p>Aging Status: {agingStatus}</p>
                        </div>
                      }
                      {this.state.orderData && <FormControlLabel
                        control={
                          <Checkbox
                            tabIndex={-1}
                            onClick={() => this.handleToggleChargeback()}
                            checked={this.state.orderData.isChargeback}
                            checkedIcon={<Check className={classes.checkedIcon} />}
                            icon={<Check className={classes.uncheckedIcon} style={{ color: "black !imporant" }} />}
                            classes={{
                              checked: classes.checked,
                              root: classes.checkRoot
                            }}
                          />
                        }
                        classes={{
                          label: classes.label
                        }}
                        label="Chargeback?"
                      />}
                              </GridItem>

                              <GridItem xs={6} md={3} lg={3}>
                                <FormControl
                                  fullWidth
                                  className={classes.selectFormControl}
                                >
                                  <InputLabel
                                    htmlFor="deliveryType"
                                    className={classes.selectLabel}
                                  >
                                    Delivery Type:
                                  </InputLabel>
                                  <Select
                                    MenuProps={{
                                      className: classes.selectMenu,
                                    }}
                                    classes={{
                                      select: classes.select,
                                    }}
                                    value={
                                      this.state.orderData &&
                                      this.state.orderData.deliveryType
                                    }
                                    onChange={(e) => {
                                      this.saveShipmentStatus(
                                        e.target.name,
                                        e.target.value
                                      );
                                    }}
                                    defaultValue={
                                      this.state.orderData &&
                                      this.state.orderData.deliveryType
                                    }
                                    inputProps={{
                                      id: 'deliveryType',
                                      name: 'deliveryType',
                                    }}
                                  >
                                    {this.deliveryTypes.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem,
                                        }}
                                        value={item.value}
                                        key={item.string}
                                      >
                                        {item.string}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                {/* {this.state.orderData && deliveryTypes.filter(item => item.value === this.state.orderData.deliveryType)[0].string} */}
                                {this.state.orderData &&
                                  this.state.orderData.deliveryType}

                                <FormControl
                                  fullWidth
                                  className={classes.selectFormControl}
                                >
                                  <InputLabel
                                    htmlFor="billingParty"
                                    className={classes.selectLabel}
                                  >
                                    Billing Party
                                  </InputLabel>
                                  <Select
                                    MenuProps={{
                                      className: classes.selectMenu,
                                    }}
                                    classes={{
                                      select: classes.select,
                                    }}
                                    value={
                                      this.state.orderData &&
                                      this.state.orderData.billingParty
                                    }
                                    onChange={(e) => {
                                      this.saveShipmentStatus(
                                        e.target.name,
                                        e.target.value
                                      );
                                    }}
                                    defaultValue={
                                      this.state.orderData &&
                                      this.state.orderData.billingParty
                                    }
                                    inputProps={{
                                      id: 'billingParty',
                                      name: 'billingParty',
                                    }}
                                  >
                                    {this.billingParties.map((item) => (
                                      <MenuItem
                                        classes={{
                                          root: classes.selectMenuItem,
                                        }}
                                        value={item}
                                        key={item}
                                      >
                                        {item}
                                      </MenuItem>
                                    ))}
                                  </Select>
                                </FormControl>
                                {this.state.orderData &&
                                  this.state.orderData.billingParty}
                              </GridItem>

                              {this.state.orderData && (
                                <GridItem xs={12} md={2} lg={2}>
                                  <GridItem xs={12}>
                                    <Button
                                      style={{
                                        color: 'white',
                                        marginTop: '5px',
                                        backgroundColor: '#ff0000',
                                      }}
                                      onClick={() => this.cancelOrder()}
                                      fullWidth
                                    >
                                      CANCEL ORDER
                                    </Button>
                                  </GridItem>


                                  <GridItem xs={12}>
                                    <PinUserForm orderID={this.state.orderData.id} dispatcher={this.state.orderData.dispatcherID} />
                                    {/* <Button
                                      color="info"
                                      onClick={() => this.favOrder()}
                                      fullWidth
                                    >
                                      {this.state.orderData.dispatcherID ===
                                        this.props.authUser.uid && 'UN'}
                                      PIN ORDER
                                      <br />
                                    </Button>
                                    {this.state.dispatcherName && (
                                      <p>
                                        <b>Dispatcher: </b>{' '}
                                        {this.state.dispatcherName}
                                      </p>
                                    )} */}
                                  </GridItem>
                                </GridItem>
                              )}
                            </GridContainer>

                            <GridItem xs={12}>
                              <Divider
                                variant="fullWidth"
                                orientation="horizontal"
                              />
                            </GridItem>

                            <Grid item container md={12} lg={6}>
                              <GridContainer
                                xs={12}
                                justify="center"
                                style={{ maxHeight: 125 }}
                              >
                                <GridItem xs={12}>
                                  <h3 style={{ textAlign: 'center' }}>
                                    <b>
                                      <u> SUMMARY </u>
                                    </b>
                                  </h3>
                                </GridItem>
                                <GridItem
                                  xs={12}
                                  style={{ textAlign: 'center' }}
                                >
                                  <br />
                                  <b>
                                    Shipper to Consignee Total Mileage:{' '}
                                  </b>{' '}
                                  {this.state.orderData &&
                                    this.state.orderData.milesDistance}
                                  <br />
                                  <b>Approximate Transit Time:</b>{' '}
                                  {this.state.orderData &&
                                    this.state.orderData.timeDistance}
                                  <br />
                                </GridItem>
                              </GridContainer>

                              {this.state.orderData && (
                                <PartyFreightSummary
                                  dispatch={true}
                                  orderID={this.props.orderID}
                                  orderData={this.state.orderData}
                                  origin={this.state.orderData.origin}
                                  destination={this.state.orderData.destination}
                                  thirdParty={this.state.orderData.thirdParty}
                                  items={this.state.orderData.items}
                                  shipperName={this.state.orderData.shipperName}
                                  handleNotificationsToggle={this.handleNotificationsToggle}
                                  billingParty={
                                    this.state.orderData.billingParty
                                  }
                                  itemCount={this.state.itemCount}
                                  isEditable={true}
                                  chat={true}
                                  openChats={this.state.openChats}
                                  openChat={this.openChat}
                                  handleClickOpen={this.handleClickOpen}
                                  handleClose={this.handleClose}
                                  classes={this.props.classes}
                                  businessQuery={this.state.businessQuery}
                                  userQuery={this.state.userQuery}
                                  errorMessage={this.state.errorMessage}
                                  assignBusiness={this.assignBusiness}
                                  assignUser={this.assignUser}
                                  handleChange={this.handleChange}
                                  handleArrChange={this.handleArrChange}
                                  handleSelectChange={
                                    this.handleSelectChangeStateObj
                                  }
                                  handleDateChange={this.handleDateChange}
                                  handleToggleServices={
                                    this.handleToggleServices
                                  }
                                  saveInfo={this.saveInfo}
                                  addItem={this.addItem}
                                  removeItem={this.removeItem}
                                  handleItemChange={this.handleItemChange}
                                  handleItemSelectChange={
                                    this.handleItemSelectChange
                                  }
                                  handleToggleItemServices={
                                    this.handleToggleItemServices
                                  }
                                  handleSelectChangeObj={
                                    this.handleSelectChangeObj
                                  }
                                  onAssignPic={this.assignPic}
                                  removePicture={this.removePicture}
                                  toggleFootage={this.toggleFootage}
                                  saveFreight={this.saveFreight}
                                  updateOrigin={this.state.updateOrigin}
                                  updateDestination={
                                    this.state.updateDestination
                                  }
                                  updateThirdParty={this.state.updateThirdParty}
                                  updateFreight={this.state.updateFreight}
                                />
                              )}
                            </Grid>
                            <Grid
                              item
                              container
                              md={12}
                              lg={6}
                              className={classes.chooseDeliveryContainer}
                            >
                              <GridContainer
                                xs={12}
                                justify="center"
                                style={{ maxHeight: 125 }}
                              >
                                <GridItem xs={12}>
                                  <h3 style={{ textAlign: 'center' }}>
                                    <b>
                                      <u>Choose Delivery Type</u>
                                    </b>
                                  </h3>
                                </GridItem>
                              </GridContainer>
                              {this.state.orderData && (
                                <Grid container className={classes.quotesContainer} alignItems='center' spacing={1}>
                                  <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={5}
                                    >
                                      <TextField
                                        label="NEXT FLIGHT OUT :"
                                        id="airQuote"
                                        variant="outlined"
                                        fullWidth
                                        type="text"
                                        onChange={(event) =>
                                          this.handleChange(event)
                                        }
                                        defaultValue={
                                          this.grabData('airQuote')
                                            ? this.grabData('airQuote')
                                            : ''
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      className={classes.dateTimePicker}
                                    >
                                      <p>ETA:</p>
                                      <DatePicker
                                        onChange={e => this.handleQuoteDateTimeChange(e, 'air')}
                                        value={quoteETAs.air ? quoteETAs.air.quoteETA : null}
                                      />
                                    </Grid>
                                    <Grid container item xs>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="startTimeWindow"
                                          className={classes.selectLabel}>
                                          START WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.air ? quoteETAs.air.start : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'air', 'start')}
                                          inputProps={{
                                            id: 'startTimeWindow',
                                            name: 'startTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="endTimeWindow"
                                          className={classes.selectLabel}>
                                          END WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.air ? quoteETAs.air.end : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'air', 'end')}
                                          inputProps={{
                                            id: 'endTimeWindow',
                                            name: 'endTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12}><Divider /></Grid>
                                  <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                    <Grid item xs={12} md={5}>
                                      <Grid container alignItems='center'>
                                        <Grid
                                          item
                                          xs
                                          className={classes.nextDayAutoComplete}
                                        >
                                          <Autocomplete
                                            style={{
                                              height: 80,
                                            }}
                                            value={this.grabData('subDeliveryType')}
                                            onChange={(event, newValue) =>
                                              this.setState({
                                                subDeliveryType: newValue,
                                              })
                                            }
                                            filterOption={filter}
                                            selectOnFocus
                                            handleHomeEndKeys
                                            id="sub-delivery-type"
                                            options={['Next Day Air', 'Air Truck']}
                                            getOptionLabel={(option) => option}
                                            renderOption={(option) => option}
                                            freeSolo
                                            fullWidth
                                            renderInput={(params) => (
                                              <TextField
                                                {...params}
                                                label="NEXT DAY AIR"
                                                variant="outlined"
                                                onChange={(e) =>
                                                  e.target.value &&
                                                  this.setState({
                                                    subDeliveryType: e.target.value,
                                                  })
                                                }
                                              />
                                            )}
                                          />
                                        </Grid>
                                        <Grid
                                          item
                                          xs
                                          className={classes.nextDayTextField}
                                        >
                                          <TextField
                                            style={{
                                              height: 80,
                                            }}
                                            variant="outlined"
                                            label="NEXT DAY AIR $:"
                                            id="cargoAirQuote"
                                            type="text"
                                            fullWidth
                                            onChange={(event) =>
                                              this.handleChange(event)
                                            }
                                            defaultValue={
                                              this.grabData('cargoAirQuote')
                                                ? this.grabData('cargoAirQuote')
                                                : ''
                                            }
                                          />
                                        </Grid>
                                      </Grid>
                                    </Grid>
                                    <Grid
                                      item
                                      className={classes.dateTimePicker}
                                    >
                                      <p>ETA:</p>
                                      <DatePicker
                                        onChange={e => this.handleQuoteDateTimeChange(e, 'cargoAir')}
                                        value={quoteETAs.scheduledAir ? quoteETAs.scheduledAir.quoteETA : null}
                                      />
                                    </Grid>
                                    <Grid container item xs>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="startTimeWindow"
                                          className={classes.selectLabel}>
                                          START WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.scheduledAir ? quoteETAs.scheduledAir.start : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'cargoAir', 'start')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'startTimeWindow',
                                            name: 'startTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="endTimeWindow"
                                          className={classes.selectLabel}>
                                          END WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.scheduledAir ? quoteETAs.scheduledAir.end : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'cargoAir', 'end')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'endTimeWindow',
                                            name: 'endTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12}><Divider /></Grid>
                                  <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={5}
                                    >
                                      <TextField
                                        label="DEDICATED GROUND:"
                                        variant="outlined"
                                        id="groundQuote"
                                        fullWidth
                                        type="text"
                                        onChange={(event) =>
                                          this.handleChange(event)
                                        }
                                        defaultValue={
                                          this.grabData('groundQuote')
                                            ? this.grabData('groundQuote')
                                            : ''
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      className={classes.dateTimePicker}
                                    >
                                      <p>ETA:</p>
                                      <DatePicker
                                        onChange={e => this.handleQuoteDateTimeChange(e, 'ground')}
                                        value={quoteETAs.ground ? quoteETAs.ground.quoteETA : null}
                                      />
                                    </Grid>
                                    <Grid container item xs>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="startTimeWindow"
                                          className={classes.selectLabel}>
                                          START WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.ground ? quoteETAs.ground.start : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'ground', 'start')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'startTimeWindow',
                                            name: 'startTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="endTimeWindow"
                                          className={classes.selectLabel}>
                                          END WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.ground ? quoteETAs.ground.end : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'ground', 'end')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'endTimeWindow',
                                            name: 'endTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12}><Divider /></Grid>
                                  <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={5}
                                    >
                                      <TextField
                                        label="LTL:"
                                        id="autoLtlQuote"
                                        fullWidth
                                        variant="outlined"
                                        type="text"
                                        onChange={(event) =>
                                          this.handleChange(event)
                                        }
                                        defaultValue={
                                          this.grabData('autoLtlQuote')
                                            ? this.grabData('autoLtlQuote')
                                            : ''
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      className={classes.dateTimePicker}
                                    >
                                      <p>ETA:</p>
                                      <DatePicker
                                        onChange={e => this.handleQuoteDateTimeChange(e, 'autoLtl')}
                                        value={quoteETAs.ltl ? quoteETAs.ltl.quoteETA : null}
                                      />
                                    </Grid>
                                    <Grid container item xs>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="startTimeWindow"
                                          className={classes.selectLabel}>
                                          START WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.ltl ? quoteETAs.ltl.start : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'autoLtl', 'start')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'startTimeWindow',
                                            name: 'startTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="endTimeWindow"
                                          className={classes.selectLabel}>
                                          END WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.ltl ? quoteETAs.ltl.end : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'autoLtl', 'end')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'endTimeWindow',
                                            name: 'endTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid item xs={12}><Divider /></Grid>
                                  <Grid container item className={classes.quotesContainer} xs={12} alignItems='center' spacing={2}>
                                    <Grid
                                      item
                                      xs={12}
                                      md={5}
                                    >
                                      <TextField
                                        label="DIRECT LTL:"
                                        variant="outlined"
                                        id="ltlQuote"
                                        fullWidth
                                        type="text"
                                        onChange={(event) =>
                                          this.handleChange(event)
                                        }
                                        defaultValue={
                                          this.grabData('ltlQuote')
                                            ? this.grabData('ltlQuote')
                                            : ''
                                        }
                                      />
                                    </Grid>
                                    <Grid
                                      item
                                      className={classes.dateTimePicker}
                                    >
                                      <p>ETA:</p>
                                      <DatePicker
                                        onChange={e => this.handleQuoteDateTimeChange(e, 'ltl')}
                                        value={quoteETAs.additionalOptions ? quoteETAs.additionalOptions.quoteETA : null}
                                      />
                                    </Grid>
                                    <Grid container item xs>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="startTimeWindow"
                                          className={classes.selectLabel}>
                                          START WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.additionalOptions ? quoteETAs.additionalOptions.start : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'ltl', 'start')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'startTimeWindow',
                                            name: 'startTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                      <FormControl
                                        fullWidth
                                        className={classes.selectFormControl}>
                                        <InputLabel
                                          htmlFor="endTimeWindow"
                                          className={classes.selectLabel}>
                                          END WINDOW
                                        </InputLabel>
                                        <Select
                                          MenuProps={{
                                            className: classes.selectMenu
                                          }}
                                          classes={{
                                            select: classes.select
                                          }}
                                          value={quoteETAs.additionalOptions ? quoteETAs.additionalOptions.end : ''}
                                          onChange={e => this.handleQuoteWindowTimeChange(e, 'ltl', 'end')}
                                          // defaultValue={''}
                                          inputProps={{
                                            id: 'endTimeWindow',
                                            name: 'endTimeWindow'
                                          }}
                                        >
                                          {
                                            this.militaryTime.map((item) => (
                                              <MenuItem
                                                classes={{
                                                  root: classes.selectMenuItem
                                                }}
                                                value={item}
                                                key={item}
                                              >{item}</MenuItem>
                                            ))
                                          }
                                        </Select>
                                      </FormControl>
                                    </Grid>
                                  </Grid>
                                  <Grid
                                    item
                                    xs={12}
                                    style={{ paddingLeft: 10 }}
                                  >
                                    <MaterialButton
                                      style={{
                                        backgroundColor: '#00acc1',
                                        color: '#FFF',
                                      }}
                                      onClick={this.updateQuote}
                                    >
                                      UPDATE QUOTE
                                    </MaterialButton>
                                  </Grid>
                                </Grid>
                              )}
                              <Grid item xs={12} style={{ paddingTop: 10, paddingBottom: 10 }}>
                                <Divider
                                  orientation="horizontal"
                                  variant="fullWidth"
                                />
                              </Grid>

                              <GridItem xs={12}>
                                {this.state.orderData && (
                                  <div>
                                    {!['Booked', 'booked'].includes(
                                      this.state.orderData.status
                                    ) && (
                                        <div>
                                          <b>Next Flight Out Quote:</b>{' '}
                                          <span
                                            style={{
                                              color: 'green',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            $
                                          </span>
                                          {this.state.orderData.airQuote}
                                          <br />
                                          <b>Next Day Air Quote:</b>{' '}
                                          <span
                                            style={{
                                              color: 'green',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            $
                                          </span>
                                          {this.state.orderData.cargoAirQuote}
                                          <br />
                                          <b>Ground Quote:</b>{' '}
                                          <span
                                            style={{
                                              color: 'green',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            $
                                          </span>
                                          {this.state.orderData.groundQuote}
                                          <br />
                                          <b>LTL Quote:</b>{' '}
                                          <span
                                            style={{
                                              color: 'green',
                                              fontWeight: 'bold',
                                            }}
                                          >
                                            $
                                          </span>
                                          {this.state.orderData.autoLtlQuote}
                                          <br />
                                          <b>Direct LTL Quote:</b> $
                                          {this.state.orderData.ltlQuote}
                                          <br />
                                          <b>Mode:</b>{' '}
                                          {this.state.orderData.deliveryType ==
                                            'Air'
                                            ? 'Next Flight Out'
                                            : this.state.orderData.deliveryType ==
                                              'Scheduled Air'
                                              ? 'Next Day Air'
                                              : this.state.orderData.deliveryType ==
                                                'Ground'
                                                ? 'Dedicated Ground'
                                                : this.state.orderData.deliveryType ==
                                                  'Additional Options'
                                                  ? 'Additional Options'
                                                  : 'LTL'}
                                          <br />
                                          <br />
                                          {!['Booked', 'booked'].includes(
                                            this.state.orderData.status
                                          ) &&
                                            this.state.orderData.deliveryType ==
                                            'LTL' ? null : (
                                            <div>
                                              <b>Pick Up Vendor:</b>{' '}
                                              {
                                                this.state.orderData
                                                  .vendorPickUpName
                                              }
                                              <br />
                                              {this.state.orderData
                                                .pickUpDriver ? (
                                                <p>
                                                  {' '}
                                                  <b>Pick Up Driver:</b>{' '}
                                                  {this.state.orderData
                                                    .pickUpDriver.displayName
                                                    ? this.state.orderData
                                                      .pickUpDriver.displayName
                                                    : `${this.state.orderData.pickUpDriver.firstName} ${this.state.orderData.pickUpDriver.lastName}`}
                                                  <br />
                                                </p>
                                              ) : null}
                                              <b>Pick Up Rate:</b> $
                                              {this.state.orderData.pickUpRate}
                                              <br />
                                              <b>Rate Confirmation:</b>{' '}
                                              <span
                                                style={{
                                                  color: this.state.orderData
                                                    .pickUpRateConIsSigned
                                                    ? 'green'
                                                    : 'red',
                                                }}
                                              >
                                                {this.state.orderData
                                                  .pickUpRateConIsSigned
                                                  ? 'confirmed'
                                                  : 'unconfirmed'}
                                              </span>
                                              <br />
                                              <b>Deliver By:</b>{' '}
                                              {this.state.originDeliverBy &&
                                                moment(
                                                  this.state.originDeliverBy.toDate()
                                                ).format('YYYY-MM-DD HH:mm')}
                                              <br />
                                              <br />
                                            </div>
                                          )}
                                          {!['Booked', 'booked'].includes(
                                            this.state.orderData.status
                                          ) &&
                                            this.state.orderData.deliveryType ==
                                            'LTL' && (
                                              <div>
                                                <b>Vendor: Accufrate</b>
                                                <br />
                                                <b>BOL #:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .accufrateBOL
                                                }
                                                <br />
                                                <b>Vendor Rate:</b>{' '}
                                                {this.state.orderData.vendorRate}
                                                <br />
                                                <b>Broker:</b>{' '}
                                                {this.state.orderData.brokerName}
                                                <br />
                                                <b>Broker PRO #:</b>{' '}
                                                {this.state.orderData.brokerPRO}
                                                <br />
                                                <b>Broker Rate:</b>{' '}
                                                {this.state.orderData.brokerRate}
                                                <br />
                                                <b>Carrier:</b>{' '}
                                                {this.state.orderData.carrierName}
                                                <br />
                                                <b>Carrier PRO #:</b>{' '}
                                                {this.state.orderData.carrierPRO}
                                                <br />
                                                <b>Insurance Cost:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .insuranceCost
                                                }
                                                <br />
                                              </div>
                                            )}
                                          {!['Booked', 'booked'].includes(
                                            this.state.orderData.status
                                          ) &&
                                            this.state.orderData.deliveryType ==
                                            'Air' && (
                                              <div>
                                                Airline Drop Time:{' '}
                                                {this.state.orderData
                                                  .dispatchedAt &&
                                                  this.state.orderData.destination
                                                    .deliverBy
                                                  ? moment(deliverBy).format(
                                                    'MM/DD/YYYY HH:mm'
                                                  )
                                                  : ' '}{' '}
                                              </div>
                                            )}
                                          {!['Booked', 'booked'].includes(
                                            this.state.orderData.status
                                          ) &&
                                            this.state.orderData.flight &&
                                            this.state.originAirlineDetails &&
                                            this.state
                                              .destinationAirlineDetails && (
                                              <div>
                                                <b>Airline:</b>{' '}
                                                {this.state.orderData.flight &&
                                                  this.state.orderData.flight
                                                    .airlineName}
                                                <br />
                                                <b>Flight Number:</b>{' '}
                                                {this.state.orderData.flight &&
                                                  `${this.state.orderData.flight.airlineName} ${this.state.orderData.flight.number}`}
                                                <br />
                                                <b>Origin Airport:</b>{' '}
                                                {this.state.orderData.flight &&
                                                  this.state.orderData.flight
                                                    .originAirport}
                                                <br />
                                                <b>
                                                  Origin Airline Address:
                                                </b>{' '}
                                                {this.state.orderData.flight &&
                                                  this.state.orderData.flight
                                                    .originAirlineAddress &&
                                                  this.state.orderData.flight
                                                    .originAirlineAddress}
                                                <br />
                                                <b>Destination Airport:</b>{' '}
                                                {this.state.orderData
                                                  .destinationAirlineDetails &&
                                                  (this.state.orderData
                                                    .destinationAirlineDetails[0] &&
                                                    this.state.orderData
                                                      .destinationAirlineDetails[0]
                                                      .name) +
                                                  ' ' +
                                                  (this.state.orderData
                                                    .destinationAirlineDetails[0] &&
                                                    this.state.orderData
                                                      .destinationAirlineDetails[0]
                                                      .airCodes[0])}
                                                <br />
                                                <b>
                                                  Destination Airline Address:
                                                </b>{' '}
                                                {this.state.orderData
                                                  .destinationAirlineDetails &&
                                                  this.state.orderData
                                                    .destinationAirlineDetails[0] &&
                                                  this.state.orderData
                                                    .destinationAirlineDetails[0]
                                                    .physicalAddress +
                                                  ' ' +
                                                  this.state.orderData
                                                    .destinationAirlineDetails[0]
                                                    .physicalCity +
                                                  ' ' +
                                                  this.state.orderData
                                                    .destinationAirlineDetails[0]
                                                    .physicalZip}
                                                <br />
                                                <b>Booking Number:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .bookingNumber
                                                }
                                                <br />
                                                <b>Air Waybill Number:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .airWaybillNumber
                                                }
                                                <br />
                                                <b>Service Type:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .serviceLevel
                                                }
                                                <br />
                                                <b>Departure Time:</b>{' '}
                                                {this.state.orderData.flight &&
                                                  this.state.orderData.flight
                                                    .departureTime &&
                                                  moment(
                                                    this.state.orderData.flight
                                                      .departureTime.seconds
                                                      ? this.state.orderData.flight.departureTime.toDate()
                                                      : this.state.orderData
                                                        .flight.departureTime
                                                  ).format('MM-DD-YYYY HH:mm')}
                                                <br />
                                                <b>Arrival Time:</b>{' '}
                                                {this.state.orderData.flight &&
                                                  this.state.orderData.flight
                                                    .arrivalTime &&
                                                  moment(
                                                    this.state.orderData.flight.arrivalTime.toDate()
                                                  ).format('MM-DD-YYYY HH:mm')}
                                                <br />
                                                {/* Scheduled Time: {this.state.orderData.flight.movement.scheduledTimeLocal}<br/>
                                                                                    Actual Time: {this.state.orderData.flight.movement.actualTimeLocal}<br/> */}
                                                <b>Air Carrier Expense:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .airCarrierExpense
                                                }
                                                <br />
                                              </div>
                                            )}
                                          {!['Booked', 'booked'].includes(
                                            this.state.orderData.status
                                          ) &&
                                            this.state.orderData &&
                                            this.state.orderData.deliveryType ==
                                            'Scheduled Air' &&
                                            this.state.orderData
                                              .originAirCarrier &&
                                            this.state.orderData
                                              .destinationAirCarrier && (
                                              <div>
                                                <b>Airline:</b>{' '}
                                                {this.state.orderData
                                                  .originAirCarrier &&
                                                  this.state.orderData
                                                    .originAirCarrier
                                                    .businessName}
                                                <br />
                                                <b>Origin Airport:</b>{' '}
                                                {this.state.orderData
                                                  .originAirCarrier &&
                                                  this.state.orderData
                                                    .originAirCarrier.airCode}
                                                <br />
                                                <b>
                                                  Origin Airline Address:
                                                </b>{' '}
                                                {this.state.orderData
                                                  .originAirCarrier &&
                                                  this.state.orderData
                                                    .originAirCarrier.address +
                                                  ' ' +
                                                  this.state.orderData
                                                    .originAirCarrier.city +
                                                  ', ' +
                                                  this.state.orderData
                                                    .originAirCarrier.state +
                                                  ' ' +
                                                  this.state.orderData
                                                    .originAirCarrier.zip}
                                                <br />
                                                <b>Destination Airport:</b>{' '}
                                                {this.state.orderData
                                                  .destinationAirCarrier &&
                                                  this.state.orderData
                                                    .destinationAirCarrier
                                                    .airCode}
                                                <br />
                                                <b>
                                                  Destination Airline Adress:
                                                </b>{' '}
                                                {this.state.orderData
                                                  .destinationAirCarrier &&
                                                  this.state.orderData
                                                    .destinationAirCarrier
                                                    .address +
                                                  ' ' +
                                                  this.state.orderData
                                                    .destinationAirCarrier
                                                    .city +
                                                  ', ' +
                                                  this.state.orderData
                                                    .destinationAirCarrier
                                                    .state +
                                                  ' ' +
                                                  this.state.orderData
                                                    .destinationAirCarrier.zip}
                                                <br />
                                                <b>Booking Number:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .bookingNumber
                                                }
                                                <br />
                                                <b>Air Waybill Number:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .airWaybillNumber
                                                }
                                                <br />
                                                <b>Service Type:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .serviceLevel
                                                }
                                                <br />
                                                <b>Air Carrier Expense:</b>{' '}
                                                {
                                                  this.state.orderData
                                                    .airCarrierExpense
                                                }
                                                <br />
                                                {/* Scheduled Time: {this.state.orderData.flight.movement.scheduledTimeLocal}<br/>
                                                                                    Actual Time: {this.state.orderData.flight.movement.actualTimeLocal}<br/> */}
                                              </div>
                                            )}
                                          {this.state.orderData &&
                                            (this.state.orderData.deliveryType ==
                                              'Ground' ||
                                              this.state.orderData.deliveryType ==
                                              'Additional Options') ? null : (
                                            <div>
                                              <br />
                                              {!['Booked', 'booked'].includes(
                                                this.state.orderData.status
                                              ) &&
                                                this.state.orderData.deliveryType ==
                                                'LTL' ? null : (
                                                <div>
                                                  <b>Drop Off Vendor:</b>{' '}
                                                  {
                                                    this.state.orderData
                                                      .vendorDropOffName
                                                  }
                                                  <br />
                                                  <b>Drop Off Driver:</b>{' '}
                                                  {
                                                    this.state.orderData
                                                      .driverDropOffName
                                                  }
                                                  <br />
                                                  <b>Drop Off Rate:</b> $
                                                  {
                                                    this.state.orderData
                                                      .dropOffRate
                                                  }
                                                  <br />
                                                  <b>Rate Confirmation:</b>{' '}
                                                  <span
                                                    style={{
                                                      color: this.state.orderData
                                                        .dropOffRateConIsSigned
                                                        ? 'green'
                                                        : 'red',
                                                    }}
                                                  >
                                                    {this.state.orderData
                                                      .dropOffRateConIsSigned
                                                      ? 'confirmed'
                                                      : 'unconfirmed'}
                                                  </span>
                                                  <br />
                                                  <b>Pick Up By:</b>{' '}
                                                  {this.state
                                                    .destinationPickUpBy &&
                                                    moment(
                                                      this.state.destinationPickUpBy.toDate()
                                                    ).format('YYYY-MM-DD HH:mm')}
                                                  <br />
                                                </div>
                                              )}
                                            </div>
                                          )}
                                        </div>
                                      )}
                                  </div>
                                )}
                              </GridItem>
                            </Grid>

                            <GridItem xs={12}>
                              <Divider
                                orientation="horizontal"
                                variant="fullWidth"
                              />
                            </GridItem>

                            {/*Routing Module*/}

                            <GridItem xs={12}>
                              <Divider
                                orientation="horizontal"
                                variant="fullWidth"
                              />
                            </GridItem>

                            <GridItem xs={12}>
                              <GridItem xs={6} md={7}>
                                <GridContainer>
                                  {console.log(
                                    'Before prompt',
                                    this.state.promptModal,
                                    this.state.temp
                                  )}
                                  <UserConfirmModal
                                    isOpen={this.state.promptModal}
                                    closeModal={() =>
                                      this.closeModal('promptModal')
                                    }
                                    yesFunc={() => {
                                      this.saveShipmentStatus(
                                        this.state.temp.name,
                                        this.state.temp.value
                                      );
                                      this.closeModal('promptModal');
                                    }}
                                    noFunc={() => {
                                      this.closeModal('promptModal');
                                    }}
                                  >
                                    {this.state.temp && (
                                      <React.Fragment>
                                        <GridItem xs={12}>
                                          <p>
                                            Are you sure you would like to roll
                                            the status back?
                                          </p>
                                        </GridItem>
                                        <GridItem>
                                          <p>
                                            <b>Previous:</b>{' '}
                                            {
                                              this.state.orderData[
                                              this.state.temp.name
                                              ]
                                            }
                                          </p>
                                        </GridItem>
                                        <GridItem>
                                          <p>
                                            <b>New:</b> {this.state.temp.value}
                                          </p>
                                        </GridItem>
                                      </React.Fragment>
                                    )}
                                  </UserConfirmModal>
                                </GridContainer>
                              </GridItem>

                              <br />
                              {this.state.orderData && (
                                <div>
                                  {(this.state.deliveryType == 'Air' ||
                                    this.state.deliveryType ==
                                    'Scheduled Air') && (
                                      <div>
                                        <GridContainer>
                                          <GridItem xs={12} sm={4}>
                                            {this.state.orderData && (
                                              <GridContainer
                                                justify="space-between"
                                                alignItems="center"
                                              >
                                                {/* <GridItem xs={8} md={9}>
                                                                                    <p>Send Reminders to Driver: </p>

                                                                                    </GridItem>
                                                                                    <GridItem xs={4} md={3}>
                                                                                    <Checkbox 
                                                                                      checked={this.state.orderData.sendDriverReminders ? this.state.orderData.sendDriverReminders : false}
                                                                                      onChange={this.textDriver}
                                                                                      inputProps={{ 'aria-label': 'Text drivers checkbox' }}
                                                                                    />
                                                                                    </GridItem> */}
                                              </GridContainer>
                                            )}
                                            Pick Up Driver:
                                            {/* <FormControl
                                                                                    fullWidth
                                                                                    className={classes.selectFormControl}>
                                                                                    <InputLabel
                                                                                      htmlFor="vendorPickUp"
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                    //className={classes.selectLabel}
                                                                                    >
                                                                                      Vendor:
                                                                                    </InputLabel>
                                                                                    <Select
                                                                                      // MenuProps={{
                                                                                      //     className: classes.selectMenu
                                                                                      // }}
                                                                                      // classes={{
                                                                                      //     select: classes.select
                                                                                      // }}
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                      
                                                                                      onChange={this.handleSelectPickUpVendorChange}
                                                                                      value={this.state.vendorPickUp}
                                                                                      inputProps={{
                                                                                        id: 'vendorPickUp',
                                                                                        name: 'vendorPickUp',
                                                                                        
                                                                                      }}
                                                                                    >
                                                                                      {this.state.qualifiedPickUpVendors &&
                                                                                        this.state.qualifiedPickUpVendors.map((item) => (
                                                                                        
                                                                                          <MenuItem
                                                                                            // classes={{
                                                                                            //     root: classes.selectMenuItem
                                                                                            // }}
                                                                                            style={{
                                                                                              color: "#000"
                                                                                            }}
                                                                                            value={item}
                                                                                            key={item}
                                                                                          >{item && item.name}</MenuItem>
                                                                                        ))
                                                                                      }
                                                                                    </Select>
                                                                                  </FormControl> */}
                                            {this.state.vendorPickUp ? (
                                              //   <FormControl
                                              //     fullWidth
                                              //     className={classes.selectFormControl}>
                                              //     <InputLabel
                                              //       htmlFor="driverPickUp"
                                              //       style={{
                                              //         color: "#000"
                                              //       }}
                                              //     //className={classes.selectLabel}
                                              //     >
                                              //       Driver:
                                              //  </InputLabel>
                                              //     <Select
                                              //       // MenuProps={{
                                              //       //     className: classes.selectMenu
                                              //       // }}
                                              //       // classes={{
                                              //       //     select: classes.select
                                              //       // }}
                                              //       style={{
                                              //         color: "#000"
                                              //       }}
                                              //       value={this.state.driver ? this.state.driver : null}
                                              //       onChange={this.handleSelectChange}
                                              //       inputProps={{
                                              //         id: 'driverPickUp',
                                              //         name: 'driverPickUp'
                                              //       }}
                                              //     >
                                              //       {this.state.driversPickUpSTAData &&
                                              //         this.state.driversPickUpSTAData.map((item) => (
                                              //           item.sta &&
                                              //           <MenuItem
                                              //           // classes={{
                                              //           //     root: classes.selectMenuItem
                                              //           // }}
                                              //           style={{
                                              //             color: "#000"
                                              //           }}
                                              //           value={item}
                                              //           key={item}
                                              //         >{item.name}</MenuItem>

                                              //         ))
                                              //       }
                                              //     </Select>

                                              //   </FormControl>

                                              <div>
                                                {this.state.orderData
                                                  .subDeliveryType == 'Air Truck'
                                                  ? !this.state.driverSelected &&
                                                  this.state
                                                    .driversPickUpSTAData &&
                                                  this.state.driversPickUpData.map(
                                                    (item) => (
                                                      <div
                                                        onClick={() =>
                                                          this.selectDriver(
                                                            item
                                                          )
                                                        }
                                                        style={{
                                                          cursor: 'pointer',
                                                        }}
                                                      >
                                                        {item && item.name}
                                                      </div>
                                                    )
                                                  )
                                                  : !this.state.driverSelected &&
                                                  this.state
                                                    .driversPickUpSTAData &&
                                                  this.state.driversPickUpSTAData.map(
                                                    (item) => (
                                                      <div
                                                        onClick={() =>
                                                          this.selectDriver(
                                                            item
                                                          )
                                                        }
                                                        style={{
                                                          cursor: 'pointer',
                                                        }}
                                                      >
                                                        {item &&
                                                          item.firstName +
                                                          ' ' +
                                                          item.lastName}
                                                      </div>
                                                    )
                                                  )}
                                                {/* {!this.state.driverSelected && this.state.driversPickUpSTAData && this.state.driversPickUpSTAData.map(item => (
                                                                                        <div
                                                                                          onClick={() => this.selectDriver(item)}
                                                                                          style={{cursor: "pointer"}}
                                                                                        >
                                                                                          {item && (item.firstName + " " + item.lastName)}
                                                                                        </div>
                                                                                      ))} */}
                                                {/* {!this.state.driverSelected &&
                                                                                        <div>
                                                                                          {this.state.driversPickUpSTAData &&
                                                                                            this.state.driversPickUpSTAData.map((item) => (
                                                                                              
                                                                                            ))
                                                                                          }
                                                                                        </div>
                                                                                      } */}
                                              </div>
                                            ) : null}
                                            <b>
                                              {(this.state.pickUpDriver ||
                                                this.state.orderData
                                                  .pickUpDriver) &&
                                                this.state.pickUpDriver ? (
                                                <React.Fragment>
                                                  {this.state.vendorPickUp &&
                                                    this.state.vendorPickUp.name}
                                                  <br />
                                                  {
                                                    this.state.pickUpDriver
                                                      .firstName
                                                  }{' '}
                                                  {
                                                    this.state.pickUpDriver
                                                      .lastName
                                                  }
                                                </React.Fragment>
                                              ) : (
                                                <React.Fragment>
                                                  {this.state.orderData
                                                    .vendorPickUp &&
                                                    this.state.orderData
                                                      .vendorPickUp.name}
                                                  <br />
                                                  {this.state.orderData
                                                    .pickUpDriver ? (
                                                    <p>
                                                      {this.state.orderData
                                                        .pickUpDriver.displayName
                                                        ? this.state.orderData
                                                          .pickUpDriver
                                                          .displayName
                                                        : `${this.state.orderData.pickUpDriver.firstName} ${this.state.orderData.pickUpDriver.lastName}`}
                                                    </p>
                                                  ) : null}
                                                </React.Fragment>
                                              )}
                                            </b>
                                            {/* <CustomInput
                                                                                    labelText="Origin Radius"
                                                                                    id="originRadius"
                                                                                    formControlProps={{
                                                                                      fullWidth: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                      required: true,
                                                                                      onChange: (event) => this.handleChange(event)
                                                                                    }}
                                                                                  /> */}
                                            {/* {this.state.orderData && 
                                                                                      <CustomInput
                                                                                        labelText="Pick Up Rate"
                                                                                        id="pickUpRate"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: true,
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.pickUpRate ? this.state.orderData.pickUpRate : ''
                                                                                        }}
                                                                                      />
                                                                                    } */}
                                            {/* Deliver By:
                                                                                 {this.state.origin &&
                                                                                  <React.Fragment>
                                                                                    <div>
                                                                                      <DateTimePicker
                                                                                        onChange={(e) => this.handleDateTimeChange(e, "origin")}
                                                                                        value={this.state.orderData.origin.deliverBy && (this.state.orderData.origin.deliverBy.seconds ? this.state.orderData.origin.deliverBy.toDate() : this.state.orderData.origin.deliverBy)}
                                                                                      />
                                                                                    </div>

                                                                                    {!['Booked', 'booked'].includes(this.grabData('status')) && (this.state.pickUpDriver || this.state.orderData.pickUpDriver) && (

                                                                                      <Button
                                                                                        onClick={() => this.pingDriver(this.state.pickUpDriver || this.state.orderData.pickUpDriver, 'pickup')}
                                                                                        color="info"
                                                                                        style={{
                                                                                          marginTop: "20px",
                                                                                          float: "right"
                                                                                        }}
                                                                                      >
                                                                                        PING PICKUP DRIVER
                                                                                      </Button>

                                                                                    )}
                                                                                    
                                                                                    {!['Booked', 'booked'].includes(this.grabData('status')) && this.state.pickUpDriver && !(_.isEqual(this.state.pickUpDriver, this.state.orderData.pickUpDriver)) && this.state.pickUpDriver.id &&

                                                                                      <Button
                                                                                        onClick={() => this.reassignPickUpDriver()}
                                                                                        color="info"
                                                                                        style={{
                                                                                          marginTop: "20px",
                                                                                          float: "right"
                                                                                        }}
                                                                                      >
                                                                                        REASSIGN PICKUP DRIVER
                                                                                      </Button>
                                                                                    
                                                                                    }
                                                                                    {!['Booked', 'booked'].includes(this.grabData('status')) && this.state.vendorPickUp &&
                                                                                      <Button
                                                                                        onClick={() => this.redispatchPickUpVendor()}
                                                                                        color="info"
                                                                                        style={{
                                                                                          marginTop: "20px",
                                                                                          float: "right"
                                                                                        }}
                                                                                      >
                                                                                        REDISPATCH PICK UP VENDOR
                                                                                      </Button>
                                                                                    }
                                                                                    <br />
                                                                                    <Button
                                                                                      onClick={() => this.openChat('vendorPickUp')}
                                                                                      color='info'
                                                                                      style={{
                                                                                        marginTop: "20px",
                                                                                        float: "right"
                                                                                      }}
                                                                                    >
                                                                                      OPEN PICK UP VENDOR CHAT
                                                                                    </Button>
                                                                                    <br />
                                                                                    {this.state.openChats.indexOf('vendorPickUp') > -1 && (
                                                                                      <Chat 
                                                                                        orderID={this.props.orderID}
                                                                                        channel='vendorPickUp'
                                                                                      />
                                                                                    )}
                                                                                    
                                                                                  </React.Fragment>
                                                                                 } */}
                                            {/* <FormControl
                                                                                      fullWidth
                                                                                      className={classes.selectFormControl}>
                                                                                      <InputLabel
                                                                                        htmlFor="deliverBy"
                                                                                        className={classes.selectLabel}>
                                                                                        DELIVER BY
                                                                                </InputLabel>
                                                                                      <Select
                                                                                        MenuProps={{
                                                                                          className: classes.selectMenu
                                                                                        }}
                                                                                        classes={{
                                                                                          select: classes.select
                                                                                        }}
                                                                                        value={this.state.orderData.origin['deliverBy']}
                                                                                        onChange={(e) => this.handleSelectChangeObj(e, 'origin')}
                                                                                        defaultValue={this.state.orderData.origin['deliverBy'] ? this.state.orderData.origin['deliverBy'] : ''}
                                                                                        inputProps={{
                                                                                          id: 'deliverBy',
                                                                                          name: 'deliverBy'
                                                                                        }}
                                                                                      >
                                                                                        {
                                                                                          militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                              classes={{
                                                                                                root: classes.selectMenuItem
                                                                                              }}
                                                                                              value={item}
                                                                                              key={item}
                                                                                            >{item}</MenuItem>
                                                                                          ))
                                                                                        }
                                                                                      </Select>
                                                                                    </FormControl> */}
                                          </GridItem>

                                          <GridItem xs={12} md={4}>
                                            {this.state.deliveryType == 'Air' && (
                                              <CustomInput
                                                labelText="Flight Number #1"
                                                id="number"
                                                formControlProps={{
                                                  fullWidth: true,
                                                }}
                                                labelProps={{
                                                  shrink: true,
                                                }}
                                                inputProps={{
                                                  required: true,
                                                  onChange: (event) =>
                                                    this.handleFlightChange(
                                                      event
                                                    ),
                                                  value: this.grabData('flight')
                                                    ? this.grabData('flight')
                                                      .number
                                                    : '',
                                                }}
                                              />
                                            )}
                                            {this.state.deliveryType ==
                                              'Scheduled Air' && (
                                                <PrototypeExploreAssignUser
                                                  labelText={
                                                    'Search Origin Air Carrier'
                                                  }
                                                  collection={'haney-vendors'}
                                                  vendorSelector={true}
                                                  id={'originBusinessQuery'}
                                                  onChange={this.handleChange}
                                                  value={
                                                    this.state.originBusinessQuery
                                                      ? this.state
                                                        .originBusinessQuery
                                                      : ''
                                                  }
                                                  assignUser={
                                                    this.assignOriginAirCarrier
                                                  }
                                                  stateObj={this.state.arrString}
                                                />
                                              )}

                                            {/* {this.state.orderData && (
                                            <Button onClick={() => this.sendDE(this.state.orderData)} color='primary'>TEST EMAILS</Button>
                                              )} */}
                                            {this.state.deliveryType ==
                                              'Scheduled Air' &&
                                              this.grabData('originAirCarrier') &&
                                              (Object.keys(
                                                this.grabData('originAirCarrier')
                                              ).length
                                                ? this.grabData(
                                                  'originAirCarrier'
                                                )['businessName']
                                                : null)}
                                            {this.state.deliveryType ==
                                              'Scheduled Air' && (
                                                <PrototypeExploreAssignUser
                                                  labelText={
                                                    'Search Destination Air Carrier'
                                                  }
                                                  collection={'haney-vendors'}
                                                  vendorSelector={true}
                                                  id={'destinationBusinessQuery'}
                                                  onChange={this.handleChange}
                                                  value={
                                                    this.state
                                                      .destinationBusinessQuery
                                                      ? this.state
                                                        .destinationBusinessQuery
                                                      : ''
                                                  }
                                                  assignUser={
                                                    this.assignDestinationAirCarrier
                                                  }
                                                  stateObj={this.state.arrString}
                                                />
                                              )}
                                            {this.state.deliveryType ==
                                              'Scheduled Air' &&
                                              this.grabData(
                                                'destinationAirCarrier'
                                              ) &&
                                              (Object.keys(
                                                this.grabData(
                                                  'destinationAirCarrier'
                                                )
                                              ).length
                                                ? this.grabData(
                                                  'destinationAirCarrier'
                                                )['businessName']
                                                : null)}

                                            <CustomInput
                                              labelText="Booking #"
                                              id="bookingNumber"
                                              formControlProps={{
                                                fullWidth: true,
                                              }}
                                              labelProps={{
                                                shrink: true,
                                              }}
                                              inputProps={{
                                                required: false,
                                                onChange: (event) =>
                                                  this.handleChange(event),
                                                defaultValue: this.state.orderData
                                                  .bookingNumber
                                                  ? this.state.orderData
                                                    .bookingNumber
                                                  : '',
                                              }}
                                            />
                                            <CustomInput
                                              labelText="Air Waybill #"
                                              id="airWaybillNumber"
                                              formControlProps={{
                                                fullWidth: true,
                                              }}
                                              labelProps={{
                                                shrink: true,
                                              }}
                                              inputProps={{
                                                required: false,
                                                onChange: (event) =>
                                                  this.handleChange(event),
                                                defaultValue: this.state.orderData
                                                  .airWaybillNumber
                                                  ? this.state.orderData
                                                    .airWaybillNumber
                                                  : '',
                                              }}
                                            />
                                            <CustomInput
                                              labelText="Service Level"
                                              id="serviceLevel"
                                              formControlProps={{
                                                fullWidth: true,
                                              }}
                                              labelProps={{
                                                shrink: true,
                                              }}
                                              inputProps={{
                                                required: true,
                                                onChange: (event) =>
                                                  this.handleChange(event),
                                                defaultValue: this.state.orderData
                                                  .serviceLevel
                                                  ? this.state.orderData
                                                    .serviceLevel
                                                  : '',
                                              }}
                                            />
                                            <CustomInput
                                              labelText="Carrier Expense"
                                              id="airCarrierExpense"
                                              formControlProps={{
                                                fullWidth: true,
                                              }}
                                              labelProps={{
                                                shrink: true,
                                              }}
                                              inputProps={{
                                                required: true,
                                                onChange: (event) =>
                                                  this.handleChange(event),
                                                defaultValue: this.state.orderData
                                                  .airCarrierExpense
                                                  ? this.state.orderData
                                                    .airCarrierExpense
                                                  : '',
                                              }}
                                            />
                                            {this.state.orderData
                                              .subDeliveryType == 'Air Truck' ||
                                              this.state.orderData.deliveryType ==
                                              'Scheduled Air' ? (
                                              <div />
                                            ) : (
                                              <div>
                                                {![
                                                  'originAirport',
                                                  'number',
                                                  'destinationAirport',
                                                  'arrivalTime',
                                                  'departureTime',
                                                ].every(
                                                  (v) =>
                                                    this.grabData('flight') &&
                                                    Object.keys(
                                                      this.grabData('flight')
                                                    ).includes(v)
                                                ) && (
                                                    <React.Fragment>
                                                      <CustomInput
                                                        labelText="Origin Airport"
                                                        id="originAirort"
                                                        formControlProps={{
                                                          fullWidth: true,
                                                        }}
                                                        labelProps={{
                                                          shrink: true,
                                                        }}
                                                        inputProps={{
                                                          required: false,
                                                          onChange: (event) =>
                                                            this.handleFlightChange(
                                                              event
                                                            ),
                                                          defaultValue: this.grabData(
                                                            'flight'
                                                          )
                                                            ? this.grabData(
                                                              'flight'
                                                            ).originAirport
                                                            : '',
                                                        }}
                                                      />
                                                      Departs at{' '}
                                                      <DateTimePicker
                                                        onChange={(e) =>
                                                          this.handleFlightDateTimeChange(
                                                            e,
                                                            'departureTime'
                                                          )
                                                        }
                                                        value={
                                                          this.grabData('flight')
                                                            ? this.grabData(
                                                              'flight'
                                                            )
                                                              .departureTime instanceof
                                                              Date
                                                              ? this.grabData(
                                                                'flight'
                                                              ).departureTime
                                                              : this.grabData(
                                                                'flight'
                                                              ).departureTime
                                                                ? this.grabData(
                                                                  'flight'
                                                                ).departureTime.toDate()
                                                                : null
                                                            : null
                                                        }
                                                      />
                                                      <CustomInput
                                                        labelText="Destination Airport"
                                                        id="destinationAirport"
                                                        formControlProps={{
                                                          fullWidth: true,
                                                        }}
                                                        labelProps={{
                                                          shrink: true,
                                                        }}
                                                        inputProps={{
                                                          required: false,
                                                          onChange: (event) =>
                                                            this.handleFlightChange(
                                                              event
                                                            ),
                                                          defaultValue: this.grabData(
                                                            'flight'
                                                          )
                                                            ? this.grabData(
                                                              'flight'
                                                            ).destinationAirport
                                                            : '',
                                                        }}
                                                      />
                                                      Arrives at{' '}
                                                      <DateTimePicker
                                                        onChange={(e) =>
                                                          this.handleFlightDateTimeChange(
                                                            e,
                                                            'arrivalTime'
                                                          )
                                                        }
                                                        value={
                                                          this.grabData('flight')
                                                            ? this.grabData(
                                                              'flight'
                                                            )
                                                              .arrivalTimFe instanceof
                                                              Date
                                                              ? this.grabData(
                                                                'flight'
                                                              ).arrivalTime
                                                              : this.grabData(
                                                                'flight'
                                                              ).arrivalTime
                                                                ? this.grabData(
                                                                  'flight'
                                                                ).arrivalTime.toDate()
                                                                : null
                                                            : null
                                                        }
                                                      />
                                                      <Button
                                                        onClick={() =>
                                                          this.findFlightInfo()
                                                        }
                                                        color="info"
                                                      >
                                                        FIND FLIGHT INFO
                                                      </Button>
                                                    </React.Fragment>
                                                  )}

                                                {!this.grabData(
                                                  'additionalLegs'
                                                ) ||
                                                  (this.grabData(
                                                    'additionalLegs'
                                                  ) &&
                                                    !this.grabData('additionalLegs')
                                                      .length) ? (
                                                  <Button
                                                    color="primary"
                                                    onClick={() => this.addLeg()}
                                                  >
                                                    {console.log()}
                                                    ADD LEG
                                                  </Button>
                                                ) : null}
                                              </div>
                                            )}
                                          </GridItem>
                                          <GridItem xs={12} sm={4}>
                                            Drop Off Driver
                                            <FormControl
                                              fullWidth
                                              className={
                                                classes.selectFormControl
                                              }
                                            >
                                              <InputLabel
                                                htmlFor="vendorDropOff"
                                                style={{
                                                  color: '#000',
                                                }}
                                              //className={classes.selectLabel}
                                              >
                                                Vendor:
                                              </InputLabel>
                                              <Select
                                                // MenuProps={{
                                                //     className: classes.selectMenu
                                                // }}
                                                // classes={{
                                                //     select: classes.select
                                                // }}
                                                style={{
                                                  color: '#000',
                                                }}
                                                value={this.state.vendorDropOff}
                                                onChange={
                                                  this
                                                    .handleSelectDropOffVendorChange
                                                }
                                                inputProps={{
                                                  id: 'vendorDropOff',
                                                  name: 'vendorDropOff',
                                                }}
                                              >
                                                {this.state
                                                  .qualifiedDropOffVendors &&
                                                  this.state.qualifiedDropOffVendors.map(
                                                    (item) => (
                                                      <MenuItem
                                                        // classes={{
                                                        //     root: classes.selectMenuItem
                                                        // }}
                                                        style={{
                                                          color: '#000',
                                                        }}
                                                        value={item}
                                                        key={item}
                                                      >
                                                        {item &&
                                                          item.name +
                                                          ' - ' +
                                                          item.physicalCity +
                                                          ', ' +
                                                          item.airCodes[0]}
                                                      </MenuItem>
                                                    )
                                                  )}
                                              </Select>
                                            </FormControl>
                                            {this.state.vendorDropOff ? (
                                              //   <FormControl
                                              //     fullWidth
                                              //     className={classes.selectFormControl}>
                                              //     <InputLabel
                                              //       htmlFor="driverDropOff"
                                              //       style={{
                                              //         color: "#000"
                                              //       }}
                                              //     //className={classes.selectLabel}
                                              //     >
                                              //       Driver:
                                              //  </InputLabel>
                                              //     <Select
                                              //       // MenuProps={{
                                              //       //     className: classes.selectMenu
                                              //       // }}
                                              //       // classes={{
                                              //       //     select: classes.select
                                              //       // }}
                                              //       style={{
                                              //         color: "#000"
                                              //       }}
                                              //       value={this.state.driver}
                                              //       onChange={this.handleSelectChange}
                                              //       inputProps={{
                                              //         id: 'driverDropOff',
                                              //         name: 'driverDropOff'
                                              //       }}
                                              //     >
                                              //       {this.state.driversDropOffData &&
                                              //         this.state.driversDropOffData.map((item) => (
                                              //           <MenuItem
                                              //             // classes={{
                                              //             //     root: classes.selectMenuItem
                                              //             // }}
                                              //             style={{
                                              //               color: "#000"
                                              //             }}
                                              //             value={item}
                                              //             key={item}
                                              //           >{item.name}</MenuItem>
                                              //         ))
                                              //       }
                                              //     </Select>
                                              //     <CustomInput
                                              //   labelText="Drop Off Rate"
                                              //   id="dropOffRate"
                                              //   formControlProps={{
                                              //     fullWidth: true
                                              //   }}
                                              //   inputProps={{
                                              //     required: true,
                                              //     onChange: (event) => this.handleChange(event)
                                              //   }}
                                              // />
                                              //   </FormControl>
                                              <div>
                                                {!this.state
                                                  .dropOffDriverSelected && (
                                                    <div>
                                                      {this.state
                                                        .driversDropOffData &&
                                                        this.state.driversDropOffData.map(
                                                          (item) => (
                                                            <div
                                                              onClick={() =>
                                                                this.selectDropOffDriver(
                                                                  item
                                                                )
                                                              }
                                                              style={{
                                                                cursor: 'pointer',
                                                              }}
                                                            >
                                                              {item &&
                                                                (item.firstName
                                                                  ? item.firstName +
                                                                  ' ' +
                                                                  item.lastName
                                                                  : item.name)}
                                                            </div>
                                                          )
                                                        )}
                                                    </div>
                                                  )}
                                              </div>
                                            ) : null}
                                            <b>
                                              {(this.state.dropOffDriver ||
                                                this.state.orderData
                                                  .dropOffDriver) &&
                                                (this.state.dropOffDriver ? (
                                                  <React.Fragment>
                                                    {
                                                      this.state.vendorDropOff
                                                        .name
                                                    }
                                                    <br />
                                                    {
                                                      this.state.dropOffDriver
                                                        .firstName
                                                    }{' '}
                                                    {
                                                      this.state.dropOffDriver
                                                        .lastName
                                                    }
                                                  </React.Fragment>
                                                ) : (
                                                  <React.Fragment>
                                                    {
                                                      this.state.orderData
                                                        .vendorDropOff.name
                                                    }
                                                    <br />
                                                    {
                                                      this.state.orderData
                                                        .dropOffDriver.firstName
                                                    }{' '}
                                                    {
                                                      this.state.orderData
                                                        .dropOffDriver.lastName
                                                    }
                                                  </React.Fragment>
                                                ))}
                                            </b>
                                            <CustomInput
                                              labelText="Drop Off Rate"
                                              id="dropOffRate"
                                              formControlProps={{
                                                fullWidth: true,
                                              }}
                                              inputProps={{
                                                required: true,
                                                onChange: (event) =>
                                                  this.handleChange(event),
                                                defaultValue: this.state.orderData
                                                  .dropOffRate
                                                  ? this.state.orderData
                                                    .dropOffRate
                                                  : '',
                                              }}
                                            />
                                            Pick Up By:
                                            {this.state.destination && (
                                              <React.Fragment>
                                                <div>
                                                  <DateTimePicker
                                                    onChange={(e) =>
                                                      this.handleDateTimeChange(
                                                        e,
                                                        'destination'
                                                      )
                                                    }
                                                    value={
                                                      this.state.orderData
                                                        .destination.deliverBy &&
                                                      (this.state.orderData
                                                        .destination.deliverBy
                                                        .seconds
                                                        ? this.state.orderData.destination.deliverBy.toDate()
                                                        : this.state.orderData
                                                          .destination
                                                          .deliverBy)
                                                    }
                                                  />
                                                </div>
                                                {!['Booked', 'booked'].includes(
                                                  this.grabData('status')
                                                ) &&
                                                  (this.state.dropOffDriver ||
                                                    this.state.orderData
                                                      .dropOffDriver) && (
                                                    <Button
                                                      onClick={() =>
                                                        this.pingDriver(
                                                          this.state
                                                            .dropOffDriver ||
                                                          this.state.orderData
                                                            .dropOffDriver,
                                                          'dropoff'
                                                        )
                                                      }
                                                      color="info"
                                                      style={{
                                                        marginTop: '20px',
                                                        float: 'right',
                                                      }}
                                                    >
                                                      PING DROPOFF DRIVER
                                                    </Button>
                                                  )}
                                                {!['Booked', 'booked'].includes(
                                                  this.grabData('status')
                                                ) &&
                                                  this.state.dropOffDriver &&
                                                  !_.isEqual(
                                                    this.state.dropOffDriver,
                                                    this.state.orderData
                                                      .dropOffDriver
                                                  ) &&
                                                  this.state.dropOffDriver.id && (
                                                    <Button
                                                      onClick={() =>
                                                        this.reassignDropOffDriver()
                                                      }
                                                      color="info"
                                                      style={{
                                                        marginTop: '20px',
                                                        float: 'right',
                                                      }}
                                                    >
                                                      REASSIGN DROP OFF DRIVER
                                                    </Button>
                                                  )}
                                                {!['Booked', 'booked'].includes(
                                                  this.grabData('status')
                                                ) &&
                                                  this.state.vendorDropOff && (
                                                    <Button
                                                      onClick={() =>
                                                        this.redispatchDropOffVendor()
                                                      }
                                                      color="info"
                                                      style={{
                                                        marginTop: '20px',
                                                        float: 'right',
                                                      }}
                                                    >
                                                      REDISPATCH DROP OFF VENDOR
                                                    </Button>
                                                  )}
                                                <br />
                                                <Button
                                                  onClick={() =>
                                                    this.openChat('vendorDropOff')
                                                  }
                                                  color="info"
                                                  style={{
                                                    marginTop: '20px',
                                                    float: 'right',
                                                  }}
                                                >
                                                  OPEN DROP OFF VENDOR CHAT
                                                </Button>
                                                <br />
                                                {this.state.openChats.indexOf(
                                                  'vendorDropOff'
                                                ) > -1 && (
                                                    <Chat
                                                      orderID={this.props.orderID}
                                                      channel="vendorDropOff"
                                                    />
                                                  )}
                                              </React.Fragment>
                                            )}
                                            {/* <FormControl
                                                                                      fullWidth
                                                                                      className={classes.selectFormControl}>
                                                                                      <InputLabel
                                                                                        htmlFor="deliverBy"
                                                                                        className={classes.selectLabel}>
                                                                                        PICK UP BY
                                                                                </InputLabel>
                                                                                      <Select
                                                                                        MenuProps={{
                                                                                          className: classes.selectMenu
                                                                                        }}
                                                                                        classes={{
                                                                                          select: classes.select
                                                                                        }}
                                                                                        value={this.state.orderData.origin['deliverBy']}
                                                                                        onChange={(e) => this.handleSelectChangeObj(e, 'destination')}
                                                                                        defaultValue={this.state.orderData.origin['deliverBy'] ? this.state.orderData.origin['deliverBy'] : ''}
                                                                                        inputProps={{
                                                                                          id: 'deliverBy',
                                                                                          name: 'deliverBy'
                                                                                        }}
                                                                                      >
                                                                                        {
                                                                                          militaryTime.map((item) => (
                                                                                            <MenuItem
                                                                                              classes={{
                                                                                                root: classes.selectMenuItem
                                                                                              }}
                                                                                              value={item}
                                                                                              key={item}
                                                                                            >{item}</MenuItem>
                                                                                          ))
                                                                                        }
                                                                                      </Select>
                                                                                    </FormControl> */}
                                          </GridItem>
                                        </GridContainer>
                                        <GridContainer justify="center">
                                          <GridItem xs={6}>
                                            <GridContainer>
                                              {this.state.flightFlights &&
                                                this.state.flightFlights.map(
                                                  (flight) =>
                                                    flight.error ? (
                                                      <p>No flights found</p>
                                                    ) : (
                                                      <GridItem
                                                        xs={12}
                                                        onClick={() =>
                                                          this.selectFlight(
                                                            flight
                                                          )
                                                        }
                                                      >
                                                        <FlightCard
                                                          flight={flight}
                                                          isSelected={false}
                                                        />
                                                      </GridItem>
                                                    )
                                                )}
                                            </GridContainer>
                                          </GridItem>
                                        </GridContainer>
                                        {[
                                          'originAirport',
                                          'number',
                                          'destinationAirport',
                                          'arrivalTime',
                                          'departureTime',
                                        ].every(
                                          (v) =>
                                            this.grabData('flight') &&
                                            Object.keys(
                                              this.grabData('flight')
                                            ).includes(v)
                                        ) && (
                                            <GridContainer justify="center">
                                              <GridItem xs={6}>
                                                <FlightCard
                                                  flight={this.grabData('flight')}
                                                  isSelected={true}
                                                  clearFlight={this.clearFlight}
                                                />
                                              </GridItem>
                                            </GridContainer>
                                          )}
                                        {this.grabData('additionalLegs') &&
                                          this.grabData('additionalLegs').length ? (
                                          <GridContainer justify="center">
                                            <GridItem xs={6}>
                                              <GridContainer>
                                                {console.log(
                                                  this.grabData('additionalLegs')
                                                )}
                                                {this.grabData(
                                                  'additionalLegs'
                                                ).map((leg, i) => (
                                                  <GridItem xs={12}>
                                                    <p>Flight {i + 2}:</p>
                                                    Departure Time:
                                                    <DateTimePicker
                                                      onChange={(e) =>
                                                        this.handleAdditionalLegDateTimeChange(
                                                          e,
                                                          'departureTime',
                                                          i
                                                        )
                                                      }
                                                      value={
                                                        this.grabData(
                                                          'additionalLegs'
                                                        )[i]
                                                          .departureTime instanceof
                                                          Date
                                                          ? this.grabData(
                                                            'additionalLegs'
                                                          )[i].departureTime
                                                          : this.grabData(
                                                            'additionalLegs'
                                                          )[i].departureTime
                                                            ? this.grabData(
                                                              'additionalLegs'
                                                            )[
                                                              i
                                                            ].departureTime.toDate()
                                                            : null
                                                      }
                                                    />
                                                    {/* <FormControl
                                                                                            fullWidth
                                                                                            className={classes.selectFormControl}>
                                                                                            <InputLabel
                                                                                              htmlFor="vendor"
                                                                                              style={{
                                                                                                color: "#000"
                                                                                              }}
                                                                                              //className={classes.selectLabel}
                                                                                            >
                                                                                              Vendor:
                                                                                            </InputLabel>
                                                                                            <Select
                                                                                              // MenuProps={{
                                                                                              //     className: classes.selectMenu
                                                                                              // }}
                                                                                              // classes={{
                                                                                              //     select: classes.select
                                                                                              // }}
                                                                                              style={{
                                                                                                color: "#000"
                                                                                              }}
                                                                                              value={this.grabData('additionalLegs') ? this.grabData('additionalLegs').vendor: ''}
                                                                                              onChange={(e) => this.handleAdditionalLegsChange(e, i)}
                                                                                              inputProps={{
                                                                                                id: 'vendor',
                                                                                                name: 'vendor'
                                                                                              }}
                                                                                            >
                                                                                              {this.state.vendorsData &&
                                                                                                this.state.vendorsData.map((item) => (
                                                                                                  <MenuItem
                                                                                                    // classes={{
                                                                                                    //     root: classes.selectMenuItem
                                                                                                    // }}
                                                                                                    style={{
                                                                                                      color: "#000"
                                                                                                    }}
                                                                                                    value={item}
                                                                                                    key={item}
                                                                                                  >{item && item.name}</MenuItem>
                                                                                                ))
                                                                                              }
  
                                                                                            </Select>
                                                                                          </FormControl> */}
                                                    {this.grabData(
                                                      'additionalLegs'
                                                    )[i].vendor && (
                                                        <b>
                                                          {
                                                            this.grabData(
                                                              'additionalLegs'
                                                            )[i].vendor.name
                                                          }{' '}
                                                          {
                                                            this.grabData(
                                                              'additionalLegs'
                                                            )[i].vendor.airCodes[0]
                                                          }
                                                        </b>
                                                      )}
                                                    <React.Fragment>
                                                      <CustomInput
                                                        labelText="Flight Number"
                                                        id="number"
                                                        formControlProps={{
                                                          fullWidth: true,
                                                        }}
                                                        labelProps={{
                                                          shrink: true,
                                                        }}
                                                        inputProps={{
                                                          onChange: (event) =>
                                                            this.handleAdditionalLegsChange(
                                                              event,
                                                              i
                                                            ),
                                                          value: this.grabData(
                                                            'additionalLegs'
                                                          )[i]
                                                            ? this.grabData(
                                                              'additionalLegs'
                                                            )[i].number
                                                            : '',
                                                        }}
                                                      />
                                                      <CustomInput
                                                        labelText="Origin Airport"
                                                        id="originAirport"
                                                        formControlProps={{
                                                          fullWidth: true,
                                                        }}
                                                        labelProps={{
                                                          shrink: true,
                                                        }}
                                                        inputProps={{
                                                          required: false,
                                                          onChange: (event) =>
                                                            this.handleAdditionalLegsChange(
                                                              event,
                                                              i
                                                            ),
                                                          value: this.grabData(
                                                            'additionalLegs'
                                                          )[i]
                                                            ? this.grabData(
                                                              'additionalLegs'
                                                            )[i].originAirport
                                                            : '',
                                                        }}
                                                      />
                                                      Arrives at{' '}
                                                      <DateTimePicker
                                                        onChange={(e) =>
                                                          this.handleAdditionalLegDateTimeChange(
                                                            e,
                                                            'arrivalTime',
                                                            i
                                                          )
                                                        }
                                                        value={
                                                          this.grabData(
                                                            'additionalLegs'
                                                          )[i]
                                                            .arrivalTime instanceof
                                                            Date
                                                            ? this.grabData(
                                                              'additionalLegs'
                                                            )[i].arrivalTime
                                                            : this.grabData(
                                                              'additionalLegs'
                                                            )[i].arrivalTime
                                                              ? this.grabData(
                                                                'additionalLegs'
                                                              )[
                                                                i
                                                              ].arrivalTime.toDate()
                                                              : null
                                                        }
                                                      />
                                                      <CustomInput
                                                        labelText="Destination Airport"
                                                        id="destinationAirport"
                                                        formControlProps={{
                                                          fullWidth: true,
                                                        }}
                                                        labelProps={{
                                                          shrink: true,
                                                        }}
                                                        inputProps={{
                                                          required: false,
                                                          onChange: (event) =>
                                                            this.handleAdditionalLegsChange(
                                                              event,
                                                              i
                                                            ),
                                                          value: this.grabData(
                                                            'additionalLegs'
                                                          )[i]
                                                            ? this.grabData(
                                                              'additionalLegs'
                                                            )[i]
                                                              .destinationAirport
                                                            : '',
                                                        }}
                                                      />
                                                      <Button
                                                        onClick={() =>
                                                          this.findAdditionalLegInfo(
                                                            i
                                                          )
                                                        }
                                                        color="info"
                                                      >
                                                        FIND FLIGHT INFO
                                                      </Button>
                                                      {this.state[
                                                        `leg${i}Flights`
                                                      ] &&
                                                        this.state[
                                                          `leg${i}Flights`
                                                        ].map((flight) =>
                                                          flight.error ? (
                                                            <p>
                                                              No flights found
                                                            </p>
                                                          ) : (
                                                            <div
                                                              onClick={() =>
                                                                this.selectAdditionalLegs(
                                                                  flight,
                                                                  i
                                                                )
                                                              }
                                                            >
                                                              <FlightCard
                                                                flight={flight}
                                                                isSelected={false}
                                                              />
                                                            </div>
                                                          )
                                                        )}
                                                      {[
                                                        'originAirport',
                                                        'number',
                                                        'destinationAirport',
                                                        'arrivalTime',
                                                        'departureTime',
                                                      ].every((v) =>
                                                        Object.keys(
                                                          this.grabData(
                                                            'additionalLegs'
                                                          )[i]
                                                        ).includes(v)
                                                      ) && (
                                                          <FlightCard
                                                            flight={
                                                              this.grabData(
                                                                'additionalLegs'
                                                              )[0]
                                                            }
                                                            isSelected={true}
                                                            clearFlight={
                                                              this
                                                                .clearAdditionalLeg
                                                            }
                                                          />
                                                        )}
                                                    </React.Fragment>
                                                  </GridItem>
                                                ))}
                                              </GridContainer>
                                            </GridItem>
                                            <GridItem xs={12} />
                                            <GridItem>
                                              <Button
                                                color="primary"
                                                onClick={this.addLeg}
                                              >
                                                ADD LEG
                                              </Button>
                                            </GridItem>
                                            <GridItem>
                                              <Button
                                                color="primary"
                                                onClick={this.removeLeg}
                                              >
                                                REMOVE LEG
                                              </Button>
                                            </GridItem>
                                          </GridContainer>
                                        ) : null}

                                        {/* {this.state.leg1 &&
                                                                                <div>
                                                                                  Transfer Driver #1:
                                                                                  <GridContainer>
                                                                                    <GridItem xs={6} sm={6}>
                                                                                      <FormControl
                                                                                        fullWidth
                                                                                        className={classes.selectFormControl}>
                                                                                        <InputLabel
                                                                                          htmlFor="vendorTransfer1"
                                                                                          style={{
                                                                                            color: "#000"
                                                                                          }}
                                                                                        //className={classes.selectLabel}
                                                                                        >
                                                                                          Vendor:
                                                                                       </InputLabel>
                                                                                        <Select
                                                                                          // MenuProps={{
                                                                                          //     className: classes.selectMenu
                                                                                          // }}
                                                                                          // classes={{
                                                                                          //     select: classes.select
                                                                                          // }}
                                                                                          style={{
                                                                                            color: "#000"
                                                                                          }}
                                                                                          value={this.state.vendorTransfer1}
                                                                                          onChange={this.handleSelectChange}
                                                                                          inputProps={{
                                                                                            id: 'vendorTransfer1',
                                                                                            name: 'vendorTransfer1'
                                                                                          }}
                                                                                        >
                                                                                          {this.state.vendorsData &&
                                                                                            this.state.vendorsData.map((item) => (
                                                                                              <MenuItem
                                                                                                // classes={{
                                                                                                //     root: classes.selectMenuItem
                                                                                                // }}
                                                                                                style={{
                                                                                                  color: "#000"
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                              >{item && item.name}</MenuItem>
                                                                                            ))
                                                                                          }
                                                                                        </Select>
                                                                                        <CustomInput
                                                                                    labelText="Drop Off Rate"
                                                                                    id="dropOffRate"
                                                                                    formControlProps={{
                                                                                      fullWidth: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                      required: true,
                                                                                      onChange: (event) => this.handleChange(event)
                                                                                    }}
                                                                                  />
                                                                                      </FormControl>
                                                                                    </GridItem>
                                                                                    {this.state.vendorTransfer1 ?
                                                                                      <GridItem xs={6} sm={6}>
                                                                                        <FormControl
                                                                                          fullWidth
                                                                                          className={classes.selectFormControl}>
                                                                                          <InputLabel
                                                                                            htmlFor="driverTransfer1"
                                                                                            style={{
                                                                                              color: "#000"
                                                                                            }}
                                                                                          //className={classes.selectLabel}
                                                                                          >
                                                                                            Driver:
                                                                                   </InputLabel>
                                                                                          <Select
                                                                                            // MenuProps={{
                                                                                            //     className: classes.selectMenu
                                                                                            // }}
                                                                                            // classes={{
                                                                                            //     select: classes.select
                                                                                            // }}
                                                                                            style={{
                                                                                              color: "#000"
                                                                                            }}
                                                                                            value={this.state.driver}
                                                                                            onChange={this.handleSelectChange}
                                                                                            inputProps={{
                                                                                              id: 'driverTransfer1',
                                                                                              name: 'driverTransfer1'
                                                                                            }}
                                                                                          >
                                                                                            {this.state.driversPickUpData &&
                                                                                              this.state.driversPickUpData.map((item) => (
                                                                                                <MenuItem
                                                                                                  // classes={{
                                                                                                  //     root: classes.selectMenuItem
                                                                                                  // }}
                                                                                                  style={{
                                                                                                    color: "#000"
                                                                                                  }}
                                                                                                  value={item}
                                                                                                  key={item}
                                                                                                >{item && (item.firstName + " " + item.lastName)}</MenuItem>
                                                                                              ))
                                                                                            }
                                                                                          </Select>
                                                                                        </FormControl>
                                                                                      </GridItem>
                                     
                                                                                      : null}
                                     
                                                                                  </GridContainer>
                                                                                  <GridContainer>
                                                                                    <GridItem xs={12}>
                                                                                      <CustomInput
                                                                                        labelText="Flight Number #2"
                                                                                        id="flightNumber2"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: true,
                                                                                          onChange: (event) => this.handleChange(event)
                                                                                        }}
                                                                                      />
                                     
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <Button
                                                                                        color="primary"
                                                                                        onClick={() => this.addLeg2()}
                                                                                      >
                                                                                        ADD LEG
                                                                            </Button>
                                     
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <Button
                                                                                        color="info"
                                                                                        onClick={() => this.removeLeg2()}
                                                                                      >
                                                                                        REMOVE LEG
                                                                            </Button>
                                     
                                                                                    </GridItem>
                                     
                                                                                  </GridContainer>
                                                                                </div>
                                                                              } */}
                                      </div>
                                    )}

                                  {(this.state.deliveryType == 'Ground' ||
                                    this.state.deliveryType ==
                                    'Additional Options') && (
                                      <div>
                                        <GridContainer>
                                          <GridItem xs={12} sm={4}>
                                            {/* {this.state.orderData && (
                                                                                    <GridContainer justify='space-between' alignItems='center'>
                                                                                      <GridItem xs={8} md={9}>
                                                                                      <p>Send Reminders to Driver: </p>

                                                                                      </GridItem>
                                                                                      <GridItem xs={4} md={3}>
                                                                                      <Checkbox 
                                                                                        checked={this.state.orderData.sendDriverReminders ? this.state.orderData.sendDriverReminders : false}
                                                                                        onChange={this.textDriver}
                                                                                        inputProps={{ 'aria-label': 'Text drivers checkbox' }}
                                                                                      />
                                                                                      </GridItem>
                                                                                    </GridContainer>
                                                                                )}
                                                                              <FormControl
                                                                                    fullWidth
                                                                                    className={classes.selectFormControl}>
                                                                                    <InputLabel
                                                                                      htmlFor="vendorPickUp"
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                    //className={classes.selectLabel}
                                                                                    >
                                                                                      Pick Up Vendor:
                                                                                       </InputLabel>
                                                                                    <Select
                                                                                      // MenuProps={{
                                                                                      //     className: classes.selectMenu
                                                                                      // }}
                                                                                      // classes={{
                                                                                      //     select: classes.select
                                                                                      // }}
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                      value={this.state.vendorPickUp}
                                                                                      onChange={this.handleSelectPickUpVendorChange}
                                                                                      inputProps={{
                                                                                        id: 'vendorPickUp',
                                                                                        name: 'vendorPickUp'
                                                                                      }}
                                                                                    >
                                                                                       {this.state.qualifiedGroundPickUpVendors &&
                                                                                        this.state.qualifiedGroundPickUpVendors.map((item) => (
                                                                                          <MenuItem
                                                                                            // classes={{
                                                                                            //     root: classes.selectMenuItem
                                                                                            // }}
                                                                                            style={{
                                                                                              color: "#000"
                                                                                            }}
                                                                                            value={item}
                                                                                            key={item}
                                                                                          >{item && item.name}</MenuItem>
                                                                                        ))
                                                                                      }
                                                                                    </Select>
                                                                                  </FormControl>
                                                        */}
                                            {this.state.vendorPickUp &&
                                              (this.state.deliveryType ==
                                                'Ground' ||
                                                this.state.deliveryType ==
                                                'Additional Options') ? (
                                              //   <FormControl
                                              //     fullWidth
                                              //     className={classes.selectFormControl}>
                                              //     <InputLabel
                                              //       htmlFor="driverPickUp"
                                              //       style={{
                                              //         color: "#000"
                                              //       }}
                                              //     //className={classes.selectLabel}
                                              //     >
                                              //       Driver:
                                              //  </InputLabel>
                                              //     <Select
                                              //       // MenuProps={{
                                              //       //     className: classes.selectMenu
                                              //       // }}
                                              //       // classes={{
                                              //       //     select: classes.select
                                              //       // }}
                                              //       style={{
                                              //         color: "#000"
                                              //       }}
                                              //       value={this.state.driver ? this.state.driver : null}
                                              //       onChange={this.handleSelectChange}
                                              //       inputProps={{
                                              //         id: 'driverPickUp',
                                              //         name: 'driverPickUp'
                                              //       }}
                                              //     >
                                              //       {this.state.driversPickUpSTAData &&
                                              //         this.state.driversPickUpSTAData.map((item) => (
                                              //           item.sta &&
                                              //           <MenuItem
                                              //           // classes={{
                                              //           //     root: classes.selectMenuItem
                                              //           // }}
                                              //           style={{
                                              //             color: "#000"
                                              //           }}
                                              //           value={item}
                                              //           key={item}
                                              //         >{item.name}</MenuItem>

                                              //         ))
                                              //       }
                                              //     </Select>

                                              //   </FormControl>

                                              <div>
                                                {!this.state.driverSelected &&
                                                  this.state.driversPickUpData &&
                                                  this.state.driversPickUpData.map(
                                                    (item) => (
                                                      <div
                                                        onClick={() =>
                                                          this.selectDriver(item)
                                                        }
                                                        style={{
                                                          cursor: 'pointer',
                                                        }}
                                                      >
                                                        {item && item.name}
                                                      </div>
                                                    )
                                                  )}
                                              </div>
                                            ) : null}
                                            <b>
                                              {(this.state.pickUpDriver ||
                                                this.state.orderData
                                                  .pickUpDriver) &&
                                                (this.state.pickUpDriver ? (
                                                  <React.Fragment>
                                                    {this.state.vendorPickUp.name}
                                                    <br />
                                                    {
                                                      this.state.pickUpDriver
                                                        .firstName
                                                    }{' '}
                                                    {
                                                      this.state.pickUpDriver
                                                        .lastName
                                                    }
                                                  </React.Fragment>
                                                ) : (
                                                  <React.Fragment>
                                                    {
                                                      this.state.orderData
                                                        .vendorPickUp.name
                                                    }
                                                    <br />
                                                    {this.state.orderData
                                                      .pickUpDriver ? (
                                                      <p>
                                                        {this.state.orderData
                                                          .pickUpDriver
                                                          .displayName
                                                          ? this.state.orderData
                                                            .pickUpDriver
                                                            .displayName
                                                          : `${this.state.orderData.pickUpDriver.firstName} ${this.state.orderData.pickUpDriver.lastName}`}
                                                      </p>
                                                    ) : null}
                                                  </React.Fragment>
                                                ))}
                                            </b>
                                            {/* <CustomInput
                                                                                    labelText="Pick Up Rate"
                                                                                    id="pickUpRate"
                                                                                    formControlProps={{
                                                                                      fullWidth: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                      required: true,
                                                                                      onChange: (event) => this.handleChange(event),
                                                                                      defaultValue: this.state.orderData.pickUpRate ? this.state.orderData.pickUpRate : ''
                                                                                    }}
                                                                                  />
                                                                                    Deliver By:
                                                                                    {this.state.origin &&
                                                                                    <React.Fragment>
                                                                                      <div>
                                                                                  
                                                                                        <DateTimePicker
                                                                                            onChange={(e) => this.handleDateTimeChange(e, "origin")}
                                                                                            value={deliverBy}
                                                                                          />
                                                                                      </div>
                                                                                      {!['Booked', 'booked'].includes(this.grabData('status')) && (this.state.pickUpDriver || this.state.orderData.pickUpDriver) && (

                                                                                        <Button
                                                                                          onClick={() => this.pingDriver(this.state.pickUpDriver || this.state.orderData.pickUpDriver, 'pickup')}
                                                                                          color="info"
                                                                                          style={{
                                                                                            marginTop: "20px",
                                                                                            float: "right"
                                                                                          }}
                                                                                        >
                                                                                          PING PICKUP DRIVER
                                                                                        </Button>

                                                                                      )}
                                                                                      {!['Booked', 'booked'].includes(this.grabData('status')) && this.state.pickUpDriver && !(_.isEqual(this.state.pickUpDriver, this.state.orderData.pickUpDriver)) && this.state.pickUpDriver.id &&

                                                                                        <Button
                                                                                          onClick={() => this.reassignPickUpDriver()}
                                                                                          color="info"
                                                                                          style={{
                                                                                            marginTop: "20px",
                                                                                            float: "right"
                                                                                          }}
                                                                                        >
                                                                                          REASSIGN PICKUP DRIVER
                                                                                        </Button>

                                                                                      }
                                                                                      {!['Booked', 'booked'].includes(this.grabData('status')) && this.state.vendorPickUp &&
                                                                                        <Button
                                                                                          onClick={() => this.redispatchPickUpVendor()}
                                                                                          color="info"
                                                                                          style={{
                                                                                            marginTop: "20px",
                                                                                            float: "right"
                                                                                          }}
                                                                                        >
                                                                                          REDISPATCH PICK UP VENDOR
                                                                                        </Button>
                                                                                      }
                                                                                      <br />
                                                                                      <Button
                                                                                        onClick={() => this.openChat('vendorPickUp')}
                                                                                        color='info'
                                                                                        style={{
                                                                                          marginTop: "20px",
                                                                                          float: "right"
                                                                                        }}
                                                                                      >
                                                                                        OPEN PICK UP VENDOR CHAT
                                                                                      </Button>
                                                                                      <br />
                                                                                      {this.state.openChats.indexOf('vendorPickUp') > -1 && (
                                                                                        <Chat 
                                                                                          orderID={this.props.orderID}
                                                                                          channel='vendorPickUp'
                                                                                        />
                                                                                      )}
                                                                                    </React.Fragment>
                                                    
                                                                                 } */}
                                            {/* {this.state.vendorPickUp ?
                                                                                    <FormControl
                                                                                      fullWidth
                                                                                      className={classes.selectFormControl}>
                                                                                      <InputLabel
                                                                                        htmlFor="driverPickUp"
                                                                                        style={{
                                                                                          color: "#000"
                                                                                        }}
                                                                                      //className={classes.selectLabel}
                                                                                      >
                                                                                        Driver:
                                                                                   </InputLabel>
                                                                                      <Select
                                                                                        // MenuProps={{
                                                                                        //     className: classes.selectMenu
                                                                                        // }}
                                                                                        // classes={{
                                                                                        //     select: classes.select
                                                                                        // }}
                                                                                        style={{
                                                                                          color: "#000"
                                                                                        }}
                                                                                        value={this.state.driver}
                                                                                        onChange={this.handleSelectChange}
                                                                                        inputProps={{
                                                                                          id: 'driverPickUp',
                                                                                          name: 'driverPickUp'
                                                                                        }}
                                                                                      >
                                                                                        {this.state.driversPickUpData &&
                                                                                          this.state.driversPickUpData.map((item) => (
                                                                                            <MenuItem
                                                                                              // classes={{
                                                                                              //     root: classes.selectMenuItem
                                                                                              // }}
                                                                                              style={{
                                                                                                color: "#000"
                                                                                              }}
                                                                                              value={item}
                                                                                              key={item}
                                                                                            >{item.name}</MenuItem>
                                                                                          ))
                                                                                        }
                                                                                      </Select>
                                                                                      <CustomInput
                                                                                    labelText="Pick Up Rate"
                                                                                    id="pickUpRate"
                                                                                    formControlProps={{
                                                                                      fullWidth: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                      required: true,
                                                                                      onChange: (event) => this.handleChange(event)
                                                                                    }}/>
                                                                                    </FormControl>
                                     
                                                                                    : null} */}
                                          </GridItem>
                                        </GridContainer>
                                      </div>
                                    )}

                                  {this.state.deliveryType == 'LTL' && (
                                    <div>
                                      <GridContainer>
                                        <GridItem xs={12} sm={4}>
                                          {/* {this.state.vendorPickUp ?
                                                                                    <FormControl
                                                                                      fullWidth
                                                                                      className={classes.selectFormControl}>
                                                                                      <InputLabel
                                                                                        htmlFor="driverPickUp"
                                                                                        style={{
                                                                                          color: "#000"
                                                                                        }}
                                                                                      //className={classes.selectLabel}
                                                                                      >
                                                                                        Driver:
                                                                                   </InputLabel>
                                                                                      <Select
                                                                                        // MenuProps={{
                                                                                        //     className: classes.selectMenu
                                                                                        // }}
                                                                                        // classes={{
                                                                                        //     select: classes.select
                                                                                        // }}
                                                                                        style={{
                                                                                          color: "#000"
                                                                                        }}
                                                                                        value={this.state.driver}
                                                                                        onChange={this.handleSelectChange}
                                                                                        inputProps={{
                                                                                          id: 'driverPickUp',
                                                                                          name: 'driverPickUp'
                                                                                        }}
                                                                                      >
                                                                                        {this.state.driversPickUpData &&
                                                                                          this.state.driversPickUpData.map((item) => (
                                                                                            <MenuItem
                                                                                              // classes={{
                                                                                              //     root: classes.selectMenuItem
                                                                                              // }}
                                                                                              style={{
                                                                                                color: "#000"
                                                                                              }}
                                                                                              value={item}
                                                                                              key={item}
                                                                                            >{item.name}</MenuItem>
                                                                                          ))
                                                                                        }
                                                                                      </Select> */}

                                          {/* </FormControl>
                                     
                                                                                    : null} */}
                                        </GridItem>
                                        {/* <GridItem xs={12} md={4}>
                                                                                  <CustomInput
                                                                                    labelText="Terminal Number #1"
                                                                                    id="terminalID"
                                                                                    formControlProps={{
                                                                                      fullWidth: true
                                                                                    }}
                                                                                    inputProps={{
                                                                                      required: true,
                                                                                      onChange: (event) => this.handleChange(event)
                                                                                    }}
                                                                                  />
                                                                                  <Button
                                                                                    color="primary"
                                                                                    onClick={() => this.addLeg()}
                                                                                  >
                                                                                    ADD LEG
                                                                            </Button>
                                                                                </GridItem> */}
                                        <GridItem xs={12} sm={4}>
                                          {/* <FormControl
                                                                                    fullWidth
                                                                                    className={classes.selectFormControl}>
                                                                                    <InputLabel
                                                                                      htmlFor="vendorDropOff"
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                    //className={classes.selectLabel}
                                                                                    >
                                                                                      Vendor:
                                                                                       </InputLabel>
                                                                                    <Select
                                                                                      // MenuProps={{
                                                                                      //     className: classes.selectMenu
                                                                                      // }}
                                                                                      // classes={{
                                                                                      //     select: classes.select
                                                                                      // }}
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                      value={this.state.vendorDropOff}
                                                                                      onChange={this.handleSelectChange}
                                                                                      inputProps={{
                                                                                        id: 'vendorDropOff',
                                                                                        name: 'vendorDropOff'
                                                                                      }}
                                                                                    >
                                                                                      {this.state.vendorsData &&
                                                                                        this.state.vendorsData.map((item) => (
                                                                                          <MenuItem
                                                                                            // classes={{
                                                                                            //     root: classes.selectMenuItem
                                                                                            // }}
                                                                                            style={{
                                                                                              color: "#000"
                                                                                            }}
                                                                                            value={item}
                                                                                            key={item}
                                                                                          >{item.name}</MenuItem>
                                                                                        ))
                                                                                      }
                                                                                    </Select> */}
                                          Pick Up Driver:
                                          {/* <FormControl
                                                                                    fullWidth
                                                                                    className={classes.selectFormControl}>
                                                                                    <InputLabel
                                                                                      htmlFor="vendorPickUp"
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                    //className={classes.selectLabel}
                                                                                    >
                                                                                      Vendor:
                                                                                       </InputLabel>
                                                                                    <Select
                                                                                      // MenuProps={{
                                                                                      //     className: classes.selectMenu
                                                                                      // }}
                                                                                      // classes={{
                                                                                      //     select: classes.select
                                                                                      // }}
                                                                                      style={{
                                                                                        color: "#000"
                                                                                      }}
                                                                                      value={this.state.vendorPickUp}
                                                                                      onChange={this.handleSelectChange}
                                                                                      inputProps={{
                                                                                        id: 'vendorPickUp',
                                                                                        name: 'vendorPickUp'
                                                                                      }}
                                                                                    >
                                                                                      {this.state.qualifiedGroundPickUpVendors &&
                                                                                        this.state.qualifiedGroundPickUpVendors.map((item) => (
                                                                                          <MenuItem
                                                                                            // classes={{
                                                                                            //     root: classes.selectMenuItem
                                                                                            // }}
                                                                                            style={{
                                                                                              color: "#000"
                                                                                            }}
                                                                                            value={item}
                                                                                            key={item}
                                                                                          >{item.name}</MenuItem>
                                                                                        ))
                                                                                      }
                                                                                    </Select>
                                                                                  </FormControl> */}
                                          <CustomInput
                                            labelText="Accufrate BOL #"
                                            id="accufrateBOL"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .accufrateBOL
                                                ? this.state.orderData
                                                  .accufrateBOL
                                                : '',
                                            }}
                                          />
                                          <CustomInput
                                            labelText="Accufrate Rate"
                                            id="vendorRate"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .vendorRate
                                                ? this.state.orderData
                                                  .vendorRate
                                                : '',
                                            }}
                                          />
                                          <CustomInput
                                            labelText="Broker Name"
                                            id="brokerName"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .brokerName
                                                ? this.state.orderData
                                                  .brokerName
                                                : '',
                                            }}
                                          />
                                          <CustomInput
                                            labelText="Broker PRO #"
                                            id="brokerPRO"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .brokerPRO
                                                ? this.state.orderData.brokerPRO
                                                : '',
                                            }}
                                          />
                                          <CustomInput
                                            labelText="Broker Rate"
                                            id="brokerRate"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .brokerRate
                                                ? this.state.orderData
                                                  .brokerRate
                                                : '',
                                            }}
                                          />
                                          <CustomInput
                                            labelText="Carrier Name"
                                            id="carrierName"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .carrierName
                                                ? this.state.orderData
                                                  .carrierName
                                                : '',
                                            }}
                                          />
                                          <CustomInput
                                            labelText="Carrier PRO #"
                                            id="carrierPRO"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .carrierPRO
                                                ? this.state.orderData
                                                  .carrierPRO
                                                : '',
                                            }}
                                          />
                                          <CustomInput
                                            labelText="Insurance Cost"
                                            id="insuranceCost"
                                            formControlProps={{
                                              fullWidth: true,
                                            }}
                                            inputProps={{
                                              required: true,
                                              onChange: (event) =>
                                                this.handleChange(event),
                                              defaultValue: this.state.orderData
                                                .insuranceCost
                                                ? this.state.orderData
                                                  .insuranceCost
                                                : '',
                                            }}
                                          />
                                          Deliver By:
                                          {this.state.origin && (
                                            <div>
                                              <DateTimePicker
                                                onChange={(e) =>
                                                  this.handleDateTimeChange(
                                                    e,
                                                    'origin'
                                                  )
                                                }
                                                value={deliverBy}
                                              />
                                            </div>
                                          )}
                                          <Button
                                            color="primary"
                                            onClick={this.saveLTLData}
                                          >
                                            SAVE
                                          </Button>
                                          {/* </FormControl> */}
                                        </GridItem>
                                      </GridContainer>
                                    </div>
                                  )}
                                </div>
                              )}
                            </GridItem>

                            <Card xs={12} elevation={3}>
                              {this.state.orderData && (
                                <GridContainer>
                                  <GridItem
                                    xs={6}
                                    style={{
                                      backgroundColor:
                                        this.state.orderData.deliveryType ==
                                          'Air'
                                          ? '#efe6e6'
                                          : null,
                                    }}
                                    onClick={() => this.deliveryType('Air')}
                                  >
                                    <h4>
                                      <b>
                                        NEXT FLIGHT OUT:{' '}
                                        <span style={{ color: 'red' }}>
                                          ${this.state.orderData.airQuote}
                                        </span>
                                      </b>
                                    </h4>
                                    <p>
                                      ETA:{' '}
                                      {quoteETAs.air && moment(quoteETAs.air.quoteETA).format('MM-DD-YYYY HH:ss')}
                                    </p>
                                    <div />
                                  </GridItem>
                                  <GridItem
                                    xs={6}
                                    style={{
                                      backgroundColor: this.state.orderData.deliveryType == 'Scheduled Air' ? '#efe6e6' : null,
                                    }}
                                    onClick={() => this.deliveryType('Scheduled Air')}
                                  >
                                    <h4>
                                      <b>
                                        {this.state.orderData.subDeliveryType ? this.state.orderData.subDeliveryType.toUpperCase() : 'NEXT DAY AIR'}
                                        :{' '}
                                        <span style={{ color: 'red' }}>
                                          ${this.state.orderData.cargoAirQuote}
                                        </span>
                                      </b>
                                    </h4>
                                    <p>
                                      ETA:{' '}
                                      {quoteETAs.scheduledAir && moment(quoteETAs.scheduledAir.quoteETA).format('MM-DD-YYYY HH:ss')}
                                    </p>

                                    <div />
                                  </GridItem>
                                  <GridItem
                                    xs={4}
                                    style={{
                                      backgroundColor:
                                        this.state.orderData.deliveryType ==
                                          'Ground'
                                          ? '#efe6e6'
                                          : null,
                                    }}
                                    onClick={() => this.deliveryType('Ground')}
                                  >
                                    <h4>
                                      <b>
                                        DEDICATED GROUND:{' '}
                                        <span style={{ color: 'red' }}>
                                          ${this.state.orderData.groundQuote}
                                        </span>
                                      </b>
                                    </h4>
                                    <p>
                                      ETA:{' '}
                                      {quoteETAs.ground && moment(quoteETAs.ground.quoteETA).format('MM-DD-YYYY HH:ss')}
                                    </p>
                                  </GridItem>
                                  <GridItem
                                    xs={4}
                                    onClick={() => this.deliveryType('LTL')}
                                    style={{
                                      backgroundColor:
                                        this.state.orderData.deliveryType ==
                                          'LTL'
                                          ? '#efe6e6'
                                          : null,
                                    }}
                                  >
                                    <h4>
                                      <b>
                                        LTL:
                                        <span style={{ color: 'red' }}>
                                          ${this.state.orderData.autoLtlQuote}
                                        </span>
                                      </b>{' '}
                                    </h4>
                                    <p>
                                      ETA:{' '}
                                      {quoteETAs.ltl && moment(quoteETAs.ltl.quoteETA).format('MM-DD-YYYY HH:ss')}
                                    </p>
                                  </GridItem>
                                  <GridItem
                                    xs={4}
                                    onClick={() =>
                                      this.deliveryType('Additional Options')
                                    }
                                    style={{
                                      backgroundColor:
                                        this.state.orderData.deliveryType ==
                                          'Additional Options'
                                          ? '#efe6e6'
                                          : null,
                                    }}
                                  >
                                    <h4>
                                      <b>
                                        DIRECT LTL:
                                        <span style={{ color: 'red' }}>
                                          ${this.state.orderData.ltlQuote}
                                        </span>
                                      </b>{' '}
                                    </h4>
                                    <p>
                                      ETA:{' '}
                                      {quoteETAs.additionalOptions && moment(quoteETAs.additionalOptions.quoteETA).format('MM-DD-YYYY HH:ss')}
                                    </p>
                                  </GridItem>
                                </GridContainer>
                              )}
                            </Card>
                          </GridContainer>
                          <GridContainer>
                            <GridItem xs={10} />
                            <GridItem xs={2}>
                              {this.state.documentsLoading ? (
                                <p>Documents are being created...</p>
                              ) : null}
                              {this.state.documentsLoading
                                ? [
                                  ...Array(
                                    this.state.documentsLoading
                                  ).keys(),
                                ].map((doc, i) => (
                                  <React.Fragment>
                                    <Check
                                      style={{
                                        color:
                                          this.state.documentsLoaded > i
                                            ? 'green'
                                            : 'initial',
                                      }}
                                    />
                                    <br />
                                  </React.Fragment>
                                ))
                                : null}
                            </GridItem>
                            <GridItem xs={12}>
                              {this.state.redispatchAllVendorsUI &&
                                'Redispatching all vendors'}
                              {this.state.orderData &&
                                !['Booked', 'booked'].includes(
                                  this.state.orderData.status
                                ) &&
                                this.state.vendorDropOff &&
                                this.state.vendorPickUp && (
                                  <Button
                                    onClick={() => this.redispatchAllVendors()}
                                    color="info"
                                    style={{
                                      marginTop: '20px',
                                      float: 'right',
                                    }}
                                  >
                                    REDISPATCH ALL VENDORS
                                  </Button>
                                )}

                              {
                                this.state.orderData &&
                                !['Booked', 'booked'].includes(
                                  this.state.orderData.status
                                ) &&
                                this.state.redispatchDropOffVendorUI &&
                                'Redispatching drop off vendor'
                              }
                             
                      <b>Enable E-sign:</b>
                      <FormControlLabel
                        control={
                          <Switch
                            checked={this.state.esignEnabled}
                            onChange={this.handleSwitchChange("esignEnabled")}
                            value="esignEnabled"
                            classes={{
                              switchBase: classes.switchBase,
                              checked: classes.switchChecked,
                              icon: classes.switchIcon,
                              iconChecked: classes.switchIconChecked,
                              bar: classes.switchBar,
                            }}
                          />
                        }
                        classes={{
                          label: classes.label,
                        }}
                        style={{ marginLeft: "10px" }}
                      />
                   

                              {this.state.orderData && this.state.orderData.deliveryType !== 'LTL' ? (
                                <Button
                                  onClick={() => this.regenerateBOL()}
                                  color="primary"
                                  style={{
                                    marginTop: "20px",
                                    float: "right"
                                  }}
                                >
                                  GENERATE BOL
                                </Button>
                              ) : null}
                              <p style={{
                                marginTop: "20px",
                                float: "right"
                              }}>
                                {this.state.regenerate && "Generating BOL"}
                              </p>


                              {/* <Button
                                  onClick={() => this.handleSubmit()}
                                  color="primary"
                                  style={{
                                    marginTop: "20px",
                                    float: "right"
                                  }}
                                >
                                  DISPATCH
                                     </Button> */}
                            </GridItem>
                          </GridContainer>

                          <GridItem
                            xs={12}
                            style={{
                              marginTop: '20px',
                              marginBottom: '15px',
                              textAlign: 'center',
                            }}
                          >
                            <h3>SEARCH FLIGHTS</h3>
                            <Switch
                              checked={this.state.isFlight}
                              onChange={this.handleFlightToggle}
                              classes={{
                                switchBase: classes.switchBase,
                                checked: classes.switchChecked,
                                icon: classes.switchIcon,
                                iconChecked: classes.switchIconChecked,
                                bar: classes.switchBar,
                              }}
                            />
                          </GridItem>
                          {console.log('feather', this.state)}

                          <Collapse in={this.state.isFlight}>
                            <GridItem
                              xs={12}
                              style={{
                                justifyContent: 'center',
                                marginTop: '25px',
                              }}
                            >
                              {this.state.orderData && (
                                <Card
                                  xs={6}
                                  elevation={3}
                                  style={{ margin: 'auto' }}
                                >
                                  <FlightSearchForm
                                    onSelectFlight={this.selectFlight}
                                    onSelectAdditionalLegs={
                                      this.selectAdditionalLegs
                                    }
                                    flight1={this.grabData('flight')}
                                    extraFlights={
                                      this.state.additionalLegs
                                        ? this.state.additionalLegs
                                        : this.state.orderData.additionalLegs
                                          ? this.state.orderData.additionalLegs
                                          : []
                                    }
                                    clearFlight={this.clearFlight}
                                    clearAdditionalLeg={this.clearAdditionalLeg}
                                  />
                                </Card>
                              )}
                            </GridItem>
                          </Collapse>

                          <GridItem xs={12}>
                            <Divider
                              variant="fullWidth"
                              orientation="horizontal"
                            />
                          </GridItem>

                          <GridContainer xs={12}>
                            <GridItem xs={12}>
                              {pathname == '/completed-orders' ? null : (
                                <GridContainer xs={12}>
                                  {this.state.orderData && (
                                    <GridContainer xs={12}>
                                      <GridItem xs={12} md={8}>
                                        <gridItem
                                          xs={6}
                                          style={{ textAlign: 'center' }}
                                        >
                                          <h3>Documents</h3>
                                        </gridItem>

                                        <GridContainer>
                                          {this.state.orderData
                                            .pickUpRateConHash && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .pickUpRateConURL &&
                                                    this.state.orderData
                                                      .pickUpRateConURL
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="info">
                                                    {' '}
                                                    SIGN PICK UP RATE CONFIRMATION
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          {this.state.orderData
                                            .pickUpRateConHash && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={`https://api.eversign.com/api/download_current_document_status?access_key=${this.state.dispatchedBeforeEversign ? 'a74f3d4d2ca030cf60500f7814618064&business_id=141252' : '751efbc709ec4ace1d6ff70a062b7243&business_id=246480'}&document_hash=${this.state.orderData.pickUpRateConHash}&audit_trail=1`}
                                                  target="_blank"
                                                >
                                                  <Button color="success">
                                                    {' '}
                                                    PRINT PICK UP RATE
                                                    CONFIRMATION
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          {this.state.orderData
                                            .dropOffRateConHash && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .dropOffRateConURL &&
                                                    this.state.orderData
                                                      .dropOffRateConURL
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="info">
                                                    {' '}
                                                    SIGN DROP OFF RATE
                                                    CONFIRMATION
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}

                                          {this.state.orderData
                                            .dropOffRateConHash && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={`https://api.eversign.com/api/download_current_document_status?access_key=${this.state.dispatchedBeforeEversign ? 'a74f3d4d2ca030cf60500f7814618064&business_id=141252' : '751efbc709ec4ace1d6ff70a062b7243&business_id=246480'}&document_hash=${this.state.orderData.dropOffRateConHash}&audit_trail=1`}
                                                  target="_blank"
                                                >
                                                  <Button color="success">
                                                    {' '}
                                                    PRINT DROP OFF RATE
                                                    CONFIRMATION
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}


                                          {!this.state.orderData
                                            .shipperBOLIsSigned &&
                                            this.state.orderData
                                              .signingURLs && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .signingURLs &&
                                                    this.state.orderData
                                                      .signingURLs[0]
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="info">
                                                    SIGN{' '}
                                                    {this.state.orderData
                                                      .deliveryType == 'Air' ||
                                                      this.state.orderData
                                                        .deliveryType ==
                                                      'Scheduled Air'
                                                      ? 'House Waybill'
                                                      : 'Bill of Lading'}{' '}
                                                    AS SHIPPER
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          {!this.state.orderData
                                            .driverBOLIsSigned &&
                                            this.state.orderData
                                              .signingURLs && (
                                              <GridItem xs={12}>
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .signingURLs &&
                                                    this.state.orderData
                                                      .signingURLs[1]
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="info">
                                                    SIGN{' '}
                                                    {this.state.orderData
                                                      .deliveryType == 'Air' ||
                                                      this.state.orderData
                                                        .deliveryType ==
                                                      'Scheduled Air'
                                                      ? 'House Waybill'
                                                      : 'Bill of Lading'}{' '}
                                                    AS DRIVER
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}
                                          {!this.state.orderData
                                            .consigneeBOLIsSigned &&
                                            this.state.orderData
                                              .signingURLs && (
                                              <GridItem xs={12}>
                                                <a
                                                  target="_blank"
                                                  href={
                                                    this.state.orderData
                                                      .signingURLs &&
                                                    this.state.orderData
                                                      .signingURLs[2]
                                                  }
                                                >
                                                  <Button color="info">
                                                    SIGN{' '}
                                                    {this.state.orderData
                                                      .deliveryType == 'Air' ||
                                                      this.state.orderData
                                                        .deliveryType ==
                                                      'Scheduled Air'
                                                      ? 'House Waybill'
                                                      : 'Bill of Lading'}{' '}
                                                    AS CONSIGNEE
                                                  </Button>
                                                </a>
                                              </GridItem>
                                            )}

                                            <GridItem xs={12}>
                                              <a
                                                href={this.state.orderData.bolHashURL}
                                                target="_blank"
                                              >
                                                <Button color="success">
                                                  {' '}
                                                  PRINT{' '}
                                                  {this.state.orderData
                                                    .deliveryType == 'Air' ||
                                                    this.state.orderData
                                                      .deliveryType ==
                                                    'Scheduled Air'
                                                    ? 'House Waybill'
                                                    : 'Bill of Lading'}
                                                </Button>
                                              </a>
                                            </GridItem>

                                          {!this.state.orderData
                                            .sampleWayBillIsSigned && (
                                              <GridItem xs={12}>
                                                {(this.state.orderData
                                                  .deliveryType == 'Air' ||
                                                  this.state.orderData
                                                    .deliveryType ==
                                                  'Scheduled Air') && (
                                                    <div>
                                                      {this.state.orderData
                                                        .signingSampleWayBill && (
                                                          <a
                                                            href={
                                                              this.state.orderData
                                                                .signingSampleWayBill
                                                            }
                                                            target="_blank"
                                                          >
                                                            <Button color="info">
                                                              SIGN SAMPLE AIRLINE
                                                              WAYBILL
                                                            </Button>
                                                          </a>
                                                        )}
                                                    </div>
                                                  )}
                                              </GridItem>
                                            )}
                                          {this.state.orderData
                                            .sampleWayBillIsSigned &&
                                            this.state.orderData
                                              .sampleWayBillHash && (
                                              <GridItem xs={12}>
                                                <div>
                                                  <a
                                                    href={`https://api.eversign.com/api/download_current_document_status?access_key=${this.state.dispatchedBeforeEversign ? 'a74f3d4d2ca030cf60500f7814618064&business_id=141252' : '751efbc709ec4ace1d6ff70a062b7243&business_id=246480'}&document_hash=${this.state.orderData.sampleWayBillHash}&audit_trail=1`}
                                                    target="_blank"
                                                  >
                                                    <Button color="success">
                                                      {' '}
                                                      PRINT SAMPLE AIRLINE
                                                      WAYBILL
                                                    </Button>
                                                  </a>
                                                </div>
                                              </GridItem>
                                            )}
                                          <GridItem xs={12}>
                                            {!this.state.orderData.origin
                                              .ksms &&
                                              this.state.orderData
                                                .driverIVFURL &&
                                              this.state.orderData
                                                .deliveryType == 'Air' &&
                                              !this.state.orderData
                                                .driverIVFIsSigned && (
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .driverIVFURL
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="info">
                                                    SIGN Shippers Identification
                                                    Validation
                                                  </Button>
                                                </a>
                                              )}
                                          </GridItem>

                                          {/*    <a href={this.state.orderData.staticBOLURL && this.state.orderData.staticBOLURL} target="_blank">
                                              <Button
                                                color="info"
                                              >Static {(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : "Bill of Lading"}</Button>
                                                </a>                           <br/> */}

                                          <GridItem xs={12}>
                                            <div>
                                              {!this.state.orderData.origin
                                                .ksms &&
                                                this.state.orderData
                                                  .driverIVFURL &&
                                                this.state.orderData
                                                  .deliveryType == 'Air' &&
                                                this.state.orderData
                                                  .driverIVFIsSigned && (
                                                  <a
                                                    href={`https://api.eversign.com/api/download_current_document_status?access_key=${this.state.dispatchedBeforeEversign ? 'a74f3d4d2ca030cf60500f7814618064&business_id=141252' : '751efbc709ec4ace1d6ff70a062b7243&business_id=246480'}&document_hash=${this.state.orderData.driverIVF}&audit_trail=1`}
                                                    target="_blank"
                                                  >
                                                    <Button color="success">
                                                      {' '}
                                                      PRINT Shippers
                                                      Identification Validation
                                                    </Button>
                                                  </a>
                                                )}
                                            </div>
                                          </GridItem>

                                          <GridItem xs={12}>
                                            {/* {this.state.orderData.driverPickUpRateConURL &&
                                    <a href={this.state.orderData.driverPickUpRateConURL && this.state.orderData.driverPickUpRateConURL} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Pick-Up Rate Con
                                  </Button>
                                  </a>
                                    } */}
                                            {/* {(this.state.orderData.pickUpRateStatus == "confirmed") ?
                                              <a href={`https://api.eversign.com/api/download_final_document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.orderData.pickUpRateConfirmHash}&audit_trail=1`} target="_blank">
                                                <Button
                                                  color="primary"
                                                >                                              
                                      Pick-Up Rate Con
                                      </Button>
                                    </a>
                                    : null
                                  }

                               
                                    {(this.state.orderData.dropOffRateStatus == "confirmed") ?
                                    <a href={`https://api.eversign.com/api/download_final_document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.orderData.dropOffRateConfirmHash}&audit_trail=1`} target="_blank">
                                      <Button
                                        color="info"
                                      >                                              
                                      Drop-Off Rate Con
                                      </Button>
                                    </a>
                                    : null
                                  }
                                        {(this.state.orderData.status == "Delivered" || this.state.orderData.status == "Completed" || this.state.orderData.status == "completed") ?
                                    <a href={`https://api.eversign.com/api/download_final_document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480&document_hash=${this.state.orderData.bolHash}&audit_trail=1`} target="_blank">
                                      <Button
                                        color="info"
                                      >Completed {(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") ? "House Waybill" : "Bill of Lading"}</Button>
                                    </a>
                                    : null
                                  } */}
                                            {/* {this.state.orderData.delivery && 
                                          <a href={this.state.orderData.delivery && this.state.orderData.delivery.BOLPICS[0]} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                             Proof of Delivery
                                  </Button>
                                          </a>
                                          }
                                          {(this.state.orderData.deliveryType == "Air" || this.state.orderData.deliveryType == "Scheduled Air") && 
                                          <div>
                                            {this.state.orderData.signingSampleWaybillURL &&
                                            <a href={this.state.orderData.signingSampleWaybillURL} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Sample Waybill
                                  </Button>
                                          </a>
                                            }
                                          </div>
                                        }
                                          {(!this.state.orderData.origin.ksms && this.state.orderData.driverIVFURL && this.state.orderData.deliveryType == "Air") &&

                                          <a href={this.state.orderData.driverIVFURL} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Shippers Identification Validation
                                          </Button>
                                         </a> 
                                        } */}

                                            {/* {this.state.orderData.signingURLs && 
                                          <a href={this.state.orderData.signingURLs && this.state.orderData.signingURLs[0]} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Shipper BOL
                                  </Button>
                                          </a>
                                        }
                                        {this.state.orderData.signingURLs && 
                                          <a href={this.state.orderData.signingURLs && this.state.orderData.signingURLs[1]} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Driver BOL
                                  </Button>
                                          </a>
                                        }
                                        {this.state.orderData.signingURLs && 
                                          <a href={this.state.orderData.signingURLs && this.state.orderData.signingURLs[2]} target="_blank">
                                            <Button
                                              color="primary"
                                            >
                                              Consignee BOL
                                  </Button>
                                          </a>
                                        } */}
                                            {(!['Booked', 'booked'].includes(
                                              this.state.orderData.status
                                            ) ||
                                              this.state.orderData
                                                .deliveryType !== 'LTL') && (
                                                <a
                                                  href={
                                                    this.state.orderData &&
                                                    'https://cargo-rx-driver.web.app/pages/upload/' +
                                                    this.state.orderData.id +
                                                    '/pickup'
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="primary">
                                                    Pick up Driver APP
                                                  </Button>
                                                </a>
                                              )}

                                            {(!['Booked', 'booked'].includes(
                                              this.state.orderData.status
                                            ) ||
                                              this.state.orderData
                                                .deliveryType !== 'LTL') &&
                                              ![
                                                'Ground',
                                                'Additional Options',
                                              ].includes(
                                                this.state.orderData
                                                  .deliveryType
                                              ) && (
                                                <a
                                                  href={
                                                    this.state.orderData &&
                                                    'https://cargo-rx-driver.web.app/pages/upload/' +
                                                    this.state.orderData.id +
                                                    '/dropoff'
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="primary">
                                                    Drop off Driver APP
                                                  </Button>
                                                  <br />
                                                </a>
                                              )}

                                            {this.state.orderData
                                              .accufrateURL && (
                                                <a
                                                  href={
                                                    this.state.orderData
                                                      .accufrateURL
                                                  }
                                                  target="_blank"
                                                >
                                                  <Button color="primary">
                                                    Accufrate
                                                  </Button>
                                                </a>
                                              )}
                                            {this.state.orderData.labelURL && (
                                              <a
                                                href={
                                                  this.state.orderData.labelURL
                                                }
                                                target="_blank"
                                              >
                                                <Button color="primary">
                                                  Label
                                                </Button>
                                              </a>
                                            )}
                                            {/* <VendorPicUpload onAssignPic={this.assignPic2} label="Accufrate" field="accufrateURL" />
                                          <VendorPicUpload onAssignPic={this.assignPic2} label="Label" field="labelURL" /> */}
                                            {console.log(
                                              'Uploaded Documents: ',
                                              uploadedDocuments
                                            )}
                                            {uploadedDocuments.map((doc, i) => (
                                              <a
                                                href={doc.fileURL}
                                                target="_blank"
                                              >
                                                <Button color="primary">
                                                  {doc.name.includes('.')
                                                    ? doc.name.split('.')[0]
                                                    : doc.name}
                                                  <IconButton
                                                    size="small"
                                                    style={{
                                                      marginLeft: '16px',
                                                      marginRight: '-16px',
                                                    }}
                                                    onClick={(e) =>
                                                      this.deleteDocument(
                                                        doc,
                                                        e
                                                      )
                                                    }
                                                  >
                                                    <Close />
                                                  </IconButton>
                                                </Button>
                                              </a>
                                            ))}
                                            <GridItem xs={12}>
                                              <FormControl
                                                fullWidth
                                                className={
                                                  classes.selectFormControl
                                                }
                                              >
                                                <InputLabel
                                                  ht
                                                  mlFor="document"
                                                  className={
                                                    classes.selectLabel
                                                  }
                                                >
                                                  Document:
                                                </InputLabel>
                                                <Select
                                                  MenuProps={{
                                                    className:
                                                      classes.selectMenu,
                                                  }}
                                                  classes={{
                                                    select: classes.select,
                                                  }}
                                                  value={this.state.document}
                                                  onChange={
                                                    this.handleSelectChange
                                                  }
                                                  defaultValue={
                                                    this.state.document
                                                      ? this.state.document
                                                      : ''
                                                  }
                                                  inputProps={{
                                                    id: 'document',
                                                    name: 'document',
                                                  }}
                                                >
                                                  {documentOptions.map(
                                                    (item) => (
                                                      <MenuItem
                                                        classes={{
                                                          root:
                                                            classes.selectMenuItem,
                                                        }}
                                                        value={item.value}
                                                        key={item.string}
                                                      >
                                                        {item.string}
                                                      </MenuItem>
                                                    )
                                                  )}
                                                </Select>
                                              </FormControl>
                                              <div style={{ display: 'flex' }}>
                                                <DocUpload
                                                  onAssignPic={this.assignPic2}
                                                />
                                                <LoadButton
                                                  isLoading={
                                                    this.state.invoiceSending
                                                  }
                                                  onClick={
                                                    uploadedDocuments.find(
                                                      (doc) =>
                                                        doc.name === 'Invoice'
                                                    )
                                                      ? this.sendInvoice
                                                      : this.createInvoice
                                                  }
                                                >
                                                  {uploadedDocuments.find(
                                                    (doc) =>
                                                      doc.name === 'Invoice'
                                                  )
                                                    ? 'SEND'
                                                    : 'CREATE'}{' '}
                                                  INVOICE
                                                </LoadButton>
                                                {this.state.invoiceData && (
                                                  <div>
                                                    {this.state.invoiceData
                                                      .invoiceAuthUri && (
                                                        <a
                                                          href={
                                                            this.state.invoiceData
                                                              .invoiceAuthUri
                                                          }
                                                        >
                                                          <Button
                                                            // style={{ float: "right", marginTop: "20px" }}
                                                            color="success"
                                                          >
                                                            QB Login
                                                          </Button>
                                                        </a>
                                                      )}
                                                  </div>
                                                )}
                                              </div>
                                              <Autocomplete
                                                multiple
                                                options={invoiceDocuments}
                                                getOptionLabel={(option) =>
                                                  option.name
                                                }
                                                value={
                                                  this.state.additionalDocuments
                                                    ? this.state
                                                      .additionalDocuments
                                                    : this.state.orderData &&
                                                      this.state.orderData
                                                        .previouslySentDocuments
                                                      ? this.state.orderData
                                                        .previouslySentDocuments
                                                      : uploadedDocuments.find(
                                                        (obj) =>
                                                          obj.name === 'Invoice'
                                                      )
                                                        ? [
                                                          uploadedDocuments.find(
                                                            (obj) =>
                                                              obj.name ===
                                                              'Invoice'
                                                          ),
                                                        ]
                                                        : []
                                                }
                                                filterSelectedOptions
                                                renderInput={(params) => (
                                                  <TextField
                                                    {...params}
                                                    label="Attachments"
                                                    variant="outlined"
                                                  />
                                                )}
                                                onChange={
                                                  this.selectAttachments
                                                }
                                                style={{ marginTop: '8px' }}
                                              />
                                            </GridItem>
                                            {this.state.orderData.newDocs &&
                                              this.state.orderData.newDocs.map(
                                                (doc, i) => (
                                                  <div
                                                    style={{ display: 'flex' }}
                                                  >
                                                    <Close
                                                      style={{
                                                        color: 'red',
                                                        cursor: 'pointer',
                                                      }}
                                                      onClick={() =>
                                                        this.removeDoc(i)
                                                      }
                                                    />
                                                    {this.state.editDocName ===
                                                      i ? (
                                                      <input
                                                        type="text"
                                                        onChange={(e) => {
                                                          const orderData = this
                                                            .state.orderData;
                                                          orderData.newDocs[
                                                            i
                                                          ].name =
                                                            e.target.value;
                                                          this.setState({
                                                            orderData: orderData,
                                                          });
                                                        }}
                                                        value={
                                                          doc.name
                                                            ? doc.name
                                                            : doc.file.name
                                                        }
                                                      />
                                                    ) : (
                                                      <p>
                                                        <a
                                                          href={doc.fileURL}
                                                          target="_blank"
                                                        >
                                                          {doc.name
                                                            ? doc.name
                                                            : doc.file.name}
                                                        </a>
                                                      </p>
                                                    )}
                                                    <ButtonBase
                                                      onClick={() => {
                                                        this.setState({
                                                          editDocName:
                                                            i ===
                                                              this.state
                                                                .editDocName
                                                              ? -1
                                                              : i,
                                                        });
                                                      }}
                                                    >
                                                      <EditIcon />
                                                    </ButtonBase>
                                                    <ButtonBase
                                                      onClick={() =>
                                                        this.saveDoc(doc)
                                                      }
                                                    >
                                                      <SaveIcon />
                                                    </ButtonBase>
                                                  </div>
                                                )
                                              )}
                                            <GridContainer>
                                              <GridItem xs={12}>
                                                <br />
                                              </GridItem>
                                              <GridItem xs={12} sm={6} md={4}>
                                                Delivered At:{' '}
                                                <DateTimePicker
                                                  onChange={(date) => {
                                                    const orderData = this.state
                                                      .orderData;
                                                    orderData.actualDeliveredAt = date;
                                                    this.setState({
                                                      orderData: orderData,
                                                    });
                                                  }}
                                                  value={
                                                    this.state.orderData
                                                      .actualDeliveredAt
                                                      ? this.state.orderData
                                                        .actualDeliveredAt
                                                        .seconds
                                                        ? this.state.orderData.actualDeliveredAt.toDate()
                                                        : this.state.orderData
                                                          .actualDeliveredAt
                                                      : null
                                                  }
                                                />
                                              </GridItem>
                                              <GridItem xs={12} sm={6} md={4}>
                                                <CustomInput
                                                  labelText="Name of Signer"
                                                  id="nameOfSigner"
                                                  formControlProps={{
                                                    fullWidth: true,
                                                  }}
                                                  inputProps={{
                                                    type: 'text',
                                                    onChange: (event) => {
                                                      const orderData = this
                                                        .state.orderData;
                                                      orderData[
                                                        event.target.id
                                                      ] = event.target.value;
                                                      this.setState({
                                                        orderData: orderData,
                                                      });
                                                    },
                                                    defaultValue: this.state
                                                      .orderData.nameOfSigner
                                                      ? this.state.orderData
                                                        .nameOfSigner
                                                      : '',
                                                  }}
                                                />
                                              </GridItem>
                                              <GridItem xs={12} sm={6} md={4}>
                                                <Button
                                                  color="primary"
                                                  onClick={this.submitDelivery}
                                                  fullWidth
                                                >
                                                  DELIVERED
                                                </Button>
                                              </GridItem>
                                            </GridContainer>

                                            {/* {(this.state.deliveryType == "Ground" || this.state.deliveryType == "LTL")
                                    &&
                                  <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FGround%20Only%20Rate%20Confirmation%20Final%203.3.2020.pdf?alt=media&token=f95662dd-c5ad-405f-a70a-0c8479a1faa9" target="_blank">
                                  <Button
                                    color="primary"
                                  >
                                    Ground Only Rate Confirmation
                                  </Button>
                                  </a>}
                                  <br/>
                                  <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FKNOWN%20Shipper%20Air%20Pick%20Up%20Final%203.3.2020.pdf?alt=media&token=b9bf832c-4c5c-40b0-ac53-bab0b1bd2336" target="_blank">
                                  <Button
                                    color="primary"
                                  >
                                    Known Shipper Air Pick-Up Alert
                                  </Button>
                                  </a><br/>
                                  <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FHouse%20Waybill%20Final%203.4.2020.pdf?alt=media&token=ffcb839a-def3-4ecc-a0f1-3f398aea160d" target="_blank">
                                  <Button
                                    color="primary"
                                  >
                                    House Waybill
                                  </Button>
                                  </a><br/> */}

                                            <br />
                                            {/* <a href="https://firebasestorage.googleapis.com/v0/b/cargo-rx.appspot.com/o/forms%2FHouse%20Waybill%20Final%203.4.2020.pdf?alt=media&token=ffcb839a-def3-4ecc-a0f1-3f398aea160d" target="_blank"> */}
                                            {/* </a> */}
                                          </GridItem>
                                          <GridItem xs={12}>
                                            {console.log(
                                              'additionalDocuments',
                                              this.state.orderData
                                            )}
                                            <b>Pick Up Driver Images</b>
                                            {(this.state.orderData.shipperBOL ||
                                              this.state.orderData
                                                .manualOriginAirlineWaybill) && (
                                                <GridContainer>
                                                  {this.state.orderData
                                                    .shipperBOL &&
                                                    this.state.orderData.shipperBOL
                                                      .length ? (
                                                    <GridItem xs={12}>
                                                      {this.state.orderData.shipperBOL.map(
                                                        (page) => (
                                                          <a
                                                            href={page.fileURL}
                                                            target="_blank"
                                                          >
                                                            <Button color="primary">
                                                              HARD COPY BOL
                                                              <IconButton
                                                                size="small"
                                                                style={{
                                                                  marginLeft:
                                                                    '16px',
                                                                  marginRight:
                                                                    '-16px',
                                                                }}
                                                                onClick={(e) =>
                                                                  this.deleteDriverUploads(
                                                                    page,
                                                                    e
                                                                  )
                                                                }
                                                              >
                                                                <Close />
                                                              </IconButton>
                                                            </Button>
                                                          </a>
                                                        )
                                                      )}
                                                    </GridItem>
                                                  ) : null}
                                                  {this.state.orderData
                                                    .manualOriginAirlineWaybill && (
                                                      <GridItem xs={12}>
                                                        <a
                                                          href={
                                                            this.state.orderData
                                                              .manualOriginAirlineWaybill[0]
                                                              .fileURL
                                                          }
                                                          target="_blank"
                                                        >
                                                          <Button color="primary">
                                                            ORIGIN AIRLINE DOCS
                                                          </Button>
                                                        </a>
                                                      </GridItem>
                                                    )}
                                                </GridContainer>
                                              )}
                                            <GridContainer>
                                              {this.state.orderData
                                                .freightPickUp && (
                                                  <GridItem xs={12}>
                                                    <GridContainer>
                                                      <GridItem xs={12}>
                                                        <b>
                                                          Freight Images at Pick
                                                          up
                                                        </b>
                                                      </GridItem>

                                                      {this.state.orderData
                                                        .freightPickUp &&
                                                        this.state.orderData.freightPickUp.map(
                                                          (img) => (
                                                            <GridItem xs={3}>
                                                              <div
                                                                style={{
                                                                  width: '100%',
                                                                }}
                                                              >
                                                                <a
                                                                  href={
                                                                    img.fileURL
                                                                  }
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src={
                                                                      img.fileURL
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        '1px',
                                                                      width:
                                                                        '100%',
                                                                      border:
                                                                        '0.7px solid black',
                                                                      borderRadius:
                                                                        '5px',
                                                                    }}
                                                                  />
                                                                </a>
                                                              </div>
                                                            </GridItem>
                                                          )
                                                        )}
                                                    </GridContainer>
                                                    <br />
                                                  </GridItem>
                                                )}

                                              {this.state.orderData
                                                .freightDropOffAirline && (
                                                  <GridItem xs={12}>
                                                    <GridContainer>
                                                      <GridItem xs={12}>
                                                        <b>
                                                          Freight Images Post
                                                          Tender
                                                        </b>
                                                      </GridItem>

                                                      {this.state.orderData
                                                        .freightDropOffAirline &&
                                                        this.state.orderData.freightDropOffAirline.map(
                                                          (img) => (
                                                            <GridItem xs={3}>
                                                              <div
                                                                style={{
                                                                  width: '100%',
                                                                }}
                                                              >
                                                                <a
                                                                  href={
                                                                    img.fileURL
                                                                  }
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src={
                                                                      img.fileURL
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        '1px',
                                                                      width:
                                                                        '100%',
                                                                      border:
                                                                        '0.7px solid black',
                                                                      borderRadius:
                                                                        '5px',
                                                                    }}
                                                                  />
                                                                </a>
                                                              </div>
                                                            </GridItem>
                                                          )
                                                        )}
                                                    </GridContainer>
                                                    <br />
                                                  </GridItem>
                                                )}
                                            </GridContainer>
                                          </GridItem>
                                          <GridItem xs={12}>
                                            {(this.state.orderData
                                              .deliveryType == 'Air' ||
                                              this.state.orderData
                                                .deliveryType ==
                                              'Scheduled Air') && (
                                                <b>Delivery Driver Images</b>
                                              )}

                                            {(this.state.orderData
                                              .consigneeBOL ||
                                              this.state.orderData
                                                .manualDestinationAirlineWaybill) && (
                                                <GridContainer>
                                                  {this.state.orderData
                                                    .consigneeBOL &&
                                                    this.state.orderData
                                                      .consigneeBOL.length ? (
                                                    <GridItem xs={12}>
                                                      {this.state.orderData.consigneeBOL.map(
                                                        (page, index) => (
                                                          <a
                                                            href={page.fileURL}
                                                            target="_blank"
                                                          >
                                                            <Button color="primary">
                                                              HARD COPY POD
                                                              <IconButton
                                                                size="small"
                                                                style={{
                                                                  marginLeft:
                                                                    '16px',
                                                                  marginRight:
                                                                    '-16px',
                                                                }}
                                                                onClick={(e) =>
                                                                  this.deleteDriverUploads(
                                                                    page,
                                                                    e,
                                                                    index
                                                                  )
                                                                }
                                                              >
                                                                <Close />
                                                              </IconButton>
                                                            </Button>
                                                          </a>
                                                        )
                                                      )}
                                                      {/* <a href={this.state.orderData.consigneeBOL[0].fileURL} target='_blank'>
                                                    <Button color='primary'>
                                                      HARD COPY POD
                                                      <IconButton size='small' style={{ marginLeft: '16px', marginRight: '-16px' }} onClick={(e) => this.deleteDriverUploads(this.state.orderData.consigneeBOL[0], e)}>
                                                        <Close />
                                                      </IconButton>
                                                    </Button>
                                                  </a> */}
                                                    </GridItem>
                                                  ) : null}
                                                  {this.state.orderData
                                                    .manualDestinationAirlineWaybill && (
                                                      <GridItem xs={12}>
                                                        <a
                                                          href={
                                                            this.state.orderData
                                                              .manualDestinationAirlineWaybill[0]
                                                              .fileURL
                                                          }
                                                          target="_blank"
                                                        >
                                                          <Button color="primary">
                                                            DESTINATION AIRLINE DOCS
                                                          </Button>
                                                        </a>
                                                      </GridItem>
                                                    )}
                                                  <br />
                                                </GridContainer>
                                              )}
                                            <GridContainer>
                                              {this.state.orderData
                                                .freightPickUpAirport && (
                                                  <GridItem xs={12}>
                                                    <GridContainer>
                                                      <GridItem xs={12}>
                                                        <b>
                                                          Freight Images at
                                                          Airline Pick up
                                                        </b>
                                                      </GridItem>

                                                      {this.state.orderData
                                                        .freightPickUpAirport &&
                                                        this.state.orderData.freightPickUpAirport.map(
                                                          (img) => (
                                                            <GridItem xs={3}>
                                                              <div
                                                                style={{
                                                                  width: '100%',
                                                                }}
                                                              >
                                                                <a
                                                                  href={
                                                                    img.fileURL
                                                                  }
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src={
                                                                      img.fileURL
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        '1px',
                                                                      width:
                                                                        '100%',
                                                                      border:
                                                                        '0.7px solid black',
                                                                      borderRadius:
                                                                        '5px',
                                                                    }}
                                                                  />
                                                                </a>
                                                              </div>
                                                            </GridItem>
                                                          )
                                                        )}
                                                      <br />
                                                    </GridContainer>
                                                  </GridItem>
                                                )}

                                              {this.state.orderData
                                                .freightDropOff && (
                                                  <GridItem xs={12}>
                                                    <GridContainer>
                                                      <GridItem xs={12}>
                                                        <b>
                                                          Freight Images at
                                                          Delivery
                                                        </b>
                                                      </GridItem>

                                                      {this.state.orderData
                                                        .freightDropOff &&
                                                        this.state.orderData.freightDropOff.map(
                                                          (img) => (
                                                            <GridItem xs={3}>
                                                              <div
                                                                style={{
                                                                  width: '100%',
                                                                }}
                                                              >
                                                                <a
                                                                  href={
                                                                    img.fileURL
                                                                  }
                                                                  target="_blank"
                                                                >
                                                                  <img
                                                                    src={
                                                                      img.fileURL
                                                                    }
                                                                    style={{
                                                                      padding:
                                                                        '1px',
                                                                      width:
                                                                        '100%',
                                                                      border:
                                                                        '0.7px solid black',
                                                                      borderRadius:
                                                                        '5px',
                                                                    }}
                                                                  />
                                                                </a>
                                                              </div>
                                                            </GridItem>
                                                          )
                                                        )}
                                                      <br />
                                                    </GridContainer>
                                                  </GridItem>
                                                )}
                                                <GridItem xs={12}>
                                                    <GridContainer>
                                                      <GridItem xs={12}>
                                                        <b>
                                                        Trans-load Images
                                                        </b>
                                                        <DocumentUpload
                                                  buttonTitle={`UPLOAD IMAGES`}
                                                  refString="transLoad"
                                                  onAssignDoc={this.assignDoc}
                                      /> 
                                      {this.state.orderData
                                        .transLoad &&
                                        this.state.orderData.transLoad.map(
                                          (img) => (
                                            <GridItem xs={3}>
                                              <div
                                                style={{
                                                  width: '100%',
                                                }}
                                              >
                                                <a
                                                  href={
                                                    img.fileURL
                                                  }
                                                  target="_blank"
                                                >
                                                  <img
                                                    src={
                                                      img.fileURL
                                                    }
                                                    style={{
                                                      padding:
                                                        '1px',
                                                      width:
                                                        '100%',
                                                      border:
                                                        '0.7px solid black',
                                                      borderRadius:
                                                        '5px',
                                                    }}
                                                  />
                                                </a>
                                              </div>
                                            </GridItem>
                                          )
                                        )}
                                                      </GridItem>

                                                  
                                                      <br />
                                                    </GridContainer>
                                                  </GridItem>
                                            </GridContainer>
                                          </GridItem>
                                          {/* {this.state.orderData &&

                                    
                                       <GridItem xs={12}>
                                       Submitted At: {this.state.orderData.updatedAt && moment(this.state.orderData.updatedAt.toDate()).format('MM-DD-YYYY HH:mm')} by {this.state.orderData["updatedBy"] && this.state.orderData["updatedBy"]}<br/>
                                       Quoted At: {this.state.orderData.quotedAt && moment(this.state.orderData.quotedAt.toDate()).format('MM-DD-YYYY HH:mm')} by {this.state.orderData["QuotedBy"] && this.state.orderData["QuotedBy"]}<br/>
                                       Booked At: {this.state.orderData.bookedAt && moment(this.state.orderData.bookedAt.toDate()).format('MM-DD-YYYY HH:mm')} by {this.state.orderData["BookedBy"] && this.state.orderData["BookedBy"]}<br/>
                                       Dispatched At: {this.state.orderData.dispatcherAssigned && (this.state.orderData.dispatcherAssigned && moment(this.state.orderData.dispatcherAssigned.toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["DispatchedBy"] && this.state.orderData["DispatchedBy"]}<br/>
                                       In Route to Shipper At: {this.state.orderData["In Route to ShipperAt"] && (this.state.orderData["In Route to ShipperAt"] && moment(this.state.orderData["In Route to ShipperAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["In Route to ShipperBy"] && this.state.orderData["In Route to ShipperBy"]}<br/>
                                       Arrived at Shipper At: {this.state.orderData["Arrived at ShipperAt"] && (this.state.orderData["Arrived at ShipperAt"] && moment(this.state.orderData["Arrived at ShipperAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Arrived at ShipperBy"] && this.state.orderData["Arrived at ShipperBy"]}<br/>
                                       Driver Departed Shipper At: {this.state.orderData["Driver Departed ShipperAt"] && (this.state.orderData["Driver Departed ShipperAt"] && moment(this.state.orderData["Driver Departed ShipperAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Driver Departed ShipperBy"] && this.state.orderData["Driver Departed ShipperBy"]}<br/>
                                       Arrived at Airline At: {this.state.orderData["Arrived at AirlineAt"] && (this.state.orderData["Arrived at AirlineAt"] && moment(this.state.orderData["Arrived at AirlineAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Arrived at AirlineBy"] && this.state.orderData["Arrived at AirlineBy"]}<br/>
                                       Tendered to Airline Awaiting Departure At: {this.state.orderData["Tendered to Airline Awaiting DepartureAt"] && (this.state.orderData["Tendered to Airline Awaiting DepartureAt"] && moment(this.state.orderData["Tendered to Airline Awaiting DepartureAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Tendered to Airline Awaiting DepartureBy"] && this.state.orderData["Tendered to Airline Awaiting DepartureBy"]}<br/>
                                       Aircraft Departed At: {this.state.orderData["Aircraft DepartedAt"] && (this.state.orderData["Aircraft DepartedAt"] && moment(this.state.orderData["Aircraft DepartedAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Aircraft DepartedBy"] && this.state.orderData["Aircraft DepartedBy"]}<br/>
                                       Aircraft Arrived At: {this.state.orderData["Aircraft ArrivedAt"] && (this.state.orderData["Aircraft ArrivedAt"] && moment(this.state.orderData["Aircraft ArrivedAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Aircraft ArrivedBy"] && this.state.orderData["Aircraft ArrivedBy"]}<br/>
                                       Aircraft Download At: {this.state.orderData["Aircraft DownloadAt"] && (this.state.orderData["Aircraft DownloadAt"] && moment(this.state.orderData["Aircraft DownloadAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Aircraft DownloadBy"] && this.state.orderData["Aircraft DownloadBy"]}<br/>
                                       Docked At: {this.state.orderData["DockedAt"] && (this.state.orderData["DockedAt"] && moment(this.state.orderData["DockedAt"].toDate()).format('MM-DD-YYYY HH:mm'))} {this.state.orderData["DockedBy"] && this.state.orderData["DockedBy"]}<br/>
                                       In Route to Consignee At: {this.state.orderData["In Route to ConsigneeAt"] && (this.state.orderData["In Route to ConsigneeAt"] && moment(this.state.orderData["In Route to ConsigneeAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["In Route to ConsigneeBy"] && this.state.orderData["In Route to ConsigneeBy"]}<br/>
                                       Aircraft Arrived At: {this.state.orderData["Aircraft ArrivedAt"] && (this.state.orderData["Aircraft ArrivedAt"] && moment(this.state.orderData["Aircraft ArrivedAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Aircraft ArrivedBy"] && this.state.orderData["Aircraft ArrivedBy"]}<br/>
                                       Arrived at Consignee At: {this.state.orderData["Arrived at ConsigneeAt"] && (this.state.orderData["Arrived at ConsigneeAt"] && moment(this.state.orderData["Arrived at ConsigneeAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["Arrived at ConsigneeBy"] && this.state.orderData["Arrived at ConsigneeBy"]}<br/>
                                       Delivered At: {this.state.orderData["DeliveredAt"] && (this.state.orderData["DeliveredAt"] && moment(this.state.orderData["DeliveredAt"].toDate()).format('MM-DD-YYYY HH:mm'))} by {this.state.orderData["DeliveredBy"] && this.state.orderData["DeliveredBy"]}
                                       </GridItem>
 
                                      
                                    } */}
                                        </GridContainer>
                                      </GridItem>
                                      {/* <GridItem xs={12} md={4}>
                                                                              <ShipFullScreenMap originCoords={this.state.originCoords} destinationCoords={this.state.destinationCoords} />
                                                                            </GridItem> <br /> */}
                                      {/* <GridItem xs={12} md={4}>
                                                                              <GridContainer>
                                                                                <GridItem xs={12}>
                                                                                  <GridContainer>
                                                                                    <GridItem xs={6}>
                                      
                                                                                      <DatePicker
                                                                                        onChange={this.handlePickUpDateChange}
                                                                                        value={this.state.pickUpDate ? this.state.pickUpDate : ''}
                                                                                      />
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <FormControl
                                                                                        fullWidth
                                                                                        className={classes.selectFormControl}>
                                                                                        <InputLabel
                                                                                          htmlFor="radius"
                                                                                          className={classes.selectLabel}>
                                                                                          Radius:
                                                                </InputLabel>
                                                                                        <Select
                                                                                          MenuProps={{
                                                                                            className: classes.selectMenu
                                                                                          }}
                                                                                          classes={{
                                                                                            select: classes.select
                                                                                          }}
                                                                                          value={this.state.radius}
                                                                                          onChange={this.handleSelectChange}
                                                                                          defaultValue={this.state.radius ? this.state.radius : ''}
                                                                                          inputProps={{
                                                                                            id: 'radius',
                                                                                            name: 'radius'
                                                                                          }}
                                                                                        >
                                                                                          {
                                                                                            radiusOptions.map((item) => (
                                                                                              <MenuItem
                                                                                                classes={{
                                                                                                  root: classes.selectMenuItem
                                                                                                }}
                                                                                                value={item}
                                                                                                key={item}
                                                                                              >{item}</MenuItem>
                                                                                            ))
                                                                                          }
                                                                                        </Select>
                                                                                      </FormControl>
                                      
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Starting City"
                                                                                        id="originCity"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.originCity ? this.state.orderData.originCity : ''
                                                                                        }}
                                                                                      />
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Starting State"
                                                                                        id="originState"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.originState ? this.state.orderData.originState : ''
                                                                                        }}
                                                                                      />
                                      
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Ending City"
                                                                                        id="destinationCity"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.destinationCity ? this.state.orderData.destinationCity : ''
                                                                                        }}
                                                                                      />
                                      
                                                                                    </GridItem>
                                                                                    <GridItem xs={6}>
                                                                                      <CustomInput
                                                                                        labelText="Ending State"
                                                                                        id="destinationState"
                                                                                        formControlProps={{
                                                                                          fullWidth: true
                                                                                        }}
                                                                                        inputProps={{
                                                                                          required: false,
                                                                                          type: "text",
                                                                                          onChange: (event) => this.handleChange(event),
                                                                                          defaultValue: this.state.orderData.destinationState ? this.state.orderData.destinationState : ''
                                                                                        }}
                                                                                      />
                                      
                                                                                    </GridItem>
                                                                                  </GridContainer>
                                      
                                      
                                                                                </GridItem>
                                                                                <GridItem xs={6}>
                                                                                  {this.state.pickUpDate &&
                                                                                    <Button
                                                                                      color="primary"
                                                                                      onClick={() => this.getFlights(this.state.originCoords, this.state.destinationCoords)}
                                                                                    >
                                                                                      SEARCH FLIGHTS
                                                                            </Button>
                                                                                  }
                                      
                                      
                                                                                </GridItem>
                                                                                <GridItem xs={6}>
                                                                                  <Button
                                                                                    color="info"
                                                                                    onClick={() => this.hideFlights()}
                                                                                  >
                                                                                    {this.state.hideFlights ? "SHOW" : "HIDE"} FLIGHTS
                                                                            </Button>
                                                                                </GridItem>
                                                                                <GridItem xs={12}>
                                                                                  {!this.state.hideFlights &&
                                                                                    <GridContainer>
                                                                                      {(this.state.matchingFlights.sort((a, b) => (a.movement.scheduledTimeUtc > b.movement.scheduledTimeUtc) ? 1 : -1)).map(flight => {
                                                                                        return (
                                                                                          <GridItem xs={12}>
                                                                                            <Card style={{ backgroundColor: (flight.number == this.state.flightNumber) ? "#efe6e6" : "white", boxShadow: "0px 0px 8px 0px #888888", borderRadius: "5px" }} onClick={() => this.assignFlightNumber(flight.number, flight.originAirport, flight.movement.airport.icao)}>
                                                                                              <GridContainer style={{ textAlign: "center" }}>
                                                                                                <GridItem xs={4}>
                                                                                                  <h4><b>{flight.number}</b></h4>
                                                                                                </GridItem>
                                                                                                <GridItem xs={4}>
                                                                                                  <h6 style={{ marginTop: "10px" }}>{flight.aircraft.model}</h6>
                                                                                                </GridItem>
                                                                                                <GridItem xs={4}>
                                                                                                  <h4><b>{flight.airline.name}</b></h4>
                                                                                                </GridItem>
                                                                                              </GridContainer>
                                                                                              <GridContainer style={{ textAlign: "center" }}>
                                                                                                <GridItem xs={5}>
                                                                                                  <h2 style={{ margin: "0" }}><b>{flight.originAirport}</b></h2>
                                                                                                </GridItem>
                                                                                                <GridItem xs={2}>
                                                                                                  <h4><b>=></b></h4>
                                                                                                </GridItem>
                                                                                                <GridItem xs={5}>
                                                                                                  <h2 style={{ margin: "0" }}><b>{flight.movement.airport.icao}</b></h2>
                                                                                                </GridItem>
                                                                                                <GridItem xs={12}>
                                                                                                  <h5><b>{flight.movement.scheduledTimeLocal.slice(0, -6)}</b></h5>
                                                                                                </GridItem>
                                                                                              </GridContainer>
                                                                                            </Card>
                                                                                          </GridItem>
                                                                                        )
                                                                                      })}
                                                                                    </GridContainer>
                                                                                  }
                                                                                </GridItem>
                                                                              </GridContainer>
                                                                            </GridItem> */}
                                    </GridContainer>
                                  )}
                                </GridContainer>
                              )}
                            </GridItem>
                          </GridContainer>
                          <br />
                          <br />
                          {pathname == '/completed-orders' ? (
                            <div>
                              <h3 style={{}}>
                                <b>Delivery Information</b>
                              </h3>
                              CONDITION:{' '}
                              <b>
                                {this.state.orderData &&
                                  this.state.orderData.CONDITION}
                              </b>
                              <br />
                              POD:{' '}
                              {this.state.orderData &&
                                this.state.orderData.BOLPICS.map((item) => (
                                  <a
                                    style={{ color: '#ff0000 !important' }}
                                    href={item}
                                    target="_blank"
                                  >
                                    Click here for image
                                  </a>
                                ))}
                              <br />
                              {this.state.orderData && (
                                <div>
                                  DAMAGE:{' '}
                                  {this.state.orderData.DAMAGEPIC &&
                                    this.state.orderData.DAMAGEPICS.map(
                                      (item) => (
                                        <a
                                          style={{
                                            color: '#ff0000 !important',
                                          }}
                                          href={item}
                                          target="_blank"
                                        >
                                          Click here for image
                                        </a>
                                      )
                                    )}
                                </div>
                              )}
                            </div>
                          ) : null}

                          <GridContainer>
                            <GridItem xs={10}>
                              {/* <Button
                                  color="primary"
                                  style={{ marginTop: "20px" }}
                                  onClick={() => this.step5Back()}
                                >BACK</Button> */}
                            </GridItem>
                            {/* <GridItem xs={4}>
                                <Button

                                  style={{ color: "black", marginTop: "20px", backgroundColor: "#efe6e6" }}
                                  onClick={() => this.saveAsQuote()}
                                >SAVE QUOTE</Button>
                              </GridItem> */}
                          </GridContainer>
                        </div>
                      ) : null}
                      <br />
                    </GridItem>
                  </GridContainer>
                </form>
              </div>
            </GridItem>
            <Snackbar
              open={this.state.errorSnack}
              autoHideDuration={6000}
              onClose={() => this.closeSnack('errorSnack')}
            >
              <Alert
                onClose={() => this.closeSnack('errorSnack')}
                severity="error"
              >
                {this.state.errorSnackMessage}
              </Alert>
            </Snackbar>
            <Snackbar
              open={this.state.infoSnack}
              autoHideDuration={6000}
              onClose={() => this.closeSnack('infoSnack')}
            >
              <Alert
                onClose={() => this.closeSnack('infoSnack')}
                severity="info"
              >
                {this.state.infoSnackMessage}
              </Alert>
            </Snackbar>
          </GridContainer>
        )}
      </div>
    );
  }
}

Form.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  //console.log(state)
  return {
    AuthBool: !!state.auth.user,
    authUser: state.auth.user,
    user: state.profile.user,
    // cattleID: ownProps.match.params.id
  };
};

export default compose(connect(mapStateToProps), withStyles(styles))(Form);



// WEBPACK FOOTER //
// ./src/components/Forms/DispatchOrderForm.jsx